var _style, _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g4, _g5, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g6, _path45, _path46, _path47, _path48, _path49, _g7, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g8, _path57, _g9, _path58, _g10, _path59, _path60, _g11, _path61, _path62, _g12, _path63, _g13, _g14, _path64, _path65, _g15, _path66, _path67, _g16, _g17, _ellipse, _use, _ellipse2, _use2, _ellipse3, _use3, _ellipse4, _use4, _ellipse5, _use5, _ellipse6, _use6, _ellipse7, _path68, _ellipse8, _path69, _ellipse9, _use7, _ellipse10, _path70, _ellipse11, _use8, _ellipse12, _path71, _ellipse13, _path72, _ellipse14, _use9, _ellipse15, _path73, _ellipse16, _use10, _ellipse17, _path74, _ellipse18, _path75, _ellipse19, _use11, _ellipse20, _use12, _ellipse21, _path76, _ellipse22, _use13, _ellipse23, _use14, _ellipse24, _use15, _ellipse25, _use16, _ellipse26, _path77, _ellipse27, _use17, _ellipse28, _use18, _ellipse29, _path78, _ellipse30, _use19, _ellipse31, _use20, _ellipse32, _path79, _ellipse33, _path80, _ellipse34, _path81, _ellipse35, _path82, _ellipse36, _use21, _ellipse37, _path83, _ellipse38, _use22, _ellipse39, _use23, _ellipse40, _use24, _ellipse41, _use25, _ellipse42, _use26, _ellipse43, _use27, _ellipse44, _use28, _ellipse45, _path84, _ellipse46, _path85, _g18, _g19, _g20, _g21, _path86, _g22, _g23, _g24, _path87, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _path88, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _path89, _path90, _ellipse47, _ellipse48, _use29, _g69, _use30, _path91, _g70, _g71, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g72, _path101, _ellipse49, _path102, _path103, _path104, _image, _g73, _image2, _g74, _mask, _use31, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _use32, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _use33, _path138, _path139, _use34, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _use35, _use36, _path149, _use37, _use38, _path150, _use39, _use40, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _use41, _path159, _path160, _path161, _path162, _path163, _path164, _use42, _path165, _path166, _use43, _path167, _path168, _path169, _path170, _use44, _path171, _path172, _use45, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _use46, _path181, _path182, _path183, _use47, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _mask2, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _path195, _use166, _use167, _use168, _use169, _use170, _use171, _path196, _use172, _use173, _use174, _use175, _path197, _use176, _path198, _use177, _use178, _use179, _path199, _use180, _use181, _use182, _use183, _use184, _path200, _path201, _use185, _use186, _use187, _use188, _path202, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _path203, _path204, _use197, _use198, _use199, _path205, _path206, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _path207, _use213, _use214, _use215, _use216, _path208, _use217, _use218, _path209, _use219, _path210, _path211, _use220, _path212, _path213, _use221, _use222, _use223, _use224, _path214, _use225, _use226, _use227, _use228, _use229, _path215, _use230, _path216, _g75;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgJoinUs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 835,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .B{opacity:.4}.C{opacity:.05}.D{fill:#211e1f}.E{fill:#f7d1b1}.F{fill:#518d40}.G{fill:#f2bf96}.H{fill:#3a5024}.I{fill:#8ac540}.J{fill:#ed4929}.K{fill:#091439}.L{fill:#e1c275}.M{fill:#fff}.N{fill-rule:nonzero}.O{opacity:.5}.P{fill:#57b247}.Q{fill:#1d2356}.R{fill:url(#BR)}.S{fill:url(#BT)}.T{fill:url(#BV)}.U{fill:url(#BZ)}.V{fill:url(#Bb)}.W{fill:url(#Bd)}.X{fill:#26316c}.Y{fill:#bb2f26}.Z{fill:#0e1333}.a{fill:url(#BM)}.b{fill:#fcf7be}.c{fill:#a31e21}.d{fill:url(#BK)}.e{fill:url(#BO)}.f{fill:url(#BS)}.g{fill:url(#BU)}.h{fill:url(#BW)}.i{fill:url(#Ba)}.j{fill:url(#Bc)}.k{fill:url(#Be)}.l{fill:#c14c27}.m{fill:url(#BL)}.n{fill:url(#BN)}.o{fill:url(#BP)}.p{fill:#efebea}>\r\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "50%",
    x2: "50%",
    y1: "80.534%",
    y2: "8.938%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#50c2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47%",
    stopColor: "#37429b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#1c0f29"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: "70.413%",
    cy: "91.363%",
    r: "98.088%",
    fx: "70.413%",
    fy: "91.363%",
    gradientTransform: "scale(1 .98237) rotate(-27.104 .738 .922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    stopColor: "#314ba0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#35c0f0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "C",
    cx: "-735.556%",
    cy: "5812.933%",
    r: "104.007%",
    fx: "-735.556%",
    fy: "5812.933%",
    gradientTransform: "matrix(1 0 0 .98164 0 1.067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    stopColor: "#314ba0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#35c0f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1c4076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#158fc7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: "50.006%",
    x2: "50.006%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#204182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#134a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: "49.99%",
    x2: "49.99%",
    y1: "99.492%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#263778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1c3f74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#204182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#134a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: "50.016%",
    x2: "50.016%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#204182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#134a87"
  })), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M43.51 17.732c-1.51.268-5.183-5.336-6.462-6.358-3.194-2.59-9.48-5.826-13.463-3.514-1.325.777-2.243 2.108-2.972 3.477-2.308 4.392-3.023 9.423-3.092 14.333-.065 4.712.923 9.442-.798 13.968a4.94 4.94 0 0 1-1.537 2.312c-2.77 2.01-5.654-1.18-6.95-3.412C3.466 30.322 1.31 20.806.272 11.407c.55 4.938 3.23 9.913 5.16 14.39 1.786 4.16 3.115 8.785 6.3 12.1 1.93-8.526.23-18.115 1.338-26.85.71-5.6 2.585-9.9 8.552-10.8C26.41-.5 31.315.707 35.705 2.82c3.563 1.702 6.817 3.967 9.997 6.307 1.274.925 6.97 6.815 7.957 6.63l-10.15 1.974z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: "70.867%",
    x2: "-13.602%",
    y1: "267.954%",
    y2: "251.451%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: "36834.845%",
    x2: "36834.845%",
    y1: "59870.353%",
    y2: "59957.215%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: "37014.483%",
    x2: "37014.483%",
    y1: "59956.352%",
    y2: "60043.214%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: "36993.935%",
    x2: "36993.935%",
    y1: "60013.286%",
    y2: "60100.106%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: "37046.18%",
    x2: "37046.18%",
    y1: "60139.904%",
    y2: "60226.782%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: "37171.372%",
    x2: "37171.372%",
    y1: "60228.791%",
    y2: "60315.672%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: "37205.325%",
    x2: "37205.325%",
    y1: "60331.328%",
    y2: "60418.232%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: "37257.467%",
    x2: "37257.467%",
    y1: "60418.113%",
    y2: "60505.019%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: "37364.578%",
    x2: "37364.578%",
    y1: "60503.945%",
    y2: "60590.849%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: "36764.891%",
    x2: "36764.891%",
    y1: "59762.217%",
    y2: "59849.079%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: "36889.778%",
    x2: "36889.778%",
    y1: "59859.601%",
    y2: "59946.479%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: "36887.629%",
    x2: "36887.629%",
    y1: "59948.124%",
    y2: "60035.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: "36976.282%",
    x2: "36976.282%",
    y1: "60050.788%",
    y2: "60137.692%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: "37046.746%",
    x2: "37046.746%",
    y1: "60137.571%",
    y2: "60224.476%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: "37098.965%",
    x2: "37098.965%",
    y1: "60193.764%",
    y2: "60280.626%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: "37187.673%",
    x2: "37187.673%",
    y1: "60279.761%",
    y2: "60366.623%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: "37184.744%",
    x2: "37184.744%",
    y1: "60366.077%",
    y2: "60452.889%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "36676.775%",
    x2: "36676.775%",
    y1: "59654.868%",
    y2: "59741.681%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "36747.239%",
    x2: "36747.239%",
    y1: "59751.762%",
    y2: "59838.59%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "36817.751%",
    x2: "36817.751%",
    y1: "59840.482%",
    y2: "59927.314%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "36888.166%",
    x2: "36888.166%",
    y1: "59818.942%",
    y2: "59905.618%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "36867.782%",
    x2: "36867.782%",
    y1: "59969.746%",
    y2: "60056.515%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "37029.142%",
    x2: "37029.142%",
    y1: "60115.531%",
    y2: "60202.387%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "37099.556%",
    x2: "37099.556%",
    y1: "60261.726%",
    y2: "60348.668%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "37078.701%",
    x2: "37078.701%",
    y1: "60228.763%",
    y2: "60315.532%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "37222.178%",
    x2: "37222.178%",
    y1: "60355.684%",
    y2: "60442.562%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: "36586.959%",
    x2: "36586.959%",
    y1: "59662.374%",
    y2: "59749.279%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "36711.533%",
    x2: "36711.533%",
    y1: "59749.155%",
    y2: "59836.06%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: "36781.962%",
    x2: "36781.962%",
    y1: "59834.991%",
    y2: "59921.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: "36798.031%",
    x2: "36798.031%",
    y1: "59891.541%",
    y2: "59978.403%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "36940.976%",
    x2: "36940.976%",
    y1: "59978.28%",
    y2: "60065.142%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "36993.248%",
    x2: "36993.248%",
    y1: "60075.081%",
    y2: "60161.959%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: "37009.055%",
    x2: "37009.055%",
    y1: "60161.513%",
    y2: "60248.391%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "37152.416%",
    x2: "37152.416%",
    y1: "60250.25%",
    y2: "60337.132%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: "36481.21%",
    x2: "36481.21%",
    y1: "59538.41%",
    y2: "59625.291%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: "36623.46%",
    x2: "36623.46%",
    y1: "59640.76%",
    y2: "59727.665%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "36712.13%",
    x2: "36712.13%",
    y1: "59683.036%",
    y2: "59769.877%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: "36710.187%",
    x2: "36710.187%",
    y1: "59813.899%",
    y2: "59900.755%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: "36834.746%",
    x2: "36834.746%",
    y1: "59869.987%",
    y2: "59956.799%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "36996.344%",
    x2: "36996.344%",
    y1: "60033.593%",
    y2: "60120.517%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: "37085.022%",
    x2: "37085.022%",
    y1: "60053.673%",
    y2: "60140.501%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: "37046.082%",
    x2: "37046.082%",
    y1: "60142.203%",
    y2: "60229.034%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: "37134.763%",
    x2: "37134.763%",
    y1: "60185.16%",
    y2: "60271.928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AA",
    x1: "36553.402%",
    x2: "36553.402%",
    y1: "59532.688%",
    y2: "59619.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AB",
    x1: "36605.865%",
    x2: "36605.865%",
    y1: "59590.056%",
    y2: "59676.869%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AC",
    x1: "36676.245%",
    x2: "36676.245%",
    y1: "59675.852%",
    y2: "59762.664%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AD",
    x1: "36764.793%",
    x2: "36764.793%",
    y1: "59743.693%",
    y2: "59830.527%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AE",
    x1: "36835.256%",
    x2: "36835.256%",
    y1: "59861.942%",
    y2: "59948.823%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AF",
    x1: "36887.58%",
    x2: "36887.58%",
    y1: "59964.38%",
    y2: "60051.285%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AG",
    x1: "36976.183%",
    x2: "36976.183%",
    y1: "60050.688%",
    y2: "60137.593%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AH",
    x1: "37046.647%",
    x2: "37046.647%",
    y1: "60137.472%",
    y2: "60224.377%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AI",
    x1: "36447.363%",
    x2: "36447.363%",
    y1: "59425.229%",
    y2: "59512.134%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AJ",
    x1: "36517.792%",
    x2: "36517.792%",
    y1: "59511.272%",
    y2: "59598.177%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AK",
    x1: "36696.54%",
    x2: "36696.54%",
    y1: "59567.983%",
    y2: "59654.844%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AL",
    x1: "36658.65%",
    x2: "36658.65%",
    y1: "59654.719%",
    y2: "59741.581%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AM",
    x1: "36729.078%",
    x2: "36729.078%",
    y1: "59751.613%",
    y2: "59838.49%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AN",
    x1: "36908.552%",
    x2: "36908.552%",
    y1: "59840.333%",
    y2: "59927.215%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AO",
    x1: "36888.067%",
    x2: "36888.067%",
    y1: "59943.239%",
    y2: "60030.144%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AP",
    x1: "36940.365%",
    x2: "36940.365%",
    y1: "60029.342%",
    y2: "60116.247%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AQ",
    x1: "37047.262%",
    x2: "37047.262%",
    y1: "59996.138%",
    y2: "60082.871%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AR",
    x1: "36447.633%",
    x2: "36447.633%",
    y1: "59374.366%",
    y2: "59461.179%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AS",
    x1: "36500.345%",
    x2: "36500.345%",
    y1: "59471.061%",
    y2: "59557.889%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AT",
    x1: "36588.609%",
    x2: "36588.609%",
    y1: "59559.919%",
    y2: "59646.751%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AU",
    x1: "36659.024%",
    x2: "36659.024%",
    y1: "59632.645%",
    y2: "59719.457%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AV",
    x1: "36711.434%",
    x2: "36711.434%",
    y1: "59689.737%",
    y2: "59776.507%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AW",
    x1: "36781.863%",
    x2: "36781.863%",
    y1: "59834.892%",
    y2: "59921.747%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AX",
    x1: "36870.217%",
    x2: "36870.217%",
    y1: "59891.442%",
    y2: "59978.254%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AY",
    x1: "36922.721%",
    x2: "36922.721%",
    y1: "59978.181%",
    y2: "60064.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AZ",
    x1: "36252.311%",
    x2: "36252.311%",
    y1: "59236.972%",
    y2: "59323.791%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aa",
    x1: "36519.822%",
    x2: "36519.822%",
    y1: "59352.294%",
    y2: "59439.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ab",
    x1: "36500.493%",
    x2: "36500.493%",
    y1: "59449.602%",
    y2: "59536.479%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ac",
    x1: "36552.735%",
    x2: "36552.735%",
    y1: "59538.31%",
    y2: "59625.192%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ad",
    x1: "36695.506%",
    x2: "36695.506%",
    y1: "59640.661%",
    y2: "59727.565%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ae",
    x1: "36711.884%",
    x2: "36711.884%",
    y1: "59726.969%",
    y2: "59813.874%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Af",
    x1: "36782.199%",
    x2: "36782.199%",
    y1: "59813.75%",
    y2: "59900.655%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ag",
    x1: "36889.042%",
    x2: "36889.042%",
    y1: "59869.838%",
    y2: "59956.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ah",
    x1: "36923.274%",
    x2: "36923.274%",
    y1: "59956.104%",
    y2: "60042.965%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ai",
    x1: "36413.537%",
    x2: "36413.537%",
    y1: "59257.846%",
    y2: "59344.727%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aj",
    x1: "36394.431%",
    x2: "36394.431%",
    y1: "59360.386%",
    y2: "59447.291%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ak",
    x1: "36482.692%",
    x2: "36482.692%",
    y1: "59446.429%",
    y2: "59533.334%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Al",
    x1: "36553.304%",
    x2: "36553.304%",
    y1: "59532.738%",
    y2: "59619.643%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Am",
    x1: "36605.766%",
    x2: "36605.766%",
    y1: "59442.3%",
    y2: "59528.948%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "An",
    x1: "36658.079%",
    x2: "36658.079%",
    y1: "59645.932%",
    y2: "59732.701%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ao",
    x1: "36782.782%",
    x2: "36782.782%",
    y1: "59773.121%",
    y2: "59859.949%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ap",
    x1: "36817.053%",
    x2: "36817.053%",
    y1: "59951.185%",
    y2: "60038.146%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aq",
    x1: "36271.633%",
    x2: "36271.633%",
    y1: "59147.443%",
    y2: "59234.271%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ar",
    x1: "36324.26%",
    x2: "36324.26%",
    y1: "59206.777%",
    y2: "59293.565%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "As",
    x1: "36394.675%",
    x2: "36394.675%",
    y1: "59339.024%",
    y2: "59425.88%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "At",
    x1: "36465.187%",
    x2: "36465.187%",
    y1: "59425.13%",
    y2: "59511.985%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Au",
    x1: "36535.7%",
    x2: "36535.7%",
    y1: "59481.618%",
    y2: "59568.43%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Av",
    x1: "36606.114%",
    x2: "36606.114%",
    y1: "59567.883%",
    y2: "59654.695%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Aw",
    x1: "36658.551%",
    x2: "36658.551%",
    y1: "59654.62%",
    y2: "59741.482%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ax",
    x1: "36728.98%",
    x2: "36728.98%",
    y1: "59751.513%",
    y2: "59838.391%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ay",
    x1: "36817.604%",
    x2: "36817.604%",
    y1: "59840.234%",
    y2: "59927.115%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Az",
    x1: "36236.144%",
    x2: "36236.144%",
    y1: "59144.791%",
    y2: "59231.697%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BA",
    x1: "36288.812%",
    x2: "36288.812%",
    y1: "59201.217%",
    y2: "59288.079%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BB",
    x1: "36359.241%",
    x2: "36359.241%",
    y1: "59287.483%",
    y2: "59374.344%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BC",
    x1: "36447.535%",
    x2: "36447.535%",
    y1: "59374.217%",
    y2: "59461.079%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BD",
    x1: "36536.063%",
    x2: "36536.063%",
    y1: "59470.912%",
    y2: "59557.79%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BE",
    x1: "36552.562%",
    x2: "36552.562%",
    y1: "59559.77%",
    y2: "59646.651%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BF",
    x1: "36658.925%",
    x2: "36658.925%",
    y1: "59662.126%",
    y2: "59749.031%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BG",
    x1: "36765.696%",
    x2: "36765.696%",
    y1: "59748.906%",
    y2: "59835.812%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BH",
    x1: "49.514%",
    x2: "49.514%",
    y1: "91.433%",
    y2: "-8.55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#b62127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#911c23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BI",
    x1: "34617.107%",
    x2: "34617.107%",
    y1: "-24.775%",
    y2: "-124.758%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "82%",
    stopColor: "#b62127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#911c23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BJ",
    x1: "143.081%",
    x2: "43.081%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BK",
    x1: "143.081%",
    x2: "43.224%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BL",
    x1: "143.224%",
    x2: "43.224%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BM",
    x1: "143.224%",
    x2: "43.367%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BN",
    x1: "143.367%",
    x2: "43.367%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BO",
    x1: "143.367%",
    x2: "43.509%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BP",
    x1: "143.509%",
    x2: "43.509%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BQ",
    x1: "143.509%",
    x2: "43.652%",
    y1: "24.002%",
    y2: "24.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BR",
    x1: "143.081%",
    x2: "43.224%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BS",
    x1: "143.224%",
    x2: "43.224%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BT",
    x1: "143.224%",
    x2: "43.367%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BU",
    x1: "143.367%",
    x2: "43.367%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BV",
    x1: "143.367%",
    x2: "43.509%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BW",
    x1: "143.509%",
    x2: "43.509%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BX",
    x1: "143.081%",
    x2: "43.081%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BY",
    x1: "143.509%",
    x2: "43.652%",
    y1: "24.145%",
    y2: "24.145%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BZ",
    x1: "143.081%",
    x2: "43.224%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ba",
    x1: "143.224%",
    x2: "43.224%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bb",
    x1: "143.224%",
    x2: "43.367%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bc",
    x1: "143.367%",
    x2: "43.367%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bd",
    x1: "143.367%",
    x2: "43.509%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Be",
    x1: "143.509%",
    x2: "43.509%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bf",
    x1: "143.081%",
    x2: "43.081%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bg",
    x1: "143.509%",
    x2: "43.652%",
    y1: "24.288%",
    y2: "24.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bh",
    x1: "143.081%",
    x2: "43.224%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bi",
    x1: "143.224%",
    x2: "43.224%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bj",
    x1: "143.224%",
    x2: "43.367%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bk",
    x1: "143.367%",
    x2: "43.367%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bl",
    x1: "143.367%",
    x2: "43.509%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bm",
    x1: "143.509%",
    x2: "43.509%",
    y1: "24.431%",
    y2: "24.431%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bn",
    d: "M1.415 38.525l-.4-1.354C-3.34 20.895 6.806 5.384 22 1.14s31.505 3.56 35.854 19.832a33.03 33.03 0 0 1 .404 1.714h.05c.023.198.04.4.06.603.352 1.876.538 3.78.556 5.69l2.61 26.682c.514 5.284-1.488 9.94-4.593 14.493-1.56 2.34-3.43 4.46-5.557 6.297-1.08.9-2.213 1.732-3.394 2.492a10.75 10.75 0 0 1-.974.576c-.33.18-.652.34-.964.46-1.772.805-3.655 1.34-5.585 1.59a11.96 11.96 0 0 1-2.067.152c-.92.014-1.842-.04-2.756-.16-.78-.078-1.424-.17-1.787-.23a30.29 30.29 0 0 1-7.918-2.534c-4.95-2.303-8.992-5.27-11.174-10.09L1.438 38.534l-.023-.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bo",
    x1: "231.332%",
    x2: "253.775%",
    y1: "-91.748%",
    y2: "-12.614%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bp",
    x1: "231.53%",
    x2: "253.973%",
    y1: "-92.29%",
    y2: "-13.047%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bq",
    x1: "232.115%",
    x2: "254.559%",
    y1: "-92.48%",
    y2: "-13.274%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Br",
    x1: "232.451%",
    x2: "254.871%",
    y1: "-92.76%",
    y2: "-13.598%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bs",
    x1: "232.841%",
    x2: "255.273%",
    y1: "-93.127%",
    y2: "-13.884%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bt",
    x1: "233.19%",
    x2: "255.623%",
    y1: "-93.305%",
    y2: "-14.098%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bu",
    x1: "233.69%",
    x2: "256.133%",
    y1: "-93.813%",
    y2: "-14.606%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bv",
    x1: "234.077%",
    x2: "256.52%",
    y1: "-93.996%",
    y2: "-14.753%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bw",
    x1: "234.483%",
    x2: "256.913%",
    y1: "-94.141%",
    y2: "-14.979%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bx",
    x1: "231.947%",
    x2: "254.399%",
    y1: "-91.885%",
    y2: "-12.686%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "By",
    x1: "232.117%",
    x2: "254.561%",
    y1: "-91.849%",
    y2: "-12.679%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bz",
    x1: "232.504%",
    x2: "254.947%",
    y1: "-92.842%",
    y2: "-13.453%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CA",
    x1: "232.83%",
    x2: "255.262%",
    y1: "-92.766%",
    y2: "-13.523%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CB",
    x1: "233.24%",
    x2: "255.66%",
    y1: "-92.9%",
    y2: "-13.737%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CC",
    x1: "233.63%",
    x2: "256.055%",
    y1: "-92.958%",
    y2: "-13.905%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CD",
    x1: "234.079%",
    x2: "256.521%",
    y1: "-93.591%",
    y2: "-14.348%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CE",
    x1: "234.472%",
    x2: "256.915%",
    y1: "-93.781%",
    y2: "-14.574%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CF",
    x1: "231.846%",
    x2: "254.278%",
    y1: "-91.524%",
    y2: "-12.281%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CG",
    x1: "232.043%",
    x2: "254.476%",
    y1: "-91.76%",
    y2: "-12.554%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CH",
    x1: "232.395%",
    x2: "254.815%",
    y1: "-92.071%",
    y2: "-12.872%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CI",
    x1: "232.901%",
    x2: "255.345%",
    y1: "-92.349%",
    y2: "-13.106%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CJ",
    x1: "233.291%",
    x2: "255.735%",
    y1: "-92.723%",
    y2: "-13.516%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CK",
    x1: "233.678%",
    x2: "256.121%",
    y1: "-92.952%",
    y2: "-13.709%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CL",
    x1: "234.071%",
    x2: "256.515%",
    y1: "-93.23%",
    y2: "-13.987%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CM",
    x1: "234.363%",
    x2: "256.783%",
    y1: "-93.41%",
    y2: "-14.247%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CN",
    x1: "234.75%",
    x2: "257.182%",
    y1: "-94.044%",
    y2: "-14.692%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CO",
    x1: "231.999%",
    x2: "254.432%",
    y1: "-91.695%",
    y2: "-12.343%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CP",
    x1: "232.386%",
    x2: "254.818%",
    y1: "-91.71%",
    y2: "-12.467%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CQ",
    x1: "232.781%",
    x2: "255.214%",
    y1: "-91.636%",
    y2: "-12.538%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CR",
    x1: "233.293%",
    x2: "255.724%",
    y1: "-92.18%",
    y2: "-13.017%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CS",
    x1: "233.68%",
    x2: "256.111%",
    y1: "-92.547%",
    y2: "-13.348%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CT",
    x1: "234.027%",
    x2: "256.471%",
    y1: "-92.813%",
    y2: "-13.57%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CU",
    x1: "234.24%",
    x2: "256.662%",
    y1: "-93.137%",
    y2: "-13.894%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CV",
    x1: "234.739%",
    x2: "257.172%",
    y1: "-93.416%",
    y2: "-14.173%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CW",
    x1: "232.039%",
    x2: "254.476%",
    y1: "-90.983%",
    y2: "-11.776%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CX",
    x1: "232.499%",
    x2: "254.93%",
    y1: "-91.305%",
    y2: "-12.106%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CY",
    x1: "233.005%",
    x2: "255.459%",
    y1: "-91.457%",
    y2: "-12.323%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CZ",
    x1: "233.233%",
    x2: "255.676%",
    y1: "-91.807%",
    y2: "-12.601%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ca",
    x1: "233.559%",
    x2: "255.991%",
    y1: "-92.174%",
    y2: "-12.931%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cb",
    x1: "234.048%",
    x2: "256.481%",
    y1: "-92.629%",
    y2: "-13.313%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cc",
    x1: "234.398%",
    x2: "256.818%",
    y1: "-92.909%",
    y2: "-13.638%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cd",
    x1: "234.854%",
    x2: "257.297%",
    y1: "-93.011%",
    y2: "-13.768%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ce",
    x1: "235.201%",
    x2: "257.645%",
    y1: "-93.188%",
    y2: "-13.982%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cf",
    x1: "232.489%",
    x2: "254.932%",
    y1: "-90.944%",
    y2: "-11.701%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cg",
    x1: "233.074%",
    x2: "255.517%",
    y1: "-91.092%",
    y2: "-11.922%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ch",
    x1: "233.235%",
    x2: "255.666%",
    y1: "-91.402%",
    y2: "-12.24%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ci",
    x1: "233.561%",
    x2: "255.981%",
    y1: "-91.768%",
    y2: "-12.57%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cj",
    x1: "233.954%",
    x2: "256.387%",
    y1: "-91.916%",
    y2: "-12.746%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ck",
    x1: "234.34%",
    x2: "256.772%",
    y1: "-92.283%",
    y2: "-13.076%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cl",
    x1: "234.815%",
    x2: "257.255%",
    y1: "-92.65%",
    y2: "-13.407%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cm",
    x1: "235.191%",
    x2: "257.634%",
    y1: "-92.919%",
    y2: "-13.713%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cn",
    x1: "232.002%",
    x2: "254.39%",
    y1: "-90.443%",
    y2: "-11.317%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Co",
    x1: "232.774%",
    x2: "255.207%",
    y1: "-90.763%",
    y2: "-11.556%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cp",
    x1: "233.161%",
    x2: "255.593%",
    y1: "-91.129%",
    y2: "-11.886%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cq",
    x1: "233.412%",
    x2: "255.845%",
    y1: "-91.583%",
    y2: "-12.268%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cr",
    x1: "233.864%",
    x2: "256.307%",
    y1: "-91.82%",
    y2: "-12.54%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cs",
    x1: "234.409%",
    x2: "256.84%",
    y1: "-91.954%",
    y2: "-12.755%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ct",
    x1: "234.803%",
    x2: "257.246%",
    y1: "-92.232%",
    y2: "-12.989%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cu",
    x1: "235.193%",
    x2: "257.636%",
    y1: "-92.468%",
    y2: "-13.262%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cv",
    x1: "235.401%",
    x2: "257.823%",
    y1: "-92.835%",
    y2: "-13.592%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cw",
    x1: "232.827%",
    x2: "255.271%",
    y1: "-90.402%",
    y2: "-11.196%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cx",
    x1: "233.163%",
    x2: "255.582%",
    y1: "-90.724%",
    y2: "-11.525%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cy",
    x1: "233.558%",
    x2: "255.978%",
    y1: "-90.915%",
    y2: "-11.752%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cz",
    x1: "234.127%",
    x2: "256.581%",
    y1: "-91.315%",
    y2: "-12.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DA",
    x1: "234.399%",
    x2: "256.842%",
    y1: "-91.593%",
    y2: "-12.35%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DB",
    x1: "234.792%",
    x2: "257.235%",
    y1: "-91.917%",
    y2: "-12.674%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DC",
    x1: "235.291%",
    x2: "257.721%",
    y1: "-92.063%",
    y2: "-12.901%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DD",
    x1: "235.612%",
    x2: "258.032%",
    y1: "-92.43%",
    y2: "-13.231%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DE",
    x1: "232.761%",
    x2: "255.193%",
    y1: "-89.997%",
    y2: "-10.791%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DF",
    x1: "233.218%",
    x2: "255.661%",
    y1: "-90.351%",
    y2: "-11.108%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DG",
    x1: "233.611%",
    x2: "256.055%",
    y1: "-90.675%",
    y2: "-11.432%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DH",
    x1: "234.19%",
    x2: "256.633%",
    y1: "-90.866%",
    y2: "-11.659%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DI",
    x1: "234.4%",
    x2: "256.831%",
    y1: "-91.188%",
    y2: "-11.989%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DJ",
    x1: "234.729%",
    x2: "257.149%",
    y1: "-91.336%",
    y2: "-12.21%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DK",
    x1: "235.07%",
    x2: "257.502%",
    y1: "-91.691%",
    y2: "-12.484%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DL",
    x1: "235.458%",
    x2: "257.89%",
    y1: "-92.057%",
    y2: "-12.814%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DM",
    x1: "235.966%",
    x2: "258.409%",
    y1: "-92.247%",
    y2: "-13.04%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DN",
    x1: "233.094%",
    x2: "255.526%",
    y1: "-89.99%",
    y2: "-10.747%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DO",
    x1: "233.277%",
    x2: "255.676%",
    y1: "-90.183%",
    y2: "-11.02%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DP",
    x1: "234.101%",
    x2: "256.554%",
    y1: "-90.461%",
    y2: "-11.254%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DQ",
    x1: "234.39%",
    x2: "256.833%",
    y1: "-90.827%",
    y2: "-11.584%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DR",
    x1: "234.719%",
    x2: "257.151%",
    y1: "-90.976%",
    y2: "-11.805%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DS",
    x1: "234.867%",
    x2: "257.299%",
    y1: "-91.33%",
    y2: "-12.123%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DT",
    x1: "235.46%",
    x2: "257.879%",
    y1: "-91.652%",
    y2: "-12.453%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DU",
    x1: "235.968%",
    x2: "258.411%",
    y1: "-91.888%",
    y2: "-12.681%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DV",
    x1: "233.277%",
    x2: "255.731%",
    y1: "-89.585%",
    y2: "-10.342%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DW",
    x1: "233.667%",
    x2: "256.121%",
    y1: "-89.909%",
    y2: "-10.666%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DX",
    x1: "233.925%",
    x2: "256.357%",
    y1: "-90.187%",
    y2: "-10.944%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DY",
    x1: "234.285%",
    x2: "256.705%",
    y1: "-90.41%",
    y2: "-11.211%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DZ",
    x1: "234.677%",
    x2: "257.097%",
    y1: "-90.646%",
    y2: "-11.484%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Da",
    x1: "235.4%",
    x2: "257.865%",
    y1: "-91.012%",
    y2: "-11.769%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Db",
    x1: "235.567%",
    x2: "258.011%",
    y1: "-91.291%",
    y2: "-12.048%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dc",
    x1: "235.957%",
    x2: "258.401%",
    y1: "-91.527%",
    y2: "-12.32%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dd",
    x1: "236.407%",
    x2: "258.837%",
    y1: "-91.837%",
    y2: "-12.638%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "De",
    x1: "233.344%",
    x2: "255.75%",
    y1: "-89.504%",
    y2: "-10.305%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Df",
    x1: "233.927%",
    x2: "256.359%",
    y1: "-89.736%",
    y2: "-10.493%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dg",
    x1: "234.274%",
    x2: "256.707%",
    y1: "-90.049%",
    y2: "-10.806%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dh",
    x1: "234.666%",
    x2: "257.099%",
    y1: "-90.286%",
    y2: "-11.079%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Di",
    x1: "235.163%",
    x2: "257.606%",
    y1: "-90.564%",
    y2: "-11.357%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dj",
    x1: "235.569%",
    x2: "258%",
    y1: "-90.798%",
    y2: "-11.635%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dk",
    x1: "235.719%",
    x2: "258.162%",
    y1: "-91.21%",
    y2: "-11.967%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dl",
    x1: "236.3%",
    x2: "258.743%",
    y1: "-91.476%",
    y2: "-12.233%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#211e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#211e1f",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#211e1f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "Dm",
    d: "M952.003 741.563l3.863-53.948-6.704-85.917-42.99.947-3.015 86.14 8.747 53.674 7.776-.175 11.614-.25 10.766-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dn",
    d: "M803.068 671.792c-1.194-.124-2.1-1.13-2.1-2.33s.907-2.206 2.1-2.33c1.194.124 2.1 1.13 2.1 2.33s-.907 2.206-2.1 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Do",
    d: "M805.6 683.23c-.955.05-1.845-.484-2.248-1.35a2.34 2.34 0 0 1 .414-2.59c.654-.698 1.666-.928 2.558-.582a2.34 2.34 0 0 1 1.495 2.155 2.32 2.32 0 0 1-2.218 2.367z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dp",
    d: "M813.685 693.197c-1.288.066-2.387-.92-2.46-2.21s.9-2.39 2.197-2.47 2.395.9 2.48 2.185c.048.627-.16 1.247-.58 1.717a2.32 2.32 0 0 1-1.638.775z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dq",
    d: "M835.143 701.818a2.27 2.27 0 0 1-1.652-.637c-.442-.427-.69-1.016-.7-1.63-.013-1.263.997-2.298 2.26-2.317s2.303.988 2.325 2.25-.98 2.306-2.242 2.333z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dr",
    d: "M859.292 732.567c-.8.03-1.558-.433-1.892-1.172s-.186-1.606.372-2.194 1.417-.778 2.172-.483 1.256 1.02 1.266 1.83a1.97 1.97 0 0 1-1.919 2.018z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ds",
    d: "M891.392 762.095c-.49.007-.96-.18-1.31-.522s-.55-.808-.558-1.297a1.82 1.82 0 0 1 1.803-1.818 1.82 1.82 0 0 1 1.835 1.786 1.82 1.82 0 0 1-1.769 1.851z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dt",
    d: "M1009.897 714.55c-1.285.052-2.372-.942-2.435-2.227s.923-2.38 2.207-2.452 2.387.904 2.47 2.187a2.29 2.29 0 0 1-.58 1.733c-.425.472-1.028.747-1.663.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Du",
    d: "M830.607 672.44a2.27 2.27 0 0 1-1.636-.646c-.436-.427-.682-1.01-.682-1.62-.014-1.266 1.002-2.303 2.268-2.317s2.304 1 2.318 2.267-1 2.303-2.268 2.317z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dv",
    d: "M808.127 724.37c-1.285.052-2.372-.942-2.435-2.227s.923-2.38 2.207-2.452 2.387.904 2.47 2.187c.048.63-.165 1.255-.588 1.726a2.32 2.32 0 0 1-1.655.766z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dw",
    d: "M1040.776 627.687c-.65.03-1.25-.336-1.523-.925s-.16-1.285.285-1.76 1.132-.63 1.738-.396 1.01.812 1.02 1.46a1.57 1.57 0 0 1-1.52 1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dx",
    d: "M897.448 571.746a6.98 6.98 0 0 1-6.623-4.079c-1.175-2.578-.674-5.6 1.267-7.673a6.98 6.98 0 0 1 7.582-1.734c2.645 1.015 4.414 3.527 4.477 6.36a6.93 6.93 0 0 1-6.704 7.127z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dy",
    d: "M-4.504 36.957a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8-5.93-1.188a5.75 5.75 0 0 1-1.888-.731l1.408-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dz",
    d: "M6.278-19.063a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EA",
    d: "M15.832-26.138l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.193 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EB",
    d: "M5.816 9.936c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EC",
    d: "M13.385 39.86l-5.95-1.193c-4.417-.883-6.79 3.12-6.79 3.12s.715 4.624 5.132 5.502l5.945 1.193 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ED",
    d: "M14.913 31.857l-5.95-1.193c-4.417-.883-6.79 3.12-6.79 3.12s.715 4.624 5.128 5.502l5.95 1.193 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EE",
    d: "M24.153-16.16l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EF",
    d: "M19.012 37.16l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.66 4.29 4.758 5.11l5.935 1.188 1.537-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EG",
    d: "M14.138 19.914c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.542 8-5.93-1.188a5.58 5.58 0 0 1-1.892-.731l1.408-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EH",
    d: "M23.692 12.84l-5.945-1.193c-4.417-.883-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EI",
    d: "M17.22 3.907a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.93-1.188a5.65 5.65 0 0 1-1.888-.735l1.408-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EJ",
    d: "M23.235 41.835l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.188 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EK",
    d: "M23.175 42.15l-5.93-1.188c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.286 4.763 5.11l5.93 1.188 1.542-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EL",
    d: "M27.795 18.14l-5.93-1.188c-4.098-.823-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EM",
    d: "M32.475-6.182l-5.95-1.188c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EN",
    d: "M35.54-22.194l-5.945-1.188c-4.417-.888-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EO",
    d: "M22.464 29.892a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.93-1.188c-.67-.13-1.3-.38-1.892-.735l1.412-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EP",
    d: "M35.078 6.81l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.502l5.945 1.193 1.662-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EQ",
    d: "M36.578-.88l-5.935-1.188c-4.094-.823-6.3 2.9-6.3 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.542-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ER",
    d: "M31.704-18.125a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8-5.93-1.188c-.67-.125-1.31-.373-1.888-.73l1.408-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ES",
    d: "M36.176 27.807l-5.95-1.193c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ET",
    d: "M36.116 28.116l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.11l5.935 1.188 1.537-8.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EU",
    d: "M37.658 20.113l-5.93-1.188c-4.098-.818-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.542-8.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EV",
    d: "M35.867-13.136c.67-.104 1.353-.087 2.017.05l5.935 1.188-1.542 8-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.412-7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EW",
    d: "M55.902 31.76l-5.95-1.193c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.618z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EX",
    d: "M75.327 123.35h-2.215c-1.643 0-2.215 1.616-2.215 1.616s.577 1.607 2.22 1.607h2.2v-3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EY",
    d: "M75.327 123.35h-2.38c-1.643 0-2.215 1.616-2.215 1.616s.577 1.607 2.22 1.607h2.375v-3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EZ",
    d: "M90.886 123.35H88.67c-1.643 0-2.215 1.616-2.215 1.616s.577 1.607 2.22 1.607h2.2v-3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ea",
    d: "M96.835 121.97H94.62c-1.643 0-2.215 1.616-2.215 1.616s.577 1.607 2.22 1.607h2.2v-3.222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eb",
    d: "M93.632 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ec",
    d: "M75.792 82.335l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.182l-1.607-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ed",
    d: "M76.095 82.252l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.524 2.38-6.66l-1.598-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ee",
    d: "M68.348 84.413l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.53 2.38-6.66l-1.598-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ef",
    d: "M60.297 86.66l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.563-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eg",
    d: "M60.6 86.578l1.598 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.5-2.53 2.384-6.66l-1.603-5.99-7.743 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eh",
    d: "M63.057 94.442a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.743-2.165 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ei",
    d: "M52.55 88.83l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.76-2.723 2.567-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ej",
    d: "M52.848 88.74l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.524 2.384-6.66l-1.603-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ek",
    d: "M44.8 90.982l1.603 5.99c1.194 4.46 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.177l-1.603-5.99-8.35 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "El",
    d: "M45.104 90.9l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.66l-1.603-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Em",
    d: "M37.054 93.147l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.607-5.99-8.345 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "En",
    d: "M37.352 93.064l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.38-6.66l-1.598-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eo",
    d: "M39.81 100.928c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.165 1.598 5.99c.186.67.255 1.37.202 2.064l-7.09 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ep",
    d: "M29.604 95.225l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.524 2.38-6.66l-1.598-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eq",
    d: "M32.06 103.112a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Er",
    d: "M21.554 97.468l1.607 5.99c1.19 4.46 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.177l-1.607-5.99-8.35 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Es",
    d: "M14.11 99.55l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.53 2.38-6.66l-1.603-5.99-7.743 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Et",
    d: "M55.093 82.764l1.603 5.99c1.194 4.455 5.787 4.85 5.787 4.85s3.757-2.723 2.563-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eu",
    d: "M55.396 82.68l1.598 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.5-2.524 2.384-6.66l-1.603-5.99-7.743 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ev",
    d: "M31.85 89.25l1.603 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.182l-1.607-5.99-8.345 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ew",
    d: "M26.858 99.196c-.392-.573-.682-1.208-.86-1.88l-1.598-5.99 7.748-2.16 1.598 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ex",
    d: "M65.385 74.55l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ey",
    d: "M57.638 76.706l1.603 5.99c1.194 4.46 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.177l-1.607-5.99-8.345 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ez",
    d: "M57.936 76.623l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.38-6.666l-1.598-5.99-7.748 2.165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FA",
    d: "M44.898 88.83a6.14 6.14 0 0 1-.859-1.884l-1.598-5.99 7.748-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FB",
    d: "M34.4 83.192l1.607 5.99c1.19 4.46 5.782 4.85 5.782 4.85s3.757-2.723 2.563-7.177l-1.603-5.99-8.35 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FC",
    d: "M37.15 90.977c-.393-.572-.683-1.208-.86-1.88l-1.598-5.99 7.743-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FD",
    d: "M29.402 93.138a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.743-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FE",
    d: "M21.655 95.303c-.394-.573-.685-1.2-.86-1.884l-1.603-5.99 7.748-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FF",
    d: "M11.445 89.595l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99-7.748 2.165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FG",
    d: "M62.937 78.433a6 6 0 0 1-.854-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.09 1.972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FH",
    d: "M37.237 77.05l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.53 2.38-6.666l-1.598-5.99-7.748 2.165z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FI",
    d: "M39.694 84.92c-.39-.573-.68-1.21-.86-1.88l-1.598-5.99 7.748-2.16 1.598 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FJ",
    d: "M70.772 62.347l1.603 5.99c1.102 4.146 5.364 4.505 5.364 4.505s3.486-2.53 2.38-6.666l-1.598-5.99-7.748 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FK",
    d: "M47.226 68.916l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.563-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FL",
    d: "M39.478 71.076l1.603 5.99c1.194 4.46 5.782 4.85 5.782 4.85s3.76-2.723 2.567-7.177l-1.603-5.99-8.35 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FM",
    d: "M8.483 79.728l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.607-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FN",
    d: "M11.243 87.51c-.392-.573-.682-1.208-.86-1.88l-1.598-5.99 7.748-2.165 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FO",
    d: "M52.53 70.643c-.393-.573-.684-1.21-.86-1.884l-1.598-5.99 7.743-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FP",
    d: "M34.275 67.18l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FQ",
    d: "M26.527 69.344l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.182l-1.607-5.99-8.345 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FR",
    d: "M29.283 77.13a6 6 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.598 5.99c.187.672.255 1.372.202 2.068l-7.09 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FS",
    d: "M18.78 71.51l1.603 5.99c1.19 4.46 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.177l-1.607-5.99-8.345 2.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FT",
    d: "M16.332 75.397c-.393-.574-.683-1.21-.86-1.884l-1.598-5.99 7.743-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FU",
    d: "M42.206 48.927l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.524 2.38-6.66l-1.603-5.99-7.743 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FV",
    d: "M36.916 58.956a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.743-2.16 1.603 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FW",
    d: "M26.408 53.36l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.76-2.727 2.567-7.182l-1.603-5.99-8.35 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FX",
    d: "M21.416 63.282a6 6 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.09 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FY",
    d: "M13.668 65.442c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.598 5.99a5.98 5.98 0 0 1 .202 2.064l-7.09 1.976z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FZ",
    d: "M34.252 49.005a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.598 5.99c.186.67.255 1.37.202 2.064l-7.09 1.98z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-61)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1c1d",
    d: "M132.923 155.548h1088.853v656.106H132.923z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M61.213.81h1294v726h-1294z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#45bde6",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.356 282.2L414.28 432.28h21.458l25.894-41.015h25.546l-2.916 11.138 21.557-18.34-11.638-20.208-2.916 11.04H472.4l31.377-49.313-8.623 34.312 12.7 22.326L533.3 282.2zM482.42 409.73h18.218l6.056-22.925-23.502 20.184zm52.335-.125l34.343-89.98H552.4l-14.878 42.386 6.255-42.386h-16.274l-10.368 90.104h7.925v-.125zm41.197-89.98l-33.92 89.98h16.474l5.782-16.122h10.467l-2.492 16.122h16.175l10.642-89.98h-23.128zm.648 60.35h-7.85l14.106-41.14-6.255 41.14zm55.053 12.634h-17.695l18.667-72.985h-17.37l-23.053 89.98h33.87zm21.01.873h10.517l-2.492 16.122h16.175l10.642-89.98h-23.178l-33.92 89.98h16.5l5.757-16.122zm18.542-54.645l-6.255 41.14h-7.875l14.13-41.14zm33.97 34.935l1.396 35.832h13.084l23.028-89.98h-15.726l-8.947 34.836-.548-34.836h-13.907l-23.078 89.98h15.377zm61 18.837H748.2c-2.293 0-3.1-1.32-2.368-3.962l13.26-51.78c.117-.833.492-1.608 1.072-2.218a3.19 3.19 0 0 1 1.944-.498h5.284l-4.312 17.094 15.75-4.2 7.003-27.4h-30.08a11.59 11.59 0 0 0-6.53 1.67 11.06 11.06 0 0 0-3.788 6.753l-16.698 65.186c-.736 2.42-.973 4.962-.698 7.475a10.69 10.69 0 0 0 2.044 4.984 9.13 9.13 0 0 0 3.938 2.9 12.91 12.91 0 0 0 3.414.822h22.953l5.807-16.795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.797 371.68h8.2l-9.695 37.925h16.175l23.053-89.98h-16.175l-9.27 36.057h-8.2l9.17-36.057H790.88l-23.078 89.98h16.2zM849.2 392.6h-14.98l5.384-20.93h14.13l4.113-15.997h-14.13l5.06-19.835h14.455l4.187-16.222h-30.83l-23.028 89.98h30.305zm26.416-21.304h5.408c.997 0 1.595.324 1.77.997.186.685.186 1.408 0 2.093l-9.022 35.2h16.2l8.374-32.717a9.96 9.96 0 0 0 0-7.2c-.58-1.326-1.723-2.323-3.115-2.716a6.43 6.43 0 0 0 4.685-1.67c1.038-1 1.794-2.272 2.193-3.663l7.8-30.6c.826-2.633.593-5.484-.648-7.95-1.475-2.456-4.26-3.813-7.103-3.464h-29.633l-23.078 89.98h16.274l9.894-38.3zm9.495-37.178h4.984c2.318 0 3.14 1.246 2.492 3.713l-4.312 16.745a4.66 4.66 0 0 1-1.57 2.766 3.79 3.79 0 0 1-2.218.698h-5.607l6.23-23.92zm43.938 74.23a6.21 6.21 0 0 0 2.966-4.087l8.947-34.885a17.44 17.44 0 0 0 .648-5.681 8.22 8.22 0 0 0-1.246-3.862 6.36 6.36 0 0 0-2.74-2.218 9.74 9.74 0 0 0-3.888-.748h-8.748l4.66-18.34a3.59 3.59 0 0 1 1.221-2.043 2.94 2.94 0 0 1 1.67-.573h14.23l4.212-16.222h-25.12a11.59 11.59 0 0 0-5.558 1.42 9.77 9.77 0 0 0-4.037 6.13l-8.947 34.885c-.83 2.6-.75 5.385.224 7.924.93 1.993 3.124 3 6.58 3h8.623c.498 0 .773 0 .847.3a1.42 1.42 0 0 1 0 .922l-3.763 15.25c-.216.907-.624 1.756-1.196 2.492a4.26 4.26 0 0 1-2.916.673h-13.583l-4.386 16.994H925.6a9.78 9.78 0 0 0 3.44-1.32zm-495.53-6.153l-30.156 47.27h23.128l35.3-58.034-4.262-4.9-16.423 13.282zm-17.843-16.97c-.263-42.924 31.2-79.457 73.695-85.57l4.984-7.974c-48 3.165-85.982 43.906-85.982 93.542a94.66 94.66 0 0 0 5.807 32.792l4.984-7.974a87.74 87.74 0 0 1-3.49-24.818z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "B"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M1180.863 391.065a91.81 91.81 0 0 1 8.424 40.292v1.694c-.43 11.52-3.052 22.852-7.726 33.4-4.443 9.89-10.602 18.918-18.193 26.662l-1.097 1.096c-34.132 33.48-88.88 33.18-122.642-.673a88.71 88.71 0 0 1-13.358-16.994c-.3-.473-.573-.947-.847-1.42a90.39 90.39 0 0 1-11.838-36.081c-.125-1.196-.224-2.492-.3-3.613a92.43 92.43 0 0 1 .648-18.614 83.96 83.96 0 0 1 1.645-8.647c0-.473.2-.947.35-1.42 2.05-8.1 5.24-15.87 9.47-23.074l.897-1.52 2.492-4.037c.3-.4.573-.822.847-1.22 14.52-20.567 37.175-33.908 62.206-36.63a86.42 86.42 0 0 1 43.414 6.404c.698.3 1.396.598 2.044.922a84.74 84.74 0 0 1 9.969 5.382l1.794 1.17a88.17 88.17 0 0 1 16.748 14.303l.997 1.12a90.65 90.65 0 0 1 11.041 15.574c1.047 1.92 2.07 3.887 3.016 5.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0f24",
    d: "M1045.012 409.13c.847 3.214 14.953 2.69 15.527-1.72s-17.32-5.083-15.527 1.72zm8.648 7.475c1.62 2.068 4.287.748 4.087-.45s-5.782-1.694-4.087.45zm80.35-4.984c1.545-4.984 3.938-3.812 5.508-2.492s-5.98 3.962-5.508 2.492zm-12.262-27.66c1.545-4.984 3.938-3.812 5.533-2.492s-5.907 4.037-5.533 2.492zm-.224 109.016c1.545-4.984 3.938-3.812 5.533-2.492s-6.006 4.037-5.533 2.492zm33.022-78.442c1.22 1.47 4.212.3 3.1-1.495s-5.134-.997-3.1 1.495zm-93.184-38c1.196 1.47 4.212.3 3.1-1.495s-5.01-.997-3.1 1.495z",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66c8c9",
    d: "M1170.42 456.85c1.396-.3 7.477.45 8.45 3.24s-10.99 6.105-11.813 3.464a6.03 6.03 0 0 1 3.364-6.703zm-82.792-95.984c.947 1.12 3.215 6.753 1.37 9.095s-10.617-6.778-8.748-8.77a5.81 5.81 0 0 1 7.377-.324z",
    style: {
      mixBlendMode: "soft-light"
    },
    className: "O"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M1166.783 412.52c.853 1.832 1.392 3.795 1.595 5.806.062.77.062 1.546 0 2.317v.35a18.46 18.46 0 0 1-1.57 6.728 16.42 16.42 0 0 1-.947 1.869 18.64 18.64 0 0 1-2.717 3.513l-.224.224a17.62 17.62 0 0 1-24.723 0c-1.033-1.024-1.937-2.17-2.692-3.414a1.87 1.87 0 0 1-.174-.299 18.19 18.19 0 0 1-2.368-7.251v-.723a17.14 17.14 0 0 1 .125-3.763c0-.598.2-1.17.324-1.744v-.3c.416-1.628 1.062-3.19 1.92-4.635a1.87 1.87 0 0 1 .174-.299l.523-.822a1.52 1.52 0 0 1 .174-.249c2.887-4.166 7.426-6.89 12.46-7.475a17.2 17.2 0 0 1 8.748 1.296l.424.174c.694.326 1.368.692 2.02 1.096l.374.224a18.59 18.59 0 0 1 3.364 2.89l.2.224a18.34 18.34 0 0 1 2.218 3.14c.374.224.598.723.773 1.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1c0f24",
    d: "M1139.393 416.133c.174.648 3.016.548 3.14-.324s-3.49-1.022-3.14.324zm1.745 1.52c.324.424.872.15.822 0s-1.146-.424-.822 0zm16.2-1.047c.324-.997.798-.772 1.12-.498s-1.22.847-1.12.498zm-2.442-5.507c.3-.997.798-.772 1.12-.498s-1.22.797-1.12.498zm-.075 21.978c.324-.997.798-.772 1.12-.523s-1.22.822-1.12.523zm6.654-15.823c.25.3.847 0 .623-.3s-1.022-.2-.623.3zm-18.79-7.65c.25.274.872 0 .623-.324s-1.022-.15-.623.324z",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66c8c9",
    d: "M1164.69 425.777c.274 0 1.47 0 1.695.648s-2.218 1.246-2.492.723a1.22 1.22 0 0 1 .798-1.37zm-16.698-19.336c.2.224.648 1.346.274 1.82s-2.143-1.346-1.77-1.77a1.17 1.17 0 0 1 1.495-.05z",
    style: {
      mixBlendMode: "soft-light"
    },
    className: "O"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#4dc4f1",
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M993.075 284.9a8.65 8.65 0 0 0-3.564-2.492c-.213-.05-.435-.05-.648 0-.47.156-.827.54-.947 1.022-.402 1.237-.16 2.593.648 3.613a2.84 2.84 0 0 0 2.941.972 2.17 2.17 0 0 0 1.421-1.121 1.82 1.82 0 0 0-.15-1.969.4.4 0 0 0-.15.548l.45-.573zm-93.134-36.306a7.48 7.48 0 0 0-3.988 1.196c-.216.115-.403.277-.548.473-.212.484-.212 1.036 0 1.52.274 1.173 1.29 2.025 2.492 2.093 1.155-.073 2.177-.77 2.667-1.82.365-.615.514-1.334.424-2.043 0-.698-.623-1.346-1.196-1.296a.35.35 0 0 0 .199.523l-.05-.648zm93.583 43.955a1.97 1.97 0 0 0-2.243-.473c-.164.952.06 1.93.623 2.716.243.344.638.55 1.06.55s.816-.205 1.06-.55c.474-.772 0-2.193-.798-2.093l.3-.15zm1.12-13.705a2.12 2.12 0 0 0-.798 0s.374.623.25.947 0 0 0 .174.125 0 .224 0c.45-.26.625-.826.4-1.296h.125l-.2.174zm-1.022-10.914a3.89 3.89 0 0 0-1.52 0 .25.25 0 0 0-.174 0c-.012.074-.012.15 0 .224 0 .673.698 1.22.474 1.794-.014.108-.014.216 0 .324 0 .2.25.224.4.174.88-.493 1.22-1.588.773-2.492h.2l-.15-.025zm12.86-7.675c-.503-.086-1.017-.086-1.52 0-.057-.02-.118-.02-.174 0-.027.072-.027.152 0 .224 0 .648.698 1.196.474 1.794a.5.5 0 0 0 0 .324c0 .2.224.224.4.174.87-.5 1.2-1.594.748-2.492h.224l-.15-.025zm-23.6 26.338c-.276-.27-.68-.366-1.047-.25.01.2.062.394.15.573 0 .174.25.3.424.25s.3-.374.374-.648v.2l.1-.125zm-74.567-14.253h-.274c-.067.096-.1.207-.125.324-.065.328-.15.653-.25.972l1.22-.772c.125 0 .174.174.3.25s.35 0 .474-.224c.947-1.146-.773-.598-1.346-.548zm67.215-10.54c-.094-.05-.205-.05-.3 0a.4.4 0 0 0-.174.274 9.27 9.27 0 0 1-.474.847l1.346-.324.25.35c.1.125.35 0 .498 0 1.196-.822-.598-.997-1.146-1.146zm-56.274-23.323h-.374c0 .324.25.623.498.648.15-.013.284-.096.363-.224s.092-.285.036-.424c0-.174-.3-.4-.15-.498l-.374.498zm64.524 15.823a.82.82 0 0 1 0 1.171c-.324.224-.798 0-.822-.548s.45-.847.773-.648l.05.025zm3.838 19.162c.274-.15.648-.25.798 0a.87.87 0 0 1-.274.922.35.35 0 0 1-.324.199c-.274-.125 0-.797-.3-.972s.15-.15.174 0l-.075-.15zm-.698 15.474c.105-.038.22-.038.324 0-.13.288-.408.48-.723.498-.15 0-.35 0-.424-.125a2.19 2.19 0 0 1 0-.424c0-.25-.274-.523-.15-.772a.25.25 0 0 1 .349 0 1.87 1.87 0 0 1 .274.324l.474.822-.125-.324zm1.27 5.183c-.2-.125-.424.274-.3.523.108.233.32.4.573.45.128-.375.052-.8-.2-1.096l-.075.125zm23.277 6.753a.75.75 0 0 0-.324 0c-.132.03-.232.14-.25.274 0 .224.174.4.224.598s0 .498 0 .698a.3.3 0 0 0 .498 0 1.42 1.42 0 0 0 .125-.673 1.47 1.47 0 0 0-.125-.573c0-.174-.274-.3-.424-.2l.274-.125zm-61.982-1.545a.3.3 0 0 1 0 .374.4.4 0 0 1-.274.174h-.2a.4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086a.45.45 0 0 1 0 .498l.075-.573zm29.31 11.91c.084.1.084.248 0 .35a.4.4 0 0 1-.274.174.3.3 0 0 1-.199 0 .4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086a.45.45 0 0 1 0 .498l.075-.548zm4.76-20.433c0-.274-.174-.573-.374-.498a.92.92 0 0 0 0 .449.25.25 0 0 0 .274.224c.1-.025.224-.2.15-.324l-.05.15zm-6.13-17.99c0-.274-.174-.573-.4-.473a.82.82 0 0 0 0 .424c0 .15.174.274.274.25a.25.25 0 0 0 0-.349l.125.15zm7.252 11.736c-.132-.27-.398-.45-.698-.473v.847c-.026.123-.026.25 0 .374.06.094.163.15.274.15s.215-.057.274-.15a.82.82 0 0 0 0-.723l.15-.025zm32.972-37.228l1.22-.174c0 .224-.15.45-.35.548-.193.073-.405.073-.598 0a.5.5 0 0 1-.299-.573l.025.2zm-6.928 5.108a.4.4 0 0 0-.723-.174c-.2.31-.2.7 0 1.022a.45.45 0 0 0 .349.224c.2 0 .35-.2.424-.45a2.49 2.49 0 0 0 0-.748l-.05.125zm-24.798 21.654a.75.75 0 0 0-.623-.623c-.075.235-.075.488 0 .723 0 .324.324.598.598.548s.374-.598 0-.748l.025.1zm2.07 2.492c.17.148.24.382.174.598h-.623c0-.324 0-.797.324-.847l.125.25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M993.922 279.558h.224c.04.23.04.467 0 .698 0 .224-.3.374-.474.324a.4.4 0 0 1-.174-.548c.128-.17.314-.285.523-.324l-.1-.15zm-8.35 16.047c.135.138.19.335.15.523a.5.5 0 0 1-.324.399.2.2 0 0 1-.249-.199.35.35 0 0 1 0-.15l.324-.648.1.075zm-3.39 2.218c0 .25.274.374.45.424s.45 0 .498.35c.025.064.025.135 0 .2 0 .15-.25 0-.4 0h-.324a.65.65 0 0 1-.648-.473c-.008-.17.078-.333.224-.424a.35.35 0 0 1 .399 0l-.2-.075zm-1.42 1.67l-.15.224c.048.13.193.198.324.15s.198-.193.15-.324c0-.15-.224-.2-.3 0l-.025-.05zm2.143 6.23l-.15.224a.3.3 0 0 0 .324.199c.13-.075.193-.23.15-.374a.2.2 0 0 0-.324 0v-.05zm.698-17.02c.125 0 .3 0 .324-.25a2.02 2.02 0 0 0 0-.548c.018-.186.097-.362.224-.498h.25c.06.042.104.104.125.174.178.313.28.663.3 1.022s-.15.7-.45.897c-.17.13-.404.13-.573 0-.178-.175-.254-.43-.2-.673v-.125zm-88.922-77.794c0 .125.274 0 .324-.224a4.41 4.41 0 0 0 0-.573c.013-.18.093-.35.224-.473 0 0 .174-.125.25 0a.3.3 0 0 1 .125.174c.188.308.29.66.3 1.022.023.358-.15.7-.45.897-.197.096-.434.045-.573-.125-.167-.18-.24-.43-.2-.673v-.025zm-5.26 77.92c.125 0 .3 0 .324-.25s0-.374 0-.548c.007-.19.087-.368.224-.498a.2.2 0 0 1 .249 0v.15a2.49 2.49 0 0 1 .274 1.047 1.02 1.02 0 0 1-.424.897.55.55 0 0 1-.598-.125.97.97 0 0 1-.199-.698l.15.025zm79.203-17.542c.125 0 .3 0 .324-.25.012-.19.012-.382 0-.573a.77.77 0 0 1 .224-.473.2.2 0 0 1 .249 0c.054.038.097.1.125.15a2.49 2.49 0 0 1 .299 1.047 1.02 1.02 0 0 1-.449.897.55.55 0 0 1-.573 0c-.175-.187-.25-.447-.2-.698v-.1zm-20.312-11.836s.3 0 .324-.25c.012-.183.012-.366 0-.548a.77.77 0 0 1 .224-.498c.08-.062.193-.062.274 0v.15a2.49 2.49 0 0 1 .274 1.047 1.02 1.02 0 0 1-.424.897.6.6 0 0 1-.598 0 .97.97 0 0 1-.199-.698l.125-.1zm32.748 25.39c-.062-.074-.153-.117-.25-.117s-.188.043-.25.117a.7.7 0 0 0-.15.623s0 .224.15.224 0 0 .15-.125l.424-.673-.075-.05zm71.253-18.1a2.89 2.89 0 0 0-.224-1.719s0-.174-.2-.2-.25.25-.35.45-.523.473-.673.822a1.72 1.72 0 0 0 0 .947c0 .45.25 1.047.623.997s.324-.224.45-.424c.23-.434.406-.894.523-1.37l-.15.498zm-91.69-29.727c.117-.6.038-1.203-.224-1.744 0 0 0-.174-.174-.2s-.274.274-.35.473-.523.45-.698.797c-.087.3-.087.637 0 .947 0 .45.224 1.047.598.997s.35-.224.45-.424c.25-.424.428-.887.523-1.37l-.125.523zm25.844 27.11c.174-.3 0-.673-.374-.872s-.324-.224-.498-.15-.25.523-.224.822v.797a.45.45 0 0 0 0 .324c.078.04.17.04.25 0 .422-.137.81-.357 1.146-.648l-.3-.274zm6.405 8.77c1.794-2.367-.623-4.7-2.492-3.2s.947 5.258 2.492 3.2zm-.374-16.52c1.794-2.492-.623-4.734-2.492-3.2s.947 5.258 2.492 3.2zm-2.293 34.536a.82.82 0 0 1-.424 1.096c-.144-.338-.204-.705-.174-1.07 0-.35.35-.673.623-.548l.25.573-.274-.05zm-5.807-77.87c0-.224-.224 0-.274.125-.024.282-.024.565 0 .847 0 .623 0 1.27.2 1.894a1.82 1.82 0 0 0 .224.947c0 .125.224 0 .274-.3.026-.298.026-.6 0-.897a6.23 6.23 0 0 0-.548-2.766l-.125.498.25-.35zm-.474 87.338h.224c.024.107.024.217 0 .324.01.074.01.15 0 .224a.25.25 0 0 1-.374 0c-.126-.123-.183-.3-.15-.473-.025-.064-.025-.135 0-.2a.15.15 0 0 1 .199 0l.1.125zm-2.368-8.746h-.25c-.038.147-.038.3 0 .45a.15.15 0 0 0 .15.15.15.15 0 0 0 .15-.15c.012-.05.012-.1 0-.15v-.548l-.05.25zm-13.383-6.03a1.22 1.22 0 0 0-.573-.199c-.213-.01-.407.122-.474.324a.5.5 0 0 0 0 .374c.02.157.112.297.247.38s.3.1.45.044c.295-.194.426-.56.324-.897l.025-.025zm-32.548-18.315a1.12 1.12 0 0 0-.548-.199c-.222-.023-.43.112-.498.324-.025.123-.025.25 0 .374.035.155.132.288.27.37s.3.1.453.055a.75.75 0 0 0 .299-.897l.025-.025zm42.193 1.62c.274 0 .573.3.45.623-.122.1-.268.17-.424.2a1.07 1.07 0 0 1 0-.623l-.025-.2zm-254.63-78.143c.274 0 .573.3.45.623-.122.1-.268.17-.424.2a1.07 1.07 0 0 1 0-.623l-.025-.2zm272.3 101.84h-.4c-.026.132-.026.267 0 .4a.4.4 0 0 0 .449-.374l-.05-.025zm-102.854-33.79a8.8 8.8 0 0 0-3.564-2.492c-.22-.06-.453-.06-.673 0a1.42 1.42 0 0 0-.922.797 3.96 3.96 0 0 0 .623 3.613c.706.87 1.855 1.25 2.94.972.617-.157 1.14-.563 1.445-1.12a1.87 1.87 0 0 0-.174-1.969c-.174 0-.25.374-.125.523l.45-.324zm-76.387-27.186c-.968-1.108-2.19-1.963-3.564-2.492a1.22 1.22 0 0 0-.648 0c-.45 0-.773.523-.947.997a4.01 4.01 0 0 0 .623 3.638 2.89 2.89 0 0 0 2.941.947c.618-.14 1.145-.54 1.445-1.096.322-.64.264-1.407-.15-1.993-.1.047-.172.134-.2.24s-.01.218.052.31l.45-.548zm50.193 67.503a1.97 1.97 0 0 0-2.243-.473 3.66 3.66 0 0 0 .623 2.741c.243.344.638.55 1.06.55s.816-.205 1.06-.55c.474-.772 0-2.218-.798-2.118l.3-.15zm-10.642-5.955c-.276-.27-.68-.366-1.047-.25.008.2.06.395.15.573 0 .174.25.3.424.25s.3-.374.374-.648v.2l.1-.125zm-2.093 2.068c-.096-.036-.203-.036-.3 0-.1.073-.17.18-.2.3-.125.295-.275.578-.45.847l1.346-.324c.125 0 .15.25.25.35s.35 0 .498 0c1.196-.972-.598-1.047-1.146-1.17zm6.13.3c.113-.036.235-.036.35 0-.142.288-.427.478-.748.498-.122.105-.302.105-.424 0a2.19 2.19 0 0 1 0-.399c0-.274-.274-.548-.15-.772a.25.25 0 0 1 .349 0 1.17 1.17 0 0 1 .274.324l.474.847-.125-.498zm1.27 5.183c-.2-.15-.424.25-.3.523a.82.82 0 0 0 .573.424c.128-.375.052-.8-.2-1.096l-.075.15zm23.277 6.728h-.324c-.132.03-.232.14-.25.274 0 .224.174.4.224.623s0 .498 0 .673.35 0 .474 0a1.37 1.37 0 0 0 .125-.648c0-.206-.042-.41-.125-.598-.028-.084-.09-.153-.17-.2s-.172-.04-.254-.01l.3-.125zm-28.062-8.248c.08.112.08.262 0 .374a.35.35 0 0 1-.299.15h-.174a.35.35 0 0 1 0-.473.25.25 0 0 1 .374 0 .45.45 0 0 1 .125.473l-.025-.523zm-4.61 18.614c.084.1.084.248 0 .35a.3.3 0 0 1-.274.174.3.3 0 0 1-.199 0c-.1-.133-.1-.316 0-.45.03-.074.094-.13.17-.154s.16-.013.228.03a.45.45 0 0 1 0 .498l.075-.45zm4.76-20.433c0-.274-.174-.573-.374-.473a.82.82 0 0 0 0 .424c0 .15.174.274.274.25a.25.25 0 0 0 .15-.349l-.05.15zm1.097-6.304a.87.87 0 0 0-.698-.498v.847c-.026.123-.026.25 0 .374.06.094.163.15.274.15s.215-.057.274-.15c.124-.225.124-.498 0-.723h.15zm.922 11.113a.6.6 0 0 1 .15.548.45.45 0 0 1-.324.374.2.2 0 0 1-.249-.199.35.35 0 0 1 0-.15l.324-.648.1.075zm-3.414 2.268c0 .25.274.374.474.424s.424 0 .474.374c.025.064.025.135 0 .2 0 .125-.25 0-.4 0a1.42 1.42 0 0 0-.324 0 .65.65 0 0 1-.648-.473.45.45 0 0 1 .224-.399c.117-.09.282-.09.4 0l-.2-.125zm-1.396 1.67l-.15.224c0 .15.2.25.324.2a.3.3 0 0 0 .15-.374c0-.15-.224-.2-.3 0l-.025-.05zm2.143 6.18l-.15.224a.3.3 0 0 0 .324.199.3.3 0 0 0 .15-.374c-.026-.066-.09-.1-.162-.1s-.136.043-.162.1v-.05zm.698-17.02c.125 0 .3 0 .324-.224.025-.2.025-.383 0-.573.013-.18.093-.35.224-.473 0 0 .174-.125.25 0a.45.45 0 0 1 .125.174 2.49 2.49 0 0 1 .299 1.022c.023.358-.15.7-.45.897a.5.5 0 0 1-.573 0 .87.87 0 0 1-.199-.698v-.125zm-2.542-3.837a.3.3 0 0 0-.498 0c-.148.18-.204.42-.15.648 0 0 0 .2.15.2s0 0 .15-.125l.424-.673-.075-.05zm9.146 6.055a.82.82 0 0 1-.424 1.096c-.146-.337-.206-.705-.174-1.07 0-.35.374-.673.648-.548l.224.573-.274-.05zm-6.28 9.444h.224c.025.107.025.217 0 .324.01.074.01.15 0 .224a.25.25 0 0 1-.374 0c-.126-.112-.183-.283-.15-.45a.3.3 0 0 1 0-.224c.024-.03.06-.05.1-.05s.076.018.1.05l.1.125zm-2.368-8.72h-.25a.92.92 0 0 0 0 .449.15.15 0 0 0 .15.15.15.15 0 0 0 .15-.15c.012-.058.012-.117 0-.174v-.548l-.05.274zm32.997-51.904a1.97 1.97 0 0 0-2.243-.473c-.164.952.06 1.93.623 2.716.243.344.638.55 1.06.55s.816-.205 1.06-.55c.474-.772 0-2.193-.798-2.093l.3-.15zm-14.455 29.104h-.3c-.093.07-.162.165-.2.274-.125.295-.275.578-.45.847l1.346-.324c.125 0 .15.224.224.35s.35 0 .523 0c1.196-.922-.598-.997-1.146-1.146zm7.402 5.482c-.2 0-.424.274-.324.523.134.2.337.37.573.45a1.12 1.12 0 0 0-.174-1.121l-.075.15zm-4.785-1.37a.35.35 0 0 1 0 .349c-.077.1-.182.152-.3.174a.2.2 0 0 1-.174 0c-.092-.047-.16-.13-.188-.23s-.014-.205.038-.294c.052-.055.124-.086.2-.086s.148.03.2.086a.45.45 0 0 1 0 .498l.224-.498zm-4.61 18.464a.3.3 0 0 1 0 .374c-.06.093-.163.15-.274.15-.064.025-.135.025-.2 0a.4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086c.085.146.085.327 0 .473l.075-.523zm4.76-20.408c0-.274-.174-.598-.4-.498a.92.92 0 0 0 0 .449c0 .15.15.25.274.224.064-.02.115-.07.14-.132s.02-.133-.014-.19v.15zm2.02 4.81a.55.55 0 0 1 .15.523c-.016.18-.147.332-.324.374a.2.2 0 0 1-.249-.174.35.35 0 0 1 0-.15l.324-.648.1.075zm-3.364 2.118c.042.224.223.395.45.424.216.022.404.154.498.35.025.064.025.135 0 .2 0 .15-.274 0-.4 0-.115-.024-.234-.024-.35 0a.65.65 0 0 1-.623-.498.45.45 0 0 1 .224-.399c.117-.09.282-.09.4 0l-.2-.075zM873 286.36l-.15.224c.047.133.187.208.324.174.135-.057.2-.21.15-.35a.2.2 0 0 0-.324 0v-.05zm2.143 6.18l-.15.2c.037.143.18.23.324.2.13-.075.193-.23.15-.374a.2.2 0 0 0-.324 0v-.025zm.698-17.02c.125 0 .3 0 .324-.25s0-.374 0-.548c.007-.19.087-.368.224-.498h.25c.054.038.097.1.125.15a2.49 2.49 0 0 1 .274 1.047 1.02 1.02 0 0 1-.424.897.5.5 0 0 1-.573 0c-.175-.187-.25-.447-.2-.698v-.1zm.324 11.687h.2c.036.096.036.203 0 .3.018.074.018.15 0 .224-.052.055-.124.086-.2.086s-.148-.03-.2-.086a.6.6 0 0 1-.15-.449c-.014-.074-.014-.15 0-.224l.35.15zm-2.368-8.77h-.25c-.038.147-.038.3 0 .45 0 .125.274.15.3 0a.2.2 0 0 0 0-.174v-.523l-.05.25zm3.215-55.094a1.97 1.97 0 0 0-2.243-.473 3.49 3.49 0 0 0 .623 2.716 1.27 1.27 0 0 0 2.093 0c.498-.772 0-2.193-.773-2.093l.3-.15zm-46.43 38.05a2.02 2.02 0 0 0-2.268-.473 3.71 3.71 0 0 0 .623 2.716c.243.344.638.55 1.06.55s.816-.205 1.06-.55c.498-.772 0-2.193-.798-2.093l.324-.15zm33.695-41.937c-.096-.036-.203-.036-.3 0-.093.07-.162.165-.2.274a4.56 4.56 0 0 1-.449.847l1.32-.324h.125c.125 0 .15.25.224.35s.35 0 .523 0c1.097-.847-.698-1.022-1.246-1.146zm47.975-4.685c-.2-.15-.4.25-.3.523a.82.82 0 0 0 .573.424c.092-.32.047-.662-.125-.947h-.15zm-45.358 8.647a.35.35 0 0 1 0 .349c-.07.098-.18.162-.3.174a.3.3 0 0 1-.199 0 .4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086a.45.45 0 0 1 0 .498l.1-.548zm-4.61 18.614c.084.1.084.248 0 .35-.068.09-.165.15-.274.174-.064.025-.135.025-.2 0a.4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086a.5.5 0 0 1 0 .498l.075-.548zm4.76-20.433c0-.274-.174-.598-.4-.498a.92.92 0 0 0 0 .449c0 .15.15.25.274.224s.2-.2.125-.324v.15zm2.02 4.81c.135.138.19.335.15.523a.5.5 0 0 1-.324.399.2.2 0 0 1-.249-.199.35.35 0 0 1 0-.15l.324-.648.1.075zm-3.364 2.218c.042.224.223.395.45.424.216.022.404.154.498.35.025.064.025.135 0 .2 0 .15-.274 0-.4 0h-.35a.7.7 0 0 1-.648-.473c.015-.17.107-.327.25-.424a.35.35 0 0 1 .399 0l-.2-.075zm-1.445 1.72l-.15.224a.3.3 0 0 0 .324.199.3.3 0 0 0 .15-.374c-.026-.066-.09-.1-.162-.1s-.136.043-.162.1v-.05zm2.143 6.18l-.15.224s.2.224.3.174a.3.3 0 0 0 .174-.349.2.2 0 0 0-.324 0v-.05zm46.68-12.334c.125 0 .3 0 .324-.25.012-.183.012-.366 0-.548.018-.186.097-.362.224-.498.085-.05.19-.05.274 0v.174c.188.308.29.66.3 1.022.028.353-.133.695-.424.897a.5.5 0 0 1-.598 0 .87.87 0 0 1-.199-.673l.1-.125zm-45.533 7.002h.2c.036.096.036.203 0 .3.014.082.014.167 0 .25-.052.055-.124.086-.2.086s-.148-.03-.2-.086c-.104-.135-.157-.303-.15-.473a.5.5 0 0 1 0-.199h.174l.174.125zm-75.3-41.34s.174 0 .224.125c.024.098.024.2 0 .3.014.082.014.167 0 .25-.105.098-.27.098-.374 0-.126-.123-.183-.3-.15-.473-.025-.064-.025-.135 0-.2a.15.15 0 0 1 .199 0h.1zm72.798 32.593h-.25c-.038.147-.038.3 0 .45 0 .15.274.15.3 0a.15.15 0 0 0 0-.15v-.548l-.05.25zm-10.94 64.96c-.166-.11-.352-.187-.548-.224-.22-.008-.416.137-.474.35-.036.113-.036.235 0 .35.03.16.124.3.262.385s.305.11.46.064a.75.75 0 0 0 .299-.897v-.025zm14.305 11.836h-.4c-.025.123-.025.25 0 .374a.4.4 0 0 0 .449-.374h-.05zm159.627 50.085a2.02 2.02 0 0 0-2.243-.473 3.66 3.66 0 0 0 .623 2.741c.243.344.638.55 1.06.55s.816-.205 1.06-.55c.474-.772 0-2.193-.798-2.118l.3-.15zm-10.642-5.88c-.27-.28-.68-.378-1.047-.25.01.2.062.394.15.573 0 .174.25.3.424.25s.3-.374.374-.648v.2l.1-.125zm-47.028-36.18c-.276-.27-.68-.366-1.047-.25a1.52 1.52 0 0 0 .15.598c0 .174.25.3.424.25s.3-.4.374-.648v.2l.1-.15zm44.935 38.224c-.094-.05-.205-.05-.3 0-.093.07-.162.165-.2.274-.125.295-.275.578-.45.847l1.346-.324.25.35c.1.125.35 0 .498 0 1.196-.922-.598-.997-1.146-1.146zm6.13.3c.11-.05.238-.05.35 0a.97.97 0 0 1-.748.498h-.424a2.19 2.19 0 0 1 0-.424c0-.274-.274-.548-.15-.772a.25.25 0 0 1 .349 0 1.17 1.17 0 0 1 .274.324l.474.822-.125-.45zm1.27 5.183c-.2 0-.424.274-.3.523.124.22.33.38.573.45.127-.383.052-.805-.2-1.12l-.075.15zm-4.785-1.495a.35.35 0 0 1 0 .349c-.074.094-.18.156-.3.174a.25.25 0 0 1-.174 0 .35.35 0 0 1 0-.473.25.25 0 0 1 .374 0 .5.5 0 0 1 .125.498l-.025-.548zm.15-1.82c0-.274-.174-.598-.374-.498a.92.92 0 0 0 0 .449.25.25 0 0 0 .274.224c.1-.025.224-.224.15-.324l-.05.15zm-64.25-41.613c0-.274-.174-.598-.4-.498a.92.92 0 0 0 0 .449c0 .15.15.25.274.224.064-.02.115-.07.14-.132s.02-.133-.014-.19v.15zm65.37 35.284c-.14-.268-.4-.453-.698-.498v.847a1.02 1.02 0 0 0 0 .399c.06.094.163.15.274.15s.215-.057.274-.15c.124-.234.124-.514 0-.748h.15zm.897 11.138a.55.55 0 0 1 .15.523c-.016.18-.147.332-.324.374a.2.2 0 0 1-.249-.174c-.014-.05-.014-.1 0-.15l.324-.648.1.075zm-3.364 2.218c0 .25.274.35.45.424s.45.125.498.35c.025.064.025.135 0 .2 0 .15-.25 0-.4 0a.75.75 0 0 0-.324 0 .65.65 0 0 1-.648-.498.45.45 0 0 1 .224-.399c.117-.09.282-.09.4 0l-.2-.075zm-1.445 1.72l-.15.224s.2.224.324.174c.135-.057.2-.21.15-.35 0-.15-.224-.2-.3 0l-.025-.05zm2.143 6.155l-.15.224c.037.143.18.23.324.2.125 0 .2-.224.15-.374a.2.2 0 0 0-.324 0v-.05zm.698-16.994c.125 0 .3 0 .324-.25a2.02 2.02 0 0 0 0-.548c.018-.186.097-.362.224-.498a.2.2 0 0 1 .249 0c.054.038.097.1.125.15a2.49 2.49 0 0 1 .299 1.047 1.02 1.02 0 0 1-.449.897.5.5 0 0 1-.573-.125c-.175-.187-.25-.447-.2-.698v.025zm-2.542-3.862c-.062-.074-.153-.117-.25-.117s-.188.043-.25.117c-.148.18-.204.42-.15.648 0 0 0 .224.15.2s0 0 .15 0l.424-.698-.075-.15zm9.146 6.08a.82.82 0 0 1-.424 1.096c-.142-.338-.202-.706-.174-1.07 0-.374.35-.698.648-.548l.224.548-.274-.025zm-6.28 9.47h.224c.024.098.024.2 0 .3.018.074.018.15 0 .224a.25.25 0 0 1-.374 0c-.126-.112-.183-.283-.15-.45a.35.35 0 0 1 0-.224c.024-.03.06-.05.1-.05s.076.018.1.05l.1.15zm-2.368-8.77h-.25c-.038.147-.038.3 0 .45a.15.15 0 0 0 .15.15.15.15 0 0 0 .15-.15.5.5 0 0 0 0-.174v-.523l-.05.25zm-.374-10.84a1.12 1.12 0 0 0-.548-.199.5.5 0 0 0-.498.324c-.025.123-.025.25 0 .374 0 .35.45.573.723.424a.75.75 0 0 0 .299-.897l.025-.025zm14.305 11.836h-.4c-.025.123-.025.25 0 .374.2 0 .424 0 .45-.35l-.05-.025zM902.98 309.11a8.8 8.8 0 0 0-3.564-2.492 1.57 1.57 0 0 0-.648 0 1.42 1.42 0 0 0-.947 1.022 3.96 3.96 0 0 0 .623 3.613c.706.87 1.855 1.25 2.94.972a2.17 2.17 0 0 0 1.445-1.121 1.92 1.92 0 0 0-.15-1.969.35.35 0 0 0-.249.324l.548-.35zm7.277-51.406a2.02 2.02 0 0 0-2.243-.473 3.66 3.66 0 0 0 .598 2.741c.243.344.638.55 1.06.55s.816-.205 1.06-.55c.498-.772 0-2.193-.798-2.118l.324-.15zM936.45 221.4a1.97 1.97 0 0 0-2.243-.473c-.164.952.06 1.93.623 2.716a1.27 1.27 0 0 0 2.093 0c.498-.772 0-2.193-.773-2.093l.3-.15zm-36.86 30.35c-.276-.27-.68-.366-1.047-.25a2.34 2.34 0 0 0 .15.598.5.5 0 0 0 .424.249c.224 0 .324-.4.374-.673v.224l.1-.15zm-2.143 2.068c-.105-.038-.22-.038-.324 0a.87.87 0 0 0-.174.299c-.125.295-.275.578-.45.847l1.32-.324h.125l.224.374c.075.125.35 0 .498 0 1.27-.972-.598-1.047-1.22-1.196zm-5.21-8.796h-.4c0 .324.274.648.523.673.152-.017.286-.107.36-.24s.08-.294.014-.432c0-.15-.274-.4-.125-.498l-.374.498zm11.414 9.095a.5.5 0 0 1 .324 0 .97.97 0 0 1-.723.523.4.4 0 0 1-.449-.15c-.014-.133-.014-.266 0-.4 0-.274-.25-.548-.125-.772.042-.044.1-.07.162-.07s.12.025.162.07c.125 0 .2.2.274.324l.498.822-.125-.35zm1.27 5.183c-.224-.15-.424.274-.324.523a.82.82 0 0 0 .573.424 1.22 1.22 0 0 0-.174-1.096l-.075.15zm-4.8-1.52a.3.3 0 0 1 0 .374c-.06.093-.163.15-.274.15-.064.025-.135.025-.2 0a.4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086c.096.143.096.33 0 .473l.075-.523zm.174-1.794c0-.274-.174-.598-.4-.498a.92.92 0 0 0 0 .449s.15.25.274.224a.25.25 0 0 0 .125-.349v.174zm-6.13-17.99c0-.274-.174-.598-.4-.498a.92.92 0 0 0 0 .449c0 .125.15.25.274.224.064-.02.115-.07.14-.132s.02-.133-.014-.19v.15zm7.227 11.662c-.125-.28-.392-.47-.698-.498v.847a1.12 1.12 0 0 0 0 .399c.06.094.163.15.274.15s.215-.057.274-.15c.13-.224.13-.5 0-.723l.15-.025zm1.047 11.113a.7.7 0 0 1 .15.548.45.45 0 0 1-.349.374s-.25 0-.224-.174a.35.35 0 0 1 0-.174l.324-.623.1.05zm-.748 3.837a.7.7 0 0 0 0 .698c0 .25.174.523 0 .723-.047.022-.102.022-.15 0-.125 0-.15-.25-.224-.4a.87.87 0 0 0-.199-.324 1.07 1.07 0 0 1 0-.947.35.35 0 0 1 .424 0c.117.127.164.305.125.473l.025-.224zm35.763-3.837a.77.77 0 0 0 0 .698.92.92 0 0 1 0 .723c-.04.015-.084.015-.125 0-.15 0-.174-.25-.224-.424a2.49 2.49 0 0 0-.224-.324c-.15-.29-.15-.633 0-.922a.3.3 0 0 1 .399 0c.126.123.183.3.15.473l.025-.224zm-37.732 3.34h-.224c-.088.128-.088.296 0 .424a.2.2 0 0 0 .324 0s0-.35-.125-.374l.025-.05zm-2.916 5.63h-.224c-.075.14-.075.31 0 .45.043.053.107.083.174.083s.132-.03.174-.083c0-.125 0-.35-.125-.374v-.075zm3.54-15.848s.3 0 .324-.25 0-.374 0-.573a.65.65 0 0 1 .224-.473.2.2 0 0 1 .249 0v.15a2.49 2.49 0 0 1 .274 1.047.97.97 0 0 1-.424.872.55.55 0 0 1-.598 0 .97.97 0 0 1-.199-.698l.15-.075zm-2.542-3.862a.3.3 0 0 0-.498 0c-.148.18-.204.42-.15.648 0 0 0 .2.15.2h.125l.424-.673-.05-.174zm9.122 6.08c.2.4 0 1.022-.4 1.07a1.92 1.92 0 0 1-.174-1.047c0-.374.35-.698.623-.573l.25.573-.3-.025zm-6.006 11.736c.062.08.062.193 0 .274-.05.085-.13.148-.224.174h-.2c-.156-.07-.254-.228-.25-.4.001-.163.086-.313.224-.4a.2.2 0 0 1 .199 0c.042.06.042.14 0 .2l.25.15zm-2.617-11.04h-.25c-.05.145-.05.303 0 .45 0 .125.274.15.3 0s0 0 0-.174v-.548l-.05.274zm-.374-10.84a1.22 1.22 0 0 0-.573-.199c-.213-.01-.407.122-.474.324-.025.123-.025.25 0 .374.02.157.112.297.247.38s.3.1.45.044a.75.75 0 0 0 .324-.897l.025-.025zm14.28 11.836h-.4a.97.97 0 0 0 0 .374c.174 0 .4-.125.424-.374h-.025zm-9.77 15.026a2.02 2.02 0 0 0-2.243-.473c-.177.96.048 1.95.623 2.74a1.27 1.27 0 0 0 2.093 0c.498-.772 0-2.218-.798-2.118l.324-.15zm-50.692-35.31a.5.5 0 0 1 .324 0c-.13.288-.408.48-.723.498-.122.105-.302.105-.424 0-.014-.133-.014-.266 0-.4 0-.274-.274-.548-.15-.772a.25.25 0 0 1 .349 0c.116.085.2.196.274.324l.474.822-.125-.473zm-72.972-46.946c-.096-.036-.203-.036-.3 0-.093.07-.162.165-.2.274a4.56 4.56 0 0 1-.449.847l1.346-.324c.125 0 .15.25.25.35s.35 0 .498 0c1.196-.947-.598-1.022-1.146-1.146zm2.617 3.962a.3.3 0 0 1 0 .349c-.065.104-.177.17-.3.174a.25.25 0 0 1-.174 0 .35.35 0 0 1 0-.473.25.25 0 0 1 .374 0 .5.5 0 0 1 .125.498l-.025-.548zm-4.61 18.614c.084.1.084.248 0 .35a.4.4 0 0 1-.274.174.3.3 0 0 1-.199 0 .4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086a.45.45 0 0 1 0 .498l.075-.548zm4.76-20.433c0-.274-.174-.598-.374-.498a.92.92 0 0 0 0 .449c.025.142.156.24.3.224a.25.25 0 0 0 .125-.324l-.05.15zm-1.22 7.102c0 .25.25.374.45.424s.424.125.474.35c.025.064.025.135 0 .2 0 .15-.25 0-.4 0a.75.75 0 0 0-.324 0 .65.65 0 0 1-.648-.473c-.008-.17.078-.333.224-.424a.35.35 0 0 1 .399.125l-.174-.2zm-1.57 1.645l-.15.224c.048.13.193.198.324.15s.198-.193.15-.324c0-.15-.224-.2-.3 0l-.025-.05zm2.143 6.18l-.15.224c.047.133.187.208.324.174.135-.057.2-.21.15-.35a.2.2 0 0 0-.324 0v-.05zm1.022-5.332s.174 0 .224.125c.024.098.024.2 0 .3.014.082.014.167 0 .25-.105.098-.27.098-.374 0-.126-.123-.183-.3-.15-.473-.025-.064-.025-.135 0-.2a.15.15 0 0 1 .199 0h.1zm-2.368-8.746h-.25c-.038.147-.038.3 0 .45a.15.15 0 0 0 .15.15.15.15 0 0 0 .15-.15.5.5 0 0 0 0-.174v-.523l-.05.25zm-13.284 15.075a.5.5 0 0 1 .324 0c-.138.28-.41.47-.723.498-.174 0-.35 0-.45-.125-.012-.133-.012-.266 0-.4 0-.274-.274-.548-.15-.772.043-.053.107-.083.174-.083s.132.03.174.083c.125 0 .2.2.274.324l.498.822-.125-.35zm114.966 44.778c-.2 0-.424.274-.3.523.108.233.32.4.573.45.128-.375.052-.8-.2-1.096l-.075.125zm10.94 19.486a.3.3 0 0 1 0 .374c-.06.093-.163.15-.274.15h-.2a.4.4 0 0 1 0-.473c.052-.055.124-.086.2-.086s.148.03.2.086c.096.143.096.33 0 .473l.075-.523zm2.193 3a.6.6 0 0 1 .15.548.45.45 0 0 1-.349.374c-.054.016-.113.005-.157-.03s-.07-.09-.067-.145a.35.35 0 0 1 0-.174l.324-.623.1.05z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M934.832 265.928c-.174.15 0 .45 0 .698s.174.498 0 .698c-.044.033-.105.033-.15 0l-.224-.4a1.42 1.42 0 0 0-.199-.324c-.15-.298-.15-.65 0-.947.128-.088.296-.088.424 0a.55.55 0 0 1 .125.473l.025-.2zm-43.066 13.28h-.224c-.086.137-.086.31 0 .45a.2.2 0 0 0 .324 0v-.374l-.1-.075zm-2.916 5.656h-.224c-.075.14-.075.308 0 .45.043.053.107.083.174.083s.132-.03.174-.083c.034-.066.04-.143.017-.213s-.075-.128-.142-.16v-.075zm10.118-13.655c.2.424 0 1.047-.4 1.096a1.92 1.92 0 0 1-.174-1.047c0-.374.35-.698.623-.573l.25.573-.3-.05zm-6.006 11.76c.062.08.062.193 0 .274l-.224.174h-.2c-.156-.07-.254-.228-.25-.4a.55.55 0 0 1 .224-.399.2.2 0 0 1 .199 0c.042.06.042.14 0 .2l.25.15zm11.3-10.042h-.4a.97.97 0 0 0 0 .374c.174 0 .4-.125.424-.374h-.025zm-18.02.723h-.4a1.07 1.07 0 0 0 0 .399c.2 0 .4 0 .45-.374l-.05-.025zm49.42 219.453a7.28 7.28 0 0 0 4.112.324 1.37 1.37 0 0 0 .623-.249c.363-.378.537-.9.474-1.42-.01-1.244-.724-2.374-1.844-2.915a3.04 3.04 0 0 0-3.863 2.492c-.125.684.22 1.367.847 1.67.076-.07.12-.17.12-.274s-.043-.203-.12-.274l-.35.648zm-2.492-25.815c.096.036.203.036.3 0 .093-.07.162-.165.2-.274a4.56 4.56 0 0 1 .449-.847l-1.32.3h-.125c-.125 0-.15-.25-.224-.35s-.35 0-.498 0c-1.12.897.673 1.022 1.22 1.17zM900.2 426.4c-.084-.1-.084-.248 0-.35.102-.05.222-.05.324 0h.15c.108.15.108.35 0 .498a.25.25 0 0 1-.399 0 .45.45 0 0 1 0-.498l-.075.35zm54.93 32.045c0-.15-.3 0-.374 0-.053.18-.095.363-.125.548a.55.55 0 0 1-.324.374c-.085.05-.19.05-.274 0v-.2a2.69 2.69 0 0 1 0-1.096c0-.35.324-.648.623-.673.226-.017.438.114.523.324.1.23.1.492 0 .723h-.05zm-63.228 6.53c0-.15-.3 0-.374 0-.053.18-.095.363-.125.548a.55.55 0 0 1-.324.374.2.2 0 0 1-.249 0c-.025-.064-.025-.135 0-.2a2.74 2.74 0 0 1 0-1.096c0-.35.35-.673.623-.698a.55.55 0 0 1 .548.324.92.92 0 0 1 0 .723l-.1.025zm13.956-2.9c.13.18.3.326.498.424a.45.45 0 0 0 .548-.15c.026-.115.026-.234 0-.35 0-.374-.274-.698-.573-.673a.65.65 0 0 0-.498.748h.025zm39.103 23.87c.658 1.44 1.62 2.725 2.816 3.763.168.163.373.283.598.35a1.17 1.17 0 0 0 1.121-.623c.69-1.11.784-2.494.25-3.688a3.24 3.24 0 0 0-2.492-1.993 1.77 1.77 0 0 0-1.969 2.492c.2 0 .35-.25.274-.45l-.598.15zm-391.976-251.25a10.69 10.69 0 0 0 2.791 3.763c.168.163.373.283.598.35a1.22 1.22 0 0 0 1.121-.623 4.01 4.01 0 0 0 .274-3.688 3.34 3.34 0 0 0-2.492-2.018 1.97 1.97 0 0 0-1.645.548c-.466.536-.582 1.292-.3 1.944.174 0 .324-.25.25-.473l-.598.2zm411.34 207.767a.82.82 0 0 0 .324.174.3.3 0 0 0 .274-.174v-.673c0-.25.15-.45 0-.673a.3.3 0 0 0-.474 0 1.12 1.12 0 0 0-.274.573 1.32 1.32 0 0 0 0 .623c0 .2.174.374.35.324l-.2-.174zm-17.47 57.287a2.27 2.27 0 0 0 2.044 1.271c.374-.9.374-1.93 0-2.84-.4-.847-1.37-1.296-2.02-.723s-.523 2.093.25 2.292h-.274zm-49.22-81.357c-.15.224 0 .623.25.623.078-.128.12-.274.125-.424s-.085-.28-.224-.324c0 0-.224 0-.2.274l.05-.15zm49.32 15.65c.65 1.44 1.602 2.723 2.79 3.763a1.87 1.87 0 0 0 .598.349 1.22 1.22 0 0 0 1.146-.623 4.01 4.01 0 0 0 .249-3.688 3.24 3.24 0 0 0-2.492-1.993 1.77 1.77 0 0 0-1.944 2.492c.174 0 .35-.25.25-.45l-.598.15zm69.558-225.857a10.69 10.69 0 0 0 2.791 3.763c.172.157.376.276.598.35a1.22 1.22 0 0 0 1.146-.623c.666-1.12.76-2.49.25-3.688a3.34 3.34 0 0 0-2.492-2.018 1.97 1.97 0 0 0-1.645.548c-.466.536-.582 1.292-.3 1.944.174 0 .35-.25.25-.473l-.598.2zm-88.648 272.38a2.27 2.27 0 0 0 2.044 1.271c.374-.9.374-1.93 0-2.84-.4-.847-1.396-1.296-2.044-.723s-.498 2.093.274 2.292h-.274z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M936.626 490.165a1.22 1.22 0 0 0 .947.623 1.72 1.72 0 0 0 0-.623c-.02-.185-.147-.34-.324-.4-.224 0-.4.25-.523.498v-.224l-.1.125zm2.492-1.296a.3.3 0 0 0 .274 0c.104-.036.192-.106.25-.2a7.95 7.95 0 0 1 .648-.648l-1.37-.174s0-.3-.15-.424-.3-.2-.474-.15c-1.37.623.324 1.346.822 1.595zm-5.807-2.492a.6.6 0 0 1-.324-.125c.216-.213.533-.3.822-.2.15 0 .35 0 .374.274.024.132.024.267 0 .4 0 .274.15.623 0 .797-.043.053-.107.083-.174.083s-.132-.03-.174-.083c-.098-.112-.16-.25-.174-.4l-.3-.972-.05.224zm.025-5.382c.15.2.45 0 .424-.374a1.07 1.07 0 0 0-.449-.623c-.186.342-.186.755 0 1.096l.025-.1zm4.212 3.214a.3.3 0 0 1 0-.374c.094-.05.205-.05.3 0h.174a.45.45 0 0 1 0 .498.25.25 0 0 1-.399 0 .45.45 0 0 1 0-.498l-.075.374zm-.573 1.67c-.15.224 0 .623.25.598.078-.128.12-.274.125-.424s0-.3-.224-.324-.25.15-.2.274l.05-.125zm-2.567 5.63c.07.31.27.572.548.723l.2-.822c.026-.132.026-.267 0-.4a.35.35 0 0 0-.523-.224.7.7 0 0 0-.224.673v.05zm1.77-10.964c-.085-.18-.085-.392 0-.573a.4.4 0 0 1 .424-.249s.224.15.174.274c.012.04.012.084 0 .125l-.474.498-.125-.075zm1.52-3.464c.174 0 .2-.424.174-.673s0-.523.15-.673c.125 0 0 .3.125.473.02.13.06.258.125.374a1.07 1.07 0 0 1-.199.922.35.35 0 0 1-.374-.174.5.5 0 0 1 0-.498v.25zm-35.115-9.42c.174 0 .2-.4.2-.648a.92.92 0 0 1 .125-.698h.15c.15 0 0 .3.125.473a2.49 2.49 0 0 0 .125.399c.1.31.034.648-.174.897a.35.35 0 0 1-.399-.174c-.064-.16-.064-.338 0-.498l-.15.25zm36.835 10.64l.224.125c.088-.128.088-.296 0-.424a.2.2 0 0 0-.324 0 .3.3 0 0 0 0 .399l.1-.1zm4.137-4.386h.224c.076-.13.076-.293 0-.424a.2.2 0 0 0-.324 0c-.055.052-.086.124-.086.2s.03.148.086.2l.1.025zm-7.128 13.93c0-.15-.3 0-.374 0-.056.17-.098.346-.125.523a.65.65 0 0 1-.324.399c-.075.05-.174.05-.25 0-.025-.064-.025-.135 0-.2-.075-.362-.075-.735 0-1.096 0-.35.35-.673.623-.698a.65.65 0 0 1 .548.324.97.97 0 0 1 0 .748h-.1zm1.52 4.635a.35.35 0 0 0 .474.199c.184-.123.295-.327.3-.548v-.25c0-.025 0 0-.174 0l-.548.498-.05.1zm-7.302-9.17c0-.45.274-.947.673-.872.088.352.088.72 0 1.07-.125.324-.498.523-.723.3v-.648l.05.15zm8.523-9.02c-.05-.085-.05-.19 0-.274.08-.033.17-.033.25 0 .064-.025.135-.025.2 0a.45.45 0 0 1 .15.449.45.45 0 0 1-.324.299.2.2 0 0 1-.199 0v-.224l-.075-.25zm-.1 11.512h.25c.036-.147.036-.3 0-.45 0-.15-.224-.224-.3 0-.012.05-.012.1 0 .15v.3h.05zm-13.06-6.055h.4c.014-.124.014-.25 0-.374-.09-.06-.202-.073-.302-.033s-.173.127-.196.232l.1.174zm13.01-10.814c.38.785 1.17 1.288 2.044 1.296.374-.9.374-1.93 0-2.84-.4-.872-1.37-1.296-2.02-.748s-.523 2.118.25 2.317l-.274-.025zm9.695 3.713a.3.3 0 0 1 0-.349c.094-.05.205-.05.3 0h.174c.108.15.108.35 0 .498a.25.25 0 0 1-.399 0 .45.45 0 0 1 0-.498l-.075.35zm-1.42-3.713a.6.6 0 0 1 0-.548c.074-.165.244-.265.424-.25 0 0 .224.15.174.274.012.04.012.084 0 .125l-.474.498v-.125l-.125.025zm-40.897-5.183c.2 0 .224-.4.2-.648s0-.548.15-.698v.473c0 .174 0 .25.125.374.1.317.034.663-.174.922a.3.3 0 0 1-.374-.174.5.5 0 0 1 0-.498l.075.25zm44.212 3.015l.2.125c.086-.137.086-.31 0-.45a.2.2 0 0 0-.324 0 .3.3 0 0 0 0 .399l.125-.075zm4.162-4.336h.224c.088-.128.088-.296 0-.424 0-.15-.224-.2-.324 0a.3.3 0 0 0 0 .399l.1.025zm-12.96 9.344c0-.45.3-.972.673-.897a2.29 2.29 0 0 1 0 1.096c0 .324-.498.523-.723.3v-.648l.05.15zm8.523-9.02c-.05-.085-.05-.19 0-.274a.35.35 0 0 1 .249 0h.2a.45.45 0 0 1 .15.449.45.45 0 0 1-.324.299c-.054.03-.12.03-.174 0-.054-.065-.054-.16 0-.224l-.1-.25zm-13.16 5.457h.4a.97.97 0 0 0 0-.374c-.09-.06-.202-.073-.302-.033s-.173.127-.196.232l.1.174zm17.42 5.906h.4a1.92 1.92 0 0 0 0-.374c-.092-.05-.2-.06-.3-.028s-.18.107-.223.202l.125.2zm67.963-251.298a1.17 1.17 0 0 1 1.346.224v.15a.4.4 0 0 1 0 .299c-.35.523-.822 1.07-1.296.872a.97.97 0 0 1-.199-1.37h.424l-.274-.174zM215.75 287.432c1.404-.51 2.656-1.367 3.64-2.492a1.62 1.62 0 0 0 .424-.648c.157-.512.085-1.066-.2-1.52-.537-1.004-1.685-1.517-2.79-1.246a3.74 3.74 0 0 0-2.218 2.492c-.225.688-.225 1.43 0 2.118.25.648.872 1.096 1.42.872 0-.224 0-.473-.274-.424v.847zm74.168-79.214a13.78 13.78 0 0 0 1.321-4.859 3.04 3.04 0 0 0 0-.822 1.37 1.37 0 0 0-.997-.922c-1.137-.198-2.26.4-2.717 1.47-.555 1.2-.618 2.55-.174 3.788a2.79 2.79 0 0 0 1.171 1.545c.28.125.6.132.885.02s.514-.335.635-.617a.25.25 0 0 0-.449 0l.324.4zm-79.602 75.65a2.89 2.89 0 0 0 1.52-2.118c-.5-.675-1.37-.988-2.193-.797a1.92 1.92 0 0 0-1.097 2.243c.076.42.413.746.836.808s.84-.153 1.033-.534l-.1.4zm8.773 8.348c.196-.25.355-.527.474-.822-.224-.174-.623 0-.773-.224v-.15s-.15 0-.174.174a.87.87 0 0 0 .673 1.121l-.2-.1zm7.95 4.784a6.53 6.53 0 0 0 .872-1.52c.012-.074.012-.15 0-.224.024-.056.024-.12 0-.174-.45-.35-1.196 0-1.47-.45 0 0 0-.224-.174-.274s-.274.125-.324.3c-.224.997.45 2.143 1.27 2.118l-.174.224zm-1.62 17.642c.357-.47.658-.98.897-1.52.012-.074.012-.15 0-.224.016-.057.016-.117 0-.174-.45-.35-1.196 0-1.47-.45a.75.75 0 0 0-.299-.324c-.15 0-.274 0-.324.3-.25.997.45 2.143 1.27 2.118l-.174.2.1.075zm-5.408-38.872a1.47 1.47 0 0 0 .723-.972c-.144-.087-.306-.138-.474-.15-.184.003-.345.123-.4.3a.92.92 0 0 0 .249.748h-.174l.075.075zm49.22-71.19a.55.55 0 0 0 0-.349c-.02-.112-.07-.216-.15-.3-.203-.252-.386-.518-.548-.797v1.844c0 .15-.224 0-.35.174a.52.52 0 0 0 0 .623c.25 1.52.798-.573 1.047-1.196zm-28.46 76.573c.146-.2.146-.472 0-.673-.117-.3-.208-.608-.274-.922l-.474 1.57h-.374c-.125 0-.25.324-.224.548.075 1.844.972 0 1.346-.523zm45.732-47.045l.15-.45c-.122-.07-.267-.1-.403-.053s-.25.128-.32.252c-.15.274 0 .748.25.748h.424l-.1-.498zm-44.985 59.73c-.324.224-.798-.15-.798-.598s.474-.822.798-.598a.82.82 0 0 1 0 1.171v.025zm-15.078-6.105c0 .35-.174.822-.474.822s-.424-.424-.474-.772 0-.35 0-.45.548.374.822.2 0 .224 0 .2h.125zm-10.168-8.946a.65.65 0 0 1-.174.349 1.32 1.32 0 0 1 0-1.022c0-.174.15-.4.3-.4s.2.125.324.174.498 0 .598.25c.077.122.077.277 0 .4a.75.75 0 0 1-.374 0h-.822l.15.25zm.498-4.535a.3.3 0 0 0 .548-.15c-.068-.115-.173-.204-.3-.25-.128-.02-.253.053-.3.174 0 .15 0 .324.15.324l-.1-.1zm15.502 3.065a.3.3 0 0 0 .548-.15c-.06-.122-.168-.213-.3-.25a.25.25 0 0 0-.299.174c0 .125 0 .324.15.324l-.1-.1zm-11.788 1.47c.3-.04.566-.214.723-.473l-.598-.45c-.1-.02-.2-.02-.3 0-.2 0-.374.3-.324.548a.55.55 0 0 0 .474.449l.025-.075zm7.826 54.496l-.523 1.395c-.224 0-.25-.374-.2-.648a1.57 1.57 0 0 1 .249-.698c.06-.094.163-.15.274-.15s.215.057.274.15l-.075-.05zm.2-9.992c.274 0 .573-.324.498-.673a.65.65 0 0 0-.723-.523.45.45 0 0 0-.324.249.65.65 0 0 0 0 .673c.15.154.328.28.523.374l.025-.1zm-1.47-37.676c.295.093.613-.045.748-.324a.87.87 0 0 0-.474-.424c-.135-.047-.284-.036-.41.03s-.222.18-.262.32c0 .3.2.698.424.523l-.025-.125zm-2.916.847c-.145.142-.378.142-.523 0l.274-.698c.3 0 .523.424.424.772l-.174-.075z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.94 291.17v.3c-.166-.137-.302-.306-.4-.498a.65.65 0 0 1 0-.673.25.25 0 0 1 .449 0 1.42 1.42 0 0 1 0 .723l-.05.15zm-.773-15.748v.473c0 .125.274.174.4.274a.82.82 0 0 1 .199.498c.042.095.042.204 0 .3a.2.2 0 0 1-.174 0c-.303.02-.603-.07-.847-.25-.28-.22-.422-.57-.374-.922.02-.242.16-.457.374-.573.21-.068.438.002.573.174l-.15.025zm49.87-99.523c-.15 0 0 .35 0 .473a2.07 2.07 0 0 0 .374.274.92.92 0 0 1 .224.498c.042.095.042.204 0 .3a.25.25 0 0 1-.174 0c-.303.02-.603-.07-.847-.25a1.02 1.02 0 0 1-.399-.922.82.82 0 0 1 .399-.573c.21-.068.438.002.573.174l-.15.025zm-30.056 92.944c-.15 0 0 .35 0 .473a2.07 2.07 0 0 0 .374.274.92.92 0 0 1 .224.498c.042.095.042.204 0 .3a.25.25 0 0 1-.174 0c-.303.02-.603-.07-.847-.25a1.02 1.02 0 0 1-.399-.922c.034-.238.183-.443.4-.548.203-.09.44-.028.573.15l-.15.025zm18.966-15.175c-.15 0 0 .324 0 .45s.274.174.4.3c.128.137.207.312.224.498.036.096.036.203 0 .3h-.174a1.77 1.77 0 0 1-.872-.249 1.07 1.07 0 0 1-.374-.947c.034-.238.183-.443.4-.548a.5.5 0 0 1 .573.15l-.174.05zm-34.89 21.106a.45.45 0 0 0 .299-.498c-.027-.22-.17-.41-.374-.498a.15.15 0 0 0-.224 0 .3.3 0 0 0 0 .199l.224.822.075-.025zm-25.37 84.82a1.72 1.72 0 0 0 1.321.673h.224c.05 0 0-.424 0-.623s0-.797-.2-1.146a1.12 1.12 0 0 0-.623-.548c-.35-.174-.847-.3-.997 0a.97.97 0 0 0 0 .698 4.71 4.71 0 0 0 .648 1.271l-.374-.324zm68.86-81.033a1.72 1.72 0 0 0 1.321.673h.224c.05 0 0-.424 0-.623s0-.797-.2-1.146a1.22 1.22 0 0 0-.623-.548c-.35-.174-.822-.3-.997.125a.97.97 0 0 0 0 .698 4.71 4.71 0 0 0 .648 1.271l-.374-.45zm-32.15 12.908c0 .324.498.224.773 0a.65.65 0 0 0 .374-.473c0-.3-.224-.523-.424-.648l-.598-.374c-.085-.05-.19-.05-.274 0a.4.4 0 0 0-.125.249 4.11 4.11 0 0 0-.174 1.57l.45-.324zm-9.37 2.118c.673 3.14 3.54 1.82 3.49-.947s-4.087-1.794-3.49.947zm11.44 8.397c.673 3.14 3.564 1.82 3.514-.947s-4.087-1.82-3.514.947zm-22.28-20.782c-.4 0-.698-.573-.523-1.022.302.023.586.156.798.374a.75.75 0 0 1 0 .972h-.523l.25-.324zm4.087-9.494l.125-.25c-.065-.123-.186-.207-.324-.224 0 0-.224.2-.15.324.04.022.086.022.125 0l.424.174-.2-.025zm11.2-10.964c.18-.126.332-.287.45-.473a.77.77 0 0 0 0-.698.5.5 0 0 0-.249-.199c-.274 0-.623.174-.673.523-.072.347.118.695.45.822l.025.025zm29.732-24.644a1.57 1.57 0 0 0 .424-.473.7.7 0 0 0 0-.698.45.45 0 0 0-.224-.199.6.6 0 0 0-.673.523.7.7 0 0 0 .449.822l.025.025zm-23.477 43.706c-.062.13-.193.21-.336.21s-.274-.082-.336-.21a2.12 2.12 0 0 1 0-.548c.18.043.34.15.45.3l.224.25zm-25.495 6.055l.15-.45a.6.6 0 0 0-.274-.15c-.15.2-.15.458 0 .648l.125-.05zm77.633-90.677c1.402-.5 2.647-1.36 3.614-2.492.2-.17.336-.384.424-.623.158-.51.095-1.06-.174-1.52-.53-1.024-1.696-1.55-2.816-1.27-1.082.44-1.895 1.363-2.193 2.492-.225.688-.225 1.43 0 2.118.16.64.806 1.03 1.445.872 0-.224 0-.473-.3-.424v.847zm11.1 1.27a2.84 2.84 0 0 0 1.52-2.118 2.17 2.17 0 0 0-2.193-.797c-.862.393-1.315 1.352-1.072 2.268a.97.97 0 0 0 1.844.274l-.1.374zm1.545 38.673v.473c0 .125.274.174.4.3a.65.65 0 0 1 .199.473c.042.095.042.204 0 .3a.2.2 0 0 1-.174 0c-.303.02-.603-.07-.847-.25-.272-.225-.413-.57-.374-.922a.7.7 0 0 1 .374-.548c.21-.085.452-.025.598.15l-.174.025zm-21.308-20.732a2.79 2.79 0 0 0 1.495-2.118c-.497-.677-1.35-1-2.168-.797a1.92 1.92 0 0 0-1.097 2.243c.076.42.413.746.836.808s.84-.153 1.033-.534l-.1.4zm10.84 46.92a2.79 2.79 0 0 0 1.495-2.118 2.17 2.17 0 0 0-2.193-.797 1.92 1.92 0 0 0-1.072 2.243c.274.922 1.495 1.17 1.844.3l-.075.374zm-1.146-55.02a1.47 1.47 0 0 0 .723-.972c-.144-.087-.306-.138-.474-.15-.19.006-.354.14-.4.324-.03.266.063.53.25.723h-.174l.075.075zm-.3-3.29c.146-.2.146-.472 0-.673a6.13 6.13 0 0 1-.349-.947l-.498 1.595v.125c0 .125-.224 0-.35 0s-.25.324-.25.573c.075 1.67 1.072-.174 1.445-.673zm8.773-.922l.174-.45a.55.55 0 0 0-.723.199c-.174.274 0 .748.224.748s.424 0 .424.125l-.1-.623zm-12.212 7.226a.87.87 0 0 1-.174.374c-.136-.336-.136-.71 0-1.047 0-.174.15-.4.3-.374s.2 0 .324.15.498 0 .598.25a.45.45 0 0 1 0 .424.7.7 0 0 1-.374 0h-.822l.15.224zm-4.212-1.395c.2-.15 0-.573-.2-.623s-.424.2-.598.4a.75.75 0 0 0 .847.374l-.05-.15zm3.564-4.26s-.224 0-.25-.174c-.05-.12-.05-.254 0-.374-.005-.066-.005-.133 0-.2a.25.25 0 0 1 .374.15.4.4 0 0 1-.125.473c-.152.057-.322-.007-.4-.15l.4.274zm1.146 1.146a.3.3 0 0 0 .548-.15c-.075-.11-.178-.195-.3-.25-.128-.02-.253.053-.3.174 0 .15 0 .324.15.324l-.1-.1zm15.502 3.04a.3.3 0 0 0 .548-.15c0-.125-.174-.224-.3-.25a.25.25 0 0 0-.299.174c0 .15 0 .324.15.324l-.1-.1zm-11.788 1.47c.3-.04.566-.214.723-.473l-.598-.424c-.083-.078-.187-.13-.3-.15-.2 0-.374.3-.324.548.034.242.23.428.474.45l.025.05zm-8.05-4.934a.45.45 0 0 1-.449 0 .65.65 0 0 1 0-.573c0-.125.174-.224.25-.15a.25.25 0 0 1 0 .125l.25.698-.05-.1zm-2.293-2.716a.5.5 0 0 0-.474-.399c-.174 0-.424 0-.498-.35-.025-.064-.025-.135 0-.2 0-.15.274 0 .4 0 .115.024.234.024.35 0 .3-.006.55.175.648.45.008.17-.078.333-.224.424-.117.09-.282.09-.4 0l.2.075zm-16.324 39.82a.55.55 0 0 0-.474-.399c-.216-.022-.404-.154-.498-.35-.025-.064-.025-.135 0-.2 0-.15.25 0 .4 0a.75.75 0 0 0 .324 0 .7.7 0 0 1 .673.473c.005.17-.093.328-.25.4-.117.09-.282.09-.4 0l.224.075zm17.695-41.663l.15-.224c-.047-.133-.187-.208-.324-.174a.3.3 0 0 0-.15.374c0 .15.25.2.324 0v.025zm-2.268-6.03l.15-.224c0-.15-.2-.224-.324-.174a.3.3 0 0 0-.15.374.2.2 0 0 0 .324 0v.025zm8.922 12.16v.473c0 .125.274.174.374.274a.77.77 0 0 1 .224.498c.042.095.042.204 0 .3a.25.25 0 0 1-.174 0c-.303.02-.603-.07-.847-.25-.28-.22-.422-.57-.374-.922a.65.65 0 0 1 .374-.548c.203-.09.44-.028.573.15l-.15.025zm3.988-.648a.45.45 0 0 0 .299-.498c-.027-.22-.17-.41-.374-.498a.15.15 0 0 0-.224 0c-.025.064-.025.135 0 .2l.224.822.075-.025zm-8.972 6.43c-.4 0-.698-.573-.523-1.022.3.035.58.166.798.374a.75.75 0 0 1 0 .972h-.523l.25-.324zm-4.8-12.584h-.224a.7.7 0 0 1 0-.324c-.01-.074-.01-.15 0-.224.105-.098.27-.098.374 0a.6.6 0 0 1 .174.449.25.25 0 0 1 0 .224l-.324-.125zm8.897 3.165v-.25a.5.5 0 0 0-.324-.224c-.068.015-.126.06-.155.125s-.027.137.005.2l.424.2.05-.05zm7.576 5.283c.168-.14.32-.298.45-.473.1-.222.1-.476 0-.698-.057-.093-.146-.164-.25-.2a.55.55 0 0 0-.673.523c-.082.342.114.7.45.797l.025.05zm-15.626 8.82l.15-.473a.6.6 0 0 0-.274-.15c-.15.2-.15.458 0 .648l.125-.025zm-4.984-18.44c.82-.414 1.38-1.208 1.495-2.118-.505-.666-1.352-.977-2.168-.797a1.92 1.92 0 0 0-1.097 2.243c.07.424.402.757.827.825s.845-.144 1.043-.526l-.1.374zm5.308-10.615c-.053.025-.115.022-.165-.008s-.082-.083-.085-.142a.55.55 0 0 1 0-.399v-.174c.068-.043.15-.054.228-.03s.14.08.17.154a.45.45 0 0 1-.15.473.3.3 0 0 1-.399-.15l.4.274zm-3.2.598c-.133.1-.316.1-.45 0-.085-.173-.085-.375 0-.548 0 0 .174-.25.25-.174s0 0 0 .15l.25.673-.05-.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.614 235.876c0-.25-.274-.35-.474-.4s-.424-.125-.498-.35c-.025-.064-.025-.135 0-.2 0-.15.274 0 .4 0 .115.024.234.024.35 0a.7.7 0 0 1 .648.473.45.45 0 0 1-.224.399c-.117.09-.282.09-.4 0l.2.075zm13.707-52.403l.15-.224a.3.3 0 0 0-.324-.199c-.13.075-.193.23-.15.374 0 .15.25.2.324 0v.05zm-2.293-6.08l.15-.25c-.047-.133-.187-.208-.324-.174-.13.075-.193.23-.15.374 0 .15.25.2.324 0v.05zm3.938 17.916c-.4 0-.698-.573-.523-1.022.3.046.58.185.798.4.224.25.3.748 0 .947h-.523l.25-.324zm-4.8-12.56s-.174 0-.224-.125a.6.6 0 0 1 0-.299c-.014-.082-.014-.167 0-.25a.25.25 0 0 1 .374 0c.12.117.185.28.174.45.032.07.032.153 0 .224h-.324zm.847 17.243l.15-.45c-.068-.09-.165-.15-.274-.174-.15.2-.15.458 0 .648l.125-.025zm9.047-19.436l.174-.45c-.073-.083-.168-.144-.274-.174-.15.2-.15.458 0 .648l.1-.025zm-37.657 170.938a1.77 1.77 0 0 1-.872 1.296h-.174a.5.5 0 0 1-.15-.274c-.174-.598-.3-1.395 0-1.82s.972 0 1.047.523l-.3.374.45-.1z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0070ab",
    opacity: 0.8,
    d: "M133.26 637.156h1208v175.1h-1208z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "O"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2293a5",
    d: "M1465.177 628.534l-278.406-9.32-29.508-5.632v-7.674l-13.682 2.492v-15.2l-10.543 8.073v17.94h-59l-8.424-5.632-11.614-2.69-10.517-4.56H979.22l-38.63-14.228-25.62-6.23-22.13-13.556-48.45-13.63-13.707-11.014-17.92-6.503v-4.187l-21.06 3.788-12.636 39.894-8.423-8.348-13.708-.2-12.635-11.886-16.45-3.513-19.165-5.333-.075-7.376-19.763 11.363h-14.13v2.816l-17.92 10.54v8.123l-13.16 3.44-5.807 4.86-11.59 2.292-7.9 9.868-4.212 1.82-17.894-13.98-11.59 3.837-13.184.623-15.277-2.168-23.7 4.8-35.365-11.587-23.152.1-9.944 9.644-37.408-13.157-22.13 3.638v3.862l-10.518 11.14-31.6 9.917-30.555 4.062-19.14 3.862-191.402-1.22-2.99 6.23-2.492 10.94 2.492 15 591.205-6.528h1130.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21869e",
    d: "M98.692 541.197l57.32-3.34 41.52 3.34h51.69l36.735 10.615v8.073l24.922 13.655 11.813 14.627 32.274 3.04 5.757 9.095s31.477 1.52 35.4 0 43.3 3.538 43.3 3.538l11.788 14.652 76.063 15.65 36.7-22.725 53.782.498 82.617 2.018 6.555 14.153 51.14.997v-6.055l94.405 7.475 70.83 3.538h22.28l241.297-10.615 123.265-2.018v22.227H98.692V541.197z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M133.608 720.532h896.053v76H133.608z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M1029.66 735.632l-70.43 2.79-10.742 6.504-28.984 6.877-94.63 7.35-16.897.847 87.975-2.666 33.196-2.79 30.53-6.728 68.486-2.093z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M832.85 758.532h-16.822l-44.212 2.492-21.956 2.268-35.963 1.97 55.7 3.1s57.52-6.578 63.253-9.818z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M1029.66 720.532l-1.496 7.126-129.32 7.974h-44.162l-31.726-7.55-12.486-.424h-42.642l-97.37 3.6-108.76-5.457h-79.5l-55.128-4.96zm-211.1 37.85l-53.982-4.86h-17.27l-10.592 3.813-43.614 1.196-7.402 2.9-13.807 1.097 41.994 2.7 57.92-4.236z",
    className: "O b"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#212e62",
    d: "M922.246 778.092l38.63-2.142 27.09-1.047 37.408 3.29-47.477 1.994z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#084f98",
    d: "M547.715 739.993l28.137.25 19.988-2.64 37.408 3.29-47.477 1.993z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M595.84 737.6h-28.536l-17.894 2.392 26.442.25z",
    className: "O b"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M921.498 734.237l-29.06 11.113-23.227 2.467h-13.26l1.894-12.185 38.106.723z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#084f98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.956 728.082l3.713 9.843 29.284 9.892 1.894-12.185-15.726-3.015-3.3-4.535z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.67 737.925l-40.847-3.688-12.76 1.395-16.275-4.26-28.41-.747-.648-1.495 40.1-1.47 26.89.424h28.237z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M773.062 735.632l-30.43 3-41.37-.2 33.794-7.625 21.732.573z",
    className: "O b"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M701.26 738.423l-1.645 2.018 20.984 1.745 16.648-.25h15.627l24.324-1.694-4.137-4.6-30.106 3.962-15.228-1.545z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M991.006 774.778l-38.405-5.855-35.713 2.167-32.972.748-12.262 4.112 54.056 2.043z",
    className: "O b"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0070ab",
    opacity: 0.8,
    d: "M133.26 601.573H285l54.93-10.067 93.333 77.17 81.097 26.812 92.437 20.134h69.757l29.657-20.134 54.057 6.728 107.265 1.67 178.792 11.736h95.053l38.355-23.473v112.356H133.26z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M133.26 770.094h94.455l72.922 14.652 52.212-14.652L499.49 780.16l25.694 4.585 61.31-18.3 88.25-3.29 171.1 21.58L956.04 791l28.163-5.73 72.922 11.96 83.69-8.797h38.804v30.675H133.26z",
    className: "K"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.618 797.803l-57.87 5.98h-29.832l-23.202 3.937-96.948-9.917-139.2-5.756-77.882 2.616-48.897-6.23-127.577-3.438-21.558-2.492-21.333 8.77-66.692-8.77-112.275-2.342L325.484 791l-25.67 2.94-101.907-5.507-64.648-8.272v34.137h1046.36z",
    className: "Q"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.618 770.108l188.165 14.01 69.936-11.663 119.456 1.75 58.156 6.41 35.9-6.41 134.302 15.723 136.78-4.06 264.898 22.132 111.407-9.314v20.42h-1119z",
    className: "K"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#134370",
    d: "M178.22 638.563l5.308-17.443-3.34-25.54 15.452-31.148-1.445-11.562-4.785-37.776-9.794-8.348L163.69 543.4l-1.47.15-.15.2-2.492-6.254-1.97-4.834-10.093 13.705c-.424.598-8.997-10.715-8.997-10.715l-9.047-8.397-1.12-8.92-9.745 10.665 16.075-179.4-2.99-26.488-10.567-1.296-10.79 76.25 2.99-64.114L109.31 308H98.717L81.27 486.837l-10.368 3.912L52.61 464.4l-28.96 10.64-2.168 7.475-2.717 9.294 9.97 12.46-1.52.673-.947.45L0 517.087l32.4 55.144-1.62 4.984-5.26 1.92 8.075 21.405 16.997 28.955-6.88 18.2-1.47 14.95.548 37.726v11.213l-17.446-13.68-12.312 1.545 8.125 29.727-4.386 18.44.623 3.887 7.153 46.098L55.8 744.365l-1.47 14.95 5.832-8.696-2.268 15.972 16.698-21.554.45 3.015 5.333 14.054 4.41 13.655 23.153-7.002 15.6-4.4 27.69 10.565 27.265-4.984-12.735-17.443v-1.894l9.047-2.74-9.296-10.914-.648-34.636 1.844-13.98-2.168-25.092 12.835-15.6.847-9.07z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M536.724 788.433l-5.275-14.178-21.192-5.93-14.107-28.905-33.612-36.904 13.294-66.755-8.832-9.394-8.802-23.498-33.07-17.742-5.125-51.157-63.394-34.386-26.437 7.425 10.61 60.003-22.94-3.54-6.18 46.248-26.618-10.74-19.293 5.58-23.844 21.804v51.53l-31.592 5.756-18.57 11.188-50.462 44.58-16.76-38.45-23.845-17.318-16.76 38.797-27.37 9.743-38.827 56.24z",
    className: "K"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M378.12 502.873l12.786 44.204 21.88-5.93v69.845l15.327 25.267v42.36l15.328-8.92 20.386-51.28 4.436 19.336-16.075 54.222-18.966 8.173 10.94 54.994 42.692 20.807 31.028 3.712 9.67 8.77h9.17l-4.36-14.178-17.52-5.93-11.664-28.905-27.788-36.904 11-66.755-7.302-9.394-7.277-23.498-27.34-17.742-4.236-51.157-52.412-34.386zM350.655 609.72l-13.258-6.478-7.8 14.427-25.122-3.987v20.333l-4.785 14.13 10.218 6.678 4.362 35.683H299.7v29.727l32.823-10.416 33.57 10.416 8.648-153.22-11.813-2.193-.474 28.332zm-217.82 138.745l28.038 8.92 32.797-4.46 25.695 21.554h28.5l30.63 13.954H107.64l26.642-46.67zm102.58-36.43l14.63 8.198 18.816 3.713-10.8 7.425-25.944 5.208-12.76-7.376z",
    className: "Q"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M475.4 702.516l-17.97 17.717v16.346l51.54 17.144-5.782-14.303zm39.453 65.81l19.464 2.242 19.963 17.866h-17.546l-3.1-10.042zm-70.38-183.198l-5.034 8.77-16.773 3.713 37.558 7.426 11.6-2.168zm34.618 41.24v9.518l7.302-.124zm-88.175-79.3l6.928-13.38 30.13-7.774 12.262 8.048-17.57-.274-9.87 7.45zm-78.032 131.916l-21.034 9.644-13.334 6.703-15.676 12.808 15.676 3.887 21.184 8.198 32.823-10.416 33.57 10.416 2.517-44.43-31.402 9.494zM137.246 736.58l21.957-2.616 7.302 11.537 19.34-1.87 7.825 9.294-32.797 4.46-28.038-8.92-7.477 8.92zm98.17-24.545l-6.006 6.404 7.975 3.364 17.77 2.5 13.707-.348-10.143-5.78H246.38z",
    className: "X"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M451.465 617.67l12.362.748 11.738 24.095-18.143 62.844h-34.767l-11.314-29.553 24.075-39.92zm-129.27 170.763l23.452-23.348 129.92 23.348z",
    className: "Q"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M345.646 765.085l-4.013 16.072-12.76 7.276h-25.545l24.075-10.042zm7.078-174.052c-.15 1.17-22.754 4.1-22.754 4.1l-20.685 6.18-9.47-6.23-6.704 31.272 19.713-21.803 24.5 7.924 13.458-2.8 1.944-18.664zm-176.5 92.62l5.233 18.564 17.595 7.376-3.115-8.622zm33.57 55.767l3.638 8.995 9.296 4.46-7.925-6.13.673-13.38zm204.81-69.048l13.233 30.524 13.134 1.62 6.23 54.122h-5.408l-8.2-44.603-15.053-5.283-3.937-15.05-7.552-13.655z",
    className: "X"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#134370",
    d: "M997.137 689.758l-7.477-2.492-4.46-33.016-10.642-42.16 4.212-76.25-2.79-10.74-2.79-26.837-10.467-20.258-1.62-58.458-4.7-9.195-15.352-30.076-3.713 3.688-4.66 4.7 3.364 68.55-7.277-4.012-1.17 31.397c0 1.346-8.698 4.685-8.698 4.685l-7.103 6.354-6.18-26.313-4.486-1.595-8.224-12.982-12.112 8.148-14.73-37.85-23.427 15.325-3.938 23.996L857 505.614l-6.056 12.758 6.48 24.72c.274 1.07-4.984 22.028-4.984 22.028l-3.988 22.152-4.212 2.766 6.43 30.898 4.137 12.46-.174 1.42-8.673 11.04-.947 4.984-1.396 7.475-9.97 51.93h23.925l.548 70.32-13.98-19.66-9.97 2.218 6.555 42.76L848.45 812h4.51v7.946l-.96-23.23L872.356 812l-3.51-15.285 21.127-33.1 17.595-53.45h90.517l-1.17-11.487 1.17 11.487h6.53l-7.477-20.408z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.564 677.872l9.445 45.476-4.037 8.57 4.8 27.958 6.255-.124-3.015-37.153 6.754-45.176zm-6.43.15l-7.477 45.85 4.4 8.397-3.613 28.133-6.256.15 1.42-37.227-8.698-44.853z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dm"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dm",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.355 768.325l17.72.897s5.98-2.168.523-9.57l-12.835-2.84-6.156 1.17.748 10.34zm-22.978.797l-17.446 2.666s-6.13-1.57-1.445-9.444l12.46-4.136 6.23.548.2 10.366z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b899",
    d: "M963.293 673.337l-19.888.473"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.982 639.772l-.523-23.572a12.46 12.46 0 0 0-5.956-10.366 17.15 17.15 0 0 0-7.726-1.645c-4.64.13-9.038 2.104-12.22 5.486a17.44 17.44 0 0 0-4.728 12.53v3.264a5.33 5.33 0 0 0 1.615 3.799c1.027.998 2.412 1.542 3.843 1.508.298.037.6.037.897 0v-4.11A11.19 11.19 0 0 1 1049 615.153a6.73 6.73 0 0 1 6.779 6.628l.424 18.813c.182 6.54-4.948 12.005-11.49 12.235l-47.95 1.07c-3.146.04-6.18-1.172-8.432-3.368a11.86 11.86 0 0 1-3.58-8.343v-6.678c-3.087.544-5.306 3.272-5.21 6.404.08 6.107 2.58 11.932 6.956 16.194a23.03 23.03 0 0 0 16.371 6.532l7.477-.174 27.414-.598h2.916c12.806-.513 22.783-11.3 22.305-24.096z",
    className: "I"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.184 626.566v4.11a5.41 5.41 0 0 0 4.312-5.432v-3.264c-.098-3.702 2.804-6.792 6.505-6.927a11.19 11.19 0 0 0-10.816 11.512z",
    className: "P"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.502 605.834a12.46 12.46 0 0 1 5.956 10.366l.498 23.548a23.23 23.23 0 0 1-22.43 23.946h4.46c12.488-.407 22.295-10.836 21.932-23.323l-.4-18.838c-.086-6.71-3.968-12.793-10.02-15.698zm-77.084 35.982c-.097-3.132 2.122-5.86 5.21-6.404l-.25-10.715c-.045-1.905-1.102-3.642-2.775-4.556s-3.705-.867-5.333.125-2.603 2.775-2.56 4.68l.374 17.443c.053 6.014 2.498 11.76 6.795 15.967a22.63 22.63 0 0 0 16.108 6.459l5.757-.125a23.03 23.03 0 0 1-16.424-6.584 23.02 23.02 0 0 1-6.903-16.29zm-14.505-6.53l-.174-9.618c.088-1.995-.942-3.873-2.67-4.873a5.36 5.36 0 0 0-5.557.117c-1.686 1.07-2.635 2.99-2.464 4.98l1.745 80.834a19.56 19.56 0 0 0 4.312 11.836l-1.62-74.455c-.107-4.06 2.533-7.68 6.43-8.82z",
    className: "H"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.64 736.828a16.42 16.42 0 0 0-4.969-11.571c-3.128-3.044-7.34-4.717-11.704-4.65l-5.98.15c-.15.518-.227 1.055-.224 1.595a5.38 5.38 0 0 0 1.629 3.784c1.024.995 2.4 1.543 3.83 1.523l5.358-.125c4.053.13 7.296 3.406 7.382 7.46s-3.015 7.465-7.058 7.766l-53.807 1.196c-4.64-.013-8.408-3.757-8.45-8.397v-1.77c-.066-5.102-2.156-9.97-5.81-13.53a19.24 19.24 0 0 0-13.678-5.458c-2.247.027-4.413-.84-6.02-2.41a8.47 8.47 0 0 1-2.552-5.962l-1.545-71.19a8.92 8.92 0 0 0-6.455 8.821l1.62 74.48c3.655 4.635 9.276 7.284 15.178 7.15 2.247-.027 4.413.84 6.02 2.41a8.47 8.47 0 0 1 2.552 5.962v1.744c.066 5.102 2.156 9.97 5.81 13.53a19.24 19.24 0 0 0 13.678 5.458l49.37-1.096c9-.35 16.05-7.866 15.826-16.87z",
    className: "I"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.352 716.67l-5.333.125c-2.36.06-4.395 1.676-4.984 3.962l5.93-.15c4.36-.06 8.565 1.616 11.688 4.66a16.42 16.42 0 0 1 4.96 11.562 16.45 16.45 0 0 1-15.925 16.919h4.436c10.213-.22 18.314-8.677 18.094-18.888a18.5 18.5 0 0 0-18.891-18.09l.025-.1zm-222.53-47.693l-.498-23.647a16.52 16.52 0 0 0-4.989-11.633c-3.142-3.062-7.372-4.748-11.76-4.69a14.53 14.53 0 0 1-10.35-4.131c-2.764-2.698-4.34-6.385-4.38-10.247l-.125-4.984c-1.853.962-2.995 2.897-2.94 4.984a19.51 19.51 0 0 0 5.891 13.724c3.706 3.612 8.696 5.604 13.872 5.538 5.115-.056 9.314 4.03 9.396 9.145l.45 21.305a27.41 27.41 0 0 0 8.276 19.38c5.23 5.1 12.282 7.9 19.587 7.78-12.342-.2-22.283-10.185-22.43-22.526zm48.35-41.214c-.045-1.905-1.102-3.642-2.775-4.556s-3.705-.867-5.333.125-2.603 2.775-2.56 4.68l.2 9.967c4.04 1.087 6.875 4.713 6.953 8.896l.648 30.724c2.5-4.398 3.75-9.396 3.614-14.452l-.748-35.384z",
    className: "H"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M871.704 637.88l.548 25.44c.327 6.045-2.664 11.788-7.804 14.987a16.6 16.6 0 0 1-16.895.381c-5.28-2.964-8.526-8.567-8.472-14.62l-.474-21.305c-.04-5.322-2.205-10.407-6.016-14.124a19.94 19.94 0 0 0-14.271-5.661c-4.836.055-8.804-3.812-8.872-8.647.003-1.85-.957-3.568-2.534-4.534a5.31 5.31 0 0 0-5.191-.2l.125 4.984c.046 3.857 1.624 7.538 4.387 10.23a14.53 14.53 0 0 0 10.342 4.122c4.387-.06 8.617 1.627 11.76 4.7a16.52 16.52 0 0 1 4.989 11.633l.498 23.672a22.78 22.78 0 0 0 22.43 22.426 27.23 27.23 0 0 0 23.053-13.954l-.648-30.7c-.1-4.154-2.94-7.742-6.953-8.82zm20.336-.475l2.093 97.18a11.84 11.84 0 0 1-11.439 12.16l-42.916.972a11.84 11.84 0 0 1-11.938-11.637c-.164-12.46-10.393-22.43-22.854-22.277l-9.545.224a5.36 5.36 0 0 0-3.764 1.692c-.978 1.044-1.5 2.435-1.445 3.865-.012.183-.012.366 0 .548l15.477-.35a17.45 17.45 0 0 1 17.645 17.193 21.78 21.78 0 0 0 22.056 21.504l16.175-.374 22.904-.498a22.43 22.43 0 0 0 17.919-9.818l-2.193-101.466c-.042-4.626-3.57-8.475-8.174-8.92z",
    className: "I"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M823.33 736.853c-.15-9.594-8.023-17.266-17.62-17.17l-15.477.324a5.36 5.36 0 0 0 5.433 4.759l9.545-.2a11.79 11.79 0 0 1 11.938 11.612c.164 12.46 10.393 22.43 22.854 22.277l5.383-.125c-5.777.086-11.35-2.13-15.49-6.16s-6.502-9.543-6.567-15.32zm80.698-110.462c0-3-4.062-5.357-7.003-5.283a5.41 5.41 0 0 0-5.234 5.557l.25 10.74c4.575.42 8.092 4.228 8.15 8.82l2.193 101.44c2.687-3.965 4.072-8.668 3.963-13.456l-2.318-107.82z",
    className: "H"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M910.98 735.01l-.35-16.346c-1.376 0-2.492-1.116-2.492-2.492s1.116-2.492 2.492-2.492l-.4-18.3c-1.234-.297-2.108-1.397-2.118-2.666-.03-1.272.798-2.406 2.02-2.766l-.424-19.31a2.74 2.74 0 0 1-.125-5.308l-.174-8.547c-.256.093-.525.144-.798.15-.568.007-1.116-.213-1.523-.6s-.64-.94-.645-1.508a2.17 2.17 0 0 1 2.093-2.218 2.64 2.64 0 0 1 .773.125l-.15-7.475c-.005-3.342-2.095-6.327-5.234-7.475l2.118 98.925c.02 1.16-.113 2.315-.4 3.44.82.387 1.37 1.182 1.444 2.085s-.34 1.777-1.084 2.292-1.71.595-2.528.208a12.66 12.66 0 0 1-9.844 5.158h3.3c7.982-.244 14.266-6.894 14.056-14.876z",
    className: "P"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M914.47 650.238a3.09 3.09 0 0 1-3.115-3.015c-.03-1.683 1.284-3.084 2.966-3.165h.3l-.548-26.014c-.045-1.905-1.102-3.642-2.775-4.556s-3.705-.867-5.333.125-2.603 2.775-2.56 4.68l.424 19.685a8.05 8.05 0 0 1 5.234 7.475l.174 7.475c.815.33 1.355 1.114 1.37 1.993.03.883-.484 1.694-1.296 2.043l.174 8.572h.598a2.72 2.72 0 0 1 2.779 2.654 2.72 2.72 0 0 1-2.654 2.778 2.32 2.32 0 0 1-.598 0l.424 19.31c.223-.038.45-.038.673 0 1.452.1 2.588 1.29 2.62 2.746s-1.05 2.695-2.496 2.86c-.232.026-.466.026-.698 0l.4 18.3h.374c1.376 0 2.492 1.116 2.492 2.492s-1.116 2.492-2.492 2.492h-.374l.35 16.37c.195 8.037-6.143 14.72-14.18 14.95h-3.265l-6.38.15c.14.332.215.687.224 1.047a2.94 2.94 0 0 1-4.824 2.414 2.94 2.94 0 0 1-.933-3.087 5.48 5.48 0 0 0-3.639 5.283 3.19 3.19 0 0 0 0 .473l29.907-.673a25.74 25.74 0 0 0 3.788-3.937c-1.042-.7-1.52-1.986-1.187-3.196s1.404-2.07 2.657-2.136a2.74 2.74 0 0 1 1.421.374 24.14 24.14 0 0 0 1.994-10.117l-.15-6.603c-.394.255-.852.393-1.32.4-1.473 0-2.667-1.194-2.667-2.666s1.194-2.666 2.667-2.666c.462-.017.92.096 1.32.324l-.523-24.72c-.236.105-.5.164-.748.174a2.12 2.12 0 0 1 0-4.211c.245-.063.502-.063.748 0l-.274-12.908a1.17 1.17 0 0 1-.424 0c-.463.007-.91-.17-1.24-.493s-.522-.764-.53-1.226c-.027-.466.14-.923.46-1.263s.768-.532 1.235-.53a1.22 1.22 0 0 1 .424 0l-.35-16.496a2.27 2.27 0 0 1-1.745-2.143c-.026-1.03.652-1.944 1.645-2.218l-.2-9.57a.5.5 0 0 1-.324-.025zm-5.458-12.46c-.9.04-1.717-.462-2.1-1.27s-.22-1.764.388-2.415 1.55-.87 2.383-.553 1.39 1.106 1.413 1.997a2.17 2.17 0 0 1-2.093 2.168v.075zm-9.97 115.744a.87.87 0 0 1-.725-.86.87.87 0 0 1 .725-.86.87.87 0 0 1 .725.86.87.87 0 0 1-.725.86zm15.352-16.27a1.47 1.47 0 0 1 0 2.915 1.47 1.47 0 0 1 0-2.915z",
    className: "F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M883.467 761.248l10.318-.224c5.19-.118 10.188-1.99 14.18-5.308l-29.907.673a5.36 5.36 0 0 0 5.408 4.859zm86.256-1.92l10.318-.224a5.41 5.41 0 0 0 5.209-4.984l-29.907.673a22.93 22.93 0 0 0 14.38 4.535zM949.785 643.6l.623 27.958h.424c.725-.013 1.425.264 1.944.77s.816 1.197.822 1.922a2.74 2.74 0 0 1-2.667 2.816 1.17 1.17 0 0 1-.424 0l.947 43.806a2.74 2.74 0 0 1 2.766 2.716c.027.725-.237 1.43-.733 1.96s-1.183.837-1.908.857l.15 6.553c.046 4.2 1.762 8.206 4.77 11.138a15.8 15.8 0 0 0 11.256 4.486h1.87c-3.395.047-6.67-1.26-9.1-3.63a12.78 12.78 0 0 1-3.859-9.004l-.798-30.3c-.395.228-.84.356-1.296.374a2.89 2.89 0 0 1-2.597-4.282 2.89 2.89 0 0 1 2.473-1.499c.457-.026.912.07 1.32.274l-.748-34.736c-.85-.104-1.5-.825-1.5-1.682s.64-1.578 1.5-1.682l-.374-17.89a2.69 2.69 0 0 1-.125-5.308v-2.492c-2.868 1.07-4.76 3.817-4.735 6.877zm4.436 48.216a1.42 1.42 0 0 1 0 2.816 1.42 1.42 0 0 1 0-2.816z",
    className: "P"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M980.34 748.24c-.34 1.534-1.685 2.637-3.256 2.672s-2.964-1.006-3.373-2.523h-6.08a15.8 15.8 0 0 1-11.256-4.486c-3.007-2.93-4.723-6.94-4.77-11.138l-.15-6.553a2.77 2.77 0 0 1-2.829-2.704c-.034-1.528 1.176-2.794 2.704-2.828l-.947-43.806c-1.302-.25-2.244-1.4-2.244-2.716s.94-2.465 2.244-2.716l-.598-27.833c-.06-3.083 1.84-5.865 4.735-6.927l-.424-19.51c-.04-1.905-1.094-3.644-2.764-4.562s-3.703-.875-5.333.112-2.6 2.77-2.57 4.674l.822 38.623c.392-.233.84-.353 1.296-.35.738-.013 1.45.27 1.98.784s.83 1.22.837 1.957a2.79 2.79 0 0 1-2.692 2.866c-.456-.008-.906-.1-1.32-.3l.45 24.744a3.54 3.54 0 0 1 1.047-.199 3.29 3.29 0 0 1 .15 6.553c-.365.017-.73-.042-1.072-.174l.947 44.23c0 .772 0 1.52.15 2.268.403-.28.88-.437 1.37-.45 1.376 0 2.492 1.116 2.492 2.492s-1.116 2.492-2.492 2.492h-.474c1.51 4.684 4.426 8.8 8.35 11.76l29.907-.673a2.69 2.69 0 0 0 0-.449 5.41 5.41 0 0 0-4.835-5.332zm-33.92-96.333c-.606 0-1.097-.49-1.097-1.096-.007-.29.102-.572.303-.783s.477-.332.768-.34a1.07 1.07 0 0 1 1.097 1.071 1.12 1.12 0 0 1-1.072 1.146zm.648-14.8c-1.285.052-2.372-.942-2.435-2.227s.923-2.38 2.207-2.452 2.387.904 2.47 2.187a2.29 2.29 0 0 1-.58 1.733c-.425.472-1.028.747-1.663.76zm.424 77.246a1.47 1.47 0 0 1 2.803-.647 1.47 1.47 0 0 1-1.86 1.993 1.47 1.47 0 0 1-.943-1.346zm5.632 32.393a1.22 1.22 0 0 1-1.246-1.221c0-.688.558-1.246 1.246-1.246s1.246.558 1.246 1.246a1.22 1.22 0 0 1-1.246 1.37v-.15zm6.48 5.258a1.22 1.22 0 0 1-1.221-1.196c-.001-.66.512-1.206 1.17-1.246.322-.007.632.116.862.34s.36.533.36.855c.042.343-.06.688-.282.952s-.544.425-.89.443v-.15zM824.227 689.51a16.75 16.75 0 0 1 11.917 4.754c3.184 3.104 5.002 7.346 5.055 11.79v1.645a18.66 18.66 0 0 0 5.634 13.141 18.67 18.67 0 0 0 13.282 5.299l8.922-.2c14.284-.447 25.505-12.38 25.072-26.662v-1.346a2.74 2.74 0 0 1-4.59-2.617 2.74 2.74 0 0 1 2.596-2.068 2.49 2.49 0 0 1 1.919.772l-.673-30.2c-1.09-.2-1.88-1.148-1.88-2.255s.79-2.056 1.88-2.255l-.2-8.447h-.25a1.62 1.62 0 0 1-1.62-1.62 1.62 1.62 0 0 1 1.62-1.62h.25l-.424-20.483c.08-1.994-.953-3.87-2.684-4.863a5.36 5.36 0 0 0-5.554.129c-1.683 1.074-2.628 2.995-2.454 4.983l.35 15.35a6.93 6.93 0 0 1 4.636 6.429l.374 16.77a1.37 1.37 0 0 1 .947 1.271 1.37 1.37 0 0 1-.897 1.296l.2 8.995c.28-.13.587-.2.897-.2a2.49 2.49 0 0 1 2.667 2.492c.03 1.426-1.07 2.623-2.492 2.716a2.74 2.74 0 0 1-.922-.15l.274 13.456c.186 7-2.646 13.745-7.776 18.514l-.822.997c.986.224 1.648 1.152 1.54 2.157s-.952 1.77-1.963 1.78a1.97 1.97 0 0 1-1.994-1.769c-2.625 1.938-5.785 3.017-9.047 3.1a2.17 2.17 0 0 1-4.312 0h-.374a16.05 16.05 0 0 1-6.48-1.221 2.74 2.74 0 0 1-4.984-1.694c-.013-.44.08-.876.274-1.27a16.27 16.27 0 0 1-3.863-5.283c-.377.224-.807.344-1.246.35-1.374-.09-2.455-1.21-2.494-2.586s.977-2.556 2.345-2.722c-.08-.553-.12-1.11-.125-1.67-.03-1.5-.215-3.012-.548-4.485a2.02 2.02 0 0 1-1.121-3.688 21.83 21.83 0 0 0-16.125-13.132c-.192 1.715-1.67 2.996-3.394 2.944s-3.122-1.42-3.2-3.143v-.324a10.72 10.72 0 0 1-3.863-1.57c-.232.116-.488.176-.748.174-.605-.014-1.168-.31-1.525-.797s-.465-1.115-.295-1.695a11.36 11.36 0 0 1-2.492-6.877l-.174-8.148a5.41 5.41 0 0 0-5.408-5.332l.324 14.95a16.07 16.07 0 0 0 4.673 11.404c3.01 3.03 7.105 4.736 11.377 4.743zm62.555-49.836c-.687-.013-1.245-.56-1.27-1.246 0-.688.558-1.246 1.246-1.246s1.246.558 1.246 1.246a1.27 1.27 0 0 1-1.221 1.296v-.05zm2.84 3.613a.7.7 0 0 1-.698-.698.7.7 0 0 1 .698-.698.7.7 0 0 1 .698.673.7.7 0 0 1-.698.797v-.075zm-3.913 70.99a.87.87 0 0 1 .897.872c.014.242-.072.48-.236.658s-.394.283-.636.29a.92.92 0 0 1-.922-.897.92.92 0 0 1 .897-.872v-.05zm-12.46 6.952c.29-.007.572.102.783.303s.332.477.34.768c0 .606-.49 1.096-1.097 1.096s-1.097-.49-1.097-1.096c.036-.55.473-.985 1.022-1.022l.05-.05zm-13.508.3a1.12 1.12 0 0 1 0 2.218 1.12 1.12 0 0 1-1.121-1.096c.013-.586.485-1.058 1.072-1.07l.05-.05zm-12.8-7.475c.687.013 1.245.56 1.27 1.246 0 .685-.553 1.24-1.238 1.246s-1.245-.545-1.254-1.23.536-1.248 1.22-1.262zm-3.2-12.46c.55-.014 1.007.42 1.02.972s-.42 1.007-.972 1.02-1.008-.42-1.022-.97c.01-.513.4-.933.922-.972l.05-.05zm-4.062-8.198a.97.97 0 1 1 0 1.944.97.97 0 1 1 0-1.944zm-6.73-6.08a2.02 2.02 0 0 1 1.571 3.398 2.02 2.02 0 0 1-3.49-1.354c-.002-1.054.817-1.928 1.87-1.993l.05-.05zm-14.73-3.14c.348-.007.684.127.933.37s.388.577.388.925a1.32 1.32 0 0 1-2.246.968 1.32 1.32 0 0 1 .925-2.263zm-7.178-16.82a.92.92 0 0 1 .947.922c.014.246-.075.488-.244.667s-.406.28-.653.28c-.458-.075-.794-.47-.794-.934s.336-.86.794-.934h-.05zm.224 7.475c.264-.007.52.092.712.274s.303.433.3.698a1.02 1.02 0 0 1-.972 1.022c-.54 0-.983-.43-.997-.972a.97.97 0 0 1 .897-1.047l.05.025z",
    className: "F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M894.258 703.687v-4.435c.42 14.277-10.794 26.202-25.072 26.662l-8.922.2a18.67 18.67 0 0 1-13.282-5.299 18.66 18.66 0 0 1-5.634-13.141v-1.645a16.72 16.72 0 0 0-16.972-16.521c-8.86.097-16.126-7-16.25-15.848l-.324-14.95a5.41 5.41 0 0 0-5.209 5.557l.174 8.148c.072 5.803 2.447 11.34 6.602 15.4a21.85 21.85 0 0 0 15.553 6.214 11.06 11.06 0 0 1 7.877 3.143c2.104 2.053 3.305 4.857 3.338 7.796.092 7.175 3.033 14.02 8.175 19.025s12.063 7.762 19.24 7.662h4.685c14.88-.595 26.496-13.076 26.02-27.958zm-6.355-7.75l-.274-13.456a2.62 2.62 0 0 1-1.745-2.492c-.016-1.082.624-2.067 1.62-2.492l-.174-8.97a1.12 1.12 0 0 1-.399 0 1.3 1.3 0 0 1-.933-.37 1.29 1.29 0 0 1-.388-.925 1.27 1.27 0 0 1 1.271-1.346.65.65 0 0 1 .374 0l-.35-16.82a6.93 6.93 0 0 0-4.636-6.404l.2 9.967c1.392.138 2.46 1.293 2.492 2.7a2.69 2.69 0 0 1-2.467 2.99l.972 45.774c.095 3.8-1.13 7.516-3.464 10.515 5.202-4.8 8.082-11.594 7.9-18.664z",
    className: "P"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.997 692.673c-1.664 0-3.025-1.327-3.065-3-.03-1.182.63-2.273 1.695-2.79-3.167-8.118-11.023-13.434-19.738-13.356-.202 1.115-1.172 1.926-2.305 1.926s-2.104-.81-2.305-1.926l-24.548.548c-1.462.04-2.922-.13-4.336-.498-.484.933-1.44 1.526-2.492 1.545-1.656.014-3.013-1.3-3.04-2.965a2.89 2.89 0 0 1 .174-1.047c-4.383-3.084-7.03-8.073-7.128-13.43l-.125-4.984c-.157.028-.317.028-.474 0-1.046 0-1.894-.848-1.894-1.894s.848-1.894 1.894-1.894h.474v-1.77c-.232.025-.466.025-.698 0a3.74 3.74 0 0 1-3.826-3.65 3.74 3.74 0 0 1 3.651-3.825c.24-.035.483-.035.723 0l-.324-14.776c.08-1.994-.953-3.87-2.684-4.863a5.36 5.36 0 0 0-5.554.129c-1.683 1.074-2.628 2.995-2.454 4.983l.598 27.06a27.73 27.73 0 0 0 5.632 16.222c.736-.885 1.816-1.41 2.966-1.445 1.662.003 3.15 1.03 3.74 2.584a4.01 4.01 0 0 1-1.075 4.418 26.47 26.47 0 0 0 16.374 5.183l9.37-.2a4.04 4.04 0 0 1 8-.174l10.318-.25v-.35a3.14 3.14 0 0 1 3.016-3.19 3.09 3.09 0 0 1 3.14 3.065 2.49 2.49 0 0 1-.125.947c6.472 1.742 10.994 7.577 11.065 14.278v9.245c.28 9.8-7.406 17.965-17.196 18.3-9.777.14-17.82-7.667-17.97-17.443l-.174-8.323a5.41 5.41 0 0 0-5.109 5.557v1.645c.068 3.117.693 6.197 1.844 9.095h.374a3.24 3.24 0 0 1 3.29 3.19c.018.805-.266 1.588-.798 2.193 1.48 2.117 3.268 4 5.308 5.582a4.14 4.14 0 0 1 1.745-.473c1.05-.02 2.067.378 2.824 1.107a3.96 3.96 0 0 1 1.213 2.78c3.255 1.37 6.763 2.032 10.293 1.944 1.423-.023 2.84-.173 4.237-.45v-.274c-.04-1.216.405-2.398 1.237-3.287s1.983-1.41 3.2-1.448a4.51 4.51 0 0 1 3.738 1.869 26.04 26.04 0 0 0 7.826-7.301l-.498-22.775a10.86 10.86 0 0 0-.025-1.346zm-72.274-60.725c1.532.105 2.73 1.36 2.763 2.896s-1.112 2.84-2.638 3c-1.532-.105-2.73-1.36-2.763-2.896s1.112-2.84 2.638-3zm-2.492 18.4c-.752 0-1.37-.594-1.396-1.346-.013-.36.12-.713.367-.975s.592-.414.953-.42a1.32 1.32 0 0 1 1.371 1.321c.02.36-.106.715-.35.982s-.585.425-.947.438zm2.766 5.906a1.32 1.32 0 0 1-1.346-1.321c-.014-.734.562-1.343 1.296-1.37.743 0 1.346.602 1.346 1.346s-.603 1.346-1.346 1.346h.05zm60.636 25.192c-.55-.012-.996-.448-1.022-.997a1.02 1.02 0 0 1 1.566-1.016 1.02 1.02 0 0 1 .453 1.016c-.013.278-.136.54-.34.726s-.477.284-.755.27h.1zm-10.467 45.7a2.12 2.12 0 0 1 0-4.211c.55-.013 1.083.196 1.477.58s.616.912.616 1.463a2.07 2.07 0 0 1-2.193 2.168h.1zm16.125-8.198a1.87 1.87 0 0 1-1.894-1.844 1.87 1.87 0 0 1 1.844-1.893 1.87 1.87 0 0 1 1.894 1.844 1.87 1.87 0 0 1-1.844 1.894zm3.215-8.05c-.853 0-1.545-.692-1.545-1.545s.692-1.545 1.545-1.545c.844 0 1.532.677 1.545 1.52a1.52 1.52 0 0 1-1.545 1.57z",
    className: "F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.318 699.55a2.69 2.69 0 0 1 2.492-2.741 2.81 2.81 0 0 1 1.495.424v-3.763c-.126-7.393-3.4-14.38-8.997-19.212a3.79 3.79 0 0 1-2.318.872 3.89 3.89 0 0 1-2.764-1.103c-.738-.72-1.16-1.703-1.174-2.734a4.51 4.51 0 0 1 0-.997 25.05 25.05 0 0 0-10.916-2.243l-8.648.2c.012.15.012.3 0 .45.027 1.22-.6 2.36-1.642 2.994s-2.345.66-3.414.075-1.745-1.7-1.772-2.92v-.45l-14.206.324c-8.992.1-16.424-6.987-16.748-15.972l.125 4.984a16.79 16.79 0 0 0 7.128 13.43c.395-1.174 1.478-1.98 2.717-2.018a3.01 3.01 0 0 1 3.04 2.965 2.89 2.89 0 0 1-.374 1.545 16.55 16.55 0 0 0 4.336.498l24.5-.548a2.49 2.49 0 0 1 0-.424c-.093-.9.335-1.772 1.102-2.25a2.37 2.37 0 0 1 2.507 0c.767.478 1.195 1.352 1.102 2.25a2.24 2.24 0 0 1 0 .449 21.06 21.06 0 0 1 19.738 13.356 2.99 2.99 0 0 1 1.246-.324c1.6.1 2.844 1.382 2.9 2.972a3.06 3.06 0 0 1-2.715 3.133 14.55 14.55 0 0 1 .125 1.819l.498 22.75a26.26 26.26 0 0 0 4.785-15.549 2.74 2.74 0 0 1-1.47.498 2.69 2.69 0 0 1-2.667-2.741zm-48.673-27.584c-.4 0-.7-.308-.723-.698a.75.75 0 0 1 .698-.748.75.75 0 0 1 .723.723c0 .4-.308.7-.698.723zm52.137 33.266c.15.53-.048 1.095-.497 1.413s-1.05.318-1.498 0-.648-.884-.497-1.413a1.32 1.32 0 0 1 1.271-1.346c.676.078 1.177.666 1.146 1.346h.075zm-27.215 16.098a17.74 17.74 0 0 0 17.197-18.29v-1.22a14.95 14.95 0 0 1-6.537 14.582 14.96 14.96 0 0 1-15.978.35 14.95 14.95 0 0 1-7.167-14.283v-1.62a5.41 5.41 0 0 0-5.458-5.332h-.125l.2 8.323c.046 4.7 1.955 9.17 5.307 12.45a17.67 17.67 0 0 0 12.562 5.042z",
    className: "P"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.573 686.593a3.34 3.34 0 0 0 3.215-3.09c-1.43-.256-2.883-.373-4.336-.35-.76.018-1.52-.04-2.268-.174v.324c.04 1.838 1.55 3.303 3.39 3.29z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 832.95,
    cy: 689.359,
    rx: 1.969,
    ry: 1.993
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.697 681.585c.256-.022.508-.08.748-.174-.942-.634-1.782-1.407-2.492-2.292-.024.207-.024.416 0 .623.023.97.776 1.768 1.745 1.844z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 811.018,
    cy: 668.353,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 811.242,
    cy: 675.804,
    r: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.196,
    cy: 685.547,
    rx: 1.296,
    ry: 1.321
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.629,
    cy: 694.418,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.015 698.355a1.97 1.97 0 0 0 2.019 1.944c-.273-1.255-.666-2.482-1.17-3.663-.565.384-.887 1.037-.847 1.72z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.691,
    cy: 702.666,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.24 709.12a2.64 2.64 0 0 0 2.667 2.492 2.69 2.69 0 0 0 1.246-.374 17.09 17.09 0 0 1-1.371-4.984 2.64 2.64 0 0 0-2.542 2.866z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.906,
    cy: 715.274,
    rx: 1.246,
    ry: 1.271
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.557 720.607c.81-.022 1.57-.406 2.07-1.047a16.6 16.6 0 0 1-4.611-2.965c-.184.398-.278.832-.274 1.27a2.79 2.79 0 0 0 2.816 2.741z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 859.716,
    cy: 722.675,
    rx: 1.097,
    ry: 1.121
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.697 722.725c1.117-.035 2.03-.904 2.118-2.018h-4.262a2.22 2.22 0 0 0 2.143 2.018z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 873.224,
    cy: 722.376,
    rx: 1.097,
    ry: 1.121
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.863 717.616a1.97 1.97 0 0 0 3.913-.274c.001-.902-.618-1.686-1.495-1.894-.74.794-1.548 1.52-2.417 2.168z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 885.71,
    cy: 715.224,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.473 696.062a2.74 2.74 0 0 0 2.766 2.716 2.79 2.79 0 0 0 1.894-.847v-3.912a2.49 2.49 0 0 0-1.919-.772 2.74 2.74 0 0 0-2.741 2.816zm-.922-13.406c1.424-.093 2.522-1.3 2.492-2.716a2.49 2.49 0 0 0-2.667-2.492c-.315.005-.627.064-.922.174l.125 4.984c.316.088.648.105.972.05z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M885.86 680.04a2.64 2.64 0 0 0 1.745 2.492v-4.984a2.64 2.64 0 0 0-1.745 2.492z",
    className: "F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M888.202 667.232a1.32 1.32 0 0 0-.947-1.271v2.492a1.27 1.27 0 0 0 .947-1.221z",
    className: "I"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M885.585 667.282c0 .348.14.68.388.925s.585.377.933.37a1.02 1.02 0 0 0 .399 0v-2.492h-.4c-.68.008-1.245.52-1.32 1.196z",
    className: "F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M891.442 661.576c.01 1.123.834 2.072 1.944 2.243v-4.56a2.32 2.32 0 0 0-1.944 2.317z",
    className: "I"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M884.987 655.37c-.03-1.398-1.1-2.553-2.492-2.69v5.482a2.74 2.74 0 0 0 2.492-2.791z",
    className: "F"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.193 649.29c.027.89.756 1.595 1.645 1.595h.25v-3.214h-.25a1.62 1.62 0 0 0-1.645 1.62z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 886.757,
    cy: 638.452,
    rx: 1.246,
    ry: 1.271
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 889.598,
    cy: 642.638,
    r: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 908.962,
    cy: 635.511,
    rx: 2.168,
    ry: 2.193
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.355 647.223a3.09 3.09 0 0 0 3.115 3.015h.424l-.15-6.155h-.3c-1.71.04-3.077 1.43-3.1 3.14z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M906.37 654.972c.007.568.24 1.11.645 1.508s.954.617 1.523.6c.274-.008.545-.067.798-.174v-4.037c-.255-.052-.518-.052-.773 0-.568-.013-1.12.2-1.53.592s-.65.932-.663 1.5z",
    className: "F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M910.632 654.873a2.17 2.17 0 0 0-1.396-1.993v4.037c.842-.33 1.396-1.14 1.396-2.043zM913.35 662a2.22 2.22 0 0 0 1.745 2.118v-4.36c-1.03.254-1.752 1.18-1.745 2.243z",
    className: "I"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M907.417 668.28a2.74 2.74 0 0 0 2.143 2.492l-.125-5.283a2.69 2.69 0 0 0-2.019 2.791z",
    className: "F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M910.233 670.77a2.72 2.72 0 0 0 2.654-2.778 2.72 2.72 0 0 0-2.779-2.654h-.598l.125 5.283c.19.078.393.128.598.15z",
    className: "I"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M908.04 692.848a2.79 2.79 0 0 0 2.118 2.666v-5.432a2.79 2.79 0 0 0-2.118 2.766z",
    className: "F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M910.857 695.69c1.446-.165 2.528-1.405 2.496-2.86s-1.168-2.646-2.62-2.746a2.74 2.74 0 0 0-.673 0v5.432a2.99 2.99 0 0 0 .798.174zm2.143 3.29c.007.555.233 1.085.63 1.473s.932.602 1.488.595a1.57 1.57 0 0 0 .748-.174v-3.912c-.247-.05-.5-.05-.748 0a2.12 2.12 0 0 0-2.118 2.018zm.324-16.57c.007.463.197.904.53 1.226s.778.5 1.24.493h.424v-3.414a1.17 1.17 0 0 0-.424 0c-.462-.02-.913.15-1.247.47s-.523.763-.523 1.225z",
    className: "I"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M908.54 716.27a2.49 2.49 0 0 0 2.118 2.492v-4.984a2.49 2.49 0 0 0-2.118 2.492z",
    className: "F"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.006 718.688c1.376 0 2.492-1.116 2.492-2.492s-1.116-2.492-2.492-2.492h-.374v4.984h.374zm1.396 9.22a2.69 2.69 0 0 0 2.692 2.492c.47-.006.927-.144 1.32-.4v-4.635c-.828-.603-1.94-.637-2.806-.087a2.49 2.49 0 0 0-1.107 2.579l-.1.05zm-27.863 26.488c1.628-.054 2.908-1.412 2.866-3.04a3.91 3.91 0 0 0-.224-1.071h-3.963c-.543.004-1.082.096-1.595.274-.026.265-.026.532 0 .797a2.94 2.94 0 0 0 2.916 3.04z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.068,
    cy: 752.601,
    r: 1
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M907.417 742.81a2.49 2.49 0 0 0-1.769-2.492 12.46 12.46 0 0 1-2.168 4.585c.426.31.944.47 1.47.45a2.49 2.49 0 0 0 2.467-2.542z",
    className: "F"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.458 749.437c-.038.995.443 1.938 1.27 2.492 1.2-1.53 2.178-3.203 2.94-4.984a2.74 2.74 0 0 0-1.421-.349 2.89 2.89 0 0 0-2.791 2.841z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 914.495,
    cy: 738.622,
    rx: 1.421,
    ry: 1.445
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.9 740.367c0-1.376-1.116-2.492-2.492-2.492-.49.01-.968.167-1.37.45a25.44 25.44 0 0 0 .997 4.585h.474c1.357-.054 2.42-1.184 2.393-2.542z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 953.1,
    cy: 745.624,
    rx: 1.246,
    ry: 1.271
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 959.579,
    cy: 750.957,
    rx: 1.196,
    ry: 1.221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.2 750.857c1.517-.026 2.84-1.036 3.265-2.492h-.523l-6.106.15a3.49 3.49 0 0 0 3.364 2.342z"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M954.097 723.522a2.74 2.74 0 0 0-2.766-2.716l.125 5.532c.725-.02 1.412-.328 1.908-.857s.76-1.234.733-1.96z",
    className: "F"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.713 723.647c.007.725.302 1.417.822 1.922s1.22.782 1.944.77l-.125-5.532a2.74 2.74 0 0 0-2.642 2.841z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 948.938,
    cy: 714.352,
    rx: 1.421,
    ry: 1.445
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M951.68 703.164c.007.76.315 1.486.857 2.02s1.274.828 2.034.822a2.79 2.79 0 0 0 1.296-.349v-5.158c-.404-.22-.86-.323-1.32-.3a2.89 2.89 0 0 0-2.866 2.965z",
    className: "F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M949.112 688.637c0-.866-.35-1.695-.968-2.3s-1.456-.935-2.322-.915a2.89 2.89 0 0 0-1.047.199l.125 6.205c.347.108.708.167 1.072.174a3.24 3.24 0 0 0 3.14-3.364z",
    className: "I"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.121,
    cy: 693.222,
    rx: 1.396,
    ry: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.473 674.234c-.007-.725-.302-1.417-.822-1.922s-1.22-.782-1.944-.77h-.424v5.432h.424a2.79 2.79 0 0 0 2.766-2.741z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M948.065 674.36c.03 1.33 1.004 2.45 2.318 2.666v-5.432c-1.362.2-2.358 1.4-2.318 2.766z",
    className: "I"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M953.25 664.192c.027.916.778 1.645 1.695 1.645v-3.34c-.454-.014-.893.16-1.214.48s-.495.76-.48 1.214z",
    className: "F"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.265 658.31c.027-.994-.48-1.926-1.332-2.44s-1.912-.535-2.78-.05v4.984a2.94 2.94 0 0 0 1.321.299c.742.007 1.456-.285 1.98-.8s.817-1.24.8-1.98z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 946.396,
    cy: 650.786,
    rx: 1.097,
    ry: 1.121
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 947.019,
    cy: 634.789,
    rx: 2.293,
    ry: 2.317
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M952.277 642c.056 1.305 1.067 2.37 2.368 2.492l-.125-5.332c-1.362.238-2.327 1.46-2.243 2.84z",
    className: "F"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.947,
    cy: 634.913,
    rx: 2.916,
    ry: 2.965
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.346 643.834a3.64 3.64 0 0 0 3.688 3.613c.24.024.482.024.723 0l-.15-6.03v-1.246c-.232-.025-.466-.025-.698 0a3.64 3.64 0 0 0-3.564 3.663z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 967.081,
    cy: 648.967,
    rx: 1.346,
    ry: 1.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.872,
    cy: 654.898,
    rx: 1.321,
    ry: 1.346
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.464 650.986c.027 1.036.882 1.858 1.92 1.844.157.026.317.026.474 0v-3.613c-.165-.026-.333-.026-.498 0-1-.002-1.828.772-1.894 1.77zm4.312 20.333a3.91 3.91 0 0 0-2.596-3.745c-1.578-.564-3.34-.06-4.382 1.254 1.602 2.105 3.5 3.968 5.632 5.532.88-.76 1.375-1.876 1.346-3.04zm8.174 3.887c1.05-.02 2.008-.612 2.492-1.545-1.926-.49-3.743-1.334-5.358-2.492-.12.336-.178.7-.174 1.047-.007.804.313 1.576.886 2.14s1.35.87 2.155.85z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.84 672.116c-.026-1.43-1.07-2.64-2.484-2.872s-2.8.578-3.273 1.925c1.62 1.147 3.437 1.99 5.358 2.492.285-.463.424-1.002.4-1.545z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.545,
    cy: 671.269,
    r: 1
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.137 675.754a4.04 4.04 0 0 0-3.913 3.563l8-.174a4.09 4.09 0 0 0-4.087-3.389z",
    className: "I"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.25 672.24a3.44 3.44 0 0 0 3.34-3.538v-.45l-6.78.15v.45c.007.905.373 1.77 1.018 2.407s1.516.99 2.422.982z",
    className: "F"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1022.508 675.43a3.14 3.14 0 0 0-3.016 3.214 1.77 1.77 0 0 0 0 .349h1.92c1.38-.036 2.757.132 4.087.498a4.11 4.11 0 0 0 .125-.947c0-1.72-1.395-3.115-3.115-3.115z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1030.508,
    cy: 680.414,
    rx: 1,
    ry: 1.022
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.67 675.53a2.32 2.32 0 0 0 2.243-2.018h-4.61a2.49 2.49 0 0 0 2.368 2.018z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.938 673.51c.012-.14.012-.283 0-.424.093-.9-.335-1.772-1.102-2.25a2.37 2.37 0 0 0-2.506 0c-.767.478-1.195 1.352-1.102 2.25-.014.14-.014.283 0 .424h4.7z",
    className: "F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.982 689.683c.04 1.663 1.4 2.99 3.065 3a21.3 21.3 0 0 0-1.421-5.806c-1.052.536-1.695 1.636-1.645 2.816z",
    className: "I"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.963 689.56a3.04 3.04 0 0 0-3.065-2.99c-.426.016-.843.126-1.22.324.744 1.85 1.222 3.797 1.42 5.78 1.634-.106 2.896-1.478 2.866-3.115zm2.417 7.675c-.45-.28-.967-.425-1.495-.424a2.69 2.69 0 0 0-2.492 2.741 2.64 2.64 0 0 0 2.692 2.492 2.49 2.49 0 0 0 1.445-.498v-.125l-.15-4.186zm-11.414-22.102a3.74 3.74 0 0 0 2.318-.872c-1.853-1.607-3.926-2.94-6.156-3.962a4.51 4.51 0 0 0 0 .997c.014 2.114 1.724 3.824 3.838 3.837z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1045.436,
    cy: 705.257,
    rx: 1.271,
    ry: 1.296
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1039.355,
    cy: 709.344,
    rx: 1.52,
    ry: 1.545
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1036.165,
    cy: 717.043,
    rx: 1.869,
    ry: 1.894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.156 722.675a4.61 4.61 0 0 0-4.461 4.734c-.012.083-.012.167 0 .25 2.89-.556 5.656-1.62 8.174-3.14-.862-1.184-2.25-1.872-3.713-1.844z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1020.016,
    cy: 725.017,
    rx: 2.069,
    ry: 2.118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.203 722.3a4.14 4.14 0 0 0-1.769.473 25.05 25.05 0 0 0 5.782 3.414c-.04-2.178-1.833-3.915-4.012-3.887zm-9.57-10.515h-.374a24.47 24.47 0 0 0 2.891 5.332c.827-.97 1.014-2.333.478-3.49s-1.696-1.896-2.97-1.893l-.025.05z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 803.018,
    cy: 669.45,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    className: "H"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 805.56,
    cy: 680.937,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    className: "H"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.635,
    cy: 690.854,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    className: "H"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 824.7,
    cy: 693.77,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    x: 11.065,
    y: 2.915,
    className: "H"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 835.143,
    cy: 699.501,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dq",
    className: "H"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 837.037,
    cy: 711.412,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: 34.019,
    y: 41.938,
    className: "H"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 841.174,
    cy: 721.304,
    rx: 3.34,
    ry: 3.389,
    className: "F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M841.224 723.273c-.812.04-1.567-.416-1.91-1.153s-.2-1.61.355-2.2 1.417-.788 2.175-.495 1.262 1.018 1.273 1.83a1.97 1.97 0 0 1-1.894 2.018z",
    className: "H"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 849.274,
    cy: 727.908,
    rx: 3.34,
    ry: 3.389,
    className: "F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M849.3 729.85c-1.01-.113-1.77-.966-1.77-1.98s.763-1.868 1.77-1.98a2.02 2.02 0 0 1 1.994 1.944 1.97 1.97 0 0 1-1.994 2.018z",
    className: "H"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 859.268,
    cy: 730.624,
    rx: 3.34,
    ry: 3.389,
    className: "F"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dr",
    className: "H"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 870.383,
    cy: 730.798,
    rx: 3.34,
    ry: 3.389,
    className: "F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M870.408 732.79c-.808.03-1.554-.43-1.89-1.166s-.192-1.6.36-2.2 1.408-.786 2.163-.498 1.262 1.003 1.283 1.812a2.02 2.02 0 0 1-1.919 2.043z",
    className: "H"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 880.402,
    cy: 727.932,
    rx: 3.34,
    ry: 3.389,
    className: "F"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dr",
    x: 21.135,
    y: -2.691,
    className: "H"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 888.377,
    cy: 721.529,
    rx: 2.766,
    ry: 2.816,
    className: "F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M888.402 723.098c-.667.02-1.28-.365-1.552-.974s-.148-1.323.313-1.805 1.168-.64 1.8-.395 1.034.838 1.045 1.506c.014.9-.696 1.642-1.595 1.67z",
    className: "H"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 883.043,
    cy: 760.426,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M883.068 762.27a1.82 1.82 0 0 1-1.844-1.794 1.82 1.82 0 0 1 1.819-1.819 1.82 1.82 0 0 1 1.819 1.819c0 .99-.803 1.794-1.794 1.794z",
    className: "H"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 891.342,
    cy: 760.251,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ds",
    className: "H"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 899.666,
    cy: 760.052,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M899.716 761.92a1.87 1.87 0 0 1-1.465-3.142 1.87 1.87 0 0 1 3.235 1.248c.028 1.01-.76 1.853-1.77 1.894z",
    className: "H"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 964.041,
    cy: 758.631,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ds",
    x: 72.708,
    y: -1.62,
    className: "H"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 972.365,
    cy: 758.432,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M972.39 760.276a1.82 1.82 0 0 1-1.844-1.794 1.82 1.82 0 0 1 2.777-1.751 1.82 1.82 0 0 1 .836 1.751c0 .98-.788 1.78-1.77 1.794z",
    className: "H"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 980.689,
    cy: 758.258,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M980.713 760.102c-1.01 0-1.83-.8-1.844-1.82a1.82 1.82 0 0 1 1.769-1.869c1.01-.014 1.842.785 1.87 1.794a1.87 1.87 0 0 1-1.794 1.894z",
    className: "H"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1005.686,
    cy: 700.797,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: 202.667,
    y: 31.372,
    className: "H"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1009.848,
    cy: 712.209,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dt",
    className: "H"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1019.866,
    cy: 717.417,
    rx: 3.115,
    ry: 3.165,
    className: "F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.89 719.26a1.82 1.82 0 0 1-1.844-1.794 1.82 1.82 0 0 1 2.729-1.575 1.82 1.82 0 0 1 .91 1.575 1.87 1.87 0 0 1-1.794 1.794z",
    className: "H"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.971,
    cy: 620.735,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    x: -3.58,
    y: -60.178,
    className: "H"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 807.903,
    cy: 628.634,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: 4.885,
    y: -40.89,
    className: "H"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 817.398,
    cy: 632.447,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dp",
    x: 3.763,
    y: -58.433,
    className: "H"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.52,
    cy: 637.355,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dt",
    x: -183.327,
    y: -74.877,
    className: "H"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.084,
    cy: 647.273,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M830.158 649.6a2.32 2.32 0 0 1-2.206-1.348c-.393-.856-.23-1.864.415-2.55a2.32 2.32 0 0 1 2.519-.58c.88.336 1.468 1.17 1.49 2.113a2.29 2.29 0 0 1-.618 1.643c-.416.444-.992.704-1.6.724z",
    className: "H"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.333,
    cy: 658.685,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dq",
    x: -4.76,
    y: -40.815,
    className: "H"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.557,
    cy: 670.123,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Du",
    className: "H"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 798.557,
    cy: 722.251,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M798.607 724.57c-1.194-.124-2.1-1.13-2.1-2.33s.907-2.206 2.1-2.33c1.275 0 2.316 1.018 2.343 2.292a2.29 2.29 0 0 1-.662 1.688c-.443.448-1.05.694-1.68.68z",
    className: "H"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 808.077,
    cy: 722.027,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    className: "H"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 816.7,
    cy: 727.359,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: 13.682,
    y: 57.91,
    className: "H"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 820.04,
    cy: 737.451,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M820.2 739.793a2.32 2.32 0 0 1-2.318-2.317 2.32 2.32 0 0 1 2.318-2.317 2.32 2.32 0 0 1 2.318 2.317 2.32 2.32 0 0 1-2.318 2.317z",
    className: "H"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 823.554,
    cy: 747.717,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M823.604 750.035c-.953.04-1.836-.5-2.23-1.37a2.34 2.34 0 0 1 .431-2.582c.656-.693 1.667-.918 2.555-.57a2.34 2.34 0 0 1 1.488 2.154 2.29 2.29 0 0 1-.627 1.652c-.42.445-1.003.702-1.616.715z",
    className: "H"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.881,
    cy: 754.52,
    rx: 2.891,
    ry: 2.94,
    className: "F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M830.906 756.214c-.445.013-.876-.154-1.195-.464s-.5-.736-.5-1.18a1.67 1.67 0 0 1 1.62-1.744c.936 0 1.695.76 1.695 1.694s-.76 1.694-1.695 1.694h.075z",
    className: "H"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1053.387,
    cy: 716.67,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.436 718.987c-.953.04-1.836-.5-2.23-1.37a2.34 2.34 0 0 1 .431-2.582c.656-.693 1.667-.918 2.555-.57a2.34 2.34 0 0 1 1.488 2.154 2.32 2.32 0 0 1-2.243 2.367z",
    className: "H"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1064.228,
    cy: 719.61,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    x: 258.678,
    y: 38.697,
    className: "H"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1072.377,
    cy: 727.858,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.427 730.2a2.32 2.32 0 0 1-2.318-2.317 2.32 2.32 0 0 1 2.318-2.317 2.27 2.27 0 0 1 1.636.646c.436.427.682 1.01.682 1.62a2.29 2.29 0 0 1-.653 1.679c-.438.447-1.04.696-1.665.69z",
    className: "H"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1074.247,
    cy: 738.772,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    x: 266.269,
    y: 16.744,
    className: "H"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1069.337,
    cy: 748.664,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Do",
    x: 263.812,
    y: 67.777,
    className: "H"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1040.726,
    cy: 626.092,
    rx: 2.667,
    ry: 2.716,
    className: "F"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dw",
    className: "H"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1042.595,
    cy: 619.788,
    rx: 2.667,
    ry: 2.716,
    className: "F"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dw",
    x: 1.869,
    y: -6.304,
    className: "H"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1063.729,
    cy: 616.574,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dv",
    x: 255.653,
    y: -105.454,
    className: "H"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1063.979,
    cy: 628.31,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dn",
    x: 260.96,
    y: -41.164,
    className: "H"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1064.228,
    cy: 640.022,
    rx: 3.938,
    ry: 4.012,
    className: "F"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Du",
    x: 233.671,
    y: -30.1,
    className: "H"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1062.757,
    cy: 650.811,
    rx: 3.215,
    ry: 3.289,
    className: "F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.807 652.705a1.92 1.92 0 0 1-1.919-1.894 1.87 1.87 0 0 1 1.869-1.843 1.87 1.87 0 0 1 1.869 1.844 1.87 1.87 0 0 1-1.819 1.893z",
    className: "H"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1057.025,
    cy: 658.66,
    rx: 2.766,
    ry: 2.816,
    className: "F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.075 660.28c-.436.007-.857-.16-1.17-.464s-.493-.72-.5-1.156a1.67 1.67 0 0 1 1.595-1.694 1.67 1.67 0 0 1 0 3.314h.075z",
    className: "H"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.386 608.102h-.673l-1.52-71.4c-.174-7.2-4.8-13.082-12.984-12.908l-6.804.15a13.81 13.81 0 0 1 12.835 8.098 3.73 3.73 0 0 1 1.82-.45 4.01 4.01 0 1 1 .174 8.024 2.72 2.72 0 0 1-.698 0v4.087c.224-.026.45-.026.673 0a4.04 4.04 0 0 1 .174 8.049h-.673v4.087a2.64 2.64 0 0 1 .648 0 3.86 3.86 0 0 1 3.863 3.938 3.81 3.81 0 0 1-.982 2.814c-.696.766-1.672 1.216-2.707 1.248h-.648v4.1h.648c2.012.177 3.57 1.84 3.614 3.86a3.96 3.96 0 0 1-3.44 4.015h-.523v4.1h.648c2.042-.042 3.734 1.572 3.788 3.613a3.54 3.54 0 0 1-3.489 3.912h-.673v4.136h.648a3.74 3.74 0 0 1 3.64 4.012c0 2.218-1.047 3.763-3.215 3.812h-.897v4.1h.648a3.89 3.89 0 0 1 2.807 1.12c.746.737 1.163 1.743 1.156 2.792-.012 2.176-1.737 3.957-3.913 4.037-.15.012-.3.012-.45 0 .297 1.517.713 3 1.246 4.46a2.79 2.79 0 0 1 .997-.15s3.688 1.246 3.713 3.3a3.71 3.71 0 0 1-1.595 3.165 25.27 25.27 0 0 0 2.492 3.115 4.11 4.11 0 0 1 .897-.548 2.89 2.89 0 0 1 1.047-.199 3.09 3.09 0 0 1 3.14 3.065c.016.54-.113 1.073-.374 1.545a24.37 24.37 0 0 0 13.882 3.862h5.807c-6.613.02-12.958-2.614-17.6-7.313a24.67 24.67 0 0 1-7.137-17.68zm-39.576-46c-.96-.276-1.624-1.155-1.624-2.155a2.24 2.24 0 0 1 1.624-2.155l-.3-14.004c-.523 0-.424.224-.598.224a2.49 2.49 0 0 1-1.445-.498 2.61 2.61 0 0 1-1.17-2.093 2.49 2.49 0 0 1 2.019-2.517 1.62 1.62 0 0 1 .523 0c.207.025.416.025.623 0v-.224a19.06 19.06 0 0 1 3.614-11.886 2.49 2.49 0 0 1-.249-.997c-.02-.588.194-1.16.596-1.6a2.22 2.22 0 0 1 1.547-.702 2.53 2.53 0 0 1 .972.224l1.22-.947-1.22.972c.13-.122.272-.23.424-.324l.773-.623.648-.45a16.73 16.73 0 0 1 2.492-1.495c2.17-.937 4.492-1.47 6.854-1.57v-.523c.001-.708.278-1.387.773-1.894h.125a2.74 2.74 0 0 1 1.67-.648h.673l.45.15h.15c1.037.4 1.734 1.38 1.77 2.492v.424l10.143-.224a23.08 23.08 0 0 0-15.452-5.507c-6.505.15-12.682 2.884-17.167 7.597s-6.908 11.018-6.734 17.52l.548 24.918a5.71 5.71 0 0 0 5.832 5.432l-.15-6.678.05-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.545 516.28h.274l-.45-.15h.15zm-22.38 22.55h0-.4zm21.707-22.726h-.025zM805.7 557.792a2.12 2.12 0 0 0-1.545 2.193 2.29 2.29 0 0 1 .349-1.296 1.94 1.94 0 0 1 1.196-.897zm5.06-34.56a2.22 2.22 0 0 0-2.143 2.292 2.49 2.49 0 0 1 .324-1.221 2.17 2.17 0 0 1 1.819-1.071zm-6.08 15.474a1.64 1.64 0 0 0-.523 0 1.91 1.91 0 0 1 .523 0zm-.922.25h.4a2.49 2.49 0 0 0-1.819 1.52 2.77 2.77 0 0 1 1.42-1.52z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041.2 589.164c-.224-.374 0-.922 0-1.37h-.05c0-1.27.648-1.72 1.894-1.744.498 0 .822-.374 1.196 0a2.02 2.02 0 0 1 .623.673v.174a.51.51 0 0 0 0-.174v.324a23.2 23.2 0 0 0 7.726-8.821 2.07 2.07 0 0 1-.125-.897v-.922a1.97 1.97 0 0 1 .947-.847h.224a26.11 26.11 0 0 0 1.072-4.635v-.947a17.17 17.17 0 0 0 0-1.969v-1.37c-.25.094-.5.16-.773.2h-.15a1.62 1.62 0 0 1-1.52-1.595c-.03-.845.604-1.566 1.445-1.645v.025c.27.035.537.093.798.174l-.274-13.107a6.03 6.03 0 0 1-1.097-1.246c-.398.15-.82.227-1.246.224a3.94 3.94 0 0 1-2.806-1.1c-.753-.724-1.186-1.718-1.206-2.762a3.86 3.86 0 0 1 0-.772v-.224c-4.263-2.972-9.332-4.57-14.53-4.585a4.46 4.46 0 0 1 .449 1.844 4.1 4.1 0 0 1-1.12 2.866l-.2.174a3.74 3.74 0 0 1-2.492.997 3.86 3.86 0 0 1-3.913-3.813v-.997c-2.672.755-5.2 1.95-7.477 3.538a2.29 2.29 0 0 1 1.022 1.894 2.24 2.24 0 0 1-.374 1.271 2.22 2.22 0 0 1-1.844 1.071 2.3 2.3 0 0 1-1.52-.598 2.19 2.19 0 0 1-.598-.872c-1.094 1.058-2.095 2.208-3 3.44a3.24 3.24 0 0 1 1.545 2.716c.043 1.7-1.282 3.146-3 3.24a2.81 2.81 0 0 1-1.47-.45 26.76 26.76 0 0 0-1.919 10.889l.698 32.02s.4-.174.698-.174a2.02 2.02 0 0 1 2.044 2.043 2.17 2.17 0 0 1-2.069 2.193c-.3-.016-.595-.083-.872-.2a17.44 17.44 0 0 1-2.991 8.846 3.57 3.57 0 0 1 1.346 2.74 3.49 3.49 0 0 1-3.389 3.613 3.64 3.64 0 0 1-2.941-1.545 17.15 17.15 0 0 1-4.785 2.093 3.44 3.44 0 0 1 .623 1.894 3.61 3.61 0 0 1-.947 2.492 3.5 3.5 0 0 1-1.57.947c.596-.162 1.138-.48 1.57-.922a3.34 3.34 0 0 1-5.832-2.218c.016-.453.135-.896.35-1.296v-.25c-1.42 0-2.94-.174-4.336-.35a3.59 3.59 0 0 1-3.489 3.289 3.66 3.66 0 0 1-3.664-3.613 4.76 4.76 0 0 1 .224-1.346v-.125H978v.25c-4.272-1.463-8.278-3.6-11.863-6.354l-12.46-9.743-11.788.274.523 24.32h2.492c.158 2.9 2.537 5.16 5.433 5.183l34.9-.772c7.68-.247 14.946-3.538 20.196-9.147a28.92 28.92 0 0 0 7.79-20.754l-.723-33.24a15.77 15.77 0 0 1 5.508-12.459 15.25 15.25 0 0 1 9.72-3.862h2.916a7.2 7.2 0 0 1 .45-.648l-.45.573.474-.598c.548-.675 1.286-1.17 2.118-1.42a4.64 4.64 0 0 1 1.57-.324 4.94 4.94 0 0 0-1.495.3 5.86 5.86 0 0 1 1.495-.249c.15-.012.3-.012.45 0h1.072a5.21 5.21 0 0 1 3.439 3.538h-.15c5.18 2.567 8.484 7.824 8.548 13.605v3.24c.15 3.86-1.167 7.637-3.688 10.565h.125a2.89 2.89 0 0 1 .199.797c.012.05.012.1 0 .15.027.737-.247 1.454-.76 1.985a2.72 2.72 0 0 1-1.957.83 2.5 2.5 0 0 1-1.72-.473 14.97 14.97 0 0 1-6.804 1.744h-.15v.374a2.49 2.49 0 0 1-2.368 2.492 2.49 2.49 0 0 1-2.492-1.944 5.68 5.68 0 0 0-2.841 4.984l6.903-.174a21.86 21.86 0 0 0 8.598-1.445zm-87.826 30.973c0 .972 0 1.844-.972 1.87a1.77 1.77 0 0 1-1.794-1.744 1.87 1.87 0 0 1 1.67-1.819c.972 0 1.12.648 1.146 1.694h-.05zm13.632-4.435v.25c.04 1.913-1.476 3.497-3.4 3.538s-3.498-1.476-3.54-3.4c-.012-.058-.012-.117 0-.174a3.49 3.49 0 1 1 6.953-.15l-.025-.075zm21.832 10.814a1.97 1.97 0 0 1-1.969 1.969 1.97 1.97 0 0 1-1.969-1.969 1.97 1.97 0 0 1 1.969-1.969 1.97 1.97 0 0 1 1.969 1.969zm53.234-79.738h-.274c-.36-.054-.685-.25-.897-.548a.54.54 0 0 1 0-.15v-.274a1.82 1.82 0 0 1 0-.598 1.32 1.32 0 0 1 .548-.897h.723c.745.097 1.303.73 1.303 1.483s-.558 1.386-1.303 1.483l-.1-.498zm9.022 9.045h.424a1.1 1.1 0 0 1 .673.997.7.7 0 0 1 0 .224 1.59 1.59 0 0 1 0 .174 1.02 1.02 0 0 1-.972.673h-.424c-.395-.165-.657-.544-.673-.972a1.07 1.07 0 0 1 .972-1.146v.05zm-1.77 22.426a1.32 1.32 0 1 1 0 2.641 1.32 1.32 0 1 1 0-2.641zm-19.764 7.6h.025v-.025l-.025.025.025.025v-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.704 550.715c-.628-.838-1.498-1.464-2.492-1.794h-1.072c.895.036 1.76.33 2.492.847a4.76 4.76 0 0 1 1.072.947zm-22.18-2.043c-.203-.092-.388-.22-.548-.374a1.32 1.32 0 0 1-.573-.897v-.075c.13.354.334.677.598.947a2.49 2.49 0 0 0 .523.399zm35.3 16.27a1.57 1.57 0 0 1 1.421-1.67c-.852.08-1.49.816-1.445 1.67.013.834.686 1.507 1.52 1.52-.824-.026-1.482-.696-1.495-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.327 547.426a2.18 2.18 0 0 0 .598.872 2.19 2.19 0 0 1-.598-.872zm38.78 23.174a26.11 26.11 0 0 1-1.072 4.635 26.11 26.11 0 0 0 1.072-4.635zm-9.994 16.296c-.03-.096-.073-.188-.125-.274a.51.51 0 0 1 0 .174l.125.1zm10.143-19.212a17.17 17.17 0 0 1 0 1.969 17.17 17.17 0 0 0 0-1.969zm-12.36 17.742c.43-.02.857.093 1.22.324h.15a2.17 2.17 0 0 0-1.371-.399 2.32 2.32 0 0 0-2.268 2.317 2.32 2.32 0 0 1 2.268-2.243zM869.04 628.858a2.07 2.07 0 0 1-2.093-2.093 2.22 2.22 0 0 1 2.044-2.193 2.12 2.12 0 0 0-2.044 2.218c0 1.156.937 2.093 2.093 2.093v-.025zm-60.09-102.213h-.025.025zm62.13 99.97a2.14 2.14 0 0 1-.598 1.52 2.19 2.19 0 0 0 .598-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.184 602.645l-12.212 10.29c-2.903 2.46-6.142 4.49-9.62 6.03a5.48 5.48 0 0 1 1.57 3.613c.012 1.382-.516 2.714-1.47 3.713l-.474.424c-.883.755-2.003 1.18-3.165 1.196a5.16 5.16 0 0 1-5.209-4.984 5.43 5.43 0 0 1 0-1.096c-2.16.446-4.352.704-6.555.772h-2.02c-.386.46-.872.827-1.42 1.07-.576.303-1.22.457-1.87.45a4.41 4.41 0 0 1-4.486-4.336v-.125c-.523-.498-1.22-1.022-1.77-1.62a1.42 1.42 0 0 1-1.321 1.071 1.47 1.47 0 0 1-1.47-1.445 1.37 1.37 0 0 1 .374-.897c.193-.266.477-.452.798-.523h.374c-1.54-2.356-2.363-5.11-2.368-7.924l-.125-5.83c-.37.254-.8.408-1.246.45-.207.026-.416.026-.623 0h-.224c-.205-.077-.39-.196-.548-.35a1.82 1.82 0 0 1-.598-1.321 1.92 1.92 0 0 1 1.869-1.894c.472.013.93.16 1.32.424l-.424-20.383a3.19 3.19 0 0 1-1.745-1.719 4.56 4.56 0 0 1-.449-1.196 3.59 3.59 0 0 1-.199-1.146 4.81 4.81 0 0 1 .847-2.94c.35-.526.82-.962 1.37-1.27l-.573-26.29c-.523 0-.498.125-.698.125-.313.003-.622-.075-.897-.224-.166-.06-.32-.154-.45-.274a1.77 1.77 0 0 1-.299-.449 1.72 1.72 0 0 1-.224-.772 1.82 1.82 0 0 1 1.769-1.794h.723v-3.513c-.124-3.872-1.13-7.664-2.94-11.09a2.12 2.12 0 0 1-1.171.374c-.586.007-1.15-.22-1.567-.633s-.65-.974-.65-1.56c-.034-.696.273-1.365.822-1.794l.2-.15h.15c-1.196-1.57-3.265-2.866-4.336-4.087l.15.125-10.143.224h-.25a2.84 2.84 0 0 1-2.492 2.492 2.49 2.49 0 0 1-2.567-1.993v-.324c.098.618.396 1.187.847 1.62a2.17 2.17 0 0 1-.573-.772c-.164-.255-.267-.545-.3-.847l-.25-.274a18.62 18.62 0 0 0-6.754 1.57c-.94.436-1.84.953-2.692 1.545l-.648.45-.773.623c-.15 0-.3 0-.424.573v-.125a2.07 2.07 0 0 1 1.146 1.894 2.12 2.12 0 0 1-2.044 2.268 2.07 2.07 0 0 1-1.844-1.071 19.06 19.06 0 0 0-3.589 9.967v1.096a4.81 4.81 0 0 0 0 .847v-.2c.424.087.813.295 1.12.598a2.49 2.49 0 0 1 .922 1.844 2.49 2.49 0 0 1-.698 1.719c-.315.403-.752.69-1.246.822l.3 14.004c.165-.026.333-.026.498 0a1.82 1.82 0 0 1 1.221.349c.227.16.422.364.573.598a2.24 2.24 0 0 1 .424 1.221c-.002.503-.198.985-.548 1.346-.376.477-.964.738-1.57.698a2.49 2.49 0 0 0-.474.199l.15 6.678a5.41 5.41 0 0 0 4.984-5.482l-.224-9.743c-1.516-.212-2.644-1.51-2.642-3.04-.064-1.52.997-2.857 2.492-3.14l-.2-8.896a13.76 13.76 0 0 1 12.91-14.403l6.405-.324c7.124-.028 12.93 5.7 12.984 12.833l1.52 71.4c.08 6.7 2.822 13.096 7.625 17.77s11.268 7.247 17.97 7.147h3.888l27.763-.623c2.89-.156 5.173-2.513 5.234-5.407l7.028-.15-.523-24.32-11.464.25zm-95.053-47.57c-.606 0-1.097-.49-1.097-1.096a1.07 1.07 0 0 1 1.047-1.121c.29-.007.572.102.783.303s.332.477.34.768a1.12 1.12 0 0 1-1.072 1.146zm3.1-21.58c.013.436-.147.86-.446 1.178s-.712.504-1.15.517-.858-.152-1.17-.458-.483-.726-.476-1.162c-.02-.43.135-.853.43-1.167s.707-.496 1.14-.502c.9-.014 1.643.696 1.67 1.595zm60.885 93.17a2.17 2.17 0 0 1-1.495 2.093h-.523a2.07 2.07 0 0 1-2.118-2.068c.068-1.126.946-2.035 2.07-2.143.382-.027.764.06 1.097.25a2.49 2.49 0 0 1 1.047 1.794l-.075.075zm21.732-1.27c-1.68.07-3.236-.883-3.936-2.412s-.403-3.33.75-4.555a4.14 4.14 0 0 1 4.501-1.025c1.57.605 2.616 2.1 2.648 3.78a4.06 4.06 0 0 1-1.101 2.934c-.745.79-1.775 1.25-2.862 1.277zm11.564-10.515c0 1.1-.893 1.993-1.994 1.993s-1.994-.892-1.994-1.993c-.013-.53.184-1.04.55-1.424s.867-.606 1.395-.62a1.97 1.97 0 0 1 2.019 1.969l.025.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.208 557.717c.44-.025.872.108 1.22.374a1.84 1.84 0 0 0-1.22-.374zm17.396-37.626a2.17 2.17 0 0 0 .573.772 2.49 2.49 0 0 1-.573-.772zm0 0a2.49 2.49 0 0 1-.274-.847 1.9 1.9 0 0 0 .274.847zm-10.617 5.357a2.25 2.25 0 0 0-1.246-1.97c.75.372 1.23 1.13 1.246 1.97zm29.782-2.442c-.55.43-.856 1.098-.822 1.794-.026-.695.28-1.36.822-1.794zm-36.36 16.346c-.315-.33-.724-.556-1.17-.648a2.22 2.22 0 0 1 1.171.648zm64.125 88.833l-.25.224a1.74 1.74 0 0 1-.523.25 2.14 2.14 0 0 0 1.495-2.093 2.29 2.29 0 0 1-.723 1.62zm-3.664-1.42c0 .564.227 1.104.63 1.498a2.09 2.09 0 0 0 1.513.595 2.12 2.12 0 0 1-2.143-2.093zm2.07-2.193a2.12 2.12 0 0 0-2.069 2.193 2.12 2.12 0 0 1 2.069-2.193zM811.766 523.48c.13-.122.272-.23.424-.324a2.72 2.72 0 0 0-.424.324zm-6.53 13.58h0v-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.03 529.91a18.69 18.69 0 0 1 1.919-3.264 18.69 18.69 0 0 0-1.919 3.264zm-1.67 6.703a3.71 3.71 0 0 1 0-.523c-.012.174-.012.35 0 .523zm-.125 1.92a4.81 4.81 0 0 1 0-.847c-.012-.216-.012-.432 0-.648-.026.498-.026.997 0 1.495zm.947-6.404c-.31 1.02-.545 2.06-.698 3.115.153-1.054.386-2.096.698-3.115zm.847-2.218a21.45 21.45 0 0 0-.847 2.218 21.45 21.45 0 0 1 .847-2.218zm-1.67 6.703v.274c0 .1 0-.2 0-.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.03 529.91a21.45 21.45 0 0 0-.847 2.218c-.31 1.02-.545 2.06-.698 3.115v.822a3.71 3.71 0 0 0 0 .523 19.06 19.06 0 0 1 3.589-9.967 18.69 18.69 0 0 0-2.044 3.289zm13.533-10.615c-.6.095-1.172.228-1.745.4.572-.17 1.155-.304 1.745-.4zm2.517-.274a16.9 16.9 0 0 0-2.492.274 16.9 16.9 0 0 1 2.492-.274z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1054.907 550.566l.274 13.107c.48.237.773.736.748 1.27.07.543-.21 1.072-.698 1.32v1.37c-.003 2.598-.45 5.177-1.32 7.625h.548a1.82 1.82 0 0 1 2.019 1.794c.02.52-.173 1.024-.536 1.397s-.863.58-1.383.572c-.744.027-1.446-.343-1.844-.972-.685 1.4-1.52 2.72-2.492 3.937a24 24 0 0 1-5.234 4.809c.1.23.14.475.15.723a2.34 2.34 0 0 1-.523 1.47v.174c-.424 0-.773.473-1.296.473 0 0-1.52-.174-1.944-.772a21.51 21.51 0 0 1-7.178 1.57h-.35l-6.903.174a5.41 5.41 0 0 0 5.483 5.158h2.492c14.396-.5 25.68-12.54 25.246-26.936v-3.24c-.148-5.433-1.986-10.686-5.26-15.026zm-10.268 38.723l.125-.174-.125.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.27 582.162a22 22 0 0 0 2.492-3.912 23.52 23.52 0 0 1-2.492 3.912zm4.187-7.002a1.07 1.07 0 0 0-.424 0c.148-.026.3-.026.45 0h-.025zm-13.308 13.98a21.66 21.66 0 0 1-7.178 1.595c2.466-.118 4.894-.658 7.178-1.595zm-9.82-38.15h-2.79a15.68 15.68 0 0 0-9.969 3.763c-3.7 3.088-5.858 7.64-5.907 12.46l1.12 33.24c.248 7.657-2.565 15.098-7.817 20.677a28.81 28.81 0 0 1-20.171 9.05l6.63-.125a27.72 27.72 0 0 0 9.969-2.043c-.04-.28-.04-.566 0-.847 0-1.42 1.196-1.844 2.492-1.894.897 0 1.097 0 1.545.797 1.208-.8 2.365-1.674 3.464-2.616-.572-.585-.886-1.375-.872-2.193 0-1.57 1.12-2.292 2.642-2.492a2.17 2.17 0 0 1 2.143.548 37.7 37.7 0 0 0 2.492-3.788c-1.246-.648-1.246-2.268-1.27-3.314h-.1c0-2.64.897-3.738 3.065-3.788.35 0 .598-.15.922 0a30.92 30.92 0 0 0 .648-4.934 3.99 3.99 0 0 1-4.486-3.414c-.144-1.073.2-2.154.94-2.946s1.793-1.2 2.874-1.14h.673v-4.984c-.197-.053-.397-.094-.598-.125a3.39 3.39 0 0 1-3.489-3.738 3.44 3.44 0 0 1 3.389-3.812 3.99 3.99 0 0 1 .523.125v-4.984c-.2.022-.383.022-.573 0-2.492 0-3.738-2.243-3.315-4.984.24-1.56 1.562-2.724 3.14-2.766.2 0 .573-.2.573-.15v-4.26a3.94 3.94 0 0 1-2.916-4.535 3.89 3.89 0 0 1 3.788-3.239c.388-.064.784-.064 1.17 0a15.08 15.08 0 0 1 10.293-7.475l-.224-.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.415 551.164c-3.594.102-7.036 1.47-9.72 3.862a15.58 15.58 0 0 1 9.969-3.788l-.25-.075z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M892.663 617.147c-1.682 0-3.197 1.02-3.83 2.577s-.26 3.345.943 4.52a4.14 4.14 0 0 0 4.542.832c1.542-.672 2.524-2.2 2.484-3.892-.013-1.084-.456-2.118-1.232-2.875a4.09 4.09 0 0 0-2.905-1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.838 625.395a4.09 4.09 0 0 0 2.854-1.284c.743-.8 1.142-1.843 1.108-2.927.056 2.252-1.71 4.13-3.963 4.21zm9.595-12.51a2.02 2.02 0 0 0-1.409 3.463 2.02 2.02 0 0 0 3.428-1.495 2.02 2.02 0 0 0-2.019-1.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.433 616.923a2.02 2.02 0 0 1-2.044-1.969c0 1.1.893 1.993 1.994 1.993s1.994-.892 1.994-1.993c-.013 1.072-.872 1.942-1.944 1.97z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#bb3f85",
    d: "M952.277 618.443c-.98.04-1.748.862-1.72 1.844a1.77 1.77 0 0 1 1.769-1.769 1.77 1.77 0 0 1 1.769 1.769c.014-.49-.173-.962-.516-1.3s-.814-.54-1.303-.534z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.467 612.238a3.49 3.49 0 0 0-3.414 3.613c-.012.058-.012.117 0 .174.027 1.237.712 2.367 1.797 2.962s2.406.567 3.464-.075 1.694-1.8 1.667-3.037v-.174c0-.927-.372-1.816-1.032-2.467s-1.554-1-2.482-.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.467 612.238a3.49 3.49 0 0 0-3.414 3.613 3.49 3.49 0 0 1 3.414-3.613zm0 0c.932-.02 1.832.336 2.498.988s1.04 1.544 1.04 2.476c0-.932-.375-1.824-1.04-2.476s-1.566-1.008-2.498-.988zm-3.39 3.713a3.49 3.49 0 0 0 3.539 3.289 3.49 3.49 0 0 1-3.539-3.289zm3.54 3.364c1.863-.066 3.35-1.575 3.39-3.44-.04 1.864-1.526 3.373-3.39 3.44zm15.55-1.744a4.46 4.46 0 0 0-.224 1.42 3.79 3.79 0 0 0 7.477.249c-2.478-.34-4.922-.9-7.302-1.67h.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.168 617.57c-.14.426-.217.872-.224 1.32.027 2.004 1.66 3.613 3.664 3.613a3.64 3.64 0 0 1-3.664-3.613 3.86 3.86 0 0 1 .224-1.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.168 617.57a3.86 3.86 0 0 0-.224 1.321 4.01 4.01 0 0 1 .224-1.346v.025zm24.648 1.32a3.94 3.94 0 0 0 3.788-4.062 4.01 4.01 0 0 0-1.52-3.09c-1.476 2.17-3.385 4.01-5.607 5.407a3.94 3.94 0 0 0 3.34 1.744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.916 618.443c-1.182.03-2.294-.556-2.94-1.545a3.44 3.44 0 0 0 2.941 1.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.916 618.443a3.44 3.44 0 0 1-2.966-1.545 3.44 3.44 0 0 0 2.966 1.545zm8.424-16.944c.003-1.31-1-2.4-2.318-2.492-.35 0-.822 0-.822.2l-.174 2.94v1.62c-.15 0 .15 0 .15 0a2.07 2.07 0 0 0 .897.174 2.49 2.49 0 0 0 2.268-2.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.848 603.342a2.09 2.09 0 0 1-.872-.174c.275.12.572.18.872.174zm-.798-.174h-.025.025zm17.994-61.622a2.49 2.49 0 0 0 0 .399v.324a4.16 4.16 0 0 0 4.162 4.087 4.09 4.09 0 0 0 2.847-1.302 4.08 4.08 0 0 0 1.09-2.934 4.01 4.01 0 0 0-.523-2.043v-.15h-.673a25.6 25.6 0 0 0-6.903 1.271 1.28 1.28 0 0 0 0 .35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.52 541.994c.02 1.018-.345 2.006-1.022 2.766.733-.773 1.135-1.8 1.12-2.866a4.46 4.46 0 0 0-.449-1.844h-.125c.327.595.5 1.265.474 1.944zm-7.477-.797v.374-.374zm6.38 3.588l-.2.174.2-.174zm-2.667 1.196a3.84 3.84 0 0 1-2.729-1.089c-.73-.7-1.146-1.68-1.16-2.7.007 1.022.42 2 1.15 2.715a3.84 3.84 0 0 0 2.737 1.097 3.74 3.74 0 0 0 2.492-.997c-.686.614-1.57.96-2.492.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.844 542.193a3.86 3.86 0 0 0 1.167 2.717c.734.715 1.722 1.11 2.746 1.096a3.84 3.84 0 0 1-2.754-1.088c-.735-.716-1.153-1.698-1.16-2.724zm7.676-.2c.04 1.018-.326 2-1.018 2.758a3.84 3.84 0 0 1-2.671 1.229c.92-.012 1.806-.358 2.492-.972l.2-.174c.677-.76 1.042-1.748 1.022-2.766l-.025-.075zm7.477 1.694h-.723a1.37 1.37 0 0 0-.548.897c-.033.198-.033.4 0 .598v.274c-.007.05-.007.1 0 .15.212.297.536.495.897.548h.374c.745-.097 1.303-.73 1.303-1.483s-.558-1.386-1.303-1.483v.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.175 544.087a1.32 1.32 0 0 0-.548.897 1.37 1.37 0 0 1 .548-.897zm.822 2.64c.388-.006.757-.168 1.024-.45s.4-.658.397-1.045c.001.797-.624 1.455-1.42 1.495zm-1.097-.548c.212.297.536.495.897.548-.36-.054-.685-.25-.897-.548zm7.626-.45a4.26 4.26 0 0 0 3.016 3.937c.382.1.776.15 1.17.15.442-.018.88-.102 1.296-.25a29.08 29.08 0 0 0-5.408-4.984v.224a3.04 3.04 0 0 0 0 .822l-.075.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.368 549.37c-1.64-.49-2.785-1.976-2.84-3.688a2.64 2.64 0 0 1 0-.772 3.86 3.86 0 0 0 0 .772c.04 1.717 1.19 3.2 2.84 3.688zm1.122.15c-.38.015-.76-.036-1.122-.15.37.12.757.18 1.146.174.408-.01.812-.085 1.196-.224a3.19 3.19 0 0 1-1.221.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.502 545.657c.02 1.044.453 2.038 1.206 2.762a3.94 3.94 0 0 0 2.806 1.1c-.39.005-.776-.054-1.146-.174-1.66-.47-2.822-1.964-2.866-3.688zm-31.427 3.214a2.17 2.17 0 0 0 1.595.623 2.49 2.49 0 0 0 2.492-2.666 3.14 3.14 0 0 0-1.246-2.342 27.61 27.61 0 0 0-3.688 3.14l.125.25c-.1.424.4.797.723.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.54 546.53a2.49 2.49 0 0 1-.324 1.271 2.24 2.24 0 0 0 .374-1.271 2.34 2.34 0 0 0-.997-1.894c.613.433.968 1.144.947 1.894zm-.25 1.296c-.39.635-1.074 1.03-1.82 1.047a2.27 2.27 0 0 1-.922-.199 1.87 1.87 0 0 0 .922.224 2.22 2.22 0 0 0 1.819-1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.925 548.298c.416.38.957.592 1.52.598a2.49 2.49 0 0 1-1.52-.598zm1.52.598a2.22 2.22 0 0 0 1.844-1.071 2.22 2.22 0 0 1-1.844 1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.3 547.825c.253-.373.376-.82.35-1.27a2.24 2.24 0 0 1-.604 1.608c-.407.435-.97.7-1.565.7a2.19 2.19 0 0 0 1.82-1.047zm.24-1.27c0 .473 0 1.17-.324 1.196.224 0 .3-.723.3-1.196h.025zm32 30.7a1.97 1.97 0 0 0 .224.947 27.88 27.88 0 0 0 1.196-2.94c-.853.3-1.425 1.093-1.42 1.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.74 578.2a1.97 1.97 0 0 1-.224-.947c-.005-.9.567-1.704 1.42-1.993h-.224c-.393.194-.72.497-.947.872-.15.302-.227.635-.224.972-.03.377.04.754.2 1.096zm1.22-2.94h-.224.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.736 575.36a1.97 1.97 0 0 0-.947.847c.22-.374.55-.67.947-.847z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1052.764 578.225a1.97 1.97 0 0 0 1.819 1.047 2.07 2.07 0 0 0 0-4.111h-.474a23.89 23.89 0 0 1-1.346 3.065zm-.024 0v.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.74 578.225v-.025.05zm3.812-1.022c.028 1.12-.85 2.053-1.97 2.093a1.97 1.97 0 0 1-1.819-1.047 2.12 2.12 0 0 0 1.844 1.047c1.1-.054 1.972-.983 1.944-2.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.74 578.25h0l.025-.025h-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.74 578.175c.386.648 1.1 1.038 1.844 1.022-.754.016-1.458-.374-1.844-1.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.96 575.26a27.88 27.88 0 0 1-1.196 2.94c.473-.96.88-1.95 1.22-2.965l-.025.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.764 578.2v.025-.025h-.025v.025zm1.22-2.94h-.025.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.985 575.26v-.025l-.025.025zm-1.22 2.94l-.025.025h.025z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1054.234 562.975a6.33 6.33 0 0 1 .947.199c-.673-.125-.673-.2-.972-.224a2.02 2.02 0 0 0-1.844 1.919 2.07 2.07 0 0 0 1.969 1.844c.305-.07.605-.16.897-.274-.648.15-.623.224-.897.25.324 0 .25 0 .897-.274v-3.24c-.673-.15-.648-.224-.972-.224l-.025.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.334 566.513h0zm.696-.2c-.2.107-.42.175-.648.2a1.42 1.42 0 0 0 .648-.199zm-.075-2.7a1.27 1.27 0 0 0-.498 0 1.13 1.13 0 0 1 .498 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.007 563.698h-.025.025zm.05 2.592l-.025.025h.025z"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.128 564.82a1.67 1.67 0 0 0-.947-1.645v3.314a1.67 1.67 0 0 0 .947-1.67z",
    className: "F"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050.62 558.465h.548c.635-.027 1.193-.43 1.42-1.022.01-.083.01-.166 0-.25.01-.108.01-.216 0-.324-.016-.643-.406-1.217-.997-1.47h-.623c-.423.013-.824.194-1.113.502s-.445.72-.432 1.142c.08.67.55 1.227 1.196 1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.72 557.867c-.395-.165-.657-.544-.673-.972.016.427.278.807.673.972zm1.47-1.022c-.006-.437-.27-.828-.673-.997.403.17.667.56.673.997zm-1.047 1.096a1.02 1.02 0 0 0 .972-.673 1.07 1.07 0 0 1-.972.673zm-6.18 28.656v-.15l-.474-.4-.224-.174h-.15c-.365-.207-.777-.318-1.196-.324a2.27 2.27 0 0 0-2.168 2.342c-.006.436.125.863.374 1.22 1.366-.565 2.677-1.257 3.913-2.068a1.52 1.52 0 0 1-.125-.299l.05-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.888 586.498h0v-.15zm-.588-.648l.224.174-.224-.2h-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.788 586.348l-.3-.3.3.3zm0 0v.15c-.144-.268-.35-.498-.598-.673l.224.2.374.324zm-3.64 2.64c-.25-.368-.388-.8-.4-1.246h.2c0 .424 0 .847.125 1.196l.075.05zm.002.026h0V589z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045.088 586.946a20.96 20.96 0 0 1-4.012 2.043 2.49 2.49 0 0 0 2.019.997c.588-.016 1.144-.267 1.545-.698a2.49 2.49 0 0 0 .623-1.719c0-.25 0 0-.15-.648l-.025.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.07 589.986c-.755-.004-1.458-.388-1.87-1.022.38.566.994.93 1.673.987s1.347-.195 1.816-.688c-.424.444-1.006.703-1.62.723z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.15 589c.434.615 1.14.978 1.894.972-.753.007-1.46-.357-1.894-.972zm.05.025a20.96 20.96 0 0 0 3.913-2.068c-1.236.81-2.546 1.503-3.913 2.068z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.474 580.717a1.32 1.32 0 1 0 0-2.641 1.32 1.32 0 1 0 0 2.641zm-39.003-24.02c.465.304 1.015.453 1.57.424a3.29 3.29 0 0 0 3.215-3.414 3.74 3.74 0 0 0-1.769-3.04c-1.276 1.882-2.33 3.906-3.14 6.03h.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.446 556.322a2.64 2.64 0 0 0 1.445.399c-.51.02-1.016-.12-1.445-.4zm1.445.3a2.99 2.99 0 0 0 2.966-3.14 3.04 3.04 0 0 1-2.966 3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.346 556.297a3.09 3.09 0 0 0 1.47.324 3.09 3.09 0 0 1-1.47-.324zm24.523 29.005v-.424h-2.816a6.38 6.38 0 0 0-2.841 1.196 2.74 2.74 0 0 0 2.841 2.093 2.89 2.89 0 0 0 2.816-2.866z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.028 587.793c1.328-.066 2.37-1.163 2.368-2.492.002 1.33-1.04 2.425-2.368 2.492a2.49 2.49 0 0 1-2.492-1.819 2.32 2.32 0 0 0 2.492 1.819zm12.46-4.46c.8-.57 1.25-1.51 1.196-2.492-.022-.407-.097-.81-.224-1.196a16.7 16.7 0 0 1-4.287 3.414c.513.407 1.14.643 1.794.673.534.01 1.06-.13 1.52-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.49 583.333c.807-.564 1.26-1.51 1.196-2.492a.92.92 0 0 0 0-.274 2.89 2.89 0 0 0-.199-.797c.136.334.22.687.25 1.047.052 1-.42 1.953-1.246 2.517z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.02 583.83a2.72 2.72 0 0 1-1.695-.573c.5.366 1.1.566 1.72.573a2.94 2.94 0 0 0 1.52-.523c-.455.318-1 .5-1.545.523zm2.492-3.962a2.89 2.89 0 0 1 .199.797 2.89 2.89 0 0 0-.199-.797zm.224.948c.027.737-.247 1.454-.76 1.985a2.72 2.72 0 0 1-1.957.83 2.72 2.72 0 0 0 1.957-.83c.512-.53.787-1.248.76-1.985zm-6.73-31.52a5.16 5.16 0 0 0-2.642-.897h-.498a6.53 6.53 0 0 0-1.695.299 5.63 5.63 0 0 0-2.293 1.595 1.62 1.62 0 0 0-.498.797h2.492a16.35 16.35 0 0 1 7.477 1.819c.01-.124.01-.25 0-.374a5.68 5.68 0 0 0-2.343-3.239z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.897 548.996a4.36 4.36 0 0 0-2.019 1.395c.546-.626 1.24-1.106 2.02-1.395zm2.093-.324c.89.04 1.753.324 2.492.822-.73-.517-1.597-.812-2.492-.847-.15-.012-.3-.012-.45 0a2.69 2.69 0 0 1 .449.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.88 550.4l-.025.025zm-.5.624l.45-.573z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.542 548.672a4.64 4.64 0 0 0-1.57.324c.502-.192 1.033-.3 1.57-.324zm-3.664 1.72a4.95 4.95 0 0 1 2.118-1.42 4.98 4.98 0 0 0-2.118 1.42zm8.698 2.068a5.26 5.26 0 0 0-.897-1.744 4.78 4.78 0 0 1 .897 1.744zm-4.586-3.788h0zm3.714 2.043c.406.52.7 1.112.897 1.744a5.21 5.21 0 0 0-3.439-3.538c1.013.32 1.9.948 2.542 1.794zm-2.916-1.894h0zm-.4-.15h0z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#bb3f85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.28 551.313a14.36 14.36 0 0 1 2.318-.274h-2.218s-.075.125-.1.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.33 551.164c.006.04.006.083 0 .125v-.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.33 551.164v.15c.006-.04.006-.083 0-.125v-.025z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M990.284 619.763v.174c-.07.204-.128.412-.174.623-.012.158-.012.316 0 .473v.15a3.64 3.64 0 0 0 6.255 2.492 3.81 3.81 0 0 0 .773-2.741c-.01-.773-.243-1.526-.673-2.168a18.22 18.22 0 0 1-4.062.698h-2.143l.025.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.333 619.713v.224s-.05-.224 0-.224zm-.3 1.42a1.42 1.42 0 0 1 0-.449c.03-.196.08-.388.15-.573-.384 1.052-.228 2.226.42 3.14s1.7 1.455 2.82 1.444a2.84 2.84 0 0 0 .822 0 2.79 2.79 0 0 1-.798 0c-.94.03-1.85-.34-2.503-1.02s-.983-1.605-.912-2.544z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.01 621.134a3.34 3.34 0 0 0 5.832 2.218c-.432.442-.974.76-1.57.922a2.84 2.84 0 0 1-.822 0 3.29 3.29 0 0 1-3.439-3.14zm.05-.673v.45c0 .15 0-.3 0-.45zm.274-.748s-.05 0 0 0zm-3.514 4.86c-1.01.113-1.77.966-1.77 1.98s.763 1.868 1.77 1.98c1.01-.113 1.77-.966 1.77-1.98s-.763-1.868-1.77-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.82 624.548a1.97 1.97 0 0 0-1.919 2.043 1.97 1.97 0 0 1 1.919-2.018 1.97 1.97 0 0 1 2.019 1.944 1.97 1.97 0 0 0-2.019-1.969zM881.25 626.7c.802-1.06 1.224-2.36 1.196-3.688a6.28 6.28 0 0 0-1.745-4.186c-3.013 1.36-6.174 2.364-9.42 3-.112.465-.163.942-.15 1.42.005 2.185 1.267 4.172 3.244 5.104a5.66 5.66 0 0 0 6.002-.743c.178-.145.345-.303.498-.473l.374-.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.726 625.918l-.324.374-.45.423.45-.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.797 622.604a5.28 5.28 0 0 1-1.072 3.314 5.38 5.38 0 0 0 1.097-3.339 5.16 5.16 0 0 0-1.52-3.588 5.2 5.2 0 0 1 1.495 3.613zm-1.347 3.688c.955-1 1.482-2.33 1.47-3.713.014 1.212-.4 2.4-1.146 3.34l-.324.374zm-11.5-1.72c-.56.02-1.1.262-1.468.674s-.578.96-.55 1.518c0 1.156.937 2.093 2.093 2.093h.548a2.02 2.02 0 0 0 .847-.523c.44-.413.683-.992.673-1.595a2.31 2.31 0 0 0-.25-.922c-.322-.76-1.07-1.25-1.894-1.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.757 625.544c-.166-.284-.408-.517-.698-.673a1.87 1.87 0 0 0-1.097-.299 2.07 2.07 0 0 1 1.794.972zm-1.17 3.24a2.27 2.27 0 0 0 .449-.374l.15-.15a2.02 2.02 0 0 1-.598.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.962 624.572c.807-.018 1.55.44 1.894 1.17v-.2a2.07 2.07 0 0 0-1.894-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.962 624.572a1.87 1.87 0 0 1 1.097.299 1.77 1.77 0 0 0-1.097-.299zm.648 4.186h-.125.125zm-.573.1h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.585 628.784h-.125.125a1.67 1.67 0 0 0 .523-.25 2.27 2.27 0 0 1-.523.249zm-.573.074h.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.037 628.858h.025zm-13.682-9.244c.068 2.548 2.16 4.574 4.7 4.56.665-.028 1.317-.2 1.92-.473a4.66 4.66 0 0 0 1.495-1.196c-2.96-.164-5.807-1.205-8.174-3v.125l.05-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.7 623.426a4.81 4.81 0 0 0 1.421-1.121 4.41 4.41 0 0 1-1.421 1.121zm-10.79-6.952c-.23.3-.353.67-.35 1.047 0 .44.177.863.49 1.172s.74.48 1.18.473a1.47 1.47 0 0 0 1.495-1.121 18.39 18.39 0 0 1-1.545-2.193h-.324c-.37.112-.698.328-.947.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.118 616.6c.204-.254.483-.437.798-.523-.32.07-.604.257-.798.523zm1.12 2.342a1.37 1.37 0 0 0 1.296-1.096 1.42 1.42 0 0 1-1.296 1.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.264 618.94a1.42 1.42 0 0 0 1.321-1.071 1.37 1.37 0 0 1-1.321 1.071zm-4.36-15.997h.3c.576-.05 1.128-.257 1.595-.598v-3.314a3.04 3.04 0 0 0-1.595-.498 2.22 2.22 0 0 0-2.218 2.243 2.29 2.29 0 0 0 .673 1.57c.2.195.438.347.698.45.173.08.358.132.548.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.604 602.57h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.604 602.57h.025a1.97 1.97 0 0 1-.573-.349c.157.153.344.27.548.35zm.872.224h-.548a1.67 1.67 0 0 0 .598 0 2.69 2.69 0 0 0 1.271-.449 3.04 3.04 0 0 1-1.296.573l-.025-.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.55 602.72c.447-.04.876-.195 1.246-.45-.384.243-.82.397-1.27.45h.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.5 602.794c.467-.055.912-.227 1.296-.498-.39.276-.845.447-1.32.498h.025zm-.274-.1a1.62 1.62 0 0 1-.523-.125h.224l.3.125zm-1.122-26.612c.123.42.3.82.523 1.196.24.593.647 1.103 1.17 1.47a3.39 3.39 0 0 1-1.121-1.47c.4.698.573 1.296 1.62 1.694l-.174-8.223c-.54.314-1.007.74-1.37 1.246-.56.866-.84 1.884-.798 2.915-.001.395.05.79.15 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.106 576.082c-.1-.382-.15-.776-.15-1.17a4.98 4.98 0 0 1 .798-2.915 4.81 4.81 0 0 0-.847 2.94 3.59 3.59 0 0 0 .199 1.146zm2.194 2.965h0l-.5-.224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.604 577.328a3.39 3.39 0 0 0 1.121 1.47l.498.224c-.972-.45-1.146-.997-1.62-1.694zm-.773-32.942h.224a1.57 1.57 0 0 1-.598-.399c.27.27.62.446.997.498h.324c.2 0 .224 0 .773-.125v-3.538h-.798c-1.044.04-1.87.9-1.87 1.944-.002.278.066.553.2.797.09.2.217.36.374.498a2.07 2.07 0 0 0 .374.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.956 544.386c-.15-.062-.287-.155-.4-.274a1.97 1.97 0 0 1-.349-.449 1.77 1.77 0 0 0 .299.449 1.33 1.33 0 0 0 .45.274zm.872.224h-.598c.22.092.46.134.698.125.2 0 .174 0 .698-.125-.523 0-.498.15-.723.15l-.075-.15zm0-.025a7.08 7.08 0 0 0 .723-.125c-.523 0-.523.125-.723.125zm-1.22-.473a2.67 2.67 0 0 0 .548.374h.374a1.62 1.62 0 0 1-.922-.374zm-3.988-21.33a2.49 2.49 0 0 0-.897 1.869 2.49 2.49 0 0 0 2.442 2.367c.462-.002.913-.14 1.296-.4a28.03 28.03 0 0 0-2.617-4.111l-.2.15-.025.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.77 523.007l.025-.025-.025.025zm-.823 1.793a1.92 1.92 0 0 0 .199.847c-.122-.266-.2-.554-.2-.847zm.2.847a2.19 2.19 0 0 0 2.044 1.32 2.02 2.02 0 0 0 1.146-.374 2.49 2.49 0 0 1-1.17.374c-.876.003-1.67-.517-2.02-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.146 525.648a1.92 1.92 0 0 1-.199-.847 2.2 2.2 0 0 0 .65 1.56c.416.413.98.64 1.567.633-.882-.002-1.678-.532-2.02-1.346zm.822-2.79h0l-.174.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.77 523.007h0l.175-.125z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.33 519.194h.125l5.333-.125v-.872a2.49 2.49 0 0 0-1.994-2.093h-.947c-1.49.054-2.66 1.3-2.617 2.79a2.69 2.69 0 0 1 2.617-2.791c-.63.018-1.235.246-1.72.648a2.79 2.79 0 0 0-.798 1.944v.2h.25s-.25.25-.25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.305 518.77a2.64 2.64 0 0 1 2.492-2.716c-1.436.067-2.55 1.28-2.492 2.716zm5.21.35h0l-.25-.224v.25zm-2.792-3.1a2.49 2.49 0 0 0-1.67.623 2.64 2.64 0 0 1 1.695-.623h-.025zm.1.074h0zm-2.492 3.1v-.15h-.2l.2.2v-.05z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.514 519.12h-5.06a1.47 1.47 0 0 0 0 .324 2.84 2.84 0 0 0 .773 1.221 2.49 2.49 0 0 0 1.769.723c1.25-.1 2.278-1.035 2.517-2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.177 520.8a2.84 2.84 0 0 1-.773-1.221 2.49 2.49 0 0 0 .773 1.221zm-.847-1.645h0zm.025.1h0-.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.177 520.79c.203.186.43.345.673.473-.243-.13-.47-.288-.673-.473zm4.336-1.67a2.84 2.84 0 0 1-2.044 2.342c1.092-.303 1.903-1.22 2.07-2.342h-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.47 521.462h-.498c-.392.01-.78-.084-1.12-.274-.243-.13-.47-.288-.673-.473a2.49 2.49 0 0 0 1.794.772 2.84 2.84 0 0 0 2.492-2.492c-.107 1.15-.893 2.12-1.994 2.467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.97 521.536a1.72 1.72 0 0 0 .498 0 2.84 2.84 0 0 0 2.044-2.342c-.144 1.312-1.18 2.348-2.492 2.492a2.49 2.49 0 0 1-1.769-.723c.203.186.43.345.673.473.338.107.695.14 1.047.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.85 521.262c.343.2.73.285 1.12.274h.498a1.72 1.72 0 0 1-.498 0c-.4-.002-.774-.096-1.12-.274z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.252 525.772a2.34 2.34 0 0 0 .324 1.096c.756-.97 1.6-1.88 2.492-2.716l.922-.847c-.372-.18-.783-.267-1.196-.25a2.49 2.49 0 0 0-2.492 2.691l-.05.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.9 526.52c-.17-.28-.264-.596-.274-.922-.008-.4.095-.815.3-1.17a2.49 2.49 0 0 0-.324 1.196c.018.345.102.684.25.997l.05-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.626 525.548a2.49 2.49 0 0 0 .249.997c-.147-.313-.232-.65-.25-.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.9 526.52l-.025.025h.025l-.025.025h.025v-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.875 526.545h0v.025l.025-.025z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.626 526.645v.15a2.49 2.49 0 0 0 2.168 1.196c1.223.07 2.316-.76 2.576-1.958a2.49 2.49 0 0 0-1.529-2.851l-.897.772a22.9 22.9 0 0 0-2.318 2.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.87 527.7a2.17 2.17 0 0 1-1.894-1.022 2.17 2.17 0 0 0 4.037-1.196 2.17 2.17 0 0 1-2.143 2.218zm-1.97-1.145v.025h.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.95 526.62l-.025.025h.025v-.025zm4.037-1.147h0v-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.95 526.62v.025-.025zm.025-.15a21.73 21.73 0 0 1 2.02-2.268 19.6 19.6 0 0 0-2.02 2.268zm-.075.075v.025-.025z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.672 541.42c.013.786.338 1.536.904 2.082s1.325.846 2.112.833h.748l-.125-5.73h-.274c-.165-.025-.333-.025-.498 0a2.94 2.94 0 0 0-2.866 2.816z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.236 538.88h-.648c.14-.024.283-.024.424 0h.224zm-.45 4.934c-1.376 0-2.492-1.116-2.492-2.492 0 1.376 1.116 2.492 2.492 2.492h0zm-2.6-2.444a2.49 2.49 0 0 0 1.171 2.018 2.49 2.49 0 0 1-1.171-2.018zm2.617 2.468h.598-.623z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.732 542.84l-.224.274.15-.174c.13-.14.24-.3.324-.473l-.25.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.236 538.43l.125 5.88c.637-.167 1.2-.544 1.595-1.07a2.99 2.99 0 0 0 .598-1.919h-.15c-.018-1.332-.894-2.5-2.168-2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.105 541.197h.125a2.64 2.64 0 0 0-.822-1.844 2.69 2.69 0 0 0-1.171-.648 2.49 2.49 0 0 1 1.869 2.492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.23 541.197a2.49 2.49 0 0 1-.299 1.246c-.085.173-.194.332-.324.473a2.49 2.49 0 0 0 .698-1.719 2.49 2.49 0 0 0-.922-1.844c.495.478.78 1.13.798 1.82l.05.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.23 541.197c-.016-.688-.303-1.34-.798-1.82a2.64 2.64 0 0 1 .798 1.819zm-.723 1.92a2.49 2.49 0 0 1-1.097.623 2.17 2.17 0 0 0 1.097-.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.41 543.69a2.49 2.49 0 0 0 1.097-.623l.224-.274a2.49 2.49 0 0 1-1.321.897zm1.32-.847l.25-.374a2.49 2.49 0 0 0 .274-1.221 2.49 2.49 0 0 1-.523 1.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.98 542.468a2.49 2.49 0 0 0 .299-1.246 2.49 2.49 0 0 1-.299 1.246zm.748 7.525c-.005 1.752 1.28 3.24 3.016 3.49l-.15-7.15a3.54 3.54 0 0 0-2.866 3.663z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.35 551.463c.342 1.134 1.317 1.963 2.492 2.118-1.17-.167-2.14-.99-2.492-2.118zm-.174-.972a3.19 3.19 0 0 0 .174.972 3.76 3.76 0 0 1-.15-.922s-.025-.025-.025-.05zm.374-18.614c-.99 0-1.794.803-1.794 1.794s.803 1.794 1.794 1.794 1.794-.803 1.794-1.794-.803-1.794-1.794-1.794z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.55 531.877c-.432.006-.843.187-1.14.502s-.452.736-.43 1.167a1.62 1.62 0 0 1 1.57-1.694 1.67 1.67 0 0 1 1.67 1.62c-.027-.9-.77-1.61-1.67-1.595z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M805.7 557.842c-.496.126-.924.44-1.196.872a2.49 2.49 0 0 0-.349 1.296 2.12 2.12 0 0 0 1.645 2.118l-.1-4.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.165 559.985a2.49 2.49 0 0 1 .349-1.296 2.29 2.29 0 0 0-.349 1.296 2.12 2.12 0 0 0 1.645 2.118 2.12 2.12 0 0 1-1.645-2.118z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M808.327 559.885a2.49 2.49 0 0 0-.125-.748 2.07 2.07 0 0 0-1.994-1.346h-.498v4.186h.474c.564-.02 1.097-.265 1.477-.683s.575-.97.54-1.535a2.29 2.29 0 0 1-.498 1.545 2.49 2.49 0 0 0 .449-1.445l.174.025zm-.125-.797a2.49 2.49 0 0 1 .15.772 2.12 2.12 0 0 0-.349-1.196 2.49 2.49 0 0 1 .199.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.202 559.088a2.49 2.49 0 0 0-.274-.523 2.07 2.07 0 0 0-1.72-.822 2.07 2.07 0 0 1 1.994 1.346zm.15.772a2.49 2.49 0 0 0-.15-.772 2.49 2.49 0 0 1 .125.748l.025.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.35 559.86a2.49 2.49 0 0 1-.449 1.445c.348-.41.542-.93.548-1.47a2.17 2.17 0 0 0-.424-1.221c.23.347.352.755.35 1.17l-.025.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.35 559.885v-.025zm-.622 1.57a2.12 2.12 0 0 1-1.52.648h-.474.474a2.07 2.07 0 0 0 1.52-.648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.283 562.178h0-.474zm2.02-2.278c.034.564-.16 1.117-.54 1.535a2.09 2.09 0 0 1-1.477.683 2.12 2.12 0 0 0 1.52-.648 2.29 2.29 0 0 0 .498-1.57zm.25-6.254a1.47 1.47 0 1 0-.896 1.378 1.47 1.47 0 0 0 .896-1.378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.01 553.98c-.007-.29.102-.572.303-.783s.477-.332.768-.34a1.07 1.07 0 0 0-1.047 1.121c0 .606.49 1.096 1.097 1.096-.605-.013-1.095-.492-1.12-1.096z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1022.06 562.626a2.29 2.29 0 0 1-.571 1.724c-.42.472-1.016.75-1.647.767-.353-.002-.7-.078-1.022-.224a13.43 13.43 0 0 0-.299 1.694c.44.117.89.184 1.346.2 1.957-.08 3.57-1.56 3.818-3.503a4.01 4.01 0 0 0-2.821-4.346 11.46 11.46 0 0 0-.773 1.57c1.075.15 1.897 1.035 1.97 2.118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.717 558.64c-2.18.08-3.883 1.907-3.813 4.087a4.06 4.06 0 0 0 3.016 3.812 13.38 13.38 0 0 1 0-1.744 2.32 2.32 0 0 1 .822-4.46c.157-.024.317-.024.474 0 .224-.548.474-1.022.748-1.545l-.274-.125c.1-.025-.573-.025-.972-.025zm.075.125h0z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1022.06 562.626c-.013-1.13-.85-2.083-1.97-2.243-.605 1.413-1 2.908-1.17 4.435a1.92 1.92 0 0 0 .922.174c.608-.02 1.184-.28 1.6-.724a2.29 2.29 0 0 0 .618-1.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.84 560.36a2.32 2.32 0 0 0-.822 4.46c.172-1.528.566-3.022 1.17-4.435-.113-.033-.232-.042-.35-.025z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.74 574.71a2.22 2.22 0 0 1-1.645 2.268v1.72c1.91-.38 3.268-2.077 3.226-4.023s-1.476-3.58-3.4-3.876v1.72c1.063.184 1.835 1.114 1.82 2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.583 574.836a3.96 3.96 0 0 0 1.196 2.787c.752.734 1.766 1.138 2.817 1.125h.573v-1.944c0 .523-.374 0-.573 0-1.246 0-1.62-.598-1.645-1.87s.3-2.342 1.545-2.367h.598v-1.72h-.573a3.99 3.99 0 0 0-3.938 3.987zm3.813-4.087h0z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.74 574.71c.025-1.048-.696-1.967-1.72-2.193v4.46a2.22 2.22 0 0 0 1.72-2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.42 572.42a2.32 2.32 0 0 0-1.638.775c-.418.47-.628 1.1-.58 1.717a2.29 2.29 0 0 0 .689 1.614c.435.425 1.02.66 1.63.654h.573v-4.46s-.45-.3-.673-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.203 575.035a2.29 2.29 0 0 0 .689 1.614c.435.425 1.02.66 1.63.654a2.32 2.32 0 0 1-2.318-2.268zm2.816-2.517h-.598c.224-.1.598-.075.598 0z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1021.013 587.12a2.22 2.22 0 0 1-1.645 2.268v1.72c1.91-.38 3.268-2.077 3.226-4.023s-1.476-3.58-3.4-3.876v1.72c1.053.202 1.815 1.12 1.82 2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.832 587.27a3.96 3.96 0 0 0 1.196 2.787c.753.734 1.766 1.138 2.817 1.125h.573v-1.72h-.573c-1.27 0-1.77-1.047-1.794-2.342s.598-1.844 1.844-1.87c0-.2.424-.374.424-.324v-1.72a1.77 1.77 0 0 0-.573 0 3.94 3.94 0 0 0-3.913 4.062zm3.838-4.086a1.77 1.77 0 0 1 .573 0 1.77 1.77 0 0 0-.573 0z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1021.013 587.12c.003-1.05-.722-1.96-1.745-2.193v4.46a2.22 2.22 0 0 0 1.745-2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.695 584.853c-.608.02-1.184.28-1.6.724a2.29 2.29 0 0 0-.618 1.643c0 .6.246 1.195.682 1.62a2.27 2.27 0 0 0 1.636.646h.573v-4.46s-.474-.174-.673-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.477 587.195a2.29 2.29 0 0 0 .689 1.614c.435.425 1.02.66 1.63.654-.608.007-1.194-.23-1.63-.654a2.29 2.29 0 0 1-.689-1.614zm2.79-2.268h-.573c.2-.075.573-.05.573 0z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.74 599.555c0 1.047 0 1.97-1.097 2.268v1.694a3.94 3.94 0 0 0 3.29-4.037c.05-1.988-1.437-3.68-3.414-3.887v1.744c1.072.25 1.196 1.17 1.22 2.218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.106 599.654a3.99 3.99 0 0 0 4.012 3.937h.523v.2-2.317a4.51 4.51 0 0 0-.573.224c-.546.047-1.085-.15-1.47-.54s-.577-.93-.523-1.477c0-1.296.598-2.367 1.87-2.492h.573v-1.744c-.2-.02-.4-.02-.598 0a3.94 3.94 0 0 0-2.804 1.293c-.72.795-1.084 1.85-1.01 2.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.12 603.492h.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.567 601.822v1.694-1.694z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.567 601.797c1-.294 1.676-1.226 1.645-2.268a2.22 2.22 0 0 0-1.745-2.193v4.186l.1.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.567 601.797v-4.485h-.573c-1.194.124-2.1 1.13-2.1 2.33s.907 2.206 2.1 2.33h.573v-.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.75 599.754a2.49 2.49 0 0 1 2.218-2.492 2.49 2.49 0 0 0 .125 4.834 2.49 2.49 0 0 1-2.343-2.342z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.415 611.964a2.32 2.32 0 0 1-2.243 2.367c-.373.01-.74-.076-1.072-.25l-.748 1.495a3.64 3.64 0 0 0 1.869.424c1.05-.033 2.046-.48 2.766-1.248a3.96 3.96 0 0 0 1.072-2.839 4.01 4.01 0 0 0-3.016-3.788c0 .548-.25 1.096-.374 1.62 1.012.267 1.724 1.172 1.745 2.218z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.352 615.577l.748-1.495a2.49 2.49 0 0 1-1.271-2.018 2.34 2.34 0 0 1 .596-1.718c.422-.47 1.016-.748 1.647-.773.2-.024.4-.024.598 0l.374-1.62a4.36 4.36 0 0 0-.997-.125c-1.754.136-3.215 1.398-3.604 3.113a4.01 4.01 0 0 0 1.909 4.362v.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.352 615.577a4.01 4.01 0 0 1-2.143-3.489c.017 1.47.84 2.81 2.143 3.49z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.415 611.964c-.02-1.046-.733-1.95-1.745-2.218a32.07 32.07 0 0 1-1.57 4.336c.33.173.7.26 1.072.25a2.32 2.32 0 0 0 2.243-2.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.072 609.67c-.63.026-1.224.304-1.647.773a2.34 2.34 0 0 0-.596 1.718 2.49 2.49 0 0 0 1.271 2.018 32.07 32.07 0 0 0 1.57-4.336c-.19-.083-.392-.142-.598-.174z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1013.885 621.333c.02.48-.153.948-.48 1.3s-.783.556-1.264.57c-.447-.001-.88-.16-1.22-.45l-.972.872a2.99 2.99 0 0 0 2.218.897 3.14 3.14 0 0 0 3.016-3.214 3.09 3.09 0 0 0-1.022-2.268l-.798 1.047c.326.334.513.78.523 1.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.947 623.626l.972-.872c-.387-.342-.613-.83-.623-1.346a1.82 1.82 0 0 1 1.745-1.869c.497-.008.976.2 1.32.548l.798-1.047a2.99 2.99 0 0 0-2.143-.822c-.826.026-1.61.38-2.174.982s-.868 1.406-.84 2.232c0 .83.343 1.623.947 2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.022 623.626c-.585-.58-.917-1.37-.922-2.193 0 .825.332 1.616.922 2.193z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1013.885 621.333c-.01-.467-.198-.912-.523-1.246a30.63 30.63 0 0 1-2.492 2.666c.34.29.774.448 1.22.45.49 0 .957-.2 1.296-.552s.52-.83.498-1.317z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.362 620.087c-.345-.358-.824-.556-1.32-.548a1.82 1.82 0 0 0-1.745 1.869c.01.516.236 1.004.623 1.346.866-.84 1.68-1.73 2.442-2.666z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.21 627.29a1.47 1.47 0 0 1-1.421 1.52c-.61.006-1.16-.373-1.37-.947l-.972.424a2.49 2.49 0 0 0 2.368 1.57c1.376 0 2.492-1.116 2.492-2.492a2.34 2.34 0 0 0-.399-1.296l-.897.548a1.37 1.37 0 0 1 .199.673zm-3.763.922l.972-.424c-.04-.172-.04-.35 0-.523-.013-.388.13-.764.397-1.045s.636-.443 1.024-.45a1.37 1.37 0 0 1 1.221.673l.897-.548a2.49 2.49 0 0 0-2.143-1.196c-1.376 0-2.492 1.116-2.492 2.492a2.49 2.49 0 0 0 .174.847l-.05.174zm0 0a2.49 2.49 0 0 1-.174-.847 2.34 2.34 0 0 0 .174.847z",
    className: "F"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1004.788 628.81a1.47 1.47 0 0 0 1.421-1.52 1.37 1.37 0 0 0-.249-.772c-.804.496-1.636.945-2.492 1.346.204.557.728.932 1.32.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.738 625.918c-.388.006-.757.168-1.024.45s-.4.658-.397 1.045c-.04.172-.04.35 0 .523.856-.4 1.688-.85 2.492-1.346a1.37 1.37 0 0 0-1.072-.673z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.79 535.565a2.84 2.84 0 0 1 1.097-2.068c-.17-.562-.38-1.11-.623-1.645a4.26 4.26 0 0 0-2.193 3.763 3.99 3.99 0 0 0 3.439 4.037v-1.82c-1.03-.266-1.742-1.204-1.72-2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.32 535.44c-.007-1.097-.45-2.147-1.23-2.918s-1.835-1.2-2.933-1.194c-.64-.03-1.275.107-1.844.4.207.552.374 1.118.498 1.694a2.64 2.64 0 0 1 1.396-.424c1.31-.003 2.4 1 2.492 2.317 0 1.376-1.116 2.492-2.492 2.492h-.723v1.82a1.97 1.97 0 0 0 .723 0 4.19 4.19 0 0 0 4.112-4.186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.12 535.6c.042 2.197-1.69 4.02-3.888 4.087h-.598c.232.03.466.03.698 0a3.99 3.99 0 0 0 3.788-4.087zm-5.284-1.87a17.46 17.46 0 0 0-.598-1.595l.598 1.595z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.862 533.372a2.49 2.49 0 0 0-1.171 2.168 2.49 2.49 0 0 0 1.794 2.492v-.274a14.95 14.95 0 0 0-.623-4.386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.887 533.397a14.95 14.95 0 0 1 .648 4.236v.274h.748c1.376 0 2.492-1.116 2.492-2.492s-1.116-2.492-2.492-2.492a2.64 2.64 0 0 0-1.271.374l-.125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.377 535.565a2.34 2.34 0 0 1-.588 1.71c-.417.468-1.004.75-1.63.782a2.49 2.49 0 0 0 0-4.784 2.49 2.49 0 0 1 2.218 2.292zm-3.54-1.844a13.53 13.53 0 0 1 .648 3.912 13.53 13.53 0 0 0-.648-3.912z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.04 547.85a2.32 2.32 0 0 1 1.62-2.317v-1.794a4.16 4.16 0 0 0 .199 8.148v-1.794c-1.06-.224-1.82-1.16-1.82-2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.42 547.7a4.06 4.06 0 0 0-1.225-2.883c-.777-.758-1.826-1.174-2.912-1.154-.224-.026-.45-.026-.673 0v1.77h.673a2.49 2.49 0 0 1 0 4.759h-.15s-.523 0-.523-.174v1.77c.23.033.466.033.698 0 1.1.013 2.14-.412 2.914-1.18a4.06 4.06 0 0 0 1.198-2.906z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.458 551.662c-.222.048-.45.048-.673 0 .222.048.45.048.673 0z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.965 547.9a2.49 2.49 0 0 0 1.794 2.342v-4.784a2.49 2.49 0 0 0-1.794 2.442zm2.492 2.417c1.376 0 2.492-1.116 2.492-2.492s-1.116-2.492-2.492-2.492c-.25 0-.698 0-.698.15v4.734s.45.125.698.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.65 547.626a2.32 2.32 0 0 0-2.343-2.268 2.32 2.32 0 0 1 2.343 2.268zm-2.89 2.268h.648c-.224.1-.648.075-.648 0z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.34 559.71c-.058-1.026.59-1.96 1.57-2.268V555.7a4.01 4.01 0 0 0-3.158 4.009c.043 1.92 1.44 3.54 3.333 3.865v-1.694c-1.024-.214-1.755-1.122-1.745-2.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.62 559.536a3.96 3.96 0 0 0-1.196-2.787c-.753-.734-1.766-1.138-2.817-1.125a2.64 2.64 0 0 0-.648 0v1.744h.673a2.12 2.12 0 0 1 1.835 3.177 2.12 2.12 0 0 1-1.835 1.059h-.648v1.694h.648c2.123.016 3.88-1.643 3.988-3.763zm-3.913 4.087h-.648.648z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.34 559.71c-.018 1.024.675 1.924 1.67 2.168v-4.435c-1.02.27-1.716 1.213-1.67 2.268zm2.343 2.268c1.194-.124 2.1-1.13 2.1-2.33s-.907-2.206-2.1-2.33a1.57 1.57 0 0 0-.673.125v4.435a3.92 3.92 0 0 0 .673.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.01 561.88h.673c-.25.1-.673.075-.673 0zm2.89-2.093a2.29 2.29 0 0 0-.689-1.614c-.435-.425-1.02-.66-1.63-.654.608-.007 1.194.23 1.63.654a2.29 2.29 0 0 1 .689 1.614z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.588 571.67c-.055-1.033.604-1.97 1.595-2.268v-1.72a4.01 4.01 0 0 0-3.158 4.009c.043 1.92 1.44 3.54 3.333 3.865v-1.72a2.22 2.22 0 0 1-1.769-2.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.794 571.522c-.006-1.053-.435-2.06-1.188-2.795a3.94 3.94 0 0 0-2.824-1.118h-.648v1.72h.648c.6-.02 1.18.2 1.617.612a2.24 2.24 0 0 1 .701 1.58c.048.627-.16 1.247-.58 1.717a2.32 2.32 0 0 1-1.638.775h-.673v1.72h.648c1.09-.005 2.132-.46 2.878-1.256a3.96 3.96 0 0 0 1.06-2.955zm-3.838 4.087h-.648.648z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.563 571.597a2.27 2.27 0 0 0 1.695 2.243v-4.535a2.22 2.22 0 0 0-1.695 2.292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.956 573.94c.64-.012 1.246-.285 1.68-.756a2.34 2.34 0 0 0 .614-1.736c-.08-1.317-1.172-2.345-2.492-2.342-.25 0-.698 0-.673.125v4.56s.623.15.872.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.258 573.84h.673c-.224.1-.648.075-.673 0zm2.89-2.417a2.29 2.29 0 0 0-.689-1.614c-.435-.425-1.02-.66-1.63-.654.608-.007 1.194.23 1.63.654a2.29 2.29 0 0 1 .689 1.614z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.862 583.557c-.065-1.022.587-1.954 1.57-2.243v-1.72a4.01 4.01 0 0 0-3.17 3.999c.036 1.92 1.428 3.544 3.32 3.875v-1.72a2.22 2.22 0 0 1-1.72-2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.068 583.557a3.96 3.96 0 0 0-1.196-2.787c-.753-.734-1.766-1.138-2.817-1.125h-.648v1.72h.648c.628.017 1.22.296 1.63.77a2.24 2.24 0 0 1 .537 1.722 1.92 1.92 0 0 1-2.069 2.118h-.648v1.72a2.17 2.17 0 0 0 .673 0 3.99 3.99 0 0 0 2.809-1.255c.73-.777 1.12-1.815 1.08-2.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.23 587.594a2.17 2.17 0 0 1-.673 0 2.17 2.17 0 0 0 .673 0z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.862 583.557a2.22 2.22 0 0 0 1.67 2.193v-4.435c-1.023.25-1.724 1.19-1.67 2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.18 586.05c.636-.01 1.238-.286 1.663-.76a2.29 2.29 0 0 0 .58-1.733 2.32 2.32 0 0 0-2.343-2.268h-.648v4.435c.218.17.475.28.748.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.532 585.825c.214.043.434.043.648 0-.214.043-.434.043-.648 0zm2.89-2.268a2.32 2.32 0 0 0-2.343-2.268 2.32 2.32 0 0 1 2.343 2.268z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.112 595.618c-.065-1.022.587-1.954 1.57-2.243v-1.744a4.01 4.01 0 0 0-3.158 4.009c.043 1.92 1.44 3.54 3.333 3.865V597.8a2.22 2.22 0 0 1-1.745-2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.317 595.468a3.96 3.96 0 0 0-1.196-2.787c-.753-.734-1.766-1.138-2.817-1.125h-.648v1.97h.673a2.12 2.12 0 0 1 2.318 2.068c.015.586-.216 1.15-.638 1.56s-.995.62-1.58.584h-.673v1.694h.648a3.99 3.99 0 0 0 3.913-3.962zm-3.838 4.087h-.648.648z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.112 595.618a2.22 2.22 0 0 0 1.67 2.193v-4.435c-1.023.25-1.724 1.19-1.67 2.243zm2.343 2.292c1.194-.124 2.1-1.13 2.1-2.33s-.907-2.206-2.1-2.33c-.25 0-.673 0-.673.125v4.435c.215.078.444.112.673.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.672 595.742a2.29 2.29 0 0 0-.689-1.614c-.435-.425-1.02-.66-1.63-.654.608-.007 1.194.23 1.63.654a2.29 2.29 0 0 1 .689 1.614zm-2.89 2.068c.222.045.45.045.673 0-.222.045-.45.045-.673 0z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M839.056 609.77h.3a2.22 2.22 0 0 1-1.794-2.118 2.02 2.02 0 0 1 1.396-2.243v-1.72a3.79 3.79 0 0 0-3.19 4.012 3.99 3.99 0 0 0 3.564 3.887c-.037-.58-.037-1.163 0-1.744l-.274-.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.63 611.54c2.197-.068 3.93-1.9 3.888-4.087.007-1.048-.4-2.055-1.156-2.792a3.89 3.89 0 0 0-2.807-1.12h-.648v1.72l.498.3v-.274c.44-.013.873.128 1.22.4a1.92 1.92 0 0 1 .847 1.719c.065.533-.12 1.066-.498 1.445-.4.45-.773.922-1.42.922a1.72 1.72 0 0 1-.623 0c0 .573 0 1.17.2 1.694h.35l.15.075z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.08 609.746c.038.576.104 1.15.2 1.72-.1-.498-.15-1.146-.2-1.72z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.36 607.578c.012 1.035.717 1.934 1.72 2.193v-4.435a2.17 2.17 0 0 0-1.72 2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.056 609.77c.204.053.42.053.623 0a2.22 2.22 0 0 0 1.62-.698 2.24 2.24 0 0 0 .623-1.67 2.29 2.29 0 0 0-.997-1.894 2.27 2.27 0 0 0-1.321-.374c-.224 0-.648 0-.648.125v3.015c.075.548.075 1.022.1 1.495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.604 605.087c.47.006.927.144 1.32.4a2.5 2.5 0 0 0-1.32-.4zm.1 4.76a2.27 2.27 0 0 0 1.62-.698 2.27 2.27 0 0 1-1.62.698zm-.698-1.372v1.42z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.498 621.333a2.17 2.17 0 0 1-.748-4.186c-.2-.472-.375-.954-.523-1.445-1.666.643-2.638 2.38-2.315 4.136s1.85 3.033 3.636 3.04c.678-.023 1.335-.24 1.894-.623a14.18 14.18 0 0 1-.822-1.321c-.33.236-.718.374-1.12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.127 615.702c.148.49.323.973.523 1.445.223-.04.45-.04.673 0 .564-.013 1.11.2 1.513.595s.63.934.63 1.498a2.17 2.17 0 0 1-.947 1.844 14.18 14.18 0 0 0 .822 1.296 3.69 3.69 0 0 0-2.069-6.778 3.04 3.04 0 0 0-1.146.224v-.125zm0 0a3.04 3.04 0 0 1 1.146-.224 3.04 3.04 0 0 0-1.146.224z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M839.355 619.215a2.12 2.12 0 0 0 2.143 2.118c.404-.024.793-.163 1.12-.4a24.59 24.59 0 0 1-1.869-3.812 2.12 2.12 0 0 0-1.396 2.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.567 619.115c0-.564-.227-1.104-.63-1.498s-.95-.61-1.513-.595c-.223-.04-.45-.04-.673 0a24.59 24.59 0 0 0 1.869 3.912 2.17 2.17 0 0 0 .947-1.819z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M847.953 629.58a1.82 1.82 0 0 1-1.097-3.289l-.922-.922c-.71.63-1.11 1.54-1.097 2.492a3.09 3.09 0 0 0 5.782 1.47l-1.097-.748a1.77 1.77 0 0 1-1.57.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.993 627.687a3.09 3.09 0 0 0-3.14-3.065 2.89 2.89 0 0 0-1.047.199 3.44 3.44 0 0 0-.872.548l.922.922c.667-.486 1.58-.455 2.212.077s.82 1.425.455 2.166l1.097.748c.28-.483.4-1.038.374-1.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.62 629.207c.26-.472.4-1.006.374-1.545.026.54-.103 1.077-.374 1.545zm-3.813-4.386a3.44 3.44 0 0 0-.872.548 3.44 3.44 0 0 1 .872-.548z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.134 627.787a1.82 1.82 0 0 0 1.819 1.794 1.77 1.77 0 0 0 1.57-1.047 24.92 24.92 0 0 1-2.667-2.243 1.82 1.82 0 0 0-.723 1.495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.722 627.712a1.77 1.77 0 0 0-2.866-1.42 24.92 24.92 0 0 0 2.667 2.243 1.82 1.82 0 0 0 .199-.822z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M940.838 530.582c-.47.194-.93.42-1.37.673-.3.174-.573.4-.872.598l-.274.224a3.19 3.19 0 0 0-1.072 1.37v.648c.054.204.156.393.3.548.154.163.34.3.548.374.253.12.52.204.798.25a5.81 5.81 0 0 0 .947 0h-.025.947c.37-.048.737-.123 1.097-.224l.972-.35c.273-.118.54-.25.798-.4a4.61 4.61 0 0 0 .847-.573l.224-.2a4.11 4.11 0 0 0 .847-1.022c.21-.337.362-.708.45-1.096a.6.6 0 0 0 0-.648c-.096-.236-.3-.413-.548-.473a2.32 2.32 0 0 0-.997-.224c-.405-.062-.817-.062-1.22 0l-.897.2c-.574.144-1.127.362-1.645.648l-.623.45c-.32.226-.555.55-.673.922a2.64 2.64 0 0 1-.224.623l.25-.473a3.34 3.34 0 0 1-.399.573l.45-.473-.374.324.623-.45h-.15l.773-.374h-.15l.872-.3.897-.2h-.15 1.072l.598.174h-.15l.45.274a.3.3 0 0 1-.125-.125l.224.4c-.01-.058-.01-.117 0-.174v.45c-.01-.058-.01-.117 0-.174l-.25.473a.77.77 0 0 1 .174-.224l-.45.45.548-.45-.623.424.523-.3-.773.374h.3c.385-.144.747-.346 1.072-.598a2.49 2.49 0 0 0 .748-.673.82.82 0 0 0 .249-.698.6.6 0 0 0-.224-.598l-.45-.3c-.426-.175-.886-.252-1.346-.224a7.33 7.33 0 0 0-2.642.523l.1.05z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M925.934 522.708c-18.492.4-33.37 13.132-34.517 28.905v.224l.847 38.648s-1.072 4.585 12.46 10.665l16.822 8c4.32 1.684 9.155 1.44 13.284-.673l21.234-11.437a10.44 10.44 0 0 0 6.53-8.148v-.847l-.798-37.925c-1.794-15.798-17.346-27.833-35.863-27.4z",
    className: "F"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.274,
    cy: 564.769,
    rx: 9.446,
    ry: 9.618,
    className: "I"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.274,
    cy: 564.769,
    rx: 9.446,
    ry: 9.618,
    className: "H"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dx",
    className: "F"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.448 569.105c-1.76.07-3.386-.93-4.117-2.53s-.423-3.485.782-4.77 3.065-1.712 4.7-1.084 2.746 2.188 2.788 3.947a4.31 4.31 0 0 1-4.162 4.435z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.511,
    cy: 563.424,
    rx: 9.446,
    ry: 9.618
  }))), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dx",
    x: 60.212,
    y: -1.346,
    className: "F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M957.586 567.76c-1.76.07-3.386-.93-4.117-2.53s-.423-3.485.782-4.77 3.065-1.712 4.7-1.084 2.746 2.188 2.788 3.947c.04 1.14-.376 2.25-1.158 3.084s-1.863 1.32-3.004 1.352z",
    className: "H"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "I"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 948.489,
    cy: 544.71,
    rx: 3.489,
    ry: 3.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 937.872,
    cy: 533.073,
    rx: 2.218,
    ry: 2.243
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 939.243,
    cy: 542.692,
    rx: 2.866,
    ry: 2.915
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 902.782,
    cy: 538.231,
    rx: 2.866,
    ry: 2.915
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.078,
    cy: 557.643,
    rx: 1.371,
    ry: 1.395
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 917.062,
    cy: 546.953,
    rx: 1.371,
    ry: 1.395
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M935.056 554.428l-9.595-20.532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.34 543.813l1.122-9.917 9.595 20.532zm4.585 4.934l-12.336 6.105 8.2-22.227-2.293 16.47z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.334 489.616h-44.86l-16.997 19.586 35.988 136.775-7.95 32.792-22.43 9.37 1.396 33.216-41.77-15.698-52.51 5.63s-1.396 34.885-17.32 33.415v17.094l-30.206-18.564-25.22-60.875-19.763-19.237 9.97 61.174-27.414 37.377 5.308 10.7-12.9 37.726-56.947 11.886 114.642 6.205 118.93-5.407 105.994 7.75h50.692l47.078-19.586 73.645 19.586-187.34-340.904z",
    className: "Q"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.334 489.616l-9.97 23.747-28.835-11.886 31.128 28.108 31.128 86.6 9.97 43.906 11.39 55.84-7.6 22.426-34.168-17.02-11.39-19.336 15.053-26.24-31.9 23.174 9.122 13.157 11.39 61.847-41.77 30.898-11.39-18.564 2.966-64.91-41.745-15.698 15.252 19.586-15.252 45.625-17.446-6.18-12.46-29.378-6.78 30.923 16.125 15.45 11.614 23.2-35.115-6.18-18.218 6.18s1.994-37.153-7.626-43.083l-30.206-18.564-25.22-60.875 3.065 28.98-5.93-3.2 13.383 29.378 7.875 14.677 10.816 17.79-11.59 19.31-25.82-9.27 37.383 34.013-26.766-6.952-8.4-6.18-27.3 13.132-68.387 7.95 114.642 6.205 118.904-5.432 105.994 7.75h50.692l47.078-19.586 73.645 19.586-187.34-340.904z",
    className: "K"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.352 509.202l29.234-2.193 32.748-17.393h-44.985zm11.116 42.236l27.937 15.65 26.194 37.127-24.474-21.454-2.592 18.54v29.005l6.58-8.697-10.243 18.714zM1068.4 678.77l17.296-2.666 23.352-.374-31.9 23.174-31.078-10.765zm-115.2 32.467l52.5-5.582 15.252 19.586-29.907 3.688s-24.573-10.44-40.748 0l2.9-17.692z",
    className: "X"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.455 721.354l14.88 38.822 51.888 11.014-11.888 30.15-61.982 12.758-14.455-55.667z",
    className: "K"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.817 645.18l-17.296 24.544v31.895l14.804 15.624 2.492-22.576 33.196 10.94z",
    className: "Q"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.954 721.354l-3.415 22.6-13.183 5.208v12.932l25.146 5.632zm52.56-37.178l-18.393 33.067 9.196-2.293 9.197-9.344-6.43 15.748-13.707 7.525 19.015 9.47 7.6-22.426zm-204.637 60.476l19.04 5.084 20.96-14.478-6.78 30.924-22.356 1.545-10.866-12.185zm-75.2-81.582l12.985 12.658-6.48 27.385zm3.69 69.746l19.713 11.737 14.63 7.7 10.842 17.792-42.368 5.208-18.642-2.816-5.308-10.7zm9.993 68.15l-38.73 9.195-56.947 11.886 68.387-7.95zm-2.243-20.88h31.402l-5.582 9.294z",
    className: "X"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.06 825.287l37.857-35.907 49.77-9.294 56.2 20.88 5.88 18.44-26.816 11.163h-50.692z",
    className: "Q"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.916 789.38l56.997 11.587 33.37-5.806-40.598-15.075z",
    className: "X"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.536 827.58l31.502-13.48 33.595 6.753 53.134-31.472 12.735 24.72-6.654 7.95-27.564 12.932z",
    className: "K"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    fill: "#45bde6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.14 469.83a8.67 8.67 0 0 0 1.246-3.613c.037-.206.037-.417 0-.623-.17-.363-.503-.623-.897-.698-.97-.166-1.946.254-2.492 1.07-.505.866-.57 1.92-.174 2.84a1.97 1.97 0 0 0 1.047 1.146 1.12 1.12 0 0 0 1.396-.424.25.25 0 0 0-.424 0l.3.3zM484.96 290.447c-1.265.022-2.51.33-3.64.897-.195.08-.367.21-.498.374a1.17 1.17 0 0 0 0 1.146 2.49 2.49 0 0 0 2.243 1.545c1.005.003 1.943-.504 2.492-1.346a2.12 2.12 0 0 0 .374-1.545 1.12 1.12 0 0 0-1.097-.947.25.25 0 0 0 .174.374l-.05-.498zm121.745 180.98c.364-.66.364-1.46 0-2.118a2.27 2.27 0 0 0-1.869.947 1.42 1.42 0 0 0 .399 1.919c.326.145.706.104.994-.107s.442-.56.402-.915l.075.274zm10.07-1.096a2.29 2.29 0 0 0 0-.723c-.224 0-.374.424-.623.374-.047-.022-.102-.022-.15 0v.2a.65.65 0 0 0 1.022.174l-.25-.025zm7.7-2.367a5.23 5.23 0 0 0-.174-1.395v-.15h-.174c-.474 0-.748.822-1.22.698h-.25c-.075 0-.125.25 0 .374a1.22 1.22 0 0 0 1.894.349v.224l-.075-.1zm-15.302-7.226a1.17 1.17 0 0 0 0-.997 1.52 1.52 0 0 0-.399.224.4.4 0 0 0 0 .424c0 .2.324.25.523.25h-.125v.1zM431.403 318.63h-.25a.4.4 0 0 0-.125.249 3.49 3.49 0 0 1-.224.723l1.12-.573s.2.15.3.2.324 0 .424-.174c.773-.872-.798-.45-1.246-.424zm194.393 131.916c.035-.088.035-.186 0-.274a.4.4 0 0 0-.224-.125c-.243-.074-.477-.174-.698-.3l.474 1.17-.224.274c-.075.1 0 .324 0 .45.922.972.673-.673.673-1.196zM441.372 293.312h-.35c.03.253.223.456.474.498.224 0 .474-.274.324-.498s-.25-.3 0-.374l-.45.374zM632.625 457.05a.55.55 0 0 1-.847.174.55.55 0 0 1 .249-.847c.17-.028.344.03.463.154s.17.3.135.47v.05zm-13.184 6.18c.15.25.3.573 0 .772s-.498 0-.698-.125-.2-.174-.2-.274.573-.15.648-.424.125 0 0 .15l.25-.1zm-11.265 1.545c.036.096.036.203 0 .3-.25 0-.4-.324-.474-.573s0-.324 0-.424.2 0 .3 0 .35-.324.523-.25a.25.25 0 0 1 0 .299c0 .125 0 .2-.2.3l-.498.548.35-.2zm-3.54 1.894c0-.2-.25-.35-.424-.224-.15.162-.23.377-.224.598.3.067.6-.063.773-.324l-.125-.05zm-.872 22.202c.024-.098.024-.2 0-.3-.03-.105-.117-.183-.224-.2-.174 0-.25.224-.4.3s-.374 0-.498.15a.35.35 0 0 0 .125.449.7.7 0 0 0 .498 0c.148-.016.287-.077.4-.174.105-.122.105-.302 0-.424l.1.2zm-134.78-150.056c.042.033.067.084.067.137s-.025.104-.067.137a.3.3 0 0 1-.249 0h-.174a.25.25 0 0 1 0-.349.25.25 0 0 1 .349 0 .25.25 0 0 1 0 .349l.075-.274zm121.72 121.65a.2.2 0 0 1-.274 0s-.125 0-.15-.224a.5.5 0 0 1 0-.174.25.25 0 0 1 .324-.174.3.3 0 0 1 .15.349.3.3 0 0 1-.324.174l.274.05zm15.55 1.495c.2 0 .374-.224.274-.424a.75.75 0 0 0-.324 0 .3.3 0 0 0 0 .299c.033.042.084.067.137.067s.104-.025.137-.067l-.224.125zm11.913-8.123c.2 0 .4-.25.274-.424a.4.4 0 0 0-.299 0c-.106.046-.16.164-.125.274 0 0 .2.174.25 0l-.1.15zm-7.178 8.248c.18-.186.27-.44.25-.698l-.623.15c-.088-.035-.186-.035-.274 0a.35.35 0 0 0 0 .498.45.45 0 0 0 .523 0l.125.05zm32.474 24.968l.324 1.096c-.15 0-.35 0-.45-.224-.114-.16-.175-.352-.174-.548s.174-.4.374-.35l-.075.025zm-4.885-5.656a.4.4 0 0 0 0-.673c-.25-.127-.557-.053-.723.174-.043.104-.043.22 0 .324.026.197.2.34.4.324a1.02 1.02 0 0 0 .523 0l-.2-.15zm-19.863-19.6a.7.7 0 0 0 .349-.648c-.178-.06-.37-.06-.548 0a.55.55 0 0 0-.274.623c0 .224.498.274.548 0l-.075.025zm-1.445 2.168c-.048.177-.217.293-.4.274l-.174-.548a.45.45 0 0 1 .673.15l-.1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.15 469.856v.2c-.172.037-.35.037-.523 0a.4.4 0 0 1-.299-.399.25.25 0 0 1 .374-.224c.136.117.247.26.324.424h.125zm-13.034-5.382a.35.35 0 0 1-.349.224c-.148-.01-.275-.11-.324-.25v-.25l.523.2.15.075zm-2.243-2.74c-.174 0-.224.274-.224.45.026.192-.038.385-.174.523a.15.15 0 0 1-.15 0c-.125 0 0-.224 0-.35a1.32 1.32 0 0 0 0-.299c-.073-.25.017-.517.224-.673.14-.012.275.055.35.174a.4.4 0 0 1 0 .374l-.025-.2zm-1.42-1.096h-.174a.25.25 0 0 0 0 .299.2.2 0 0 0 .299 0c.052-.032.085-.088.085-.15s-.032-.118-.085-.15h-.125zm-4.087 2.816h-.174c-.07.096-.07.228 0 .324a.2.2 0 0 0 .299 0c.052-.032.085-.088.085-.15s-.032-.118-.085-.15l-.125-.025zm12.386-1.744c0 .15 0 .274.25.274a3.09 3.09 0 0 0 .399 0 .5.5 0 0 1 .374.15c.04.07.04.155 0 .224a.25.25 0 0 1 0 .125 1.37 1.37 0 0 1-.698.424c-.274.056-.555-.05-.723-.274a.55.55 0 0 1 0-.548c.083-.175.255-.3.45-.3l-.05-.075zm-188.81-189.003s.274 0 .3-.174 0-.3 0-.424c.004-.15.078-.288.2-.374a.2.2 0 0 1 .224 0h.125c.153.23.24.497.25.772.03.28-.12.55-.374.673a.55.55 0 0 1-.548 0c-.153-.127-.22-.33-.174-.523v.05zm-4.984 58.258s.274 0 .3-.174a2.49 2.49 0 0 0 0-.424.6.6 0 0 1 .224-.374c.065-.054.16-.054.224 0a1.37 1.37 0 0 1 .274.772.7.7 0 0 1-.399.648.5.5 0 0 1-.523 0 .6.6 0 0 1-.199-.523l.1.075zM617.77 445.56c0 .15 0 .274.224.274a1.87 1.87 0 0 0 .399 0c.147-.003.3.05.4.15a.25.25 0 0 1 0 .224 1.37 1.37 0 0 1-.698.424c-.267.06-.542-.05-.698-.274a.55.55 0 0 1 0-.548.55.55 0 0 1 .474-.299l-.1.05zm-7.65 13.406a.35.35 0 0 0 0-.473.45.45 0 0 0-.474 0s-.15 0-.125.174 0 0 0 0l.573.3h.025zm25.246 62.52c.45.02.9-.143 1.22-.45a.3.3 0 0 0 0-.199c0-.174-.224-.2-.374-.25s-.45-.424-.723-.523a1.07 1.07 0 0 0-.673 0c-.324.125-.723.374-.623.698a.65.65 0 0 0 .374.349c.346.16.717.26 1.097.3l-.3.075zm-9.396-60.6c.25 0 .474-.2.573-.45a.7.7 0 0 0 0-.498c-.125-.2-.424-.15-.623 0l-.573.15a.45.45 0 0 0-.224.15.35.35 0 0 0 0 .224c.157.366.386.696.673.972l.174-.548zm-5.16 7.102c2.044 1.296 3.315-1.246 1.894-2.74s-3.713 1.62-1.894 2.74zm-13.508.075c-.14.107-.32.143-.49.1s-.31-.163-.382-.324a1.27 1.27 0 0 1 .748-.324c.274 0 .548.25.498.498l-.374.324v-.274zm55.178-16.222c.125 0 0-.224-.15-.224-.198-.033-.4-.033-.598 0l-1.346.45a1.32 1.32 0 0 0-.648.324s0 .224.274.224c.215.022.433.022.648 0a3.64 3.64 0 0 0 1.894-.897h-.374l.3.125zm-63.103 11.81a.15.15 0 0 1 0 .199c-.07.04-.155.04-.224 0a.25.25 0 0 1-.174 0 .3.3 0 0 1 0-.349.4.4 0 0 1 .324-.199.25.25 0 0 1 .174 0v.174l-.1.174zm5.93-3.414v-.2c-.105-.034-.22-.034-.324 0v.274l.374-.174-.05.1zm2.02-13.082a1.32 1.32 0 0 0 0-.548.5.5 0 0 0-.324-.399h-.274c-.237.158-.322.466-.2.723a.55.55 0 0 0 .723.15l.075.075zm13.732 6.504a.4.4 0 0 1-.399.498.92.92 0 0 1-.199-.374.55.55 0 0 1 .449 0l.15-.125zm-14.08 19.46v-.35a.87.87 0 0 0-.274 0c0 .197.152.36.35.374l-.075-.025zM360.225 317.383c-.92-.876-2.03-1.532-3.24-1.92a1.72 1.72 0 0 0-.623 0c-.4.092-.708.372-.847.748a2.49 2.49 0 0 0 .573 2.716c.725.666 1.73.936 2.692.723.538-.1 1.015-.396 1.32-.847.295-.466.233-1.073-.15-1.47a.25.25 0 0 0 0 .399l.274-.35zm32.823 21.305a2.07 2.07 0 0 0-2.069-.349 2.49 2.49 0 0 0 .573 2.043c.253.257.6.402.96.402s.707-.145.96-.402c.45-.573 0-1.645-.723-1.57l.3-.125zm-9.745-4.46a1.12 1.12 0 0 0-.972-.174 1.22 1.22 0 0 0 .15.424.4.4 0 0 0 .374.199c.2 0 .3-.3.35-.498v.15l.1-.1zm-1.92 1.545a.5.5 0 0 0-.274 0 .77.77 0 0 0-.174.224 3.44 3.44 0 0 1-.424.623l1.246-.25.224.274c.075.1.324 0 .474 0 1.072-.723-.573-.772-1.072-.872zm5.607.224c.094-.05.205-.05.3 0a.87.87 0 0 1-.648.374h-.4a1.47 1.47 0 0 1 0-.324c0-.2-.25-.4 0-.573s.2 0 .3 0c.1.063.186.15.25.25l.45.598-.25-.324zm1.17 3.862c-.2 0-.374.2-.3.4a.75.75 0 0 0 .548.324.82.82 0 0 0-.174-.822l-.075.1zm21.284 5.058h-.3a.3.3 0 0 0-.224.199c0 .174.15.3.2.473s0 .374 0 .498.35 0 .45 0a.87.87 0 0 0 .125-.498 1.32 1.32 0 0 0 0-.449c-.09-.128-.248-.188-.4-.15l.15-.075zm-25.67-6.18c.062.08.062.193 0 .274a.4.4 0 0 1-.274 0h-.174c-.08-.1-.094-.223-.03-.327s.187-.153.305-.122a.3.3 0 0 1 0 .374l.174-.2zm-4.212 13.93a.15.15 0 0 1 0 .249.25.25 0 0 1-.249 0h-.25a.25.25 0 0 1 0-.349.25.25 0 0 1 .349 0c.098.105.098.268 0 .374l.15-.274zm4.486-15.275c0-.2-.15-.45-.35-.374a.5.5 0 0 0 0 .324s.15.2.25.174a.15.15 0 0 0 0-.249l.1.125zm.897-4.734a.87.87 0 0 0-.648-.374v.648a.5.5 0 0 0 0 .274c.062.074.153.117.25.117s.188-.043.25-.117a.45.45 0 0 0 0-.548h.15zm.822 8.323c.118.096.175.25.15.4a.4.4 0 0 1-.324.274h-.224a.2.2 0 0 1 0-.125l.3-.473.1-.075zm-3.065 1.67c0 .174.224.274.4.3s.4 0 .45.274a.15.15 0 0 1 0 .15h-.673a.6.6 0 0 1-.598-.349.4.4 0 0 1 .224-.324c.118-.058.256-.058.374 0l-.174-.05zm-1.346 1.27v.174c.006.117.086.217.2.25.106-.046.16-.164.125-.274-.033-.042-.084-.067-.137-.067s-.104.025-.137.067l-.05-.15zm1.97 4.6v.174c.03.1.116.15.212.15s.18-.06.212-.15a.2.2 0 0 0-.299 0l-.125-.174zm.723-12.708s.274 0 .3-.174c.013-.14.013-.283 0-.424a.6.6 0 0 1 .224-.374c.065-.054.16-.054.224 0a1.52 1.52 0 0 1 .274.772.7.7 0 0 1-.399.673.5.5 0 0 1-.523 0 .6.6 0 0 1-.199-.523l.1.05zm-2.492-2.9c-.125-.12-.323-.12-.45 0s-.183.3-.15.473c0 0 0 .174.15.15.04.012.084.012.125 0l.4-.523-.075-.1zm8.45 4.535c.082.16.083.35.005.5s-.228.277-.404.312a1.47 1.47 0 0 1-.15-.797c.018-.132.1-.25.2-.325s.245-.102.374-.073l.224.424-.25-.05zm-5.757 7.102a.15.15 0 0 1 .199 0c.025.08.025.168 0 .25v.15c-.1.084-.248.084-.35 0a.3.3 0 0 1 0-.498.15.15 0 0 1 .174 0l-.025.1zm-2.168-6.553h-.2c-.05.102-.05.222 0 .324.033.042.084.067.137.067s.104-.025.137-.067v-.4l-.075.075zm30.256-38.822c-.572-.47-1.35-.602-2.044-.35a2.34 2.34 0 0 0 .573 2.043c.253.257.6.402.96.402s.707-.145.96-.402c.45-.573 0-1.645-.723-1.57l.274-.125zm-13.333 21.778a.35.35 0 0 0-.274 0c-.1.044-.154.127-.174.224a5.48 5.48 0 0 1-.424.623l1.22-.25c.125 0 .125.174.224.274.133.1.316.1.45 0 1.17-.723-.474-.772-1.022-.872zm6.804 4.087c-.174 0-.374.2-.274.4a.75.75 0 0 0 .523.324.77.77 0 0 0-.15-.822l-.1.1zm-4.312-1.12c.062.08.062.193 0 .274a.55.55 0 0 1-.274 0h-.174c-.098-.105-.098-.268 0-.374a.3.3 0 0 1 .374 0 .35.35 0 0 1 0 .374l.075-.274zm-4.262 13.904c.062.08.062.193 0 .274a.4.4 0 0 1-.274 0h-.174c-.076-.05-.12-.135-.115-.225s.057-.17.137-.212.176-.036.252.013a.3.3 0 0 1 0 .349l.174-.2zm4.262-15.25a.3.3 0 0 0-.374-.374c-.038.105-.038.22 0 .324a.25.25 0 0 0 .249.174s.2-.174 0-.25l.125.125zm1.944 3.588c.12.095.168.253.125.4a.35.35 0 0 1-.299.274h-.224a.2.2 0 0 1 0-.125l.3-.473.1-.075zm-3.1 1.645c0 .2.25.274.424.324s.374 0 .45.274a.15.15 0 0 1 0 .15h-.673a.6.6 0 0 1-.598-.374.35.35 0 0 1 .224-.299.3.3 0 0 1 .349 0l-.174-.075zm-1.346 1.296v.174c.046.106.164.16.274.125a.2.2 0 0 0 .15-.274.2.2 0 0 0-.299 0l-.125-.025zm1.97 4.6v.174c.054.112.177.173.3.15.062-.08.062-.193 0-.274-.033-.042-.084-.067-.137-.067s-.104.025-.137.067l-.025-.05zm.673-12.708s.25 0 .274-.2a2.14 2.14 0 0 0 0-.399.6.6 0 0 1 .199-.374.3.3 0 0 1 .249 0 1.52 1.52 0 0 1 .274.772c.01.283-.145.546-.4.673-.173.085-.375.085-.548 0a.6.6 0 0 1-.174-.523l.125.05zm.274 8.746a.15.15 0 0 1 .199 0 .35.35 0 0 1 0 .224c.024.056.024.12 0 .174-.1.084-.248.084-.35 0-.12-.072-.18-.212-.15-.35-.022-.047-.022-.102 0-.15h.174l.125.1zm-2.168-6.553h-.224c-.026.115-.026.234 0 .35h.274v-.4l-.05.05zm2.94-41.165c-.567-.478-1.344-.62-2.044-.374a2.29 2.29 0 0 0 .548 2.043c.254.265.605.415.972.415s.718-.15.972-.415c.45-.573 0-1.645-.723-1.57l.274-.1zm-11.64-2.965a.35.35 0 0 0-.274 0c-.1.044-.154.127-.174.224a5.48 5.48 0 0 1-.424.623l1.22-.25c.125 0 .125.174.224.274s.324 0 .45 0c1.097-.723-.548-.772-1.022-.872zm43.888-3.464c-.2 0-.374.2-.274.4s.3.25.523.324a.77.77 0 0 0-.174-.822l-.075.1zm-41.495 6.43a.2.2 0 0 1 0 .274.4.4 0 0 1-.249 0h-.174c-.098-.105-.098-.268 0-.374.1-.084.248-.084.35 0 .098.105.098.268 0 .374l.075-.274zm-4.212 13.904c.062.08.062.193 0 .274s-.168.13-.274.125h-.174c-.084-.1-.084-.248 0-.35.105-.098.27-.098.374 0a.3.3 0 0 1 0 .349l.075-.4zm4.36-15.25c0-.224-.174-.45-.374-.374-.038.105-.038.22 0 .324a.25.25 0 0 0 .249.174c.033-.033.052-.078.052-.125s-.02-.092-.052-.125l.125.125zm1.844 3.588a.45.45 0 0 1 .125.399.35.35 0 0 1-.299.274s-.224 0-.224-.125l.3-.473.1-.075zm-3.1 1.67c0 .174.224.25.424.3s.374 0 .45.274h-.648a.6.6 0 0 1-.598-.349c-.008-.14.075-.27.205-.32s.28-.013.368.095h-.2zm-1.32 1.27v.174c.05.102.16.162.274.15.062-.017.113-.06.142-.116s.03-.124.008-.183a.2.2 0 0 0-.299 0l-.125-.025zm1.944 4.6v.174c.054.112.177.173.3.15.062-.08.062-.193 0-.274-.033-.042-.084-.067-.137-.067s-.104.025-.137.067l-.025-.05zm42.717-9.22s.25 0 .274-.174a2.49 2.49 0 0 0 0-.424c.026-.135.096-.258.2-.35a.3.3 0 0 1 .249 0 .25.25 0 0 1 0 .125c.164.226.26.494.274.772s-.145.546-.4.673a.55.55 0 0 1-.548 0c-.144-.133-.2-.33-.174-.523l.125-.1zm-41.67 5.258h.2a.45.45 0 0 1 0 .249.82.82 0 0 1 0 .15c-.1.084-.248.084-.35 0-.12-.072-.18-.212-.15-.35-.022-.047-.022-.102 0-.15l.3.1zm-2.268-6.553h-.224a.55.55 0 0 0 0 .349h.274c.025 0 0 0 0-.125v-.4l-.05.174zm-9.994 48.6a.92.92 0 0 0-.498-.174c-.19-.027-.372.075-.45.25a.35.35 0 0 0 0 .274.5.5 0 0 0 .648.324c.258-.114.38-.41.274-.673h.025zm13.06 8.846h-.35c-.024.1-.024.184 0 .274a.35.35 0 0 0 .399-.274h-.05zm100.262 18.913c-.928-.874-2.045-1.522-3.265-1.894a1.27 1.27 0 0 0-.598 0c-.4.088-.723.382-.847.772a2.49 2.49 0 0 0 .573 2.691c.72.674 1.73.944 2.692.723a2.07 2.07 0 0 0 1.296-.822c.315-.466.263-1.088-.125-1.495a.3.3 0 0 0-.15.424l.424-.4zM433.098 307.7c-.576-.46-1.348-.592-2.044-.35-.157.73.047 1.5.548 2.043a1.37 1.37 0 0 0 1.944 0c.45-.598 0-1.645-.723-1.595l.274-.1zm-9.745-4.435a1.02 1.02 0 0 0-.947-.199 1.52 1.52 0 0 0 .125.449c.09.127.244.194.4.174.2 0 .274-.274.324-.473v.15l.1-.1zm-1.92 1.545c-.096-.036-.203-.036-.3 0a.4.4 0 0 0-.15.199c-.127.225-.268.442-.424.648l1.22-.25s.125.174.224.25.324 0 .45 0c1.12-.698-.498-.748-1.022-.847zm-4.8-6.578h-.35c.044.246.23.442.474.498.25 0 .474-.274.35-.498s-.274-.3 0-.374l-.474.374zM427.067 305h.3c-.15.225-.402.364-.673.374h-.4c-.075 0 0-.2 0-.3s-.25-.4-.15-.573c.096-.07.228-.07.324 0 .1.063.186.15.25.25l.45.623-.1-.374zm1.146 3.887c-.174 0-.374.2-.274.4.134.163.318.277.523.324.124-.283.054-.614-.174-.822l-.075.1zm-4.287-1.12a.15.15 0 0 1 0 .249.25.25 0 0 1-.249 0 .2.2 0 0 1-.174 0 .25.25 0 0 1 0-.349.25.25 0 0 1 .349 0c.098.105.098.268 0 .374l.075-.274zm0-1.37a.3.3 0 0 0-.374-.349c-.038.105-.038.22 0 .324s.14.172.25.174c0 0 .174-.174.125-.25v.1zm-5.558-13.456c.034-.1.01-.21-.065-.284s-.185-.1-.284-.065c-.038.105-.038.22 0 .324.025.114.133.2.25.174 0 0 .174-.174.125-.25l-.025.1zm6.63 8.746c-.132-.22-.366-.36-.623-.374v.673c-.022.098-.022.2 0 .3.062.074.153.117.25.117s.188-.043.25-.117c.117-.164.117-.384 0-.548l.125-.05zm.822 8.298c.118.096.175.25.15.4s-.147.27-.3.3c-.05.015-.104.007-.147-.022s-.072-.076-.077-.128l.3-.498.075-.05zm-.573 2.9c-.125 0 0 .35 0 .523s.15.4 0 .548 0 0 0 0l-.224-.324c-.075-.125-.125-.15-.174-.224a.65.65 0 0 1 0-.698.35.35 0 0 1 .374 0 .35.35 0 0 1 0 .374l.025-.2zm-1.77-.4h-.224c-.07.096-.07.228 0 .324a.2.2 0 0 0 .299 0c.042-.033.067-.084.067-.137s-.025-.104-.067-.137l-.075-.05zm-2.692 4.236h-.2c-.044.042-.07.1-.07.162s.025.12.07.162a.2.2 0 0 0 .299 0 .2.2 0 0 0-.125-.274l.025-.05zm3.14-11.86c.125 0 .274 0 .3-.2s0-.274 0-.424a.5.5 0 0 1 .199-.349.25.25 0 0 1 .224 0 1.42 1.42 0 0 1 .249.772.7.7 0 0 1-.374.673.55.55 0 0 1-.548 0c-.153-.127-.22-.33-.174-.523l.125.05zm26.84-10.715a.35.35 0 0 0-.474 0 .45.45 0 0 0-.125.473.15.15 0 0 0 .125.15l.4-.523.075-.1zm-20.7 12.36c.082.156.087.342.014.502s-.216.28-.387.32c-.13-.244-.19-.52-.174-.797 0-.274.35-.523.598-.424l.224.424-.274-.025zm-5.508 8.77c.054.065.054.16 0 .224a.35.35 0 0 1-.199 0c-.064.025-.135.025-.2 0-.122-.034-.204-.148-.2-.274s.08-.25.2-.3c.056-.024.12-.024.174 0v.15l.224.2zm-2.393-8.298h-.224a.55.55 0 0 0 0 .349h.274c.025 0 0 0 0-.15v-.4l-.05.2zm-.324-8.05c-.163-.084-.34-.134-.523-.15-.19-.027-.372.075-.45.25a.5.5 0 0 0 0 .274c.094.264.38.407.648.324.262-.124.4-.423.3-.698h.025zm13.06 8.846h-.374c-.024.098-.024.2 0 .3a.35.35 0 0 0 .399-.274l-.025-.025zm-9.072 11.238c-.572-.47-1.35-.602-2.044-.35-.15.734.063 1.495.573 2.043.253.257.6.402.96.402s.707-.145.96-.402c.45-.598 0-1.67-.723-1.595l.274-.1zM379.6 292.6h.3c0 .25-.4.324-.648.374s-.324 0-.4 0 0-.2 0-.3-.25-.424-.15-.573c.096-.07.228-.07.324 0 .1.063.186.15.25.25l.45.623-.125-.374zm26.89 11.886c-.2 0-.374.2-.3.4a.92.92 0 0 0 .548.324.82.82 0 0 0-.174-.822l-.075.1zm10.093 14.577c.062.08.062.193 0 .274-.033.043-.075.077-.125.1h-.174a.25.25 0 0 1 0-.349c.105-.098.27-.098.374 0a.3.3 0 0 1 0 .349l-.075-.374zm1.994 2.243a.4.4 0 0 1 .125.399c-.028.152-.147.27-.3.3 0 0-.224 0-.224-.15s0 0 0 0l.3-.473.1-.075zm36.9-7.45a.5.5 0 0 0 0 .523c0 .174.15.374 0 .523-.125 0-.15-.174-.2-.3a.97.97 0 0 0-.199-.249.65.65 0 0 1 0-.698.35.35 0 0 1 .374 0c.058.11.058.24 0 .35l.025-.15zm-39.277 9.942h-.224a.3.3 0 0 0 0 .324h.3c.05 0 0-.274 0-.274l-.075-.05zm-2.667 4.21h-.224c-.07.096-.07.228 0 .324a.2.2 0 0 0 .299 0c.042-.033.067-.084.067-.137s-.025-.104-.067-.137l-.075-.05zm9.246-10.19c.082.156.087.342.014.502s-.216.28-.387.32a1.57 1.57 0 0 1-.15-.797c0-.274.324-.523.573-.424l.224.424-.274-.025zm-5.483 8.77a.15.15 0 0 1 0 .224l-.2.125h-.174a.3.3 0 0 1-.224-.274c.01-.127.086-.24.2-.3a.15.15 0 0 1 .174 0c.033.044.033.105 0 .15l.224.075zm10.318-7.5h-.35a.5.5 0 0 0 0 .274c.086.022.178.008.253-.04s.128-.123.146-.2l-.05-.025zm-16.498.548h-.35c-.024.098-.024.2 0 .3a.35.35 0 0 0 .399-.274l-.05-.025zM661.983 488.12c.213.388.213.858 0 1.246.015.04.015.084 0 .125a.25.25 0 0 1-.224 0c-.424-.224-.897-.573-.847-1.047.045-.205.19-.374.385-.45s.416-.047.587.075v.4l.1-.35zm-237.1-77.096a8.52 8.52 0 0 0-1.994-3.239 1.47 1.47 0 0 0-.498-.374c-.388-.108-.805-.004-1.097.274a2.49 2.49 0 0 0-.748 2.641c.318.946 1.083 1.674 2.044 1.944a2.07 2.07 0 0 0 1.545 0c.477-.276.703-.842.548-1.37-.15 0-.35 0-.3.274l.498-.15zm-2.293 5.258a2.17 2.17 0 0 0-1.645-1.296 2.24 2.24 0 0 0-.449 2.068c.103.345.34.635.66.803s.69.202 1.035.094c.673-.3.773-1.47 0-1.744l.4.075zm5.583-8.597a3.19 3.19 0 0 0-.623-.374v.723l.15.15c.195.03.393-.03.542-.158s.233-.318.23-.515l-.3.174zm3.016-7.575c-.343-.317-.74-.57-1.17-.748-.047-.022-.102-.022-.15 0v.125c0 .125.15 1.096-.25 1.37-.077.044-.145.104-.2.174 0 .15 0 .25.274.3a1.27 1.27 0 0 0 1.47-1.296l.15.15-.125-.075zm-15.128 7.55c-.143-.32-.43-.55-.773-.623-.012.15-.012.3 0 .45a.4.4 0 0 0 .274.349c.2 0 .374 0 .523-.274v.174l-.025-.075zm2.692-19.56c-.082-.022-.168-.022-.25 0a.45.45 0 0 0-.249 0 3.44 3.44 0 0 1-.673.349l1.196.374v.35c0 .125.274.2.45.174 1.32-.15-.075-.922-.474-1.246zm9.246-1.395a.55.55 0 0 1-.399.772c-.173-.003-.333-.092-.427-.236s-.112-.326-.046-.486a.5.5 0 0 1 .847 0l.025-.05zm-3.564 14.403c.274 0 .623 0 .623.4s-.274.4-.523.473-.25 0-.324 0 .224-.548 0-.772.174 0 .15 0l.075-.1zm-5.93 9.892a.6.6 0 0 1 .274.15.87.87 0 0 1-.748 0c-.15 0-.3 0-.324-.274-.01-.1-.01-.2 0-.3 0-.2 0-.473.15-.573.096-.07.228-.07.324 0a1.62 1.62 0 0 1 0 .324v.772l.324-.1zm-.773 3.962c0-.174-.424 0-.424.224s.15.374.3.523a.77.77 0 0 0 .249-.797l-.125.05zm16.424 14.702c-.066-.08-.152-.14-.25-.174-.094-.05-.205-.05-.3 0v.523c0 .174-.224.3-.2.473a.3.3 0 0 0 .424.174c.145-.087.258-.218.324-.374a.97.97 0 0 0 0-.449.3.3 0 0 0-.274-.299l.274.125zm-29.932-7.55a.2.2 0 0 1 0 .249c-.094.05-.205.05-.3 0a.25.25 0 0 1-.125 0c-.098-.105-.098-.268 0-.374.1-.084.248-.084.35 0 .084.1.084.248 0 .35l.075-.224zm10.94-11.363c.06-.082.08-.19.05-.287s-.104-.177-.2-.212a.6.6 0 0 0-.174.299c0 .11.056.214.15.274 0 0 .25 0 .224-.174l-.05.1zm1.296-14.552c.06-.082.08-.19.05-.287s-.104-.177-.2-.212a.65.65 0 0 0-.174.274s0 .25.15.274.25 0 .224-.15l-.05.1zm1.77 10.864a.87.87 0 0 0-.374-.623l-.274.573c-.024.1-.024.184 0 .274a.35.35 0 0 0 .424.274.45.45 0 0 0 .299-.449l-.075-.05zm39.477-9.967l1.047.424c0 .2-.25.224-.45.2a.87.87 0 0 1-.548-.199s-.174-.4 0-.498l-.05.075zm-7.352.3a.4.4 0 0 0-.523-.424.65.65 0 0 0-.324.698.5.5 0 0 0 .199.299.4.4 0 0 0 .498 0c.114-.146.19-.317.224-.498l-.075-.075zm-27.49 3.364c.048-.26-.06-.52-.274-.673-.15.1-.254.27-.3.45-.07.253.057.52.3.623.224 0 .498-.224.374-.424l-.1.025zm.798 2.542c.108.15.108.35 0 .498l-.548-.224a.45.45 0 0 1 .548-.424v.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.39 407.885h.224a.92.92 0 0 1-.324.424.4.4 0 0 1-.498 0c-.125-.125 0-.4 0-.424.17-.05.352-.05.523 0h.075zm-12.287 6.927a.4.4 0 0 1 0 .399.35.35 0 0 1-.399 0c-.047-.01-.088-.042-.11-.085s-.028-.093-.013-.14l.474-.274.05.1zm-3.49-.025a.5.5 0 0 0 .224.473c0 .125.3.274.274.45 0 0-.224 0-.324-.174l-.274-.125c-.227-.113-.372-.344-.374-.598.08-.1.214-.167.35-.15a.35.35 0 0 1 .274.249l-.15-.125zm-1.77.498h-.174c-.015.06-.005.123.028.174s.086.088.146.1c.116.016.224-.06.25-.174 0-.125 0-.25-.224-.2l-.025.1zm-.424 5.01h-.174a.25.25 0 0 0 .174.274.2.2 0 0 0 .249-.174c.012-.06-.01-.123-.055-.164s-.1-.055-.17-.036l-.025.1zm6.48-10.914c0 .15.274 0 .35 0s.125-.274.2-.374c.076-.124.204-.207.35-.224a.2.2 0 0 1 .224 0c.012.05.012.1 0 .15.034.28-.01.565-.125.822-.123.245-.374.4-.648.4-.196-.027-.36-.162-.424-.35a.55.55 0 0 1 0-.548l.075.125zm-6.006-18.066c0 .125.25 0 .324 0a1.77 1.77 0 0 0 .199-.374c.076-.124.204-.207.35-.224a.35.35 0 0 1 .224 0 .35.35 0 0 1 0 .174 1.47 1.47 0 0 1-.15.797c-.113.254-.37.412-.648.4-.186-.032-.344-.153-.424-.324a.55.55 0 0 1 0-.548l.125.1zm5.308 14.403a.35.35 0 0 0-.399-.249c-.173.055-.306.197-.35.374-.042.06-.042.14 0 .2.047.022.102.022.15 0l.598-.25v-.075zm63.7 19.436c.288-.34.44-.775.424-1.22v-.224c0-.05-.3 0-.45.15s-.573 0-.822.25c-.18.154-.304.365-.35.598 0 .324-.174.797.15.922a.6.6 0 0 0 .498 0 3.39 3.39 0 0 0 .897-.673l-.35.2zm-52.162-30.7c.25 0 .15-.498 0-.723s-.2-.324-.35-.324-.374.224-.474.424l-.224.573v.25c0 .075.125 0 .2 0 .38.075.768.075 1.146 0l-.3-.2zm2.168 8.597c2.268-.772 1.12-3.39-.897-3.2s-1.12 3.887.897 3.2zm42.12-18.838c2.268-.797 1.12-3.39-.922-3.214s-1.047 3.837.922 3.214zm-50.567 29.528c-.002.177-.085.344-.227.452s-.325.143-.496.097c-.006-.274.073-.544.224-.772.1-.098.216-.153.35-.153s.26.056.35.153v.498l-.2-.274zm22.33-53.873c0-.174 0-.15-.25 0-.12.176-.213.37-.274.573l-.523 1.32c0 .274-.2.573-.125.723s.2 0 .324 0a3.14 3.14 0 0 0 .324-.573 4.01 4.01 0 0 0 .523-2.068l-.274.274.274-.25zm-30.68 57.36s.125 0 .125.174 0 .15-.125.2 0 0-.15 0a.25.25 0 0 1-.324-.15.35.35 0 0 1 0-.349c.05-.012.1-.012.15 0h.15l.174.125zm1.12-6.803h-.2c-.025.107-.025.217 0 .324 0 0 .174.2.25.125a.2.2 0 0 0 0-.125v-.4l-.05.075zm-8.698-9.868a1.92 1.92 0 0 0-.374-.399.5.5 0 0 0-.523 0 .65.65 0 0 0-.125.224.55.55 0 0 0 .424.623.55.55 0 0 0 .573-.473l.025.025zm13.583-6.753c.115.043.202.14.232.26s-.001.246-.083.338a.8.8 0 0 1-.424 0c-.004-.165.07-.322.2-.424l.075-.174zm6.006 23.398h-.35c-.02.082-.02.167 0 .25.06.066.147.103.237.103s.175-.037.237-.103l-.125-.25zm4.984-58.358a8 8 0 0 0 3.763 0c.197-.033.384-.1.548-.224a1.12 1.12 0 0 0 .374-1.071 2.49 2.49 0 0 0-1.794-2.068c-.962-.23-1.975.04-2.692.723-.425.336-.695.83-.748 1.37a1.17 1.17 0 0 0 .847 1.221c.063-.052.1-.13.1-.212s-.037-.16-.1-.212l-.3.473zm-3.14-4.784a2.17 2.17 0 0 0 1.969-.698c-.21-.722-.774-1.286-1.495-1.495a1.32 1.32 0 0 0-1.645.997c0 .723.798 1.42 1.396.997l-.224.2zm4.137 9.394c.242-.067.47-.177.673-.324 0 0-.523-.25-.523-.498.012-.05.012-.1 0-.15a.15.15 0 0 0-.199 0c-.133.15-.193.35-.164.546s.144.372.314.476l-.1-.05zm4.685 6.678c.445-.142.866-.352 1.246-.623a.25.25 0 0 0 0-.174c-.224-.424-.997-.45-1.022-.947.025-.08.025-.168 0-.25h-.374a1.27 1.27 0 0 0 .274 1.944h-.2l.075.05zm1.82-17.07a1.07 1.07 0 0 0 .922-.324.92.92 0 0 0-.324-.299c-.128-.088-.296-.088-.424 0-.174.15 0 .4 0 .598h-.15l-.025.025zm14.73 12.758c.096-.025.182-.077.25-.15v-.274a3.81 3.81 0 0 1 0-.748l-.947.822h-.3c-.1 0-.324 0-.4.274-.474 1.022.972.25 1.396.075zm-3.763 8.67c-.17-.016-.323-.114-.407-.263s-.09-.33-.016-.484a.5.5 0 0 1 .847 0 .55.55 0 0 1-.399.772l-.025-.025zm-9.994-10.715c-.174.224-.424.473-.673.324s-.174-.473 0-.723 0-.224.174-.25.324.498.598.473l-.1.174zm-5.06-10.39c-.063.078-.15.13-.25.15 0-.274.2-.473.4-.648s.274-.2.4-.125c.072.073.13.157.174.25 0 .15.424.224.4.424s-.125.2-.25.224c-.107.02-.217.02-.324 0l-.698-.3.15.025zm-2.866-2.79c.2 0 .224-.374 0-.498-.2-.074-.422-.074-.623 0 .046.297.26.54.548.623l.075-.125zm1.27-15.45s-.15 0-.15-.224a.4.4 0 0 1 .174-.224c.056-.024.12-.024.174 0 .142.013.25.132.25.274a.3.3 0 0 1-.274.249.35.35 0 0 1-.274-.274l.1.2zm3.614 15.474c.014.105.088.193.19.225s.212.002.284-.076a.5.5 0 0 0-.15-.299c-.085-.076-.214-.076-.3 0v.274l-.025-.125zm11.39 8.896c.014.105.088.193.19.225s.212.002.284-.076c.026-.127.008-.258-.05-.374-.085-.076-.214-.076-.3 0v.274l-.125-.05zm-9.994-4.26a.87.87 0 0 0 .748 0l-.324-.548c-.053-.086-.12-.162-.2-.224-.09-.04-.19-.038-.277.006s-.15.124-.17.218c-.043.19.036.4.2.498l.025.05zm2.766 7.326a.65.65 0 0 0 .723.15c-.016-.192-.105-.37-.25-.498-.182-.17-.466-.17-.648 0-.2.15 0 .548.15.548l.025-.2zm-2.542-.673c-.18.004-.338-.122-.374-.3l.474-.324c.105.08.166.205.166.336s-.06.256-.166.336l-.1-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.356 362.71l-.15.174a1.17 1.17 0 0 1-.15-.498.5.5 0 0 1 .249-.449c.174 0 .4 0 .324.3a.92.92 0 0 1-.274.449v.025zm.847-14.278a.4.4 0 0 1-.324-.274c-.044-.146.006-.304.125-.4h.274v.573l-.075.1zm1.87-3a.5.5 0 0 0-.523 0 .5.5 0 0 1-.523 0s.174-.15.3-.2c.097-.035.183-.095.25-.174a.65.65 0 0 1 .698 0 .35.35 0 0 1 0 .374.3.3 0 0 1-.349 0h.15zm.523-1.794v-.2a.2.2 0 0 0-.299 0c-.052.032-.085.088-.085.15s.032.118.085.15c.033.042.084.067.137.067s.104-.025.137-.067l.025-.1zm-3.938-3.015v-.224c-.042-.044-.1-.07-.162-.07s-.12.025-.162.07a.2.2 0 0 0 0 .299c.033.042.084.067.137.067s.104-.025.137-.067l.05-.075zm5.583 11.388s-.2.174-.15.3.15.25.2.374c.05.137.05.287 0 .424-.038.07-.1.123-.174.15h-.174c-.24-.135-.443-.322-.598-.548-.15-.236-.15-.537 0-.772.123-.145.3-.22.498-.2a.55.55 0 0 1 .424.349l-.025-.075zm18.243 4.46c-.15 0-.224.174-.174.324s.15.224.2.35c.076.13.076.293 0 .424-.026.078-.093.135-.174.15h-.15a1.27 1.27 0 0 1-.598-.548c-.15-.236-.15-.537 0-.772a.6.6 0 0 1 .523-.199.55.55 0 0 1 .399.374l-.025-.1zm-14.804-3.115a.35.35 0 0 0 .399-.199.5.5 0 0 0 0-.498h-.2c-.05 0 0 0 0 .125v.648l-.2-.075zm-15.203 24.843a.35.35 0 0 0 .424-.199c.05-.17.002-.35-.125-.473h-.2c-.075 0 0 0 0 .15v.623l-.1-.1zm18.393-8.946c0 .274.324.4.598.4.168.025.34-.02.474-.125.125-.2 0-.45 0-.648l-.35-.473a.35.35 0 0 0-.199-.174.3.3 0 0 0-.199 0 2.74 2.74 0 0 0-.822 1.022h.498zm-8.3-2.716c-.548 2.492 2.218 2.79 3.165.922s-2.667-3-3.165-.922zm30.08 37.6c-.548 2.492 2.218 2.79 3.14.947s-2.642-2.94-3.14-.947zM429.2 353.59c-.137-.11-.216-.274-.216-.45s.08-.34.216-.45a1.27 1.27 0 0 1 .523.623c.056.125.055.268-.002.392s-.166.218-.297.256l-.4-.25.174-.125zm1.57-9.045a.15.15 0 0 1-.224 0 .5.5 0 0 1 0-.199.55.55 0 0 1 0-.199.3.3 0 0 1 .299-.199c.12.03.22.113.274.224v.2l-.35.174zm5.034 4.635h.2a.4.4 0 0 0-.174-.274s-.274 0-.25.15l.274.3-.05-.174zm12.835-2.342c.183.013.366-.03.523-.125.175-.065.286-.237.274-.424a.77.77 0 0 0-.125-.249c-.138-.116-.327-.15-.497-.087s-.293.21-.324.386.035.358.173.474l-.025.025zm-1.645 15.4a.35.35 0 0 1-.573-.199.87.87 0 0 1 .274-.324c.128.1.217.24.25.4l.05.125zm-22.63-7.326l.3-.224a.4.4 0 0 0-.174-.224c-.084.028-.153.09-.2.17s-.04.172-.01.254l.075.025zm-16.773-17.567a8.25 8.25 0 0 0 3.564-1.171c.18-.105.34-.24.474-.4a1.17 1.17 0 0 0 0-1.146 2.49 2.49 0 0 0-2.343-1.395c-.987.103-1.856.692-2.318 1.57a2.12 2.12 0 0 0-.299 1.545 1.17 1.17 0 0 0 1.196.872c.032-.08.024-.17-.02-.242s-.12-.122-.205-.13l-.05.498zm-4.46-3.513c.74-.1 1.363-.617 1.62-1.32-.428-.603-1.13-.95-1.87-.922a1.37 1.37 0 0 0-1.246 1.47c.125.723 1.196 1.096 1.62.523l-.125.25zm6.854 7.575a2.49 2.49 0 0 0 .523-.523c-.174-.15-.573 0-.673-.3s0 0 0 0a.15.15 0 0 0-.174 0 .7.7 0 0 0 .449.947l-.125-.125zm6.455 4.81c.38-.28.716-.617.997-.997.017-.048.017-.1 0-.15v-.15c0-.15-1.072 0-1.27-.573v-.224c0-.05-.274 0-.35.174a1.32 1.32 0 0 0 .872 1.769h-.174l-.075.15zm-3.54-16.82a1.17 1.17 0 0 0 .773-.598.87.87 0 0 0-.399-.199c-.153-.01-.302.055-.4.174-.067.2-.02.42.125.573h-.174l.075.05zm18.02 7.475s.15 0 .174-.224a.55.55 0 0 0 0-.274 3.44 3.44 0 0 1-.199-.723l-.648 1.07h-.35c-.125 0-.25.2-.274.374-.25 1.17.872-.025 1.296-.224zm-.947 9.37a.55.55 0 0 1-.648-.598.5.5 0 0 1 .497-.387.5.5 0 0 1 .479.408.5.5 0 0 1-.303.552l-.025.025zm-12.8-6.877c0 .25-.274.573-.523.523s-.324-.374-.35-.648a.4.4 0 0 1 0-.299c.25-.15.474.35.723.274s0 .174 0 0l.15.15zm-8.025-8.298a.6.6 0 0 1-.199.224c-.065-.263 0-.54.174-.748 0 0 .2-.25.324-.224s.174 0 .274.15.45 0 .498.3a.25.25 0 0 1-.174.274c-.107.025-.217.025-.324 0h-.748l.174.025zm-3.614-1.67c.2 0 0-.424 0-.473-.207-.028-.416.036-.573.174.123.272.4.44.698.424l-.125-.125zm-17.92 12.683c.086-.053.162-.12.224-.2.06-.09.06-.208 0-.3 0-.15-.324 0-.474-.15s-.224-.3-.4-.3-.3.174-.274.35a.6.6 0 0 0 .299.399c.1.11.23.2.374.224.157.036.316-.05.374-.2l-.125.174zm14.33-27.784s-.174 0-.2-.174a.35.35 0 0 1 0-.274h.15a.25.25 0 0 1 .324.15c.03.144-.057.287-.2.324-.137.034-.277-.042-.324-.174l.25.15zm8.25 13.506c.045.097.142.16.25.16s.205-.062.25-.16a.5.5 0 0 0-.224-.224c-.085-.076-.214-.076-.3 0a.15.15 0 0 0 0 .249l.025-.025zm13.558 4.76a.3.3 0 0 0 .523 0 .7.7 0 0 0-.249-.224.25.25 0 0 0-.299 0v.25l.025-.025zm-10.79-.822a.87.87 0 0 0 .698-.224l-.474-.424c-.067-.072-.154-.124-.25-.15a.35.35 0 0 0-.374.349.5.5 0 0 0 .374.424l.025.025zm4.9 6.055a.65.65 0 0 0 .723 0 .97.97 0 0 0-.374-.399c-.233-.106-.507-.045-.673.15-.125.224 0 .548.324.473v-.224zm-2.617.2a.4.4 0 0 1-.449-.174l.324-.473a.45.45 0 0 1 .274.648h-.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.995 340.607v.224c-.13-.127-.232-.28-.3-.45-.082-.167-.03-.37.125-.473.067-.06.163-.074.245-.036s.132.12.13.21c.06.16.06.337 0 .498l-.2.025zm-3.664-13.705c-.148.022-.295-.047-.374-.174-.088-.128-.088-.296 0-.424 0 0 .2-.15.274 0s0 0 0 0l.25.598h-.15zm.847-3.538h-.498c-.15 0-.35.224-.498.15 0 0 0-.2.224-.274l.2-.25a.6.6 0 0 1 .648-.199.35.35 0 0 1 0 .374c-.05.12-.168.2-.3.2h.224zm-.05-1.87v-.224c-.116-.028-.237.022-.3.125a.25.25 0 0 0 0 .299c.054.016.113.005.157-.03s.07-.09.067-.145l.075-.025zm-4.685-1.62v-.2c-.056-.025-.12-.025-.176-.002s-.1.07-.123.126a.2.2 0 0 0 0 .274c.057.027.124.022.176-.014s.08-.097.074-.16l.05-.025zm8.847 9.02c-.125 0-.15.224 0 .35s.2.15.3.274a.45.45 0 0 1 .125.399.25.25 0 0 1-.125.199h-.125a1.57 1.57 0 0 1-.748-.324c-.214-.184-.302-.476-.224-.748a.55.55 0 0 1 .424-.349c.195-.025.388.062.498.224l-.125-.025zm18.692-1.645c-.15 0-.15.224 0 .35a3.74 3.74 0 0 0 .324.274.7.7 0 0 1 .125.399s0 .174-.125.2-.125 0-.174 0a1.47 1.47 0 0 1-.723-.324c-.226-.176-.316-.476-.224-.748.064-.187.228-.322.424-.35s.388.062.498.224l-.125-.025zm-15.028 1.794c.174 0 .324-.15.35-.324a.55.55 0 0 0-.274-.424h-.2c-.05 0 0 0 0 .174v.623l.125-.05zm8 14.13c0 .25.45.25.698.174s.35 0 .4-.274-.125-.424-.324-.573l-.474-.35s-.15-.125-.224 0a.4.4 0 0 0-.174.174 3.29 3.29 0 0 0-.349 1.121l.45-.274zm-8.723.025c.224 2.492 2.966 1.944 3.3-.125s-3.564-1.97-3.3.125zm-8.174-10.864c-.167-.047-.304-.168-.37-.328s-.06-.342.023-.495a1.32 1.32 0 0 1 .773.374.5.5 0 0 1 0 .723h-.45l.025-.274zm46.03 34.96c.174 0 .2 0 0-.25a1.92 1.92 0 0 0-.474-.399l-1.146-.822c-.224-.174-.498-.35-.648-.324s-.125.174 0 .35a2.84 2.84 0 0 0 .474.473 3.84 3.84 0 0 0 1.869.997l-.224-.324.15.3zm-47.352-44.03a.15.15 0 0 1-.199 0s-.125 0-.174-.15a.6.6 0 0 1 0-.199.3.3 0 0 1 .224-.274c.123-.025.25.024.324.125.024.056.024.12 0 .174l-.174.324zm6.23 2.74l.15-.174c-.07-.093-.165-.162-.274-.2 0 0-.25 0-.174.2s0 0 0 0l.35.2-.05-.025zm11.464-6.254a1.17 1.17 0 0 0 .474-.299.45.45 0 0 0 0-.498.45.45 0 0 0-.199-.174c-.262-.105-.56.017-.673.274a.55.55 0 0 0 .299.673l.1.025zm3.215 15.05c-.07.104-.186.167-.312.167s-.242-.063-.312-.167c.028-.14.078-.275.15-.4a.7.7 0 0 1 .349.299l.125.1zm-8.773 19.685c.03.024.05.06.05.1s-.018.076-.05.1a.35.35 0 0 1-.199 0h-.224a.3.3 0 0 1-.199-.299c.056-.047.126-.073.2-.075.056-.024.12-.024.174 0v.15l.25.025zm13.657 8.572a.2.2 0 0 1-.15-.224.35.35 0 0 1 .174-.249h.15c.068-.008.136.016.185.064s.072.117.064.185c.035.113-.006.235-.1.304s-.225.07-.32 0-.137-.19-.1-.304l.1.224zm-1.27 5.457v-.224a.3.3 0 0 0-.324 0c-.044.042-.07.1-.07.162s.025.12.07.162a.2.2 0 0 0 .274 0l.05-.1zm1.27-3.862a.4.4 0 0 0 .174-.224v-.274c-.084-.234-.143-.476-.174-.723l-.648 1.096h-.35c-.125 0-.25.2-.274.374-.35 1.27.847.075 1.27-.25zm-13.757 2.517c0 .274-.274.598-.548.548s-.324-.4-.324-.673v-.3c0-.05.474.374.723.274s0 .174 0 .125l.15.025zm6.58-6.728c.045.097.142.16.25.16s.205-.062.25-.16a.5.5 0 0 0-.224-.224.3.3 0 0 0-.299 0c-.042.033-.067.084-.067.137s.025.104.067.137l.025-.05zm-5.882 5.258a.6.6 0 0 0 .698 0c-.063-.174-.2-.31-.374-.374a.5.5 0 0 0-.648 0c-.125.224 0 .573.324.473v-.1zm12.087-10.565s-.15.224 0 .35.224.174.3.274a.45.45 0 0 1 0 .399c.03.063.03.137 0 .2a.15.15 0 0 1-.15 0c-.277-.028-.538-.14-.748-.324a.7.7 0 0 1-.224-.748c.08-.17.238-.292.424-.324.19-.043.4.036.498.2l-.1-.025zm-7.003 15.923c0 .274.424.25.698.174a.65.65 0 0 0 .399-.274c0-.224-.15-.424-.324-.573l-.474-.35h-.224c-.075 0 0 0-.174.15a2.49 2.49 0 0 0-.349 1.121l.45-.25zm-8.598.05c.2 2.492 2.966 1.92 3.265-.15s-3.564-1.97-3.265.15zm11.265-8.422c-.07.104-.186.167-.312.167s-.242-.063-.312-.167a1.27 1.27 0 0 1 .174-.424c.155.058.28.174.35.324l.1.1zm61 24.694a.15.15 0 0 1 0 .199.35.35 0 0 1-.199.125h-.174a.3.3 0 0 1-.224-.274c.012-.133.085-.254.2-.324h.174a.15.15 0 0 1 0 .15l.224.125zm13.632 8.572s-.15 0-.15-.224c.035-.097.095-.183.174-.25h.174c.133.012.238.117.25.25a.3.3 0 0 1-.274.249.3.3 0 0 1-.274-.274l.1.25zm-1.17 5.457v-.2c-.085-.076-.214-.076-.3 0-.044.042-.07.1-.07.162s.025.12.07.162c.033.042.084.067.137.067s.104-.025.137-.067l.025-.125zm1.17-3.862c.084-.04.146-.117.17-.208s.007-.188-.046-.265c0-.25-.125-.498-.174-.748l-.648 1.096h-.35c-.125 0-.25.2-.274.374-.224 1.37.897.075 1.32-.25zm-13.632 2.542c0 .25-.274.573-.523.523s-.324-.374-.35-.648a.45.45 0 0 1 0-.324c.25-.15.474.374.723.274s0 .174 0 .15l.15.025zm6.455-6.728a.3.3 0 0 0 .498 0 .4.4 0 0 0-.224-.224.25.25 0 0 0-.299 0v.25l.025-.025zm-5.882 5.233a.65.65 0 0 0 .723 0 .82.82 0 0 0-.374-.399c-.23-.126-.518-.062-.673.15 0 .2 0 .548.324.45v-.2zm12.112-10.565c-.15 0-.15.25 0 .35s.224.174.324.274a.7.7 0 0 1 .125.399s0 .174-.125.2h-.174a1.67 1.67 0 0 1-.748-.324c-.206-.2-.283-.48-.2-.748.06-.18.212-.313.4-.35a.6.6 0 0 1 .523.199h-.125zm-7.028 15.923c0 .274.424.274.698.174s.35 0 .4-.274-.125-.424-.324-.548l-.474-.374a.25.25 0 0 0-.224 0s-.125 0-.174.15a3.09 3.09 0 0 0-.349 1.121l.45-.25zm-8.723.05c.224 2.492 2.966 1.92 3.3 0s-3.464-2.118-3.3 0zm11.414-8.422c-.07.104-.186.167-.312.167s-.242-.063-.312-.167c.023-.14.074-.277.15-.4a.6.6 0 0 1 .349.299l.125.1zm-92.686-60.426l.2-.324c-.063-.072-.14-.13-.224-.174-.127.142-.127.356 0 .498h.025zm68.287 47.967a1.27 1.27 0 0 1 .997.723.2.2 0 0 1 0 .174l-.174.15c-.45.174-1.022.35-1.346 0-.134-.164-.176-.385-.1-.587s.23-.356.434-.4l.3.25-.1-.3z"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5833c",
    d: "M476.338 616.898l-14.256 2.018-11.1-.125-5.308 4.31-2.916 1.545-15.876 17.418-20.012 7.126-4.835 3.688 29.01-10.09 12.362-16.172 7.925-5.258 3.963 1.894 2.915-2.84 8.424-.448 11.788 2.84z"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.061,
    cy: 737.725,
    opacity: 0.36,
    rx: 54.106,
    ry: 5.382,
    className: "K"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M696.4 574.313c-4.012-.424-7.477 1.395-7.726 3.912l14.53 1.495c.25-2.517-2.79-5.01-6.804-5.407zm-16.773-1.72c-4.012-.424-7.477 1.395-7.726 3.912l14.53 1.495c.274-2.517-2.766-5.01-6.804-5.407z",
    className: "L"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M696.35 574.81c-4.012-.424-7.477.897-7.676 3.414l14.53 1.495c.25-2.517-2.84-4.485-6.854-4.91zm-16.773-1.72c-4.012-.424-7.477.897-7.676 3.414l14.53 1.495c.274-2.517-2.816-4.4-6.854-4.91z",
    className: "J"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M685.136 386.705c.766.817 1.784 1.352 2.89 1.52-.364.796-.632 1.632-.798 2.492a4.61 4.61 0 0 1-2.916-1.545 8.22 8.22 0 0 1 .822-2.467z",
    className: "B M"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 45.634,
    height: 29.789,
    x: 679.578,
    y: 368.833,
    transform: "rotate(7.595 702.395 383.727)",
    xlinkHref: "data:image/png;base64,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"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e85a6c",
    d: "M687.155 384.637c-.45 4.26 6.854 6.155 15.427 7.102s15.875-1.22 16.324-5.507-5.98-9.967-14.555-10.89-16.773 5.01-17.196 9.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb576c",
    d: "M689.82 384.836c-.374 3.513 5.857 4.66 12.9 5.457s13.134-.922 13.508-4.46-4.984-8.248-12.062-9.045-13.98 4.535-14.355 8.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6dfe2",
    d: "M714.096 387.876c.08.17.238.292.424.324.86.177 1.742-.176 2.243-.897.354-.364.656-.775.897-1.22a.77.77 0 0 0 0-.573c-.123-.145-.3-.22-.498-.2a3.84 3.84 0 0 0-2.891 1.993c-.145.153-.21.365-.174.573z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.06 386.506c.766.817 1.784 1.352 2.89 1.52-.358.798-.625 1.634-.798 2.492a4.61 4.61 0 0 1-2.916-1.545 9.07 9.07 0 0 1 .822-2.467z",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.887 385.185a.75.75 0 0 0 0-.997.6.6 0 0 0-.847 0 .75.75 0 0 0 0 .972c.206.275.597.33.872.125l-.025-.1zm2.417-3.464c-.25-.276-.25-.696 0-.972a.6.6 0 0 1 .872 0c.25.276.25.696 0 .972-.11.12-.262.187-.424.187s-.315-.068-.424-.187h-.025z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 713.287,
    cy: 386.442,
    r: 1,
    transform: "rotate(274.88 713.287 386.442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.496,
    cy: 388.363,
    r: 1,
    transform: "rotate(274.83 699.496 388.363)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 704.281,
    cy: 388.925,
    r: 1,
    transform: "rotate(274.83 704.281 388.925)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.208,
    cy: 381.609,
    r: 1,
    transform: "rotate(274.88 697.208 381.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.952,
    cy: 384.142,
    r: 1,
    transform: "rotate(274.88 696.952 384.142)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.9,
    cy: 383.795,
    r: 1,
    transform: "rotate(274.83 692.9 383.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.8 389.197c-.242.237-.63.237-.872 0-.25-.276-.25-.696 0-.972.242-.237.63-.237.872 0 .25.276.25.696 0 .972z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 711.087,
    cy: 385.125,
    r: 1,
    transform: "rotate(274.88 711.087 385.125)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 699.923,
    cy: 383.439,
    r: 1,
    transform: "rotate(274.83 699.923 383.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.91 380.625a.75.75 0 0 0 0-.997c-.242-.237-.63-.237-.872 0-.25.276-.25.696 0 .972a.6.6 0 0 0 .847 0l.025.025z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 694.544,
    cy: 386.532,
    r: 1,
    transform: "rotate(274.88 694.544 386.532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.88 378.83a.75.75 0 0 0 0-.997.6.6 0 0 0-.847 0 .75.75 0 0 0 0 .972c.242.237.63.237.872 0l-.025.025zm5.484 5.757l-2.368 2.043-.025.025h-.05l-8.797-.997-.424 3.738.274.025.35-3.314.025-.125.997.125 7.7.847 2.467-2.143zm3.39-3.065l1.67 2.268.025.024-.025.05-.25 2.492.25.025.3-2.64-1.77-2.392zm-12.237 7.002l4.636.523.025-.3-4.6-.523zm-2.69-4.484l.274.025.25-2.368-.25-.025zm-6.655-.4l2.592.274.025-.274-2.592-.3zm17.346 5.083l1.745-1.52.05-.025h.05l1.62.2.225-2.143-.25-.025-.2 1.72v.125h-.124l-1.396-.175-1.87 1.62zM700 383.3l-.025.3 5.084.548 4.486-3.887-.175-.224-4.36 3.787-.025.05-.05-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.357 378.233l-2.118 1.844-.05.025h-.05l-5-.573-.723 6.902.25.05.698-6.504.025-.125 1.446.15 3.44.4 2.243-1.944zm3.938.397l.05.025.972.1.025-.3-1.122-.125-2.617 2.318.15.224 2.517-2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.002 381.348a.6.6 0 0 1-.847 0 .75.75 0 0 1 0-.972c.242-.237.63-.237.872 0 .243.282.233.703-.025.972z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707.425,
    cy: 378.651,
    r: 1,
    transform: "rotate(274.83 707.425 378.65)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f6dfe2",
    d: "M688.675 382.444c.004.235.064.465.174.673.118.217.252.425.4.623a12.46 12.46 0 0 0 1.296 1.495c.202.193.52.193.723 0a.97.97 0 0 0 0-.872c-.084-.178-.253-.3-.45-.324a2.79 2.79 0 0 0-.299-.872 2.49 2.49 0 0 0-.324-.548 1.72 1.72 0 0 0-.249-.473.75.75 0 0 0-.897-.299c-.21.13-.35.35-.374.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0252a",
    d: "M705.797 370.707c-10.766-1.022-20.66 8.597-23.302 19.586 5.408 3.987 12.7 5.357 20.835 6.13s15.626.847 21.682-2.068c-.573-11.313-8.474-22.6-19.215-23.647zm-4.212 23.074c-11.813-1.37-16.773-5.208-17.246-6.53s2.492-11.014 11.788-14.677c6.206-2.492 23.103-2.492 24.922 14.353.424 4.11-7.477 8.248-19.39 6.877l-.075-.025z",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.6 384.81s5.408-13.007 19.49-11.71c0 0-12.7 2.218-16.798 13.73a3.94 3.94 0 0 1-2.692-2.018z",
    className: "B M"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0252a",
    d: "M703.454 395.9c8.1.772 15.502 1.346 21.558-1.545-.573-11.313-8.474-22.626-19.215-23.647s-20.66 8.597-23.302 19.586c5.408 3.887 12.86 4.834 20.96 5.607z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("g", {
    className: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.463 379.454c.523 4.984-5.433 9.793-13.333 10.914s-14.73-1.993-15.252-6.902 5.433-9.818 13.333-10.914 14.704 1.993 15.252 6.902z",
    className: "C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.108 376.49c.45 2.492-3.49 5.357-8.773 6.578s-9.97.2-10.393-2.218 3.464-5.382 8.773-6.578 9.92-.224 10.393 2.218z",
    className: "B"
  })), /*#__PURE__*/React.createElement("g", {
    className: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.31 512.64c-.773-1.77-2.044-2.965-3.065-3 .117-.136.262-.246.424-.324 1.072-.473 2.667.822 3.564 2.915s.748 4.186-.3 4.66h-.498c.653-1.356.607-2.945-.125-4.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.036 513.19c-.748-1.794-2.02-3-3.04-3.015.104-.133.242-.237.4-.3 1.072-.498 2.667.822 3.564 2.915s.773 4.16-.3 4.635a1.12 1.12 0 0 1-.498 0 4.71 4.71 0 0 0-.125-4.236zm3.59-3.738c-.773-1.794-2.044-3-3.065-3.015a1.37 1.37 0 0 1 .424-.324c1.047-.473 2.642.847 3.54 2.94s.773 4.16-.3 4.635c-.162.05-.336.05-.498 0a4.51 4.51 0 0 0-.1-4.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.35 509.974c-.773-1.77-2.044-3-3.065-3.015.12-.127.264-.23.424-.3 1.072-.473 2.667.822 3.564 2.915s.748 4.16-.3 4.635c-.173.036-.35.036-.523 0a4.56 4.56 0 0 0-.1-4.236zm-17.645 1.17c1.097-1.595 2.492-2.492 3.59-2.317-.1-.154-.208-.29-.35-.4-.947-.673-2.766.274-4.062 2.143s-1.57 3.912-.623 4.6c.142.094.304.154.474.174-.4-1.478-.035-3.058.972-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.856 511.72a4.46 4.46 0 0 1 3.589-2.317c-.09-.155-.207-.3-.35-.4-.947-.673-2.766.274-4.062 2.143s-1.57 3.937-.623 4.6c.143.097.304.165.474.2a4.71 4.71 0 0 1 .972-4.236zm-2.766-4.386c1.097-1.595 2.492-2.492 3.59-2.317-.074-.165-.195-.304-.35-.4-.947-.673-2.766.274-4.062 2.143s-1.57 3.912-.598 4.6c.14.098.303.158.474.174a4.56 4.56 0 0 1 .947-4.211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.24 507.906c1.097-1.595 2.492-2.492 3.59-2.317a1.07 1.07 0 0 0-.349-.399c-.947-.673-2.766.274-4.062 2.143s-1.545 3.937-.598 4.6c.14.098.303.158.474.174a4.56 4.56 0 0 1 .947-4.211z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M710.906 505.54c-7.932 2.104-13.488 9.238-13.583 17.443l-4.237 53.1 4.984.498 12.835-71.04z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.214 506.46l-12.46 69.945 2.492.25 12.685-71.116c-.933.22-1.843.528-2.717.922z",
    className: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.407 502.698c7.36 3.65 11.424 11.725 9.97 19.8l-6.405 53-4.984-.523 1.42-72.287z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.407 502.698l-1.52 72.262 1.97.2 1.52-71.34c-.625-.427-1.283-.802-1.97-1.12z",
    className: "l"
  }), /*#__PURE__*/React.createElement("g", {
    className: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M698.793 553.232a3.69 3.69 0 0 1-3.215-2.068c0 1.022 1.396 2.492 3.39 2.69s3.788-.947 3.863-1.944a3.74 3.74 0 0 1-4.037 1.321zm-17.72-1.82a3.74 3.74 0 0 1-3.364-2.193c0 1.022 1.396 2.492 3.414 2.69s3.763-.947 3.863-1.944c-.885 1.238-2.436 1.81-3.913 1.445zm12.7-54.197h.424a.45.45 0 0 1 .374.473l-.3 3.165a.45.45 0 0 1-.474.399h-.424c-.113-.012-.216-.07-.286-.16s-.102-.202-.088-.315l.3-3.165c.006-.117.06-.227.15-.302s.207-.11.323-.097z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.336 497.167h.424c.224.026.39.223.374.45l-.3 3.165a.45.45 0 0 1-.474.399h-.424c-.113-.012-.216-.07-.286-.16s-.102-.202-.088-.315l.3-3.165a.45.45 0 0 1 .474-.374z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d3cc47",
    d: "M684.937 500.207c-.272-.848.067-1.772.822-2.243a1.93 1.93 0 0 0-1.732 2.106 1.93 1.93 0 0 0 2.106 1.732c.262-.025.516-.1.748-.224-.9.058-1.7-.513-1.944-1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.385 500.256a1.97 1.97 0 0 1 .822-2.268c-1.046.13-1.797 1.07-1.695 2.118.038.508.28.98.668 1.307s.894.486 1.4.438c.262-.025.516-.1.748-.224a1.92 1.92 0 0 1-1.944-1.37z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3cc47",
    d: "M701.684 501.926c.504-.8.345-1.865-.374-2.492.505.154.925.506 1.165.976s.278 1.017.106 1.516c-.15.51-.5.935-.97 1.18s-1.02.286-1.523.116c-.245-.093-.473-.228-.673-.4a1.87 1.87 0 0 0 2.268-.897z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.236 501.876c.435-.78.28-1.758-.374-2.367.505.154.925.506 1.165.976s.278 1.017.106 1.516c-.15.51-.5.935-.97 1.18s-1.02.286-1.523.116c-.25-.083-.48-.22-.673-.4a1.87 1.87 0 0 0 2.268-1.022z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.987 394.654c-6.056 2.716-13.608 2.69-21.732 1.993s-15.402-1.993-20.885-5.656c-1.593 3.65-2.603 7.525-2.99 11.487-1.62 16.546 6.28 42.81 19.1 44.13s25.745-22.825 27.414-39.37c.414-4.215.1-8.47-.897-12.584z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d5e0e4",
    d: "M705.92 396.92c6.448.872 13.003.508 19.315-1.07 0-.4-.15-.797-.25-1.196-6.056 2.716-13.608 2.69-21.732 1.993h-.723l3.39.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.07 402.752c.328-3.58 1.168-7.097 2.492-10.44a25.62 25.62 0 0 1-2.268-1.321 37.37 37.37 0 0 0-2.966 11.487c-1.645 16.546 6.255 42.81 19.065 44.13a8.5 8.5 0 0 0 1.371 0c-11.988-2.9-19.3-27.883-17.695-43.856zm43.888-1.47c-7.776-1.047-29.234-13.53-26.118 45.4 2.377-.372 4.665-1.174 6.754-2.367 9.695-6.354 17.92-24.046 19.215-37.053a39.86 39.86 0 0 0 .15-5.98z",
    className: "l"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 712.351,
    cy: 411.797,
    fill: "#d0262b",
    rx: 9.047,
    ry: 9.22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efd136",
    d: "M711.653 418.7a6.93 6.93 0 0 1-6.081-7.475c.4-3.734 3.732-6.445 7.467-6.06s6.45 3.725 6.068 7.46-3.72 6.453-7.454 6.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b12925",
    d: "M711.903 416.407c-1.88-.152-3.478-1.426-4.046-3.224s.01-3.76 1.46-4.962 3.485-1.41 5.147-.52 2.62 2.696 2.424 4.57a4.56 4.56 0 0 1-4.984 4.136z"
  }))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 49.783,
    height: 35.822,
    x: 2.374,
    y: 3.132,
    opacity: 0.33,
    transform: "rotate(7.595 -2888.41 5289.001)",
    xlinkHref: "data:image/png;base64,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"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.64 477.108c1.42 5.945.796 12.194-1.77 17.742l-.847 1.87c-.306.682-.02 1.484.648 1.82a1.37 1.37 0 0 0 .773.125 45.74 45.74 0 0 1 21.583 2.168c.34.118.714.095 1.037-.064s.57-.44.683-.783c.1-.274.1-.573 0-.847v-.2c-2.135-7-1.38-14.564 2.093-21.006l9.42-17.767c.128-.272.172-.576.125-.872-.212-1.654-.212-3.33 0-4.984 0-.822.224-1.645.4-2.492.08-.354.016-.726-.18-1.03s-.51-.517-.865-.59l-34.89-3.588a1.37 1.37 0 0 0-1.47 1.221v2.666c-.167 1.792-.578 3.552-1.22 5.233a1.32 1.32 0 0 0 0 .822l4.486 20.557z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.217 498.238c-3.313-.365-6.656-.365-9.97 0 .286.3.693.43 1.097.374 3.3-.475 6.645-.575 9.97-.3l-1.097-.075zm25.97-38.075c.127-.28.17-.592.125-.897-.214-1.654-.214-3.33 0-4.984 0-.822.224-1.645.4-2.492.08-.354.016-.726-.18-1.03s-.51-.517-.865-.59l-2.243-.25c.743.115 1.26.8 1.17 1.545-.174.822-.3 1.654-.374 2.492a20.83 20.83 0 0 0 0 4.984c.087.284.087.588 0 .872l-9.67 17.89c-3.475 6.442-4.23 14.005-2.093 21.006v.2c.184.585-.052 1.22-.573 1.545l1.072.374c.34.118.714.095 1.037-.064s.57-.44.683-.783c.088-.276.088-.572 0-.847v-.2c-2.135-7-1.38-14.564 2.093-21.006l9.42-17.767z",
    className: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.242 496.942l.872-1.894a27.18 27.18 0 0 0 1.769-17.742l-4.984-20.632a1.52 1.52 0 0 1 0-.822 20.98 20.98 0 0 0 1.196-5.233v-2.492c-.007-.357.13-.702.376-.96s.587-.405.944-.412h.15l-2.218-.224a1.37 1.37 0 0 0-1.495 1.221v2.64a20.98 20.98 0 0 1-1.196 5.233 1.17 1.17 0 0 0 0 .822l4.835 20.632c1.412 5.943.798 12.187-1.745 17.742l-.847 1.87c-.306.682-.02 1.484.648 1.82a1.37 1.37 0 0 0 .773.125l1.097-.15c-.366-.432-.435-1.042-.174-1.545zm12.46 1.744h-1.122c3.21.4 6.37 1.142 9.42 2.218.368.186.803.186 1.17 0-3.07-1.074-6.244-1.817-9.47-2.218z",
    className: "l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.332 499.932c-3.932-.704-7.964.52-10.84 3.29 2.88 2.506 4.787 5.947 5.383 9.718a17.67 17.67 0 0 0 4.212.847c1.168.125 2.346.125 3.514 0 1.378-3.775 4.103-6.908 7.65-8.796-2.365-3.107-6.015-4.97-9.92-5.058z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bb2a26",
    d: "M695.33 513.936a17.45 17.45 0 0 1-4.062-.324c-.65-4.16-2.544-8.025-5.433-11.09a8.5 8.5 0 0 1 3.489-2.492 9.97 9.97 0 0 0-5.807 3.115c2.875 2.507 4.772 5.95 5.358 9.718a17.67 17.67 0 0 0 4.212.922c1.17.112 2.345.112 3.514 0a8.85 8.85 0 0 1-1.271.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.35 469.607c-6.555-.673-11.963-1.97-13.26-3.04h-.35c0 .897 5.882 2.965 13.483 3.763s13.932 0 14.03-.947c-1.47.748-7.377.897-13.907.224z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.476 469.16c-6.555-.673-12.262-1.72-13.533-2.766l-.174.15c0 .922 6.006 2.492 13.608 3.264s13.98.498 14.08-.424v-.125c-1.87.723-7.402.573-13.98-.1z",
    className: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.326 449.748c-3.014 2.843-3.767 7.344-1.844 11.014l11.54 23.398 2.492-1.17-12.187-33.24z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.457 460.76a9.67 9.67 0 0 1 1.869-11.014 8.57 8.57 0 0 0-2.492 10.715l11.64 23.423.324-.174-11.34-22.95z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.015 479.55s-3.59 3.713-2.492 6.778l4.062 10.99 1.57-1.22-3.14-16.546z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.597 486.377c-.972-2.492 1.645-5.88 2.492-6.753 0 0-3.863 3.638-2.717 6.703l4.037 10.964.224-.15-4.037-10.765z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.283 495.995c2.492-1.42 4.984-1.246 5.857.324h-1.047c-.922-1.595-2.492-.872-4.436.25s-3.34 2.268-2.492 3.862l-.673.922c-.897-1.47.4-3.937 2.79-5.357z",
    className: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.382 496.344c2.492-1.42 4.8-1.694 5.732 0l-.922.548c-.922-1.57-2.492-.872-4.436.274s-3.265 2.218-2.492 3.812l-.872.523c-.798-1.62.623-3.638 2.99-5.158zm-55.9-50.883c2.4 3.38 2.256 7.94-.35 11.163l-15.9 20.557-2.118-1.62 18.368-30.1z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.133 456.625c2.464-3.276 2.594-7.75.324-11.163a8.57 8.57 0 0 1 .274 10.964l-15.9 20.582-.274-.224 15.576-20.16z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.21 472.273s2.766 4.386 1.022 7.127l-6.106 9.967-1.32-1.495 6.405-15.6z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.233 479.4c1.47-2.317-.45-6.08-1.047-7.127 0 0 3.065 4.386 1.346 7.127l-6.106 9.967-.174-.2 5.98-9.768z",
    className: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.703 487.922c-2.044-1.87-4.586-2.218-5.782-.872l.997.324c1.196-1.37 2.667-.324 4.287 1.146s2.84 2.915 1.62 4.286l.498 1.047c1.246-1.37.474-4.037-1.62-5.93z",
    className: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.553 488.346c-2.07-1.894-4.386-2.64-5.583-1.296l.773.723c1.22-1.346 2.692-.324 4.287 1.17s2.79 2.866 1.595 4.21l.748.698c1.196-1.37.224-3.638-1.82-5.507z",
    className: "J"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.952 401.058l-5.632-.598-8.723-4.436-7.227 6.03 5.98 33.84 5.084 5.208 2.617-1.944 3.938.3z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dabb72",
    d: "M703.18 400.958l5.632.598 9.396-2.59 5.906 7.375-12.51 31.945-6.006 4.062-2.168-2.442-3.913-.498z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cdebf2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.096 411.25l.797 2.64 6.505 2.592 3-1.395-.324-2.816zm-8.823-.923l-1.296 2.442L689.1 414l-2.667-1.993.872-2.7zm5.21 57.337l-4.336-13.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.75 460.363l1.395-5.93 4.337 13.232zm2.417 3.364l-7.95 2.8 6.63-12.932-2.616 9.867z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M697.074 525.15l4.586-2.12-4.138 25.64-2.193-.224zm-8.824-.922l-4.037-3-.997 25.965 2.193.224zm19.44-46.248l-5.757.697-5.184 11.04.847 3.962 4.262-7.924 2.84.3zm-24.398-2.492l5.508 1.844 2.94 11.886-1.644 3.688-2.617-8.622-2.84-.3zm-7.776-25.192l-1.495 7.176-8.175 12.36-2.666.873zm46.206 3.464l.05 7.35 5.582 13.755 2.443 1.395z",
    className: "L"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccac6c",
    d: "M685.385 406.54l33.97 3.488-2.617 2.293-28.162-2.89-2.492-.25z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#95d1b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.6 504.94l-1.745 17.742 24.025-7.775-13.93-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M701.16 586.124l4.212 39.944-28.985-15.674 14.83-27.46z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M674.818 584.006l-18.268 37.178 32.623-2.368-3.962-33.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.23 496.892l-1.77 17.742-22.03-12.51 15.95-8.596z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.251,
    cy: 726.338,
    opacity: 0.36,
    rx: 29.433,
    ry: 2.915,
    className: "K"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f0eceb"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 541.166,
    cy: 606.35,
    rx: 1,
    ry: 4.161,
    transform: "rotate(345 541.166 606.35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.035,
    cy: 598.078,
    rx: 1,
    ry: 4.179,
    transform: "rotate(344.995 578.035 598.078)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M562.743 586.473l-13.956-15.35",
    className: "M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.743 657.913l-20.162-.997-10.418 8.173-7.277 16.32 7.277-9.867 3.066-7.027 2.866-3 3.962-2.84 1.745 2.068 2.517-2.64 15.65 4.386zM255.527 691.9l36.312-3.264 7.85 7.998-5.433-9.095-6.928-1.57-9.72 2.243-19.04 1.47zm875.543-127.13l-2.492 37.053-1.62 3.364-7.078 14.702-4.685 4.485-12.6-4.485-12.062-4.585-22.08 35.658 24.473-31.57 3.3 1.67 10.9 2.567.523 5.257 7.876-2.043 8.423-5.208 5.757-16.645 6.306-5.98-4.4-18.166 4.187-7.55zm-50.942 2.566l7.402 14.9 17.396 8.646 2.168-13.58 14.405-10.84-17.296 9.32v7.85l-1.022 2.392-6.978-2.392-1.196-2.8-4.66 1.42-4.386-4.635.274-1.72-1.62-.698z",
    fill: "#f5833c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.565 615.004l-13.483 3.912-9.645.748 13.782-.474 10.543-1.12zM406.88 649.2l-9.446 7.152 5.2-5.93zm56.922 11.563l1.495 3.315 1.022-5.956zm10.79-.323h7.726l-.35 2.068zm-30.355 24.444l-.822 1.77h1.47zm-.822-61.672l1.894.922.623-2.517zM271.727 687.6l2.342 1.794 2.044-1.794zm-17.67 5.372l3.788.598 9.196-2.7h-3.938l-6.753.424zm875.616-87.985l-3.015 14.8v3.588l-2.02 4.3-4.187-4.8zM1092 618.218l1.72.698-3.813 11.138-10.592 5.233zm40.5-50.858l5.807 10.6-6.73 10.7-.997-9.12 2.74-5.383zm-26.552 17.07l1.046 12.184-7.75-8.546 4.96 1.77zm-19.988-6.803l2.193 8 .823-3.987z",
    fill: "#fbed24"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501 565)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 121)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Fa",
    className: "M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I",
    className: "Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Fa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.508 37.886l-5.95-1.193C-6.853 35.8-9.23 39.8-9.23 39.8s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M3.448 38.196l-5.93-1.207c-4.098-.805-6.286 2.908-6.286 2.908s.665 4.29 4.763 5.086l5.93 1.188 1.523-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    fill: "url(#J)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05 29.883L-.9 28.7c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30.192l-5.912-1.188c-4.117-.8-6.323 2.9-6.323 2.9s.665 4.286 4.763 5.086l5.93 1.193 1.542-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M-2.962 28.953c.67-.104 1.353-.087 2.017.05L5 30.192l-1.542 8.004-5.93-1.207a5.58 5.58 0 0 1-1.892-.731l1.412-7.305z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.587 21.88L.642 20.686c-4.417-.883-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.507l5.95 1.207 1.657-8.637z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M6.527 22.193l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.305 4.782 5.105l5.935 1.188 1.514-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M-1.425 20.95c.67-.104 1.356-.087 2.022.05l5.93 1.193-1.537 8-5.912-1.188c-.668-.13-1.307-.38-1.888-.735l1.385-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.128 13.87l-5.95-1.193c-4.412-.878-6.794 3.126-6.794 3.126s.715 4.624 5.132 5.502L6.462 22.5l1.666-8.628z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M8.068 14.185l-5.93-1.188c-4.098-.818-6.29 2.894-6.29 2.894s.66 4.286 4.758 5.11l5.922 1.193 1.542-8.008z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M.116 12.946a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8.008-5.93-1.188c-.668-.13-1.307-.38-1.888-.735l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.693 5.872l-5.95-1.188C-.673 3.796-3.045 7.8-3.045 7.8s.715 4.624 5.132 5.502l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 6.182L3.693 4.993c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188L9.6 6.182z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M1.658 4.943a5.75 5.75 0 0 1 2.017.051L9.6 6.182l-1.542 8.004-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.207-2.132L5.262-3.32C.845-4.208-1.532-.204-1.532-.204S-.816 4.42 3.6 5.303l5.95 1.17 1.657-8.605z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.152-1.817L5.216-3.005c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.277 4.777 5.11l5.93 1.188 1.528-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M3.195-3.06c.672-.103 1.356-.084 2.022.055l5.935 1.188-1.542 8-5.917-1.188c-.67-.13-1.31-.377-1.892-.73L3.195-3.06z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.748-10.13L6.8-11.323C2.387-12.207.001-8.207.001-8.207S.716-3.583 5.133-2.7l5.945 1.188 1.67-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.688-9.82l-5.93-1.188C2.66-11.832.462-8.12.462-8.12S1.122-3.828 5.22-3l5.935 1.188 1.532-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M4.736-11.06c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8L5.216-3a5.79 5.79 0 0 1-1.888-.731l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.308-18.134L8.34-19.327c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193 1.68-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M14.23-17.824l-5.922-1.188c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.532-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    fill: "url(#Q)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15.772-25.828l-5.935-1.188c-4.098-.818-6.3 2.894-6.3 2.894S4.2-19.836 8.3-19.036l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M7.815-27.067c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.542 8-5.922-1.188a5.58 5.58 0 0 1-1.892-.731l1.398-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.232 34.872L3.287 33.68c-4.417-.883-6.794 3.12-6.794 3.12s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M9.148 35.18l-5.917-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.188 1.523-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M1.196 33.942c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.935-1.188c-.668-.13-1.307-.38-1.888-.735l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 26.868L4.8 25.68c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.502l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 27.178L4.76 26c-4.098-.818-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M2.738 25.94a5.78 5.78 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.917-1.188a5.75 5.75 0 0 1-1.888-.731l1.394-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.292 18.864l-5.95-1.188c-4.417-.888-6.803 3.13-6.803 3.13s.715 4.624 5.128 5.507l5.95 1.174 1.675-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.232 19.18L6.296 17.99c-4.094-.823-6.295 2.9-6.295 2.9s.665 4.29 4.763 5.086l5.93 1.188 1.537-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M4.28 17.935a5.65 5.65 0 0 1 2.017.055l5.935 1.188-1.542 8L4.76 26c-.67-.13-1.31-.377-1.892-.73l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.847 10.866L7.902 9.673C3.485 8.8 1.108 12.79 1.108 12.79s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M13.768 11.175L7.847 9.987c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.086l5.935 1.188 1.528-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    fill: "url(#V)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.37 2.862L9.42 1.67c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 3.172L9.38 1.983c-4.098-.823-6.3 2.9-6.3 2.9s.66 4.29 4.758 5.086l5.93 1.188L15.3 3.172z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M7.358 1.933a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8-5.922-1.188a5.75 5.75 0 0 1-1.897-.735l1.408-7.315z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.912-5.142l-5.95-1.193c-4.417-.883-6.808 3.098-6.808 3.098s.734 4.624 5.15 5.548l5.926 1.17 1.68-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16.852-4.832l-5.935-1.18c-4.094-.828-6.3 2.885-6.3 2.885S5.28 1.16 9.38 1.96l5.93 1.193 1.542-7.985z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M8.9-6.07c.67-.104 1.353-.087 2.017.05l5.935 1.188L15.3 3.172 9.38 1.98c-.67-.127-1.31-.374-1.892-.73L8.9-6.07z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.462-13.145l-5.958-1.188C8.087-15.217 5.7-11.217 5.7-11.217s.715 4.624 5.132 5.507l5.95 1.193 1.67-8.628z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M18.388-12.835l-5.926-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.532-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M10.436-14.074c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.93-1.18a5.68 5.68 0 0 1-1.892-.735l1.408-7.328z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20-21.15l-5.95-1.193c-4.412-.883-6.79 3.12-6.79 3.12s.715 4.624 5.132 5.502l5.95 1.193L20-21.15z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19.93-20.84L14-22.027c-4.098-.818-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086l5.935 1.188 1.537-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M12-22.078c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.954-1.188c-.668-.13-1.307-.38-1.888-.735L12-22.078z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M13.312 40.17l-5.926-1.188c-4.098-.818-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.537-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M5.36 38.93a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.93-1.188c-.67-.134-1.31-.387-1.888-.75L5.36 38.93z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14.853 32.167l-5.935-1.188c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.542-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M6.896 30.928a5.78 5.78 0 0 1 2.022.051l5.935 1.188-1.542 8.004-5.926-1.188c-.67-.13-1.31-.377-1.892-.73l1.403-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 23.853l-5.945-1.198c-4.417-.878-6.812 3.126-6.812 3.126s.715 4.624 5.132 5.502l5.95 1.193 1.675-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 24.168l-5.93-1.188c-4.098-.823-6.305 2.913-6.305 2.913s.665 4.286 4.758 5.11l5.935 1.188 1.542-8.022z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M8.438 22.924c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.85l-5.95-1.188c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.188L18 15.85z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M17.932 16.183L12 14.976c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M9.98 14.92c.672-.1 1.356-.082 2.022.055l5.93 1.207-1.542 8-5.93-1.188a5.75 5.75 0 0 1-1.888-.731L9.98 14.92z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.533 7.86l-5.95-1.202c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.188 1.662-8.61z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.473 8.16l-5.935-1.188c-4.094-.823-6.3 2.9-6.3 2.9s.665 4.29 4.763 5.11l5.93 1.21 1.542-8.022z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M11.54 6.935c.67-.104 1.353-.087 2.017.05l5.935 1.188-1.56 8.008L12 14.97a5.82 5.82 0 0 1-1.892-.731l1.43-7.305z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.07-.153l-5.945-1.193C10.708-2.23 8.332 1.77 8.332 1.77s.715 4.624 5.132 5.507l5.95 1.193L21.07-.153z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21 .157L15.08-1.03C10.98-1.85 8.77 1.85 8.77 1.85s.665 4.29 4.758 5.11l5.935 1.188 1.546-8z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M13.058-1.082c.67-.104 1.356-.087 2.022.05L21 .157l-1.537 8-5.935-1.188a5.59 5.59 0 0 1-1.888-.731l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.616-8.156L16.662-9.35c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.662-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M22.552-7.86l-5.935-1.174c-4.098-.818-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086L21.005.14l1.546-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14.6-9.086c.67-.104 1.356-.087 2.022.05l5.93 1.174L21 .143 15.08-1.05a5.59 5.59 0 0 1-1.888-.731L14.6-9.086z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M24.093-15.85l-5.935-1.188c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.174 1.542-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M16.155-17.108c.67-.104 1.353-.087 2.017.05l5.935 1.188-1.555 8.008-5.935-1.174c-.67-.13-1.3-.38-1.892-.735l1.43-7.338z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7-24.163l-5.945-1.193c-4.417-.883-6.79 3.12-6.79 3.12s.715 4.624 5.128 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M25.635-23.854L19.7-25.042c-4.098-.818-6.314 2.894-6.314 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.555-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M17.678-25.093a5.78 5.78 0 0 1 2.022.051l5.935 1.188-1.542 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.072 36.846l-5.95-1.188c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M11.078 35.92c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8-5.954-1.188a5.79 5.79 0 0 1-1.888-.731l1.426-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.613 28.847l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.174 1.662-8.605z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.553 29.157l-5.93-1.188c-4.098-.823-6.314 2.9-6.314 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.55-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dz",
    x: 6.322,
    y: 46.981,
    fill: "url(#k)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    x: 6.323,
    y: 46.981,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22.095 21.153l-5.94-1.188c-4.098-.823-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.546-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EG",
    fill: "url(#l)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EH",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.632 13.15L17.7 11.96c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.754 5.11l5.935 1.188 1.542-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M15.693 11.9c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.954-1.188c-.668-.13-1.307-.38-1.888-.735l1.426-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.233 4.836l-5.95-1.193c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.173 5.146l-5.93-1.188c-4.098-.818-6.318 2.894-6.318 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.555-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    fill: "url(#n)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.77-3.167L20.82-4.36c-4.417-.883-6.79 3.12-6.79 3.12s.715 4.624 5.128 5.502l5.95 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26.715-2.857L20.77-4.046c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.55-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M18.762-4.097a5.75 5.75 0 0 1 2.017.051l5.935 1.188-1.542 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.412-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.312-11.17l-5.945-1.188c-4.417-.888-6.794 3.112-6.794 3.112s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28.252-10.856l-5.93-1.193c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.188 1.537-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M20.308-12.1a5.78 5.78 0 0 1 2.022.051l5.93 1.193-1.537 8-5.954-1.188a5.79 5.79 0 0 1-1.888-.731l1.426-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.853-19.174l-5.95-1.17c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.642z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M29.793-18.86l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.66 4.29 4.758 5.11l5.93 1.188 1.542-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M21.84-20.104c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.542 8-5.93-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M15.232 40.905c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.542 8-5.95-1.188a5.82 5.82 0 0 1-1.892-.731l1.43-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.776 33.836l-5.95-1.193c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.188 1.662-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M24.716 34.146l-5.935-1.188c-4.098-.823-6.318 2.9-6.318 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.56-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M16.76 32.906c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.542 8-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.308 25.832l-5.945-1.193c-4.412-.883-6.79 3.102-6.79 3.102s.734 4.624 5.132 5.52l5.95 1.188 1.652-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26.253 26.142l-5.945-1.174c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.086l5.935 1.188 1.55-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M18.3 24.903c.668-.098 1.348-.076 2.008.065l5.93 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.422-7.333z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.855 17.83l-5.95-1.184c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.632z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M19.847 16.9a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8-5.95-1.17c-.67-.125-1.31-.373-1.888-.73l1.426-7.338z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    x: 13.564,
    y: 35.963,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M29.336 10.135L23.4 8.947c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.542-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M21.38 8.896c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.542 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.924 1.822L24.98.63c-4.417-.883-6.794 3.12-6.794 3.12s.738 4.62 5.142 5.498l5.95 1.193 1.648-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M30.873 2.13L24.924.925c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.188 1.555-7.985z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M22.92.892c.664-.108 1.343-.097 2.003.032l5.93 1.188-1.537 8.004-5.917-1.17c-.668-.13-1.307-.38-1.888-.735L22.92.892z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M32.415-5.872l-5.93-1.188c-4.098-.8-6.305 2.9-6.305 2.9S20.844.12 24.924.925l5.93 1.188 1.56-7.985z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M24.462-7.11a5.78 5.78 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.95-1.207a5.75 5.75 0 0 1-1.846-.712l1.385-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.016-14.185l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.502l5.95 1.207 1.662-8.637z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M33.956-13.87L28.02-15.06c-4.094-.823-6.3 2.9-6.3 2.9s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M26.004-15.115a5.65 5.65 0 0 1 2.017.055l5.935 1.188-1.542 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M35.493-21.875l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.763 5.086l5.93 1.216 1.537-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M27.54-23.118c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.008-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.408-7.328z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.935 38.84l-5.95-1.207c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.61z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 39.135l-5.93-1.188c-4.098-.823-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086l5.935 1.188 1.537-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AA)",
    d: "M20.922 37.914c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8-5.935-1.188a5.59 5.59 0 0 1-1.888-.731l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 6.309,
    y: 46.98,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M30.416 31.13l-5.93-1.188c-4.098-.814-6.305 2.885-6.305 2.885s.665 4.286 4.763 5.11l5.93 1.188 1.542-7.994z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EO",
    fill: "url(#AB)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ED",
    x: 17.105,
    y: -9.039,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M31.958 23.118l-5.935-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.542-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AC)",
    d: "M24 21.888c.67-.104 1.356-.087 2.022.05l5.935 1.18-1.542 8.013-5.93-1.188a5.68 5.68 0 0 1-1.892-.735L24 21.888z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.555 14.796L27.6 13.607c-4.417-.888-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M33.495 15.124l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.18 1.537-7.994z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AD)",
    d: "M25.542 13.87a5.78 5.78 0 0 1 2.022.051l5.93 1.188-1.537 8.008-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.328z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EP",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EK",
    x: 11.861,
    y: -35.025,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AE)",
    d: "M27.084 5.88c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.542 8-5.93-1.188a5.75 5.75 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.638-1.188l-5.95-1.193C26.272-3.27 23.9.735 23.9.735s.715 4.624 5.128 5.507l5.95 1.188 1.662-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EQ",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AF)",
    d: "M28.616-2.118c.67-.104 1.356-.087 2.022.05L36.573-.88l-1.542 8-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.175-9.192l-5.945-1.193c-4.417-.883-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.507l5.95 1.188 1.657-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M38.115-8.882l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.086l5.935 1.188 1.537-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    x: 24.346,
    y: -20.056,
    fill: "url(#AG)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.716-17.195l-5.95-1.193c-4.412-.883-6.79 3.13-6.79 3.13s.715 4.624 5.132 5.493l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: 11.861,
    y: -35.026,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ER",
    fill: "url(#AH)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 8.945,
    y: 59.974,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EQ",
    x: -3.54,
    y: 45.003,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AI)",
    d: "M25.085 42.884c.67-.104 1.353-.087 2.017.05l5.935 1.188-1.542 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.616 35.8l-5.945-1.193c-4.417-.883-6.794 3.116-6.794 3.116s.72 4.624 5.132 5.507l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M34.58 36.12l-5.935-1.188c-4.098-.823-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EG",
    x: 12.484,
    y: 14.966,
    fill: "url(#AJ)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ES",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ET",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AK)",
    d: "M28.155 26.877c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.935-1.188c-.66-.127-1.3-.37-1.865-.717l1.385-7.338z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    x: 24.333,
    y: -20.057,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EU",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EO",
    x: 7.241,
    y: -11.018,
    fill: "url(#AL)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.26 11.8l-5.95-1.165c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.502l5.95 1.193L39.26 11.8z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 12.11l-5.935-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188L39.2 12.11z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AM)",
    d: "M31.242 10.87a5.78 5.78 0 0 1 2.022.051L39.2 12.11l-1.542 8.004-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 5.256,
    y: 25.99,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M40.736 4.1l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.286 4.758 5.11L39.2 12.11l1.537-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AN)",
    d: "M32.77 2.867c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.865-.749l1.385-7.305z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.338-4.203l-5.95-1.193C31.976-6.28 29.6-2.28 29.6-2.28s.715 4.624 5.132 5.507l5.945 1.188 1.662-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M42.278-3.893l-5.93-1.193c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.542-7.994z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Dy",
    x: 38.829,
    y: -42.089,
    fill: "url(#AO)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.88-12.207l-5.95-1.202c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.193 1.662-8.614z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M43.82-11.897l-5.935-1.188c-4.094-.823-6.3 2.913-6.3 2.913s.665 4.29 4.763 5.11l5.93 1.188 1.542-8.022z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EV",
    fill: "url(#AP)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.416-20.2l-5.945-1.193c-4.394-.883-6.794 3.116-6.794 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M45.356-19.882l-5.93-1.188c-4.098-.823-6.3 2.894-6.3 2.894S33.8-13.9 37.884-13.1L43.82-11.9l1.537-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AQ)",
    d: "M37.385-21.14c.67-.104 1.356-.087 2.022.05l5.95 1.207-1.537 8-5.935-1.188c-.668-.133-1.306-.387-1.883-.75l1.385-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.798 40.8l-5.95-1.193c-4.412-.883-6.79 3.12-6.79 3.12s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M38.738 41.11l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AR)",
    d: "M30.785 39.87a5.67 5.67 0 0 1 2.022.051l5.93 1.188-1.542 8.004-5.93-1.188c-.668-.13-1.307-.38-1.888-.735l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EP",
    x: 5.262,
    y: 25.986,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M40.28 33.105l-5.935-1.202c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.967z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AS)",
    d: "M32.308 31.866a5.75 5.75 0 0 1 2.017.051l5.935 1.188-1.542 8.004-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 6.336,
    y: 46.986,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M41.816 25.106l-5.93-1.188c-4.098-.8-6.3 2.9-6.3 2.9s.665 4.286 4.763 5.086l5.93 1.188 1.537-7.985z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AT)",
    d: "M33.864 23.863c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.537 8-5.93-1.202c-.67-.13-1.31-.377-1.892-.73l1.408-7.3z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.418 16.793l-5.95-1.193c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.207 1.657-8.637z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    x: 24.346,
    y: -20.053,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AU)",
    d: "M35.405 15.864c.67-.104 1.356-.087 2.022.05l5.93 1.193-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.96 8.785L39 7.592c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9 9.1l-5.93-1.188c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.93 1.198L44.9 9.1z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AV)",
    d: "M36.947 7.86a5.67 5.67 0 0 1 2.022.051L44.9 9.1l-1.542 8.008-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.328z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5.786l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.193L46.5.786z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M46.44 1.096L40.505-.093c-4.098-.823-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.98z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EG",
    x: 24.346,
    y: -20.057,
    fill: "url(#AW)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.038-7.218L42.093-8.4C37.676-9.294 35.3-5.294 35.3-5.294S36.015-.67 40.432.213l5.95 1.174 1.657-8.605z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M48-6.908l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.188L48-6.908z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AX)",
    d: "M40.025-8.147c.67-.104 1.356-.087 2.022.05L48-6.908l-1.537 8.004-5.935-1.188c-.668-.13-1.307-.38-1.888-.735l1.385-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    x: 36.195,
    y: -55.08,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M49.52-14.91l-5.93-1.188c-4.098-.818-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.11L48-6.908l1.518-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AY)",
    d: "M41.567-16.15a5.67 5.67 0 0 1 2.022.051l5.93 1.188L48-6.908l-5.93-1.188a5.65 5.65 0 0 1-1.915-.735l1.412-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    x: 27.128,
    y: 71.912,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M42.924 46.098L36.988 44.9c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.908 1.184 1.565-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#AZ)",
    d: "M34.948 44.85c.67-.104 1.353-.087 2.017.05l5.958 1.198-1.565 8-5.93-1.188c-.67-.13-1.3-.38-1.892-.735l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.498 37.784l-5.945-1.193c-4.417-.883-6.794 3.12-6.794 3.12s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M44.438 38.094l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.954 1.188 1.514-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Aa)",
    d: "M36.485 36.855c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.514 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.385-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EM",
    x: 13.565,
    y: 35.962,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ET",
    x: 9.864,
    y: 1.974,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ab)",
    d: "M38.027 28.852a5.78 5.78 0 0 1 2.022.051l5.93 1.188-1.537 8.004-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.58 21.777l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507L45.92 30.4l1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M47.54 22.092l-5.93-1.188c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.93 1.188 1.542-8z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ac)",
    d: "M39.568 20.848c.672-.103 1.356-.084 2.022.055l5.95 1.188-1.542 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.394-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.118 13.778l-5.945-1.193c-4.403-.883-6.79 3.135-6.79 3.135s.715 4.624 5.128 5.507l5.95 1.188 1.657-8.637z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M49.062 14.088L43.127 12.9c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.763 5.11l5.95 1.188 1.523-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ad)",
    d: "M41.105 12.85c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.523 8-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.39-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66 5.775L44.7 4.582c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EF",
    x: 31.588,
    y: -31.075,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    x: 36.831,
    y: -5.09,
    fill: "url(#Ae)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2-2.23l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.193L52.2-2.23z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.155-1.92l-5.93-1.188C42.125-3.93 39.92-.213 39.92-.213s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.98z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Af)",
    d: "M44.188-3.158a5.67 5.67 0 0 1 2.022.051l5.945 1.188-1.542 8-5.93-1.188c-.67-.125-1.31-.373-1.888-.73l1.394-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.742-10.232l-5.95-1.193c-4.408-.883-6.79 3.102-6.79 3.102s.715 4.624 5.128 5.507l5.95 1.193 1.662-8.61z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M53.682-9.922l-5.935-1.174c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.945 1.198 1.528-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ag)",
    d: "M45.725-11.162c.67-.104 1.356-.087 2.022.05l5.935 1.188-1.528 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.394-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.28-18.236l-5.945-1.184c-4.417-.883-6.794 3.12-6.794 3.12s.715 4.624 5.132 5.502l5.95 1.193 1.657-8.632z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M55.22-17.926l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11l5.935 1.188 1.537-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ah)",
    d: "M47.267-19.165c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.935-1.174c-.668-.13-1.307-.38-1.888-.735l1.408-7.333z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.66 42.773l-5.95-1.188c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507L47 51.396l1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 43.088L42.67 41.9c-4.098-.823-6.305 2.9-6.305 2.9s.665 4.29 4.763 5.11l5.95 1.188 1.523-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ai)",
    d: "M40.648 41.844c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.523 8-5.93-1.188a5.75 5.75 0 0 1-1.888-.731l1.39-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.202 34.774l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.507l5.95 1.188 1.662-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EQ",
    x: 13.564,
    y: 35.964,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EV",
    x: 6.333,
    y: 46.981,
    fill: "url(#Aj)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.74 26.77l-5.945-1.193C41.378 24.695 39 28.694 39 28.694s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M51.693 27.08l-5.945-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.11l5.935 1.188 1.55-8z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ak)",
    d: "M43.727 25.842c.67-.104 1.356-.087 2.022.05l5.945 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.394-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28 18.767l-5.95-1.198c-4.412-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.95 1.193 1.657-8.618z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M53.22 19.077L47.3 17.89c-4.098-.823-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086l5.945 1.207 1.528-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Al)",
    d: "M45.268 17.838c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.528 8-5.945-1.184a5.59 5.59 0 0 1-1.888-.731l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 30.669,
    y: 26.924,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EU",
    x: 17.104,
    y: -9.016,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Am)",
    d: "M46.8 9.834a5.67 5.67 0 0 1 2.022.051l5.93 1.21L53.22 19.1l-5.93-1.188c-.67-.13-1.3-.38-1.892-.735L46.8 9.834z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36 2.774L50.415 1.58c-4.417-.883-6.79 3.12-6.79 3.12s.71 4.624 5.128 5.502l5.95 1.193 1.657-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M56.308 3.07l-5.935-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.926 1.21 1.546-8.027z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#An)",
    d: "M48.347 1.85c.67-.104 1.356-.087 2.022.05l5.94 1.17-1.546 8.027-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9-5.243l-5.95-1.188c-4.412-.888-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.502l5.95 1.193L57.9-5.243z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M57.84-4.934L51.9-6.122c-4.098-.814-6.3 2.885-6.3 2.885s.66 4.286 4.758 5.11l5.94 1.198 1.532-8.004z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ao)",
    d: "M49.888-6.173a5.78 5.78 0 0 1 2.022.051l5.93 1.188-1.532 8.004-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.403-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EJ",
    x: 36.207,
    y: -55.082,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M59.382-12.946l-5.93-1.188c-4.098-.823-6.305 2.9-6.305 2.9S47.812-6.96 51.9-6.16l5.93 1.188 1.542-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ap)",
    d: "M51.43-14.176c.672-.103 1.356-.084 2.022.055l5.93 1.174-1.542 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.412-7.3z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.824 47.762l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.502l5.95 1.216 1.662-8.646z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M52.764 48.086l-5.935-1.193c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.94 1.202 1.532-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Aq)",
    d: "M44.812 46.833a5.75 5.75 0 0 1 2.017.051l5.935 1.202-1.532 8-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.403-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 18.82,
    y: 61.957,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3 40.073l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.086l5.935 1.225 1.537-8.013z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ar)",
    d: "M46.348 38.84c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.537 8.004-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.408-7.328z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EW",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M55.847 32.07l-5.93-1.188c-4.103-.828-6.305 2.87-6.305 2.87s.66 4.29 4.758 5.086l5.93 1.188 1.546-7.957z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#As)",
    d: "M47.9 30.83a5.67 5.67 0 0 1 2.022.051l5.935 1.188-1.542 8-5.93-1.188a5.75 5.75 0 0 1-1.888-.731l1.403-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.444 23.756l-5.95-1.193c-4.417-.883-6.79 3.116-6.79 3.116s.715 4.624 5.132 5.507l5.945 1.18 1.662-8.61z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M57.384 24.066l-5.935-1.188c-4.094-.823-6.3 2.9-6.3 2.9s.665 4.29 4.763 5.086l5.935 1.21 1.537-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#At)",
    d: "M49.432 22.827c.67-.104 1.353-.087 2.017.05l5.935 1.188-1.537 8-5.93-1.188a5.82 5.82 0 0 1-1.892-.731l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EH",
    x: 35.288,
    y: 2.913,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M58.92 16.063L53 14.874c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.193 1.537-7.985z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Au)",
    d: "M50.968 14.823c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004-5.93-1.193a5.58 5.58 0 0 1-1.892-.731l1.408-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ES",
    x: 24.346,
    y: -20.057,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ET",
    x: 24.346,
    y: -20.056,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Av)",
    d: "M52.5 6.82c.67-.104 1.356-.087 2.022.05l5.93 1.188-1.537 8.004L53 14.874c-.668-.13-1.307-.38-1.888-.735L52.5 6.82z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EC",
    x: 48.679,
    y: -40.114,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M62.004.055l-5.93-1.188c-4.098-.818-6.305 2.894-6.305 2.894s.665 4.286 4.763 5.11l5.93 1.188L62.004.055z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EO",
    x: 31.588,
    y: -31.076,
    fill: "url(#Aw)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.605-8.258l-5.95-1.188c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.502l5.95 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M63.545-7.948L57.6-9.136c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188 1.542-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ax)",
    d: "M55.588-9.187a5.78 5.78 0 0 1 2.022.051l5.935 1.188L62.004.055l-5.93-1.188c-.67-.13-1.31-.377-1.892-.73l1.408-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 29.602,
    y: 5.934,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M65.078-15.947l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.11l5.935 1.188 1.537-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ay)",
    d: "M57.13-17.19c.672-.103 1.356-.084 2.022.055l5.926 1.188-1.537 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731l1.412-7.324z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.524 44.752l-5.95-1.193c-4.417-.883-6.79 3.14-6.79 3.14s.715 4.624 5.132 5.507l5.945 1.193 1.662-8.646z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EL",
    x: 30.669,
    y: 26.922,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ER",
    x: 18.808,
    y: 61.948,
    fill: "url(#Az)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EA",
    x: 44.233,
    y: 62.888,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37.06l-5.935-1.188c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.11l5.93 1.188L60 37.06z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BA)",
    d: "M52.048 35.82c.67-.104 1.356-.087 2.022.05L60 37.06l-1.542 8.004-5.93-1.188a5.68 5.68 0 0 1-1.892-.735l1.412-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EH",
    x: 37.91,
    y: 15.905,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M61.542 29.055l-5.93-1.188c-4.098-.818-6.3 2.894-6.3 2.894s.665 4.286 4.758 5.11L60 37.06l1.542-8.004z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BB)",
    d: "M53.6 27.816c.67-.104 1.356-.087 2.022.05l5.93 1.188L60 37.06l-5.935-1.188c-.668-.13-1.307-.38-1.888-.735l1.412-7.32z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.144 20.742l-5.95-1.193c-4.412-.883-6.79 3.12-6.79 3.12s.715 4.624 5.132 5.502l5.945 1.193 1.662-8.623z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M63.084 21.05l-5.93-1.17c-4.098-.818-6.3 2.894-6.3 2.894s.66 4.286 4.758 5.086l5.93 1.188 1.542-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EI",
    x: 37.912,
    y: 15.905,
    fill: "url(#BC)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.685 12.738l-5.95-1.18c-4.417-.888-6.79 3.116-6.79 3.116s.715 4.624 5.128 5.502l5.95 1.193 1.662-8.632z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64.616 13.053L58.68 11.86c-4.094-.818-6.3 2.894-6.3 2.894s.665 4.286 4.763 5.086l5.93 1.188 1.542-7.976z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BD)",
    d: "M56.673 11.81a5.75 5.75 0 0 1 2.017.051l5.926 1.193-1.542 8-5.922-1.17a5.82 5.82 0 0 1-1.892-.731l1.412-7.342z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EN",
    x: 30.682,
    y: 26.929,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M66.162 5.05l-5.93-1.188c-4.098-.823-6.3 2.9-6.3 2.9s.665 4.29 4.758 5.086l5.926 1.21 1.546-8z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BE)",
    d: "M58.2 3.805c.672-.103 1.356-.084 2.022.055l5.93 1.188-1.546 8-5.935-1.188a5.79 5.79 0 0 1-1.888-.731L58.2 3.805z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EW",
    x: 11.862,
    y: -35.024,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M67.704-2.955l-5.93-1.207c-4.098-.823-6.3 2.9-6.3 2.9s.66 4.29 4.758 5.086l5.935 1.188 1.537-7.957z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EB",
    x: 53.936,
    y: -14.13,
    fill: "url(#BF)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EE",
    x: 45.152,
    y: 4.892,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M69.232-10.958l-5.93-1.188c-4.085-.8-6.29 2.9-6.29 2.9s.683 4.282 4.763 5.086l5.93 1.188 1.528-7.985z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BG)",
    d: "M61.293-12.197a5.67 5.67 0 0 1 2.022.051l5.917 1.188-1.542 8-5.917-1.202a5.82 5.82 0 0 1-1.892-.731l1.412-7.305z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BH)",
    d: "M65 142.01l5.027 15.55-2.507 2.888L70.036 170h3.706l-1.316-12.665L77 142z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BI)",
    d: "M54 142l-5.006 15.553 2.5 2.888-2.506 9.554-3.71.005 1.302-12.666-4.59-15.33z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 79.556L24.695 74l35.16.463h33.77l12.208 5.398L109 97.593l-18.3 15.8-2.95-4.106 6.308-15.36h4.22l-4.63-3.028-1.688-4.972-2.1 9.52-9.244 25.093-.84 5.625v6.282s-4.326 10.398-9.914 10.093L59.768 143h-10.68c-5.588-.14-10.157-10.532-10.157-10.532v-5.583l-.867-5.75L28.58 95.48l-2.156-9.722-1.716 5.093-4.735 3.097h4.303l6.464 15.7-3 4.208L9 97.708l3.22-18.153z",
    className: "Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#b62127",
    d: "M70 173.3l9.946 1.7s3.6-.43 1.27-3.857L74.23 169h-3.595L70 173.3zm-21 .99L39.056 176s-3.6-.428-1.274-3.856l6.98-2.144h3.6l.64 4.28z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BJ)",
    d: "M72.123 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -3.223,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -6.445,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B m"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -9.667,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -16.11,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B n"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -18.873,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -18.873,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 104.615c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -22.096,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.123 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B o"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: -0.457,
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: -0.457,
    y: -25.318,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BQ)",
    d: "M72.123 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -1.38,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -1.38,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -4.603,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -4.603,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -7.826,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -7.826,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B m"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -11.048,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -11.048,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 112.44c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -14.27,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -14.27,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 109.218c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B n"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -17.492,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -17.492,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -20.715,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -20.715,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 1.83,
    y: -23.937,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 1.83,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.954 99.55c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B o"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BJ)",
    d: "M75.784 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -3.223,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -6.445,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B m"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -9.667,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -16.11,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B n"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -18.873,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -18.873,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 104.615c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -22.096,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.784 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B o"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 3.661,
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 3.661,
    y: -25.318,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BQ)",
    d: "M75.784 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -1.38,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -1.38,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -4.603,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -4.603,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -7.826,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -7.826,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B f"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -11.048,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -11.048,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 112.44c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -14.27,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -14.27,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 109.218c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B g"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -17.492,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -17.492,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -20.715,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -20.715,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 5.491,
    y: -23.937,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 5.491,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.615 99.55c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BX)",
    d: "M79.903 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -3.223,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -6.445,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B f"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -9.667,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -16.11,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B g"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -18.873,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -18.873,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 104.615c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -22.096,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.903 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 7.779,
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 7.779,
    y: -25.318,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BY)",
    d: "M79.903 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -1.38,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -1.38,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -4.603,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -4.603,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -7.826,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -7.826,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B f"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -11.048,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -11.048,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 112.44c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -14.27,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -14.27,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 109.218c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B g"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -17.492,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -17.492,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -20.715,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -20.715,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 9.61,
    y: -23.937,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 9.61,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.734 99.55c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BX)",
    d: "M83.564 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -3.223,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B R"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -6.445,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B f"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -9.667,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B S"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -16.11,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B g"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -19.334,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -19.334,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 104.154c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B T"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -22.096,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.564 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B h"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 11.44,
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 11.44,
    y: -25.318,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BY)",
    d: "M83.564 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -1.38,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -1.38,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -4.603,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -4.603,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -7.826,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -7.826,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B i"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -11.048,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -11.048,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 112.44c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -14.27,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -14.27,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 109.218c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B j"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -17.492,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -17.492,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -20.715,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -20.715,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 13.271,
    y: -23.937,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 13.271,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.852 99.55c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B k"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bf)",
    d: "M87.683 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -3.223,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -6.445,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B i"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -9.667,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -16.11,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B j"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -19.334,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -19.334,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 104.154c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -22.096,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.683 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B k"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EZ",
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 15.559,
    y: -25.318,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bg)",
    d: "M87.683 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -1.38,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -1.38,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -4.603,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -4.603,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -7.826,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -7.826,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 115.662c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B i"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -11.048,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -11.048,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 112.44c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -14.27,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -14.27,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 109.218c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B j"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -17.492,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -17.492,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -20.715,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -20.715,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 17.39,
    y: -23.937,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 17.39,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.513 99.55c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B k"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bf)",
    d: "M91.344 123.488c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -3.223,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 120.266c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B U"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -6.445,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -6.445,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 117.043c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B i"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -9.667,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -9.667,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 113.82c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -12.89,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 110.6c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B V"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -16.11,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -16.11,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 107.377c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B j"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -19.334,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -19.334,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 104.154c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -22.096,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -22.096,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.344 101.393c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B k"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EX",
    x: 19.22,
    y: -25.318,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 19.22,
    y: -25.318,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bg)",
    d: "M91.344 98.17c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -1.38,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bh)",
    d: "M93.632 122.107c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -3.223,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -4.603,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bh)",
    d: "M93.632 118.885c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -6.446,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -7.826,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eb",
    fill: "url(#Bi)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -9.668,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -11.048,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eb",
    y: -3.222,
    fill: "url(#Bj)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -12.89,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -14.27,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eb",
    y: -6.444,
    fill: "url(#Bk)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -16.112,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -17.492,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bl)",
    d: "M93.632 105.996c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -19.335,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -20.715,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bl)",
    d: "M93.632 102.773c.255-.094.525-.14.796-.138h2.407v3.222h-2.412c-.27.001-.54-.044-.796-.133l.005-2.95z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ea",
    y: -22.557,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EY",
    x: 21.508,
    y: -23.937,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eb",
    y: -16.112,
    fill: "url(#Bm)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 1)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "Fb",
    className: "M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bn"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bn",
    className: "Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Fb)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ec",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ed",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bo)",
    d: "M78.552 90.12a6.14 6.14 0 0 1-.859-1.884l-1.598-5.99 7.748-2.17 1.598 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.067 84.496l1.607 5.99c1.148 4.473 5.74 4.865 5.74 4.865s3.757-2.723 2.563-7.177l-1.603-5.99-8.308 2.313z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bp)",
    d: "M70.823 92.28a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.748-2.16 1.598 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eh",
    fill: "url(#Bq)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ei",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Br)",
    d: "M55.31 96.607c-.394-.573-.685-1.2-.86-1.884l-1.603-5.99 7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ek",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bs)",
    d: "M47.557 98.767c-.392-.572-.68-1.208-.854-1.88L45.1 90.9l7.748-2.16 1.603 5.99a6.08 6.08 0 0 1 .197 2.064l-7.09 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Em",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eo",
    fill: "url(#Bt)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ec",
    x: -46.492,
    y: 12.973,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eq",
    fill: "url(#Bu)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -46.491,
    y: 12.972,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bv)",
    d: "M24.314 105.254c-.39-.573-.68-1.21-.86-1.88l-1.598-5.99 7.748-2.16 1.598 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -46.491,
    y: 12.973,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Es",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eh",
    x: -46.491,
    y: 12.972,
    fill: "url(#Bw)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 49.036,
    y: -19.026,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: 2.544,
    y: -6.058,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bx)",
    d: "M73.35 86.223c-.392-.573-.682-1.208-.86-1.88l-1.598-5.99 7.74-2.16 1.598 5.99a6.08 6.08 0 0 1 .197 2.064l-7.077 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: 2.543,
    y: -6.057,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Es",
    x: 49.034,
    y: -19.01,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#By)",
    d: "M65.6 88.37c-.393-.574-.683-1.21-.86-1.884l-1.598-5.99 7.743-2.165 1.603 5.99c.183.672.25 1.37.197 2.064L65.6 88.37z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Et",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eu",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Bz)",
    d: "M57.853 90.55c-.393-.573-.684-1.21-.86-1.884l-1.598-5.99 7.743-2.138 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.953z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.346 84.93l1.603 5.99c1.208 4.47 5.8 4.86 5.8 4.86s3.757-2.723 2.567-7.177l-1.603-5.99-8.368 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: 2.54,
    y: -6.06,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CA)",
    d: "M50.1 92.7c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.08 6.08 0 0 1 .197 2.064L50.1 92.7z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Em",
    x: 2.539,
    y: -6.057,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 2.544,
    y: -6.076,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eo",
    x: 2.54,
    y: -6.058,
    fill: "url(#CB)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ev",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    x: 2.546,
    y: -6.058,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CC)",
    d: "M34.606 97.035a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.748-2.174 1.598 5.99c.188.672.255 1.373.197 2.068l-7.086 2z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 2.544,
    y: -6.068,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 91.328L26 97.316c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.53 2.38-6.66l-1.598-5.99-7.748 2.16z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ew",
    fill: "url(#CD)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -43.947,
    y: 6.916,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -51.695,
    y: 9.08,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CE)",
    d: "M19.1 101.356a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.748-2.165L26 97.312c.183.672.25 1.37.197 2.064l-7.086 1.98z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.12 72.385l1.603 5.99c1.194 4.455 5.782 4.846 5.782 4.846s3.76-2.723 2.567-7.177l-1.603-5.99-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: 28.328,
    y: -18.603,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CF)",
    d: "M75.875 80.165a5.96 5.96 0 0 1-.859-1.88l-1.603-5.99 7.748-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ex",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: 12.836,
    y: -14.278,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CG)",
    d: "M68.14 82.33a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.09 1.98z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ey",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ez",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CH)",
    d: "M60.393 84.49a6 6 0 0 1-.854-1.88l-1.603-5.99 7.748-2.16 1.598 5.99c.187.672.255 1.372.202 2.068l-7.09 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9 78.87l1.603 5.99c1.19 4.455 5.782 4.846 5.782 4.846s3.757-2.723 2.567-7.177l-1.607-5.99-8.345 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 12.836,
    y: -14.281,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CI)",
    d: "M52.645 86.652c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ec",
    x: -33.654,
    y: -1.305,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ed",
    x: -33.655,
    y: -1.302,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FA",
    fill: "url(#CJ)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FB",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M34.693 83.11l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.53 2.38-6.666l-1.603-5.99-7.743 2.165z",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FC",
    fill: "url(#CK)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.642 85.357l1.607 5.99c1.19 4.455 5.782 4.846 5.782 4.846s3.757-2.723 2.563-7.177l-1.603-5.99-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    x: -33.655,
    y: -1.308,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FD",
    fill: "url(#CL)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.894 87.518l1.603 5.99c1.185 4.47 5.777 4.865 5.777 4.865s3.76-2.723 2.567-7.182L27.24 85.2l-8.345 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: -33.655,
    y: -1.29,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FE",
    fill: "url(#CM)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.147 89.678l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.177l-1.603-5.99-8.35 2.326z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FF",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CN)",
    d: "M13.902 97.464a6 6 0 0 1-.854-1.88l-1.603-5.99 7.748-2.147 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.09 1.958z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ex",
    x: 2.545,
    y: -6.063,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: 15.38,
    y: -20.336,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CO)",
    d: "M70.7 76.273c-.394-.573-.685-1.2-.86-1.884l-1.603-5.99 7.748-2.142 1.603 5.99c.183.672.25 1.37.197 2.064L70.7 76.273z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ey",
    x: 2.544,
    y: -6.058,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M60.48 70.565l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99-7.748 2.165z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FG",
    fill: "url(#CP)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.453 72.813l1.603 5.99c1.153 4.47 5.745 4.865 5.745 4.865s3.757-2.727 2.567-7.182l-1.607-5.99-8.308 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 15.381,
    y: -20.357,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CQ)",
    d: "M55.208 80.594c-.4-.576-.696-1.22-.873-1.898l-1.603-5.99 7.748-2.16 1.598 5.99c.186.67.255 1.37.202 2.064l-7.073 1.995z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ec",
    x: -31.11,
    y: -7.361,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M44.985 74.89l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.538 2.38-6.684l-1.598-5.99-7.748 2.184z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FA",
    x: 2.544,
    y: -6.07,
    fill: "url(#CR)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FB",
    x: 2.534,
    y: -6.058,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FH",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FI",
    fill: "url(#CS)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -31.111,
    y: -7.36,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    x: -31.1,
    y: -7.366,
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FD",
    x: 2.545,
    y: -6.058,
    fill: "url(#CT)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.44 81.46l1.62 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.76-2.723 2.567-7.182l-1.603-5.99-8.368 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: -31.111,
    y: -7.363,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CU)",
    d: "M24.2 89.245c-.394-.573-.685-1.2-.86-1.884l-1.603-5.99 7.752-2.156 1.603 5.99c.183.672.25 1.37.197 2.064l-7.09 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ek",
    x: -31.11,
    y: -7.362,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M14 83.538l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99L14 83.538z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CV)",
    d: "M16.447 91.406a6 6 0 0 1-.854-1.88L14 83.538l7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.09 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ev",
    x: 38.624,
    y: -26.82,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FJ",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CW)",
    d: "M73.23 70.215a6 6 0 0 1-.854-1.884l-1.603-5.99 7.748-2.16 1.598 5.99c.188.672.255 1.373.197 2.068l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 41.168,
    y: -32.868,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -5.332,
    y: -19.906,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ew",
    x: 38.624,
    y: -26.821,
    fill: "url(#CX)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -5.323,
    y: -19.905,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Es",
    x: 41.167,
    y: -32.878,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CY)",
    d: "M57.734 74.55c-.393-.574-.683-1.21-.86-1.884l-1.598-5.99 7.74-2.17 1.603 5.99c.183.672.25 1.37.197 2.064l-7.082 2z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FK",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eu",
    x: -7.866,
    y: -13.847,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#CZ)",
    d: "M49.986 76.7c-.393-.573-.684-1.21-.86-1.884l-1.598-5.99 7.743-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068L49.986 76.7z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FL",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: -5.327,
    y: -19.907,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ca)",
    d: "M42.24 78.862a5.86 5.86 0 0 1-.859-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.73 73.24l1.603 5.99c1.208 4.47 5.8 4.865 5.8 4.865s3.757-2.727 2.567-7.182l-1.603-5.99-8.368 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.03 73.168l1.594 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.66l-1.603-5.99-7.74 2.16z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cb)",
    d: "M34.486 81.022c-.394-.567-.686-1.198-.863-1.866l-1.603-5.99 7.748-2.165 1.603 5.99c.183.672.25 1.37.197 2.064l-7.082 1.967z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ev",
    x: -7.872,
    y: -13.848,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24.282 75.32l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.506 2.374-6.652l-1.598-5.99-7.743 2.15z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cc)",
    d: "M26.734 83.187a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.752-2.147 1.594 5.99c.187.672.255 1.372.202 2.068l-7.09 1.962z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: -5.324,
    y: -19.905,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -51.814,
    y: -6.933,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ew",
    x: -7.868,
    y: -13.848,
    fill: "url(#Cd)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FM",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -59.562,
    y: -4.768,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FN",
    fill: "url(#Ce)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.266 58.537l1.607 5.99c1.194 4.47 5.787 4.86 5.787 4.86s3.757-2.723 2.567-7.177l-1.607-5.99-8.354 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -2.778,
    y: -25.963,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ew",
    x: 41.168,
    y: -32.878,
    fill: "url(#Cf)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -2.793,
    y: -25.963,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ed",
    x: -18.275,
    y: -21.638,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cg)",
    d: "M60.26 68.483a6.14 6.14 0 0 1-.859-1.884l-1.598-5.99 7.748-2.165 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FK",
    x: 2.544,
    y: -6.058,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M50.074 62.775l1.598 5.99c1.107 4.146 5.37 4.505 5.37 4.505s3.486-2.53 2.38-6.666l-1.603-5.99-7.743 2.16z",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FO",
    fill: "url(#Ch)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FL",
    x: 2.545,
    y: -6.053,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: -2.784,
    y: -25.964,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ci)",
    d: "M44.783 72.804a5.96 5.96 0 0 1-.859-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.08 6.08 0 0 1 .197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FP",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: -10.53,
    y: -23.8,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cj)",
    d: "M37.03 74.97a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.748-2.165 1.603 5.99c.183.672.25 1.37.197 2.064l-7.09 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FQ",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    x: -2.778,
    y: -25.965,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FR",
    fill: "url(#Ck)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FS",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: -18.274,
    y: -21.642,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cl)",
    d: "M21.535 79.3c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.598 5.99a5.97 5.97 0 0 1 .197 2.064L21.535 79.3z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.027 73.67l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.598-6.003-8.36 2.345z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -57.018,
    y: -10.826,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FN",
    x: 2.545,
    y: -6.05,
    fill: "url(#Cm)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: 7.503,
    y: -34.18,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    x: 7.513,
    y: -34.188,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cn)",
    d: "M70.57 60.27a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.76-2.17 1.603 5.99c.183.672.25 1.37.197 2.064L70.57 60.27z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ei",
    x: 7.512,
    y: -34.19,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: 7.512,
    y: -34.183,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FE",
    x: 41.168,
    y: -32.878,
    fill: "url(#Co)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ek",
    x: 7.515,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FF",
    x: 41.168,
    y: -32.878,
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FG",
    x: -7.867,
    y: -13.848,
    fill: "url(#Cp)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Em",
    x: 7.513,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M44.866 58.887l1.617 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.38-6.66l-1.598-5.99-7.76 2.16z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cq)",
    d: "M47.323 66.746c-.386-.57-.67-1.203-.84-1.87l-1.603-5.99 7.748-2.16 1.598 5.99c.186.67.255 1.37.202 2.064l-7.105 1.967z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.838 61.126l1.607 5.99c1.148 4.47 5.74 4.865 5.74 4.865s3.757-2.723 2.567-7.182l-1.607-5.99-8.308 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M37.118 61.043l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.51 2.397-6.657l-1.598-5.99-7.766 2.156z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cr)",
    d: "M39.593 68.91a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.73-2.15 1.617 5.99c.183.672.25 1.37.197 2.064l-7.086 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 7.513,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FH",
    x: -7.867,
    y: -13.847,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FI",
    x: -7.867,
    y: -13.848,
    fill: "url(#Cs)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: -38.977,
    y: -21.21,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Es",
    x: 7.512,
    y: -34.186,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FD",
    x: -5.322,
    y: -19.906,
    fill: "url(#Ct)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Et",
    x: -41.521,
    y: -15.152,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eu",
    x: -41.521,
    y: -15.15,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FT",
    fill: "url(#Cu)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ek",
    x: -38.976,
    y: -21.209,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6.122 69.7l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99L6.122 69.7z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cv)",
    d: "M8.584 77.558c-.394-.57-.685-1.207-.86-1.88L6.122 69.7l7.752-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.09 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Et",
    x: 7.514,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9 48.5l1.598 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.5-2.524 2.384-6.66l-1.603-5.99L62.9 48.5z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FT",
    x: 49.035,
    y: -19.03,
    fill: "url(#Cw)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.86 50.742l1.603 5.99c1.194 4.46 5.782 4.85 5.782 4.85S66 58.86 64.81 54.405l-1.603-5.99-8.35 2.326z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FF",
    x: 43.713,
    y: -38.935,
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FG",
    x: -5.322,
    y: -19.905,
    fill: "url(#Cx)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Em",
    x: 10.056,
    y: -40.249,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 10.048,
    y: -40.24,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cy)",
    d: "M49.867 60.688c-.392-.572-.68-1.208-.854-1.88L47.4 52.82l7.748-2.165 1.598 5.99c.186.67.255 1.37.202 2.064l-7.09 1.98z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ev",
    x: 7.514,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    x: 10.058,
    y: -40.24,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Cz)",
    d: "M42.12 62.853a6.03 6.03 0 0 1-.854-1.884l-1.603-5.99 7.74-2.156L49 58.813c.186.67.255 1.37.202 2.064l-7.082 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 10.056,
    y: -40.24,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FH",
    x: -5.323,
    y: -19.904,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FI",
    x: -5.322,
    y: -19.906,
    fill: "url(#DA)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.864 59.394l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85S35 67.506 33.816 63.05l-1.603-5.99-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -44.181,
    y: -25.107,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DB)",
    d: "M26.624 67.18a5.96 5.96 0 0 1-.859-1.88l-1.598-5.99 7.748-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.116 61.554l1.607 5.99c1.203 4.47 5.796 4.865 5.796 4.865s3.757-2.723 2.563-7.182l-1.603-5.99-8.363 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eu",
    x: -38.976,
    y: -21.21,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DC)",
    d: "M18.876 69.34c-.396-.573-.69-1.2-.868-1.884l-1.598-5.99 7.743-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.077 1.98z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FL",
    x: -31.114,
    y: -7.361,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FF",
    x: -2.778,
    y: -25.963,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DD)",
    d: "M11.12 71.5c-.394-.57-.685-1.207-.86-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068L11.12 71.5z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FQ",
    x: 38.623,
    y: -26.82,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FJ",
    x: -5.322,
    y: -19.907,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FR",
    x: 38.624,
    y: -26.82,
    fill: "url(#DE)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FS",
    x: 38.623,
    y: -26.82,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 20.35,
    y: -48.458,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DF)",
    d: "M60.16 52.47c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.598 5.99a6.08 6.08 0 0 1 .197 2.064L60.16 52.47z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.65 46.85l1.607 5.99c1.194 4.47 5.787 4.865 5.787 4.865s3.757-2.727 2.567-7.182l-1.607-5.99-8.354 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -18.394,
    y: -37.646,
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DG)",
    d: "M52.41 54.635a6.14 6.14 0 0 1-.859-1.884l-1.598-5.99 7.748-2.156 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9 49L43.497 55c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.563-7.182l-1.603-5.99L41.9 49z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FU",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FO",
    x: -7.885,
    y: -13.848,
    fill: "url(#DH)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.156 51.175l1.603 5.99c1.194 4.46 5.787 4.85 5.787 4.85s3.757-2.723 2.563-7.177l-1.603-5.99-8.35 2.326z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    x: -26.14,
    y: -35.49,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FV",
    fill: "url(#DI)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FW",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: -18.398,
    y: -37.647,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DJ)",
    d: "M29.168 61.12c-.394-.573-.685-1.2-.86-1.884l-1.603-5.99 7.748-2.165 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.66 55.496l1.603 5.99c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.723 2.567-7.182L27 53.165l-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18.96 55.413l1.603 5.99c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.524 2.384-6.66l-1.603-5.99-7.748 2.16z",
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FX",
    fill: "url(#DK)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FS",
    x: -7.867,
    y: -13.85,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: -26.142,
    y: -35.49,
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FY",
    fill: "url(#DL)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FM",
    x: -5.323,
    y: -19.92,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -64.885,
    y: -24.673,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FN",
    x: -5.323,
    y: -19.907,
    fill: "url(#DM)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.948 38.617l1.603 5.99c1.19 4.46 5.782 4.85 5.782 4.85s3.757-2.7 2.572-7.154l-1.607-5.99-8.35 2.303z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: 22.908,
    y: -54.521,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FY",
    x: 49.035,
    y: -19.03,
    fill: "url(#DN)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FM",
    x: 43.712,
    y: -38.936,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ed",
    x: -23.597,
    y: -41.542,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DO)",
    d: "M54.956 48.577a6.14 6.14 0 0 1-.859-1.884l-1.598-5.99 7.76-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.1 1.98z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.448 42.952l1.607 5.99c1.19 4.455 5.782 4.85 5.782 4.85S55.594 51.07 54.4 46.6l-1.603-5.99-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M44.75 42.87l1.598 5.99c1.107 4.146 5.37 4.505 5.37 4.505s3.486-2.53 2.38-6.666l-1.598-5.99-7.748 2.16z",
    className: "G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DP)",
    d: "M47.208 50.738c-.393-.573-.684-1.21-.86-1.884l-1.598-5.99 7.748-2.16 1.598 5.99a6.11 6.11 0 0 1 .193 2.059l-7.082 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FB",
    x: 2.3,
    y: -38.075,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eg",
    x: -23.597,
    y: -41.548,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FV",
    x: 2.544,
    y: -6.058,
    fill: "url(#DQ)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FW",
    x: 2.544,
    y: -6.082,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ej",
    x: -23.598,
    y: -41.545,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DR)",
    d: "M31.712 55.063c-.394-.573-.685-1.2-.86-1.884L29.25 47.2l7.748-2.165 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.986z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ex",
    x: -44.162,
    y: -25.112,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M21.503 49.356l1.603 5.99c1.107 4.146 5.364 4.505 5.364 4.505s3.486-2.53 2.384-6.666l-1.603-5.99-7.748 2.16z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FX",
    x: 2.562,
    y: -6.058,
    fill: "url(#DS)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ey",
    x: -44.181,
    y: -25.102,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#En",
    x: -23.597,
    y: -41.548,
    className: "G"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FY",
    x: 2.544,
    y: -6.058,
    fill: "url(#DT)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71 53.764l1.603 5.99c1.19 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.607-5.99-8.345 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M6.008 53.68L7.6 59.67c1.102 4.146 5.364 4.5 5.364 4.5s3.486-2.524 2.38-6.66l-1.598-5.99-7.748 2.16z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eq",
    x: -23.595,
    y: -41.562,
    fill: "url(#DU)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ef",
    x: 2.19,
    y: -54.087,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8 32.486l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.515 2.38-6.66l-1.603-5.99-7.743 2.16z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DV)",
    d: "M65.248 40.354a5.96 5.96 0 0 1-.854-1.88l-1.598-5.99 7.74-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FK",
    x: 7.524,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Eu",
    x: -0.353,
    y: -48.03,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DW)",
    d: "M57.504 42.52c-.393-.574-.683-1.21-.86-1.884l-1.598-5.99 7.74-2.156 1.603 5.99c.183.672.25 1.37.197 2.064l-7.082 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FL",
    x: 7.514,
    y: -34.182,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3 36.81l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99L47.3 36.81z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DX)",
    d: "M49.752 44.68c-.394-.57-.685-1.207-.86-1.88L47.3 36.81l7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FP",
    x: 4.969,
    y: -28.102,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M39.543 38.972l1.603 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.66L47.3 36.81l-7.748 2.16z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DY)",
    d: "M42 46.84c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.603 5.99c.183.672.25 1.37.197 2.064L42 46.84z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ev",
    x: -0.353,
    y: -48.03,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    x: 2.182,
    y: -54.088,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FZ",
    fill: "url(#DZ)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Er",
    x: 2.19,
    y: -54.088,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FH",
    x: -13.19,
    y: -33.752,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Da)",
    d: "M26.504 51.166c-.39-.573-.68-1.21-.86-1.88l-1.598-5.99 7.74-2.16 1.598 5.99a6.11 6.11 0 0 1 .197 2.068l-7.077 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FM",
    x: 7.514,
    y: -34.201,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ee",
    x: -52.048,
    y: -38.955,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Db)",
    d: "M18.757 53.327c-.392-.573-.682-1.208-.86-1.88l-1.598-5.99 7.748-2.16 1.598 5.99c.183.672.25 1.37.197 2.064l-7.086 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FK",
    x: -38.976,
    y: -21.21,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FU",
    x: -33.654,
    y: -1.304,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FT",
    x: -5.322,
    y: -19.905,
    fill: "url(#Dc)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 49.867l1.603 5.99c1.208 4.473 5.8 4.874 5.8 4.874s3.757-2.723 2.563-7.177l-1.603-5.99L.5 49.867z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M.804 49.784l1.598 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.486-2.53 2.384-6.666l-1.603-5.99-7.743 2.165z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dd)",
    d: "M3.26 57.652c-.396-.57-.7-1.207-.868-1.88l-1.598-5.99 7.743-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068L3.26 57.652z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.284 28.676l1.607 5.99c1.19 4.47 5.782 4.874 5.782 4.874s3.757-2.723 2.563-7.182l-1.603-5.99-8.35 2.308z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FU",
    x: 15.381,
    y: -20.334,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#De)",
    d: "M60.044 36.46c-.393-.574-.683-1.21-.86-1.884l-1.598-5.99 7.725-2.156 1.603 5.99c.194.665.273 1.358.234 2.05l-7.105 2z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FL",
    x: 10.058,
    y: -40.24,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FF",
    x: 38.39,
    y: -58.842,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Df)",
    d: "M52.296 38.617c-.393-.572-.683-1.208-.86-1.88l-1.603-5.99 7.748-2.16 1.603 5.99a6.11 6.11 0 0 1 .197 2.068l-7.086 1.972z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.79 33.002L43.39 39c1.194 4.455 5.782 4.85 5.782 4.85s3.757-2.727 2.567-7.182l-1.603-5.99-8.35 2.33z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#El",
    x: -3.017,
    y: -57.986,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dg)",
    d: "M44.544 40.782c-.392-.572-.68-1.208-.854-1.88l-1.603-5.99 7.748-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.09 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.04 35.162l1.603 5.99c1.194 4.47 5.787 4.865 5.787 4.865s3.757-2.723 2.567-7.182l-1.607-5.99-8.35 2.317z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ep",
    x: 4.736,
    y: -60.145,
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FZ",
    x: 2.544,
    y: -6.057,
    fill: "url(#Dh)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FS",
    x: 7.495,
    y: -34.187,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Ez",
    x: -31.344,
    y: -39.388,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Di)",
    d: "M29.03 45.108a6 6 0 0 1-.836-1.884l-1.603-5.99 7.748-2.16 1.598 5.99a6.11 6.11 0 0 1 .197 2.068l-7.105 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FM",
    x: 10.057,
    y: -40.24,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18.844 39.4l1.598 5.99c1.107 4.146 5.37 4.5 5.37 4.5s3.486-2.52 2.38-6.666l-1.598-5.99-7.748 2.165z",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj)",
    d: "M21.3 47.27c-.392-.573-.682-1.208-.86-1.88l-1.598-5.99 7.748-2.165 1.598 5.99c.183.672.25 1.37.197 2.064L21.3 47.27z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FK",
    x: -36.433,
    y: -27.268,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FU",
    x: -31.086,
    y: -7.361,
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dk)",
    d: "M13.553 49.434c-.393-.574-.683-1.21-.86-1.884l-1.575-5.984 7.743-2.16 1.603 5.99c.183.672.25 1.37.197 2.064l-7.11 1.976z",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FB",
    x: -31.355,
    y: -39.382,
    style: {
      mixBlendMode: "multiply"
    },
    className: "C D"
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35 43.726l1.598 5.99c1.107 4.146 5.364 4.5 5.364 4.5s3.5-2.53 2.384-6.666l-1.603-5.99-7.743 2.165z",
    className: "E"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FC",
    x: -31.344,
    y: -39.383,
    fill: "url(#Dl)",
    style: {
      mixBlendMode: "multiply"
    },
    className: "B"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.79 1.55S1.814 12.406 32.244 59.703L36.29 69l23.394-11.742L86 55.048s.462-40.05-17.37-49.485S42.79 1.55 42.79 1.55z",
    className: "Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.459,
    cy: 45.144,
    rx: 11.446,
    ry: 10.598,
    transform: "rotate(331.2 37.459 45.144)",
    className: "p"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc1f26",
    d: "M39.612 49.363c3.582-1.55 5.325-5.442 3.88-8.673s-5.524-4.596-9.106-3.057-5.32 5.442-3.88 8.673 5.524 4.606 9.106 3.057z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.096,
    cy: 35.792,
    rx: 11.406,
    ry: 10.634,
    transform: "rotate(352.49 71.096 35.792)",
    className: "p"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc1f26",
    d: "M71.666 39.958c-3.843.405-7.268-2.162-7.634-5.722s2.46-6.79 6.302-7.194 7.268 2.162 7.634 5.726-2.46 6.78-6.302 7.19z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.68,
    cy: 43.46,
    rx: 1,
    ry: 4.193,
    transform: "rotate(345 36.68 43.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.189,
    cy: 33.866,
    rx: 1,
    ry: 4.193,
    transform: "rotate(345 71.19 33.866)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#172b53",
    d: "M27 42s3.495-6.247 21-.607c0 0-2.014-8.157-10.97-7.335.01 0-7.483.518-10.03 7.942zm21 6.443S33.936 58.84 26 48c0 0 1.963 8.463 11.79 7.98 0 .004 7.614-.466 10.21-7.537zM79 28.14S72.4 24.186 60.105 38c0 0-1.46-8.575 6.497-12.036 0 .024 6.863-3.266 12.398 2.176zM63 43.91S79.627 46.952 81.52 33c0 0 3.018 8.59-6.076 13.057 0-.023-6.89 3.202-12.443-2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 140.356L44.783 158h4.163L55 139zM64 138h14l-4.064 19h-4.064z",
    className: "Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35,
    cy: 112.5,
    fill: "#cf252a",
    rx: 8,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 23L44 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7 16.807L44 8l14 15zm5.3 3.298L42 29l1.173-22 2.38 15.244zM38 122l.74 7h42.386l.874-7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#bb2026",
    d: "M71.01 105c-.42-18.172 14.568-36.344 36.102-35.985 19.008.313 34.536 15.43 34.883 35.148.393 22.414-17.9 37.016-35.53 36.845C86.717 140.805 71.01 125.026 71.01 105zm62.17 0c0-15.057-11.897-27.07-26.76-27.06s-26.7 12.118-26.69 27.143c0 14.827 12.04 27 26.686 27.014 14.78.032 26.78-12.118 26.76-27.088h.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faf7f8",
    d: "M133 104.968c0 14.927-11.88 27.04-26.54 27.032C91.94 132 80.01 119.85 80 105.064 80 90.07 91.792 78 106.466 78S132.982 89.954 133 104.968zm-46.215-.124c-.087 11.124 8.567 20.096 19.516 20.23s19.937-8.84 20.006-19.995-8.85-20.26-19.772-20.29c-10.82-.04-19.658 8.936-19.75 20.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba2027",
    d: "M86 104.913C86.093 93.873 95.037 84.96 105.99 85c11.053.036 20.085 9.11 20.01 20.145S116.847 125.13 105.752 125s-19.84-9.04-19.75-20.086zm3.765.055c0 9.11 7.047 16.155 16.093 16.3 9.05-.17 16.286-7.437 16.262-16.327s-7.3-16.12-16.35-16.242c-8.768.032-15.99 7.365-16.005 16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 104.475c0-9.013 7.158-16.442 15.83-16.475 8.95.125 16.147 7.45 16.17 16.457s-7.134 16.37-16.083 16.543c-8.942-.157-15.93-7.277-15.916-16.525zm5.443-2.377c2.05 1.532 3.517 2.792 5.136 3.79 1.27.78 1.348 1.597.87 2.893-.66 1.814-1.376 3.636-1.687 5.856 1.834-1.357 3.5-2.455 4.998-3.743.986-.844 1.674-.706 2.595.05 1.467 1.204 3.036 2.28 4.86 3.632-.326-2.404-1.068-4.25-1.7-6.12-.362-1.048-.316-1.717.73-2.4 1.697-1.08 3.25-2.4 5.35-3.97-2.595 0-4.586-.097-6.603.037-1.224.078-1.65-.46-1.953-1.523-.555-1.938-1.21-3.85-2.004-6.33-.812 2.533-1.51 4.472-2.045 6.46-.284 1.075-.784 1.426-1.834 1.384-2.03-.088-4.054-.028-6.704-.028z",
    className: "K"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f8f9",
    d: "M96 101.685l6.65.023c1.057.04 1.554-.304 1.823-1.36L106.505 94l1.992 6.22c.3 1.043.725 1.573 1.94 1.496 1.982-.13 3.983-.036 6.563-.036l-5.318 3.9c-1.04.662-1.085 1.32-.725 2.35.638 1.836 1.367 3.65 1.7 6.012l-4.83-3.568c-.91-.744-1.6-.88-2.58-.05-1.5 1.265-3.145 2.344-4.967 3.677.305-2.18 1.02-3.972 1.677-5.754.456-1.274.396-2.077-.866-2.843-1.595-.975-3.053-2.2-5.1-3.718zM54 90.23h3.792c.244.044.496-.012.696-.153s.328-.356.355-.593L60.002 86l1.136 3.418c.17.57.413.862 1.108.817 1.13-.072 2.27 0 3.754 0l-3.036 2.143c-.59.36-.62.723-.413 1.29a15.34 15.34 0 0 1 .971 3.297l-2.755-1.958c-.526-.41-.94-.48-1.478-.027-.85.696-1.793 1.29-2.816 2.02a14.19 14.19 0 0 1 .939-3.144c.268-.7.225-1.136-.47-1.56-.948-.57-1.783-1.24-2.943-2.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 122l.733 7h2.998l1.27-7zm12 0l.5 7H57v-7zm10 0h4l-.607 7H63z",
    fill: "#cf252a"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJoinUs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/join_us.74ae2114.svg";
export { ForwardRef as ReactComponent };